/**
 * SEO 配置 - image-tools
 * 自动从 seo.ts 拆分生成
 */

export default {
    en: {
        textToImage: {
            title: 'Free AI Image Generator from Text - Create 4K Art & Realistic Photos',
            description: `Turn text prompts into stunning visuals with 微鲤AI's Text to Image Generator. Features Nano Banana Pro model for high-fidelity results. Supports 1K/2K/4K resolution and 9:16/16:9 aspect ratios. Free & Online.`,
            keywords: 'text to image, ai image generator, ai art generator, 4k ai images, nano banana model, flux ai free, wallpaper generator, create images from text',
            og_title: 'Free AI Image Generator from Text - Create 4K Art & Realistic Photos',
            og_description: `Turn text prompts into stunning visuals with 微鲤AI's Text to Image Generator. Features Nano Banana Pro model for high-fidelity results. Supports 1K/2K/4K resolution and 9:16/16:9 aspect ratios. Free & Online.`,
            twitter_title: 'Free AI Image Generator from Text - Create 4K Art & Realistic Photos',
            twitter_description: `Turn text prompts into stunning visuals with 微鲤AI's Text to Image Generator. Features Nano Banana Pro model for high-fidelity results. Supports 1K/2K/4K resolution and 9:16/16:9 aspect ratios. Free & Online.`,
            faq: [
                {
                    question: 'How do I generate 4K AI images?',
                    answer: `Simply enter your prompt and select '4K' in the Image Size settings on the left panel before clicking Create.`,
                },
                {
                    question: 'What aspect ratios are supported?',
                    answer: 'We support all major ratios including 1:1, 9:16 (Mobile), 16:9 (Desktop), 4:3, and 3:2 to fit any platform.',
                },
                {
                    question: 'Can I use the images commercially?',
                    answer: 'Yes. Images generated on 微鲤AI plans typically come with a commercial license suitable for ads and merchandise.',
                },
            ],
            page: {
                title1: 'Free AI Text to Image Generator',
                title2: 'Create breathtaking art, photorealistic images, and unique wallpapers in seconds. Just describe what you want to see, and our advanced Nano Banana Pro model will generate high-fidelity 4K images that match your prompt perfectly.',
                resolution: 'Stop settling for blurry AI images. 微鲤AI lets you generate crystal-clear 1K, 2K, and 4K images directly, perfect for printing or high-res displays.',
                aspectRatio: 'Whether you need a 9:16 image for TikTok backgrounds, 16:9 for YouTube thumbnails, or 1:1 for Instagram, we have presets for every social platform.',
                online_search: 'Need up-to-date context? Enable "Online Search" to let the AI browse the web for better understanding of current events or specific references in your prompt.',
                faq: [
                    {
                        question: 'How do I generate high-quality images from text?',
                        answer: 'Enter a detailed prompt describing the subject, lighting, and style. Select "4K" in the Image Size settings for the sharpest details.',
                    },
                    {
                        question: 'What is the Nano Banana Pro model?',
                        answer: 'Nano Banana Pro is our highest-fidelity model, optimized for prompt adherence and photorealism. It rivals top models like Midjourney v6 and Flux in quality.',
                    },
                    {
                        question: 'Can I use the images for commercial purposes?',
                        answer: 'Yes. Images generated on 微鲤AI (paid plans) come with a commercial license, allowing you to use them for ads, websites, and merchandise.',
                    },
                    {
                        question: 'How many images can I generate at once?',
                        answer: 'You can generate up to 4 images simultaneously (as shown in the "Output Image Number" setting), allowing you to quickly iterate on ideas.',
                    },
                    {
                        question: 'Is it free?',
                        answer: 'Yes, you can generate images using our free daily credits. Higher resolutions (4K) may require more credits.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Free AI Image to Image Generator - Turn Photo into Art & 4K',
            description: `Upload a reference photo and transform it with 微鲤AI's Image to Image AI. Turn sketches into realistic art, change styles, or generate variations while keeping the original composition. Support 4K resolution.`,
            keywords: 'image to image ai, img2img, turn photo into drawing, ai image variation, sketch to image, photo remix ai, free ai art generator',
            og_title: 'Free AI Image to Image Generator - Turn Photo into Art & 4K',
            og_description: `Upload a reference photo and transform it with 微鲤AI's Image to Image AI. Turn sketches into realistic art, change styles, or generate variations while keeping the original composition. Support 4K resolution.`,
            twitter_title: 'Free AI Image to Image Generator - Turn Photo into Art & 4K',
            twitter_description: `Upload a reference photo and transform it with 微鲤AI's Image to Image AI. Turn sketches into realistic art, change styles, or generate variations while keeping the original composition. Support 4K resolution.`,
            faq: [
                {
                    question: 'What is Image to Image AI?',
                    answer: 'Image to Image (Img2Img) uses an uploaded image as a reference along with a text prompt to generate a new image, blending visual input with creative description.',
                },
                {
                    question: 'How do I turn a sketch into a realistic photo?',
                    answer: `Upload your sketch, enter a prompt describing the scene (e.g., 'photorealistic building'), and click Create.`,
                },
                {
                    question: 'Does it keep the original face?',
                    answer: 'It preserves structure and pose. For precise face identity retention, please use our Photo Face Swap tool.',
                },
            ],
            page: {
                title1: 'Free AI Image to Image Generator',
                title2: 'Use your existing images as a blueprint. Upload a photo, sketch, or layout, and let our AI regenerate it in a completely new style based on your text prompt. Perfect for preserving composition while exploring infinite artistic variations.',
                title3: 'Transform Your Photos with AI Style Transfer',
                title4: 'Why Use Image to Image (Img2Img)?',
                upload_image: 'Struggling to describe a pose or layout in words? Just upload a reference image. Our Img2Img engine keeps the structure of your original photo but repaints the details.',
                resolution: 'Turn a rough doodle or wireframe into a photorealistic render or high-quality illustration in seconds. Ideal for designers and architects.',
                output: 'Generate production-ready assets. Unlike other tools that output small images, 微鲤AI supports 1K, 2K, and 4K resolutions for crisp details.',
                faq: [
                    {
                        question: 'What is Image to Image AI?',
                        answer: 'Image to Image (Img2Img) is a technology that uses an uploaded image as a "reference" along with a text prompt to generate a new image. It blends your visual input with your creative description.',
                    },
                    {
                        question: 'How do I turn a sketch into a realistic photo?',
                        answer: 'Upload your sketch to the "Image" area. In the "Prompt" box, describe what the sketch represents (e.g., "A modern villa, sunset, photorealistic, 8k"). Click Create to see the magic.',
                    },
                    {
                        question: 'Does it keep the original face/person?',
                        answer: 'It tries to preserve the general structure and pose. However, for precise face retention, we recommend using our specific "Photo Face Swap" tool instead.',
                    },
                    {
                        question: 'What aspect ratios are supported?',
                        answer: 'We support a wide range of ratios including 9:16 (Story), 16:9 (Cinematic), 3:4, and 1:1, ensuring your generated art fits any platform perfectly.',
                    },
                    {
                        question: 'Is it free?',
                        answer: 'Yes, you can generate variations for free using your daily credits.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Free AI Image Extender & Resizer - Uncrop & Outpaint Photos',
            description: `Resize images for Instagram, TikTok, and YouTube without cropping. 微鲤AI's AI Image Extender uses generative fill (outpainting) to expand image backgrounds intelligently. Change aspect ratios seamlessly.`,
            keywords: 'ai image extender, uncrop image, ai outpainting, image resizer ai, expand image background, generative fill online, make photo vertical',
            og_title: 'Free AI Image Extender & Resizer - Uncrop & Outpaint Photos',
            og_description: `Resize images for Instagram, TikTok, and YouTube without cropping. 微鲤AI's AI Image Extender uses generative fill (outpainting) to expand image backgrounds intelligently. Change aspect ratios seamlessly.`,
            twitter_title: 'Free AI Image Extender & Resizer - Uncrop & Outpaint Photos',
            twitter_description: `Resize images for Instagram, TikTok, and YouTube without cropping. 微鲤AI's AI Image Extender uses generative fill (outpainting) to expand image backgrounds intelligently. Change aspect ratios seamlessly.`,
            page: {
                title1: 'Free AI Image Extender & Resizer',
                title2: 'Stop cropping your favorite photos to fit social media. Whether you need to turn a horizontal shot into a vertical Story or expand a square image to 16:9, our AI Image Extender magically generates new background details (Outpainting) to fit any aspect ratio perfectly.',
                faq: [
                    {
                        question: 'How do I resize an image without cropping?',
                        answer: `Use 微鲤AI's AI Image Extender. Upload your photo, select the target aspect ratio (e.g., 9:16), and the AI will automatically generate (outpaint) the missing background areas instead of cropping your image.`,
                    },
                    {
                        question: 'What is AI Outpainting?',
                        answer: 'Outpainting is a generative AI technology that expands the borders of an image by predicting and drawing new content that matches the original style, effectively "uncropping" the photo.',
                    },
                    {
                        question: 'Can I turn a horizontal photo into a vertical one?',
                        answer: 'Yes! Simply upload your horizontal (landscape) photo and select the 9:16 ratio. The AI will extend the top and bottom of the image to fill the vertical frame.',
                    },
                    {
                        question: 'Will the expanded background look fake?',
                        answer: '微鲤AI uses advanced generative models trained on massive datasets to ensure the extended background blends naturally with the original lighting and texture.',
                    },
                    {
                        question: 'Is it free to use?',
                        answer: 'Yes, users receive free credits to try the AI Smart Resize and Outpainting features.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I resize an image without cropping?',
                    answer: `Use 微鲤AI's AI Image Extender. Upload your photo, select the target aspect ratio (e.g., 9:16), and the AI will automatically generate (outpaint) the missing background areas instead of cropping your image.`,
                },
                {
                    question: 'What is AI Outpainting?',
                    answer: `Outpainting is a generative AI technology that expands the borders of an image by predicting and drawing new content that matches the original style, effectively 'uncropping' the photo.`,
                },
                {
                    question: 'Can I turn a horizontal photo into a vertical one?',
                    answer: 'Yes! Simply upload your horizontal (landscape) photo and select the 9:16 ratio. The AI will extend the top and bottom of the image to fill the vertical frame.',
                },
                {
                    question: 'Will the expanded background look fake?',
                    answer: '微鲤AI uses advanced generative models trained on massive datasets to ensure the extended background blends naturally with the original lighting and texture.',
                },
                {
                    question: 'Is it free to use?',
                    answer: 'Yes, users receive free credits to try the AI Smart Resize and Outpainting features.',
                },
            ],
            feature_title1: 'Smart Background Extension',
            feature_desc1: 'Magic Outpainting: The AI understands the context of your image and paints new pixels beyond the original borders. Expand landscapes, rooms, or textures seamlessly to fill the frame.',
            feature_title2: 'Center Stage Protection',
            feature_desc2: 'Never Crop the Subject: Our AI automatically identifies the main person or object and locks them in the center, ensuring they are never cut off during the resizing process.',
            feature_title3: 'Social Media Ready',
            feature_desc3: 'One-click presets for Instagram Stories (9:16), YouTube Thumbnails (16:9), and Posts (4:5). Repurpose your content across all platforms instantly.',
        },
        imageTextTranslate: {
            title: 'Free AI Image Translator - Translate Text in Photos, Manga & Comics',
            description: `Instantly translate text in images while preserving the original visual style. 微鲤AI's AI Image Translator automatically erases original text and redraws translations. Perfect for comics, manga, and marketing posters.`,
            keywords: 'ai image translator, translate text in image, picture translator, manga translator, translate comics, ocr translator, image text replacement',
            og_title: 'Free AI Image Translator - Translate Text in Photos, Manga & Comics',
            og_description: `Instantly translate text in images while preserving the original visual style. 微鲤AI's AI Image Translator automatically erases original text and redraws translations. Perfect for comics, manga, and marketing posters.`,
            twitter_title: 'Free AI Image Translator - Translate Text in Photos, Manga & Comics',
            twitter_description: `Instantly translate text in images while preserving the original visual style. 微鲤AI's AI Image Translator automatically erases original text and redraws translations. Perfect for comics, manga, and marketing posters.`,
            page: {
                title1: 'Free AI Image Translator & Text Replacer',
                title2: 'Translate posters, menus, comics, and screenshots in seconds. Unlike standard translators that just overlay text, 微鲤AI uses Generative AI to erase the original text and redraw the background, making the translated text look like it was part of the original design.',
                faq: [
                    {
                        question: 'How do I translate text inside an image?',
                        answer: 'Upload your image (JPG, PNG) to 微鲤AI. Select the source language (or use Auto-Detect) and the target language. Click "Create" to let the AI replace the text.',
                    },
                    {
                        question: 'Will the translated text look natural?',
                        answer: 'Yes. 微鲤AI attempts to match the font size and style of the original text. Crucially, it redraws the background behind the text so the translation blends in seamlessly.',
                    },
                    {
                        question: 'Can I use this to translate Manga or Manhwa?',
                        answer: 'Absolutely. This is one of the best use cases. The AI detects speech bubbles and vertical text (common in Japanese), replacing them with horizontal translated text.',
                    },
                    {
                        question: 'What languages are supported?',
                        answer: 'We support translation between major global languages including English, Spanish, Chinese, Japanese, Korean, French, German, and more.',
                    },
                    {
                        question: 'Does it work on handwritten text?',
                        answer: 'It works best on printed text, but our advanced OCR engine can recognize clear handwritten text on whiteboards or notes.',
                    },
                    {
                        question: 'Is it free?',
                        answer: 'You can translate images for free using your daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I translate text inside an image?',
                    answer: `Upload your image to 微鲤AI. Select the target language and click 'Create'. The AI will replace the original text with the translation.`,
                },
                {
                    question: 'Will the translated text look natural?',
                    answer: 'Yes. 微鲤AI redraws the background behind the text and attempts to match the font style, ensuring the translation blends seamlessly.',
                },
                {
                    question: 'an I use this to translate Manga or Manhwa?',
                    answer: 'Absolutely. This is one of the best use cases. The AI detects speech bubbles and vertical text (common in Japanese), replacing them with horizontal translated text.',
                },
            ],
            feature_title1: 'Smart Inpainting & Redrawing',
            feature_desc1: 'Seamless Text Replacement: Our AI analyzes the background texture behind the text. It erases the original words and fills the gap intelligently before adding the translation, ensuring no ugly text boxes cover your image.',
            feature_title2: 'Manga & Comic Translation',
            feature_desc2: 'Read Raw Manga Instantly: Perfect for anime fans. Upload raw manga pages (Japanese/Korean) and get instant English translations that fit perfectly inside the speech bubbles.',
            feature_title3: 'Global Marketing Localization',
            feature_desc3: 'One-Click Localization: Launching products globally? Translate your marketing posters, banners, and UI screenshots into 30+ languages without needing the original PSD files.',
        },
        aiBackgroundChanger: {
            title: 'Free AI Background Changer - Generate Backgrounds from Text',
            description: 'Instantly change photo backgrounds using AI. Describe the scene you want, and 微鲤AI will generate realistic backgrounds for product photography, LinkedIn headshots, and creative portraits. Free & Online.',
            keywords: 'change photo background, ai background generator, product photography ai, white background maker, replace background online, generative fill background',
            og_title: 'Free AI Background Changer - Generate Backgrounds from Text',
            og_description: 'Instantly change photo backgrounds using AI. Describe the scene you want, and 微鲤AI will generate realistic backgrounds for product photography, LinkedIn headshots, and creative portraits. Free & Online.',
            twitter_title: 'Free AI Background Changer - Generate Backgrounds from Text',
            twitter_description: 'Instantly change photo backgrounds using AI. Describe the scene you want, and 微鲤AI will generate realistic backgrounds for product photography, LinkedIn headshots, and creative portraits. Free & Online.',
            page: {
                title1: 'Free AI Background Changer & Generator',
                title2: `Don't just remove the background—replace it with something better. Upload your photo and describe any scene (e.g., 'luxury marble studio', 'office skyline'). Our Generative AI understands lighting and perspective to blend your subject perfectly into the new environment.`,
                faq: [
                    {
                        question: 'How do I change the background using text?',
                        answer: 'Upload your image, and in the "Background Prompt" box, describe the scene you want (e.g., "a cozy coffee shop"). Click Create, and the AI will generate that exact background for you.',
                    },
                    {
                        question: 'Can I change the background to plain white?',
                        answer: 'Yes. Simply type "pure white background" or "studio white" in the prompt box. This is perfect for Amazon/eBay product listings and official ID photos.',
                    },
                    {
                        question: 'Is this good for product photography?',
                        answer: 'Absolutely. 微鲤AI analyzes the angle of your product and generates backgrounds with correct shadows and lighting, making it look like a professional studio shoot.',
                    },
                    {
                        question: 'Will the lighting look natural?',
                        answer: 'Our Generative AI (similar to Adobe Firefly or SDXL) attempts to match the lighting of the generated background to your subject, blending them seamlessly.',
                    },
                    {
                        question: 'Is it free to use?',
                        answer: 'Yes, you can generate new backgrounds for free using your daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I change the background using text?',
                    answer: 'Upload your image, and in the "Background Prompt" box, describe the scene you want (e.g., "a cozy coffee shop"). Click Create, and the AI will generate that exact background for you.',
                },
                {
                    question: 'Can I change the background to plain white?',
                    answer: 'Yes. Simply type "pure white background" or "studio white" in the prompt box. This is perfect for Amazon/eBay product listings and official ID photos.',
                },
                {
                    question: 'Is this good for product photography?',
                    answer: 'Absolutely. 微鲤AI analyzes the angle of your product and generates backgrounds with correct shadows and lighting, making it look like a professional studio shoot.',
                },
                {
                    question: 'Will the lighting look natural?',
                    answer: 'Our Generative AI (similar to Adobe Firefly or SDXL) attempts to match the lighting of the generated background to your subject, blending them seamlessly.',
                },
                {
                    question: 'Is it free to use?',
                    answer: 'Yes, you can generate new backgrounds for free using your daily credits.',
                },
            ],
            feature_title1: 'Professional ID Photos',
            feature_desc1: 'DIY LinkedIn Headshots: Turn a casual selfie into a professional profile picture. Change a messy bedroom background to a clean office or studio grey background instantly.',
            feature_title2: 'Instant Product Photography',
            feature_desc2: 'Boost E-commerce Sales: Save thousands on photoshoots. Place your product on a wooden table, a sandy beach, or a podium with simple text prompts. The AI adds realistic shadows and reflections.',
            feature_title3: 'Creative Teleportation',
            feature_desc3: 'Travel Anywhere: Want to be in Paris or the Cyberpunk future? Just type it. Our AI replaces the background while keeping the lighting consistent with your original photo.',
        },
        imageUpscaler: {
            title: 'Free AI Image Upscaler - Upscale to 4K & Restore Old Photos',
            description: `Instantly upscale low-res images to 2x, 4x, and 4K with 微鲤AI's Free AI Image Enhancer. Fix blurry photos, remove noise, and restore old family photos online. Lossless quality.`,
            keywords: 'ai image upscaler, photo enhancer, upscale image to 4k, unblur image, old photo restoration, fix pixelated photo, increase image resolution',
            og_title: 'Free AI Image Upscaler - Upscale to 4K & Restore Old Photos',
            og_description: `Instantly upscale low-res images to 2x, 4x, and 4K with 微鲤AI's Free AI Image Enhancer. Fix blurry photos, remove noise, and restore old family photos online. Lossless quality.`,
            twitter_title: 'Free AI Image Upscaler - Upscale to 4K & Restore Old Photos',
            twitter_description: `Instantly upscale low-res images to 2x, 4x, and 4K with 微鲤AI's Free AI Image Enhancer. Fix blurry photos, remove noise, and restore old family photos online. Lossless quality.`,
            page: {
                title1: 'Free AI Image Upscaler & Enhancer',
                title2: 'Turn pixelated, blurry, or old photos into high-definition masterpieces. 微鲤AI uses advanced AI to upscale image resolution by up to 400% (4K) while recovering lost details, fixing noise, and restoring faces in old family portraits.',
                faq: [
                    {
                        question: 'Can I upscale low-res images for printing?',
                        answer: 'Yes! 微鲤AI increases the resolution (pixel count) of your image up to 4K, making it suitable for high-quality printing on posters, canvas, or marketing materials.',
                    },
                    {
                        question: 'How does AI old photo restoration work?',
                        answer: 'The AI analyzes the damaged or blurry parts of the old photo and uses deep learning to predict and reconstruct facial details, textures, and backgrounds, effectively "healing" the image.',
                    },
                    {
                        question: 'What formats are supported?',
                        answer: 'We support common formats like JPG, PNG, and WEBP. The output will be a high-quality PNG or JPG.',
                    },
                    {
                        question: 'Does it work on anime/cartoons?',
                        answer: 'Yes. Our AI excels at upscaling anime and illustrations (waifu2x style), keeping lines sharp and colors vibrant without artifacts.',
                    },
                    {
                        question: 'Is it free?',
                        answer: 'Yes, you can enhance images for free using your daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Can I upscale low-res images for printing?',
                    answer: 'Yes! 微鲤AI increases the resolution up to 4K, making images suitable for high-quality printing.',
                },
                {
                    question: 'How does AI old photo restoration work?',
                    answer: 'The AI analyzes damaged areas and reconstructs facial details and textures using deep learning to heal the image.',
                },
                {
                    question: 'Does it work on anime?',
                    answer: 'Yes. Our AI excels at upscaling anime and illustrations, keeping lines sharp without artifacts.',
                },
            ],
            feature_title1: 'Lossless Upscaling to 4K',
            feature_desc1: 'Print-Ready Quality: Need to print a small image? Upscale it to 4K or 8K without losing quality. Perfect for posters, e-commerce product shots, and wallpapers.',
            feature_title2: 'Smart Denoise & Deblur',
            feature_desc2: 'Fix Night Shots: Remove digital noise and grain from low-light photos. Sharpen blurry edges instantly to make your photos look crisp and professional.',
            feature_title3: 'Old Photo Restoration',
            feature_desc3: 'Revive Memories: Have old, damaged, or black-and-white photos? Our AI creates new pixels to repair scratches, sharpen faces, and bring clarity back to your treasured memories.',
        },
        photoFaceSwap: {
            title: 'Free AI Face Swap Online - Realistic Photo Face Changer',
            description: `Swap faces in photos instantly with 微鲤AI's Free AI Face Swapper. Create funny memes, artistic portraits (Mona Lisa), or professional headshots with high realism. 100% private and secure.`,
            keywords: 'ai face swap, face swap online, photo face changer, reface free, replace face in image, deepfake photo, meme maker ai',
            og_title: 'Free AI Face Swap Online - Realistic Photo Face Changer',
            og_description: `Swap faces in photos instantly with 微鲤AI's Free AI Face Swapper. Create funny memes, artistic portraits (Mona Lisa), or professional headshots with high realism. 100% private and secure.`,
            twitter_title: 'Free AI Face Swap Online - Realistic Photo Face Changer',
            twitter_description: `Swap faces in photos instantly with 微鲤AI's Free AI Face Swapper. Create funny memes, artistic portraits (Mona Lisa), or professional headshots with high realism. 100% private and secure.`,
            page: {
                title1: 'Free AI Photo Face Swap',
                title2: 'Want to see yourself as an astronaut, a movie star, or in a classic painting? Upload a base photo and a target face, and let our AI seamlessly blend facial features, lighting, and skin tones for a hyper-realistic face swap in seconds.',
                faq: [
                    {
                        question: 'Is 微鲤AI Face Swap free to use?',
                        answer: 'Yes, we provide free daily credits for you to swap faces in photos online. No installation or credit card required.',
                    },
                    {
                        question: 'Is my data safe?',
                        answer: 'Absolutely. We prioritize your privacy. The photos you upload are used solely for the swapping process and are automatically deleted from our servers after a short period.',
                    },
                    {
                        question: 'How do I get the best results?',
                        answer: 'For the most realistic swap, ensure both the "Base Image" and "Face Image" are clear, front-facing, and have good lighting. Avoid photos where the face is obscured by hair or hands.',
                    },
                    {
                        question: 'Can I swap faces in group photos?',
                        answer: 'Currently, our tool focuses on single-face swapping precision. For group photos, please crop the image or use our upcoming multi-face feature.',
                    },
                    {
                        question: 'Can I use this for memes?',
                        answer: `Yes! It's perfect for creating funny memes. Swap your friend's face onto a movie poster or a viral meme template instantly.`,
                    },
                ],
            },
            faq: [
                {
                    question: 'Is 微鲤AI Face Swap free to use?',
                    answer: 'Yes, we provide free daily credits for you to swap faces in photos online. No installation or credit card required.',
                },
                {
                    question: 'Is my data safe?',
                    answer: 'Absolutely. We prioritize your privacy. The photos you upload are used solely for the swapping process and are automatically deleted from our servers after a short period.',
                },
                {
                    question: 'How do I get the best results?',
                    answer: 'Ensure both photos are clear, front-facing, and well-lit. Avoid faces obscured by hair or glasses.',
                },
            ],
            feature_title1: 'Artistic Masterpieces',
            feature_desc1: 'Time Travel: Swap your face into classic oil paintings like the Mona Lisa or Girl with a Pearl Earring. Create unique vintage avatars instantly.',
            feature_title2: 'Professional & Cool Avatars',
            feature_desc2: 'Dream Jobs: See yourself in a racing suit, astronaut gear, or business attire without buying the costume. Perfect for creating standout profile pictures.',
            feature_title3: 'Hyper-Realistic Blending',
            feature_desc3: 'No "Paste" Effect: Unlike simple cut-and-paste tools, 微鲤AI analyzes the angle, lighting, and skin texture to ensure the swapped face looks 100% natural, not fake.',
        },
        removeTextFromImage: {
            title: 'Free AI Text Remover from Image - Erase Watermarks & Date Stamps',
            description: `Instantly remove text, date stamps, logos, and captions from images with 微鲤AI's Free AI Text Eraser. Restore backgrounds perfectly using AI Inpainting. Ideal for cleaning up photos and e-commerce mockups.`,
            keywords: 'remove text from image, ai text remover, remove date stamp, remove watermark online, cleanup pictures, ai inpainting, remove logo from photo',
            og_title: 'Free AI Text Remover from Image - Erase Watermarks & Date Stamps',
            og_description: `Instantly remove text, date stamps, logos, and captions from images with 微鲤AI's Free AI Text Eraser. Restore backgrounds perfectly using AI Inpainting. Ideal for cleaning up photos and e-commerce mockups.`,
            twitter_title: 'Free AI Text Remover from Image - Erase Watermarks & Date Stamps',
            twitter_description: `Instantly remove text, date stamps, logos, and captions from images with 微鲤AI's Free AI Text Eraser. Restore backgrounds perfectly using AI Inpainting. Ideal for cleaning up photos and e-commerce mockups.`,
            page: {
                title1: 'Free AI Text Remover from Image',
                title2: 'Distracted by unwanted text? Simply upload your image, and our AI will detect and erase text, logos, date stamps, or captions instantly. It intelligently analyzes the surrounding pixels to reconstruct the background, leaving no trace behind.',
                faq: [
                    {
                        question: 'How do I remove text from a picture without blurring it?',
                        answer: `Use 微鲤AI's AI Text Remover. Instead of blurring, our tool uses AI Inpainting technology to analyze the surroundings and generate new pixels to fill the gap seamlessly.`,
                    },
                    {
                        question: 'Can I remove date stamps from photos?',
                        answer: 'Yes! This is a perfect use case. The AI easily recognizes the digital font of date/time stamps and removes them while restoring the landscape behind.',
                    },
                    {
                        question: 'Does it work on complex backgrounds?',
                        answer: 'Yes. As shown in our examples, it can remove text even from complex backgrounds like mountain ranges or patterned clothing by understanding the texture flow.',
                    },
                    {
                        question: 'Can I use it to remove people or objects?',
                        answer: 'While optimized for text, the underlying technology (Inpainting) works well for removing small unwanted objects, skin blemishes, or clutter as well.',
                    },
                    {
                        question: 'Is it free?',
                        answer: 'Yes, you can use the AI Text Remover for free with daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I remove text from a picture without blurring it?',
                    answer: `Use 微鲤AI's AI Text Remover. Instead of blurring, our tool uses AI Inpainting technology to analyze the surroundings and generate new pixels to fill the gap seamlessly.`,
                },
                {
                    question: 'Can I remove date stamps from photos?',
                    answer: 'Yes! The AI easily recognizes the digital font of date/time stamps and removes them while restoring the landscape behind.',
                },
                {
                    question: 'Does it work on complex backgrounds?',
                    answer: 'Yes. As shown in our examples, it can remove text even from complex backgrounds like mountain ranges or patterned clothing by understanding the texture flow.',
                },
            ],
            feature_title1: 'Apparel & Design Cleanup',
            feature_desc1: 'Perfect for Mockups: Reselling clothing online? Remove existing logos, slogans, or graphics from T-shirt model photos to create a clean slate for your own designs.',
            feature_title2: 'Memory Restoration',
            feature_desc2: 'Erase Date Stamps: Remove distracting orange digital date stamps from your old family photos or travel shots without damaging the underlying scenery.',
            feature_title3: 'Intelligent Inpainting',
            feature_desc3: 'Seamless Background Fill: Unlike basic eraser tools that leave a blur, 微鲤AI uses Generative AI to "paint" realistic textures (like grass, sky, or mountains) into the erased area.',
        },
        imgExtender: {
            title: 'Extend Images for Free Instantly - AI Image Extender | 微鲤AI',
            description: `Use 微鲤AI's free AI Image Extender to break past your photo's original borders instantly. Our AI outpainting tool generates new pixels that blend perfectly with your upload—turn portraits into wide-angle shots while preserving the original look and quality.`,
            keywords: 'AI image extender, free image expansion, wide-angle photo generator, extend photo borders, seamless outpainting, preserve original quality',
            og_title: 'Extend Images for Free Instantly - AI Image Extender | 微鲤AI',
            og_description: 'Expand your photos to new sizes and generate matching content. Try our AI Image Extender for free today.',
            twitter_title: 'Extend Images for Free Instantly - AI Image Extender | 微鲤AI',
            twitter_description: 'Expand your photos to new sizes and generate matching content. Try our AI Image Extender for free today.',
            featureList: [
                'AI image extender, free image expansion, wide-angle photo generator, preserve original quality',
            ],
            page: {
                title1: 'A powerful AI Image Extender for stunning results',
                title2: `With just a few clicks, expand beyond your photo's original borders. Our AI Image Extender generates new pixels that seamlessly blend with your upload—turn portraits into wide-angle photos while keeping the original look and quality.`,
                feature_title: 'What makes 微鲤AI Image Extender special',
                faq: [
                    {
                        question: 'What is an AI Image Extender?',
                        answer: 'Powered by advanced AI, this tool expands an image by intelligently filling missing areas beyond the original boundaries. It creates a larger version of your photo, great for marketing, e-commerce, and social media.',
                    },
                    {
                        question: 'Why use our AI Image Extender?',
                        answer: '微鲤AI uses state-of-the-art models to analyze image features and seamlessly outpaint surrounding areas with natural, high-definition results.',
                    },
                    {
                        question: 'Is 微鲤AI Image Extender free?',
                        answer: 'Yes. You can use our AI Image Extender for free with trial credits, making it a budget-friendly addition to any image editing workflow.',
                    },
                    {
                        question: 'How fast is the AI Image Extender?',
                        answer: `Usually it completes in seconds with minimal waiting. It's ideal for handling both quick edits and batch workflows.`,
                    },
                    {
                        question: 'Will it affect resolution or quality?',
                        answer: 'No. The tool preserves resolution, clarity, and details during expansion—safe for personal and professional use.',
                    },
                    {
                        question: 'Will my uploaded image stay private?',
                        answer: 'Yes. We protect your data with industry-standard security and strict privacy practices to ensure your images are not shared with third parties.',
                    },
                    {
                        question: 'What image formats are supported?',
                        answer: 'JPG, PNG, WebP and other common formats are supported. Max file size is 10MB—no conversion needed.',
                    },
                ],
            },
            faq: [
                {
                    question: 'What is an AI Image Extender?',
                    answer: 'Powered by advanced AI, this tool expands an image by intelligently filling missing areas beyond the original boundaries. It creates a larger version of your photo, great for marketing, e-commerce, and social media.',
                },
                {
                    question: 'Why use our AI Image Extender?',
                    answer: '微鲤AI uses state-of-the-art models to analyze image features and seamlessly outpaint surrounding areas with natural, high-definition results.',
                },
                {
                    question: 'Is 微鲤AI Image Extender free?',
                    answer: 'Yes. You can use our AI Image Extender for free with trial credits, making it a budget-friendly addition to any image editing workflow.',
                },
                {
                    question: 'How fast is the AI Image Extender?',
                    answer: `Usually it completes in seconds with minimal waiting. It's ideal for handling both quick edits and batch workflows.`,
                },
                {
                    question: 'Will it affect resolution or quality?',
                    answer: 'No. The tool preserves resolution, clarity, and details during expansion—safe for personal and professional use.',
                },
                {
                    question: 'Will my uploaded image stay private?',
                    answer: 'Yes. We protect your data with industry-standard security and strict privacy practices to ensure your images are not shared with third parties.',
                },
                {
                    question: 'What image formats are supported?',
                    answer: 'JPG, PNG, WebP and other common formats are supported. Max file size is 10MB—no conversion needed.',
                },
            ],
            feature_title1: 'Recover missing details and background',
            feature_desc1: 'If your photo was cropped, intelligently fill missing details to make the frame complete. The tool supports outpainting to restore missing elements in old photos and bring back meaningful memories.',
            feature_title2: 'Improve product photos to boost sales',
            feature_desc2: 'Expand the area around product images to add complementary background elements. You can also create wider compositions to showcase more product details and increase conversions.',
            feature_title3: 'Create unique visual masterpieces',
            feature_desc3: `Whether you're a photographer, content creator, or artist, expand beyond the edges to push creative boundaries and turn your ideas into stunning visuals.`,
            feature_title4: 'Optimize aspect ratios for social media',
            feature_desc4: 'Expand images to fit any ratio for Instagram, X (formerly Twitter), Facebook, and more. The AI keeps details sharp so the final result remains eye-catching.',
            textRemoverHowToUseTitle: 'How to use our AI Image Extender',
            textRemoverHowToUseDesc: '3 simple steps to expand your photo beyond its borders',
            textRemoverHowToUseStep1Title: 'Upload an image',
            textRemoverHowToUseStep1Desc: 'Click or drag and drop the image you want to expand.',
            textRemoverHowToUseStep2Title: 'AI auto-processes',
            textRemoverHowToUseStep2Desc: 'After upload, the AI will automatically detect and extend the image borders.',
            textRemoverHowToUseStep3Title: 'Download the expanded image',
            textRemoverHowToUseStep3Desc: 'When it’s ready, preview and download your expanded image!',
        },
        photoRestoration: {
            title: 'Free AI Photo Restoration - Colorize B&W Photos & Repair Scratches',
            description: `Revive old family memories with 微鲤AI's Free AI Photo Restoration. Automatically colorize black and white photos, remove scratches, rips, and blur to restore faces instantly.`,
            keywords: 'old photo restoration, colorize photos, fix scratched photos, ai photo repair, restore old pictures, black and white to color, image restoration ai',
            og_title: 'Free AI Photo Restoration - Colorize B&W Photos & Repair Scratches',
            og_description: `Revive old family memories with 微鲤AI's Free AI Photo Restoration. Automatically colorize black and white photos, remove scratches, rips, and blur to restore faces instantly.`,
            twitter_title: 'Free AI Photo Restoration - Colorize B&W Photos & Repair Scratches',
            twitter_description: `Revive old family memories with 微鲤AI's Free AI Photo Restoration. Automatically colorize black and white photos, remove scratches, rips, and blur to restore faces instantly.`,
            page: {
                title1: 'Free AI Old Photo Restoration & Colorizer',
                title2: `Bring your history back to life. Whether it's a faded black-and-white wedding photo or a scratched childhood portrait, our AI analyzes and restores damaged areas, sharpens faces, and intelligently adds realistic colors in seconds.`,
                faq: [
                    {
                        question: 'How do I colorize a black and white photo?',
                        answer: `Simply upload your B&W image to 微鲤AI. The tool automatically detects it's grayscale and applies the "Colorize" feature to add realistic colors instantly.`,
                    },
                    {
                        question: 'Can it fix torn or scratched photos?',
                        answer: 'Yes. Our AI is trained to recognize scratches, tears, and creases. It fills these damaged areas with pixels that match the surrounding texture.',
                    },
                    {
                        question: 'Will the restored photo look fake?',
                        answer: `Our goal is realism. While face enhancement adds details, we strive to keep the person's identity recognizable. For colorization, the AI chooses natural tones suitable for the era.`,
                    },
                    {
                        question: 'What if the photo is very small?',
                        answer: 'No problem. The restoration process also includes Upscaling, which increases the resolution of small wallet-sized photos for digital viewing or printing.',
                    },
                    {
                        question: 'Is my privacy protected?',
                        answer: 'Yes. We understand old photos are personal. Your images are processed securely and are not stored permanently on our servers.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I colorize a black and white photo?',
                    answer: `Simply upload your B&W image to 微鲤AI. The tool automatically detects it's grayscale and applies the "Colorize" feature to add realistic colors instantly.`,
                },
                {
                    question: 'Can it fix torn or scratched photos?',
                    answer: 'Yes. Our AI is trained to recognize scratches, tears, and creases. It fills these damaged areas with pixels that match the surrounding texture.',
                },
                {
                    question: 'Will the restored photo look fake?',
                    answer: `Our goal is realism. While face enhancement adds details, we strive to keep the person's identity recognizable. For colorization, the AI chooses natural tones suitable for the era.`,
                },
            ],
            feature_title1: 'Scratch & Tear Removal',
            feature_desc1: `Erase Time's Marks: Automatically detect and fill creases, scratches, rips, and dust spots. Our AI reconstructs missing facial details to make the photo look new again.`,
            feature_title2: 'Intelligent Colorization',
            feature_desc2: 'B&W to Color: Not just a sepia filter. Our Deep Learning model understands context (sky, skin, fabric) to add historically accurate and vibrant colors to black-and-white photos.',
            feature_title3: 'Face Enhancement',
            feature_desc3: 'Unblur Faces: Old photos often suffer from motion blur or low focus. 微鲤AI sharpens facial features (eyes, nose, mouth) to reveal the true likeness of your ancestors.',
        },
        photoEffects: {
            title: 'Photo Effects - AI Image Effects Generator | 微鲤AI',
            description: 'Transform your photos with AI-powered effects. Create stunning image filters, styles and transformations online for free.',
            keywords: 'AI photo effects, image effects, photo filter, AI image transformation, image style transfer',
        },
    },
    zh: {
        textToImage: {
            title: '文生图 - 免费 AI 文本生成图片工具 | 微鲤AI',
            description: '输入提示词即可生成写实照片、插画与多种艺术风格图像，支持常用画幅比例与多分辨率导出，一键出图；适用于电商主图、海报设计、社媒配图与创意素材制作，支持批量生成与高清下载，并可快速迭代多种风格方案，立即免费试用。',
            keywords: '文生图, 文本生成图片, 文本转图像, AI图像生成, AI绘画, 海报设计, 电商主图, 社媒配图, 高清下载, 微鲤AI',
            og_title: '文生图 - 免费 AI 文本生成图片工具 | 微鲤AI',
            og_description: '输入提示词即可生成写实照片、插画与多种艺术风格图像，支持常用画幅比例与多分辨率导出，一键出图；适用于电商主图、海报设计、社媒配图与创意素材制作，支持批量生成与高清下载，并可快速迭代多种风格方案，立即免费试用。',
            twitter_title: '文生图 - 免费 AI 文本生成图片工具 | 微鲤AI',
            twitter_description: '输入提示词即可生成写实照片、插画与多种艺术风格图像，支持常用画幅比例与多分辨率导出，一键出图；适用于电商主图、海报设计、社媒配图与创意素材制作，支持批量生成与高清下载，并可快速迭代多种风格方案，立即免费试用。',
            faq: [
                {
                    question: '如何生成 4K AI 图片？',
                    answer: '只需输入您的提示词，在左侧面板的图像尺寸设置中选择"4K"，然后点击创建即可。',
                },
                {
                    question: '支持哪些宽高比？',
                    answer: '我们支持所有主流宽高比，包括 1:1、9:16（移动端）、16:9（桌面端）、4:3 和 3:2，以适应任何平台。',
                },
                {
                    question: '我可以将图片用于商业用途吗？',
                    answer: '可以。在微鲤AI计划上生成的图片通常附带商业许可证，适用于广告和商品。',
                },
            ],
            page: {
                title1: '免费 AI 文本生成图片工具',
                title2: '几秒钟内创建令人惊叹的艺术作品、逼真的图片和独特的壁纸。只需描述您想要看到的内容，即可生成高质量图片，支持 1K/2K/4K 分辨率与常用宽高比，适配社媒、电商与设计场景。',
                resolution: '不要再满足于模糊的 AI 图片。微鲤AI 让您直接生成清晰锐利的 1K、2K 和 4K 图片，非常适合打印或高分辨率显示。',
                aspectRatio: '无论您需要 9:16 的 TikTok 背景图片、16:9 的 YouTube 缩略图，还是 1:1 的 Instagram 图片，我们都有适合每个社交平台的预设。',
                online_search: '需要最新的上下文？启用"在线搜索"功能，让 AI 浏览网络，更好地理解您提示中的当前事件或特定引用。',
                faq: [
                    {
                        question: '如何从文本生成高质量图片？',
                        answer: '输入详细描述主题、光线和风格的提示词。在图片尺寸设置中选择"4K"以获得最清晰的细节。',
                    },
                    {
                        question: '平台的高质量图像模型有什么特点？',
                        answer: '我们提供多种高质量图像模型，优化提示词理解与细节表现，可在写实、插画等风格间选择；并支持高分辨率与多种画幅比例，便于快速迭代出图。',
                    },
                    {
                        question: '我可以将图片用于商业用途吗？',
                        answer: '可以。在微鲤AI（付费计划）上生成的图片附带商业许可证，允许您将其用于广告、网站和商品。',
                    },
                    {
                        question: '我可以一次生成多少张图片？',
                        answer: '您可以同时生成最多 4 张图片（如"输出图片数量"设置中所示），让您能够快速迭代想法。',
                    },
                    {
                        question: '它是免费的吗？',
                        answer: '是的，您可以使用我们的免费每日积分生成图片。更高分辨率（4K）可能需要更多积分。',
                    },
                ],
            },
        },
        imageToImage: {
            title: '免费 AI 图生图生成器 - 将照片转换为艺术 & 4K | 微鲤AI',
            description: '上传参考图片即可进行图生图创作：在保留原始构图与主体结构的前提下，改变风格、生成变体或把草图提升为更精细的画面。支持多分辨率与常用画幅比例，适用于设计迭代、产品素材与社媒内容制作；支持批量生成与高清下载，立即免费试用。',
            keywords: '图生图 ai, img2img, 照片转绘画, ai 图片变体, 素描转图片, 照片混音 ai, 免费 ai 艺术生成器',
            og_title: '免费 AI 图生图生成器 - 将照片转换为艺术 & 4K | 微鲤AI',
            og_description: '上传参考图片即可进行图生图创作：在保留原始构图与主体结构的前提下，改变风格、生成变体或把草图提升为更精细的画面。支持多分辨率与常用画幅比例，适用于设计迭代、产品素材与社媒内容制作；支持批量生成与高清下载，立即免费试用。',
            twitter_title: '免费 AI 图生图生成器 - 将照片转换为艺术 & 4K | 微鲤AI',
            twitter_description: '上传参考图片即可进行图生图创作：在保留原始构图与主体结构的前提下，改变风格、生成变体或把草图提升为更精细的画面。支持多分辨率与常用画幅比例，适用于设计迭代、产品素材与社媒内容制作；支持批量生成与高清下载，立即免费试用。',
            faq: [
                {
                    question: '什么是图生图 AI？',
                    answer: '图生图（Img2Img）使用上传的图片作为参考，结合文本提示生成新图片，将视觉输入与创意描述融合。',
                },
                {
                    question: '如何将素描转换为逼真照片？',
                    answer: '上传您的素描，输入描述场景的提示（例如，"逼真建筑"），然后点击创建。',
                },
                {
                    question: '它会保留原始人脸吗？',
                    answer: '它会保留结构和姿势。如需精确保留人脸身份，请使用我们的照片换脸工具。',
                },
            ],
            page: {
                title1: '免费 AI 图生图生成器',
                title2: '使用您现有的图片作为蓝图。上传照片、素描或布局，让我们的 AI 根据您的文本提示以全新风格重新生成。完美保留构图的同时探索无限艺术变体。',
                title3: '使用 AI 风格转换转换您的照片',
                title4: '为什么使用图生图（Img2Img）？',
                upload_image: '难以用文字描述姿势或布局？只需上传参考图片。我们的 Img2Img 引擎保留原始照片的结构，但重新绘制细节。',
                resolution: '将粗略涂鸦或线框在几秒钟内转换为逼真渲染或高质量插图。适合设计师和建筑师。',
                output: '生成可用于生产的资源。与其他输出小图片的工具不同，微鲤AI 支持 1K、2K 和 4K 分辨率，提供清晰细节。',
                faq: [
                    {
                        question: '什么是图生图 AI？',
                        answer: '图生图（Img2Img）是一种技术，使用上传的图片作为"参考"，结合文本提示生成新图片。它将您的视觉输入与创意描述融合。',
                    },
                    {
                        question: '如何将素描转换为逼真照片？',
                        answer: '将您的素描上传到"图片"区域。在"提示"框中，描述素描代表的内容（例如，"现代别墅，日落，逼真，8k"）。点击创建查看效果。',
                    },
                    {
                        question: '它会保留原始人脸/人物吗？',
                        answer: '它会尝试保留一般结构和姿势。但是，如需精确保留人脸，我们建议使用我们专门的"照片换脸"工具。',
                    },
                    {
                        question: '支持哪些宽高比？',
                        answer: '我们支持多种比例，包括 9:16（故事）、16:9（电影）、3:4 和 1:1，确保您生成的艺术作品完美适配任何平台。',
                    },
                    {
                        question: '是免费的吗？',
                        answer: '是的，您可以使用每日积分免费生成变体。',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: '免费 AI 图像扩展器和尺寸调整器 - 取消裁剪和扩展照片',
            description: '为 Instagram、TikTok 和 YouTube 调整图像尺寸而无需裁剪。微鲤AI 的 AI 图像扩展器使用生成填充（扩展）智能扩展图像背景。无缝更改宽高比。',
            keywords: 'ai图像扩展器, 取消裁剪图像, ai扩展, 图像尺寸调整ai, 扩展图像背景, 在线生成填充, 制作垂直照片',
            og_title: '免费 AI 图像扩展器和尺寸调整器 - 取消裁剪和扩展照片',
            og_description: '为 Instagram、TikTok 和 YouTube 调整图像尺寸而无需裁剪。微鲤AI 的 AI 图像扩展器使用生成填充（扩展）智能扩展图像背景。无缝更改宽高比。',
            twitter_title: '免费 AI 图像扩展器和尺寸调整器 - 取消裁剪和扩展照片',
            twitter_description: '为 Instagram、TikTok 和 YouTube 调整图像尺寸而无需裁剪。微鲤AI 的 AI 图像扩展器使用生成填充（扩展）智能扩展图像背景。无缝更改宽高比。',
            page: {
                title1: '免费 AI 图像扩展器和尺寸调整器',
                title2: '停止裁剪您喜爱的照片以适应社交媒体。无论您需要将横向照片转换为垂直故事，还是将方形图像扩展为 16:9，我们的 AI 图像扩展器都能神奇地生成新的背景细节（扩展）以完美适配任何宽高比。',
                faq: [
                    {
                        question: '如何在不裁剪的情况下调整图像尺寸？',
                        answer: '使用 微鲤AI 的 AI 图像扩展器。上传您的照片，选择目标宽高比（例如 9:16），AI 将自动生成（扩展）缺失的背景区域，而不是裁剪您的图像。',
                    },
                    {
                        question: '什么是 AI 扩展？',
                        answer: '扩展是一种生成式 AI 技术，通过预测和绘制与原始风格匹配的新内容来扩展图像的边界，有效地"取消裁剪"照片。',
                    },
                    {
                        question: '我可以将横向照片转换为纵向照片吗？',
                        answer: '可以！只需上传您的横向（风景）照片并选择 9:16 比例。AI 将扩展图像的顶部和底部以填充纵向框架。',
                    },
                    {
                        question: '扩展的背景看起来会假吗？',
                        answer: '微鲤AI 使用在大型数据集上训练的高级生成模型，确保扩展的背景与原始光照和纹理自然融合。',
                    },
                    {
                        question: '它是免费使用的吗？',
                        answer: '是的，用户可以获得免费积分来试用 AI 智能调整大小和扩展功能。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何在不裁剪的情况下调整图像尺寸？',
                    answer: '使用 微鲤AI 的 AI 图像扩展器。上传您的照片，选择目标宽高比（例如 9:16），AI 将自动生成（扩展）缺失的背景区域，而不是裁剪您的图像。',
                },
                {
                    question: '什么是 AI 扩展？',
                    answer: '扩展是一种生成式 AI 技术，通过预测和绘制与原始风格匹配的新内容来扩展图像的边界，有效地"取消裁剪"照片。',
                },
                {
                    question: '我可以将横向照片转换为纵向照片吗？',
                    answer: '可以！只需上传您的横向（风景）照片并选择 9:16 比例。AI 将扩展图像的顶部和底部以填充纵向框架。',
                },
                {
                    question: '扩展的背景看起来会假吗？',
                    answer: '微鲤AI 使用在大型数据集上训练的高级生成模型，确保扩展的背景与原始光照和纹理自然融合。',
                },
                {
                    question: '它是免费使用的吗？',
                    answer: '是的，用户可以获得免费积分来试用 AI 智能调整大小和扩展功能。',
                },
            ],
            feature_title1: '智能背景扩展',
            feature_desc1: '魔法扩展：AI 理解您图像的上下文，并在原始边界之外绘制新像素。无缝扩展风景、房间或纹理以填充画面。',
            feature_title2: '中心保护',
            feature_desc2: '永不裁剪主体：我们的 AI 自动识别主要人物或物体并将其锁定在中心，确保在调整大小过程中永远不会被裁剪。',
            feature_title3: '社交媒体就绪',
            feature_desc3: '一键预设 Instagram Stories (9:16)、YouTube 缩略图 (16:9) 和帖子 (4:5)。立即在所有平台上重新利用您的内容。',
        },
        imageTextTranslate: {
            title: '免费 AI 图片翻译器 - 翻译照片、漫画和漫画中的文字',
            description: '在保留原始视觉风格的同时即时翻译图片中的文字。微鲤AI 的 AI 图片翻译器自动擦除原始文字并重新绘制翻译。完美适用于漫画、日漫和营销海报。',
            keywords: 'ai图片翻译器, 翻译图片中的文字, 图片翻译器, 漫画翻译器, 翻译漫画, ocr翻译器, 图片文字替换',
            og_title: '免费 AI 图片翻译器 - 翻译照片、漫画和漫画中的文字',
            og_description: '在保留原始视觉风格的同时即时翻译图片中的文字。微鲤AI 的 AI 图片翻译器自动擦除原始文字并重新绘制翻译。完美适用于漫画、日漫和营销海报。',
            twitter_title: '免费 AI 图片翻译器 - 翻译照片、漫画和漫画中的文字',
            twitter_description: '在保留原始视觉风格的同时即时翻译图片中的文字。微鲤AI 的 AI 图片翻译器自动擦除原始文字并重新绘制翻译。完美适用于漫画、日漫和营销海报。',
            page: {
                title1: '免费 AI 图片翻译器和文字替换器',
                title2: '在几秒钟内翻译海报、菜单、漫画和截图。与仅覆盖文字的标准翻译器不同，微鲤AI 使用生成式 AI 擦除原始文字并重新绘制背景，使翻译后的文字看起来像是原始设计的一部分。',
                faq: [
                    {
                        question: '如何翻译图片中的文字？',
                        answer: '将您的图片（JPG、PNG）上传到 微鲤AI。选择源语言（或使用自动检测）和目标语言。点击"创建"让 AI 替换文字。',
                    },
                    {
                        question: '翻译后的文字看起来自然吗？',
                        answer: '是的。微鲤AI 会尝试匹配原始文字的字体大小和样式。重要的是，它会重新绘制文字后面的背景，使翻译无缝融合。',
                    },
                    {
                        question: '我可以用这个来翻译漫画或韩漫吗？',
                        answer: '当然可以。这是最佳用例之一。AI 会检测对话气泡和垂直文字（日语中常见），并用水平翻译文字替换它们。',
                    },
                    {
                        question: '支持哪些语言？',
                        answer: '我们支持主要全球语言之间的翻译，包括英语、西班牙语、中文、日语、韩语、法语、德语等。',
                    },
                    {
                        question: '它适用于手写文字吗？',
                        answer: '它最适合印刷文字，但我们的高级 OCR 引擎可以识别白板或笔记上清晰的手写文字。',
                    },
                    {
                        question: '是免费的吗？',
                        answer: '您可以使用每日积分免费翻译图片。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何翻译图片中的文字？',
                    answer: '将您的图片上传到 微鲤AI。选择目标语言并点击"创建"。AI 将用翻译替换原始文字。',
                },
                {
                    question: '翻译后的文字看起来自然吗？',
                    answer: '是的。微鲤AI 会重新绘制文字后面的背景，并尝试匹配字体样式，确保翻译无缝融合。',
                },
                {
                    question: '我可以用这个来翻译漫画或韩漫吗？',
                    answer: '当然可以。这是最佳用例之一。AI 会检测对话气泡和垂直文字（日语中常见），并用水平翻译文字替换它们。',
                },
            ],
            feature_title1: '智能修复和重绘',
            feature_desc1: '无缝文字替换：我们的 AI 分析文字后面的背景纹理。它擦除原始文字并智能填充空白，然后添加翻译，确保没有难看的文本框覆盖您的图片。',
            feature_title2: '漫画和漫画翻译',
            feature_desc2: '即时阅读原始漫画：完美适用于动漫爱好者。上传原始漫画页面（日语/韩语），即可获得完美适配对话气泡的即时英语翻译。',
            feature_title3: '全球营销本地化',
            feature_desc3: '一键本地化：正在全球发布产品？将您的营销海报、横幅和 UI 截图翻译成 30+ 种语言，无需原始 PSD 文件。',
        },
        aiBackgroundChanger: {
            title: '免费 AI 背景更换器 - 文字生成并替换照片背景',
            description: '使用 AI 一键更换照片背景。描述你想要的场景，微鲤AI 将为产品摄影、LinkedIn 头像和创意人像生成逼真背景。免费在线使用。',
            keywords: '更换照片背景, AI 背景生成器, 产品摄影 AI, 纯白背景制作, 在线替换背景, 生成式填充背景',
            og_title: '免费 AI 背景更换器 - 文字生成并替换照片背景',
            og_description: '使用 AI 一键更换照片背景。描述你想要的场景，微鲤AI 将为产品摄影、LinkedIn 头像和创意人像生成逼真背景。免费在线使用。',
            twitter_title: '免费 AI 背景更换器 - 文字生成并替换照片背景',
            twitter_description: '使用 AI 一键更换照片背景。描述你想要的场景，微鲤AI 将为产品摄影、LinkedIn 头像和创意人像生成逼真背景。免费在线使用。',
            page: {
                title1: '免费 AI 背景更换器与生成器',
                title2: '别只“去背景”——把背景换成更好的。上传你的照片并描述任意场景（例如“奢华大理石影棚”“办公楼天际线”）。我们的生成式 AI 理解光线与透视，让主体自然融入新环境。',
                faq: [
                    {
                        question: '如何用文字更换背景？',
                        answer: '上传图片，在“背景提示词”输入框里描述你想要的场景（例如“温馨的咖啡店”）。点击创建，AI 就会为你生成对应背景。',
                    },
                    {
                        question: '可以换成纯白背景吗？',
                        answer: '可以。在提示词里输入“纯白背景”或“影棚白”。非常适合 Amazon/eBay 产品图和证件照。',
                    },
                    {
                        question: '适合做产品摄影吗？',
                        answer: '当然。微鲤AI 会分析产品角度，并生成带有正确阴影与光照的背景，让效果像专业影棚拍摄。',
                    },
                    {
                        question: '光照会自然吗？',
                        answer: '我们的生成式 AI（类似 Adobe Firefly 或 SDXL）会尽量匹配背景与主体的光线，让融合更自然。',
                    },
                    {
                        question: '免费吗？',
                        answer: '是的，你可以使用每日赠送的积分免费生成新背景。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何用文字更换背景？',
                    answer: '上传图片，在“背景提示词”输入框里描述你想要的场景（例如“温馨的咖啡店”）。点击创建，AI 就会为你生成对应背景。',
                },
                {
                    question: '可以换成纯白背景吗？',
                    answer: '可以。在提示词里输入“纯白背景”或“影棚白”。非常适合 Amazon/eBay 产品图和证件照。',
                },
                {
                    question: '适合做产品摄影吗？',
                    answer: '当然。微鲤AI 会分析产品角度，并生成带有正确阴影与光照的背景，让效果像专业影棚拍摄。',
                },
                {
                    question: '光照会自然吗？',
                    answer: '我们的生成式 AI（类似 Adobe Firefly 或 SDXL）会尽量匹配背景与主体的光线，让融合更自然。',
                },
                {
                    question: '免费吗？',
                    answer: '是的，你可以使用每日赠送的积分免费生成新背景。',
                },
            ],
            feature_title1: '专业证件照与头像',
            feature_desc1: 'DIY LinkedIn 头像：把随手自拍变成专业头像。将杂乱的卧室背景瞬间换成干净的办公室或影棚灰背景。',
            feature_title2: '即时产品摄影',
            feature_desc2: '提升电商转化：省下昂贵的拍摄费用。用简单文字把产品放到木桌、沙滩或展示台上，AI 会自动补上真实阴影与反射。',
            feature_title3: '创意瞬移',
            feature_desc3: '想去巴黎或赛博朋克未来？直接打字。AI 在保持原图光线一致的同时替换背景。',
        },
        imageUpscaler: {
            title: '免费 AI 图像增强器 - 放大至 4K 并修复老照片',
            description: '使用 微鲤AI 的免费 AI 图像增强器，即时将低分辨率图像放大至 2 倍、4 倍和 4K。修复模糊照片、去除噪点，在线修复老照片。无损质量。',
            keywords: 'ai图像增强器, 照片增强器, 图像放大至4k, 图像去模糊, 老照片修复, 修复像素化照片, 提高图像分辨率',
            og_title: '免费 AI 图像增强器 - 放大至 4K 并修复老照片',
            og_description: '使用 微鲤AI 的免费 AI 图像增强器，即时将低分辨率图像放大至 2 倍、4 倍和 4K。修复模糊照片、去除噪点，在线修复老照片。无损质量。',
            twitter_title: '免费 AI 图像增强器 - 放大至 4K 并修复老照片',
            twitter_description: '使用 微鲤AI 的免费 AI 图像增强器，即时将低分辨率图像放大至 2 倍、4 倍和 4K。修复模糊照片、去除噪点，在线修复老照片。无损质量。',
            page: {
                title1: '免费 AI 图像增强器和放大器',
                title2: '将像素化、模糊或老照片转换为高清杰作。微鲤AI 使用先进的 AI 技术将图像分辨率提升高达 400%（4K），同时恢复丢失的细节、修复噪点并修复老家庭肖像中的人脸。',
                faq: [
                    {
                        question: '我可以放大低分辨率图像用于打印吗？',
                        answer: '可以！微鲤AI 可以将图像的分辨率（像素数）提升至 4K，使其适合在海报、画布或营销材料上进行高质量打印。',
                    },
                    {
                        question: 'AI 老照片修复是如何工作的？',
                        answer: 'AI 会分析老照片中受损或模糊的部分，使用深度学习来预测和重建面部细节、纹理和背景，有效地"修复"图像。',
                    },
                    {
                        question: '支持哪些格式？',
                        answer: '我们支持常见格式，如 JPG、PNG 和 WEBP。输出将是高质量的 PNG 或 JPG。',
                    },
                    {
                        question: '它适用于动漫/卡通吗？',
                        answer: '是的。我们的 AI 擅长放大动漫和插画（waifu2x 风格），保持线条清晰、色彩鲜艳，无伪影。',
                    },
                    {
                        question: '它是免费的吗？',
                        answer: '是的，您可以使用每日积分免费增强图像。',
                    },
                ],
            },
            faq: [
                {
                    question: '我可以放大低分辨率图像用于打印吗？',
                    answer: '可以！微鲤AI 可以将分辨率提升至 4K，使图像适合高质量打印。',
                },
                {
                    question: 'AI 老照片修复是如何工作的？',
                    answer: 'AI 会分析受损区域，使用深度学习重建面部细节和纹理，以修复图像。',
                },
                {
                    question: '它适用于动漫吗？',
                    answer: '是的。我们的 AI 擅长放大动漫和插画，保持线条清晰，无伪影。',
                },
            ],
            feature_title1: '无损放大至 4K',
            feature_desc1: '打印就绪质量：需要打印小图像吗？将其放大至 4K 或 8K 而不损失质量。非常适合海报、电商产品照片和壁纸。',
            feature_title2: '智能降噪和去模糊',
            feature_desc2: '修复夜景照片：去除低光照片中的数字噪点和颗粒。即时锐化模糊边缘，让您的照片看起来清晰专业。',
            feature_title3: '老照片修复',
            feature_desc3: '重拾回忆：有老旧、受损或黑白照片吗？我们的 AI 创建新像素来修复划痕、锐化人脸，并为您珍贵的回忆带来清晰度。',
        },
        photoFaceSwap: {
            title: '免费 AI 图片换脸 - 真实自然的在线人脸替换',
            description: '使用 微鲤AI 的免费 AI 换脸工具，瞬间在照片中交换人脸。轻松做搞笑表情包、艺术肖像（如蒙娜丽莎），或高真实感的职业头像。100% 隐私安全。',
            keywords: '图片换脸, 在线换脸, 照片换脸, 人脸替换, AI 换脸, deepfake 照片, meme 生成',
            og_title: '免费 AI 图片换脸 - 真实自然的在线人脸替换',
            og_description: '使用 微鲤AI 的免费 AI 换脸工具，瞬间在照片中交换人脸。轻松做搞笑表情包、艺术肖像（如蒙娜丽莎），或高真实感的职业头像。100% 隐私安全。',
            twitter_title: '免费 AI 图片换脸 - 真实自然的在线人脸替换',
            twitter_description: '使用 微鲤AI 的免费 AI 换脸工具，瞬间在照片中交换人脸。轻松做搞笑表情包、艺术肖像（如蒙娜丽莎），或高真实感的职业头像。100% 隐私安全。',
            page: {
                title1: '免费 AI 图片换脸',
                title2: '想把自己变成宇航员、电影明星，或出现在经典名画里吗？上传一张底图和一张人脸图，我们的 AI 会在几秒钟内无缝融合五官、光线和肤色，生成超真实的换脸效果。',
                faq: [
                    {
                        question: '微鲤AI 换脸可以免费使用吗？',
                        answer: '可以。我们提供每日免费积分，让你在线换脸，无需安装，也不需要信用卡。',
                    },
                    {
                        question: '我的数据安全吗？',
                        answer: '当然安全。我们非常重视隐私。你上传的照片只用于换脸处理，并会在短时间后自动从服务器删除。',
                    },
                    {
                        question: '如何获得最好的换脸效果？',
                        answer: '为了更真实，请确保“底图”和“人脸图”都清晰、正面且光线充足。避免脸部被头发或手遮挡的照片。',
                    },
                    {
                        question: '可以在多人合照里换脸吗？',
                        answer: '目前我们的工具更专注于单人脸的高精度换脸。多人合照建议先裁剪，或等待我们即将推出的多人脸功能。',
                    },
                    {
                        question: '可以用来做表情包吗？',
                        answer: '当然可以！非常适合做搞笑表情包。把朋友的脸换到电影海报或热门梗图模板上，立刻出图。',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI 换脸可以免费使用吗？',
                    answer: '可以。我们提供每日免费积分，让你在线换脸，无需安装，也不需要信用卡。',
                },
                {
                    question: '我的数据安全吗？',
                    answer: '当然安全。我们非常重视隐私。你上传的照片只用于换脸处理，并会在短时间后自动从服务器删除。',
                },
                {
                    question: '如何获得最好的换脸效果？',
                    answer: '请确保两张照片清晰、正面且光线良好；尽量避免头发或眼镜遮挡面部。',
                },
            ],
            feature_title1: '艺术名作体验',
            feature_desc1: '穿越时空：把你的脸换进《蒙娜丽莎》或《戴珍珠耳环的少女》等经典油画中，瞬间生成独特的复古头像。',
            feature_title2: '职业与酷炫头像',
            feature_desc2: '梦想职业：无需购买服装，就能看到自己穿着赛车服、宇航服或商务正装的样子，轻松做出更吸睛的头像。',
            feature_title3: '超真实自然融合',
            feature_desc3: '不再是“贴上去”的效果：不同于简单抠图粘贴，微鲤AI 会分析角度、光线和皮肤纹理，让换脸看起来 100% 自然不假。',
        },
        removeTextFromImage: {
            title: '免费 AI 图片去文字 - 去水印与日期水印',
            description: '使用 微鲤AI 的免费 AI 文本橡皮擦，瞬间移除图片中的文字、日期水印、Logo 和字幕。通过 AI 修复（Inpainting）完美还原背景，适合清理照片与电商素材图。',
            keywords: '图片去文字, ai 文本删除, 去日期水印, 在线去水印, 清理图片, ai 修复, 去除图片logo',
            og_title: '免费 AI 图片去文字 - 去水印与日期水印',
            og_description: '使用 微鲤AI 的免费 AI 文本橡皮擦，瞬间移除图片中的文字、日期水印、Logo 和字幕。通过 AI 修复（Inpainting）完美还原背景，适合清理照片与电商素材图。',
            twitter_title: '免费 AI 图片去文字 - 去水印与日期水印',
            twitter_description: '使用 微鲤AI 的免费 AI 文本橡皮擦，瞬间移除图片中的文字、日期水印、Logo 和字幕。通过 AI 修复（Inpainting）完美还原背景，适合清理照片与电商素材图。',
            page: {
                title1: '免费 AI 图片去文字工具',
                title2: '被多余文字干扰了吗？只需上传图片，我们的 AI 就会自动识别并立刻擦除文字、Logo、日期水印或字幕。它会智能分析周围像素来重建背景，不留任何痕迹。',
                faq: [
                    {
                        question: '如何不糊图地去掉图片上的文字？',
                        answer: '使用 微鲤AI 的 AI 文本橡皮擦。它不会用模糊遮盖，而是用 AI 修复（Inpainting）分析周围内容并生成新像素来无缝填补空白。',
                    },
                    {
                        question: '可以去除照片上的日期水印吗？',
                        answer: '可以！这是最常见的使用场景之一。AI 能识别日期/时间水印的数字字体，并在还原背景风景的同时将其移除。',
                    },
                    {
                        question: '复杂背景也能去掉吗？',
                        answer: '可以。就像示例展示的那样，它能理解纹理走向，即使在山脉或花纹衣物等复杂背景上也能去除文字。',
                    },
                    {
                        question: '能用来去掉人物或小物体吗？',
                        answer: '虽然工具主要针对文字，但底层的修复技术（Inpainting）也适合移除小型杂物、皮肤瑕疵或不想要的物体。',
                    },
                    {
                        question: '免费吗？',
                        answer: '是的，你可以使用每日赠送的积分免费使用该工具。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何不糊图地去掉图片上的文字？',
                    answer: '使用 微鲤AI 的 AI 文本橡皮擦。它不会用模糊遮盖，而是用 AI 修复（Inpainting）分析周围内容并生成新像素来无缝填补空白。',
                },
                {
                    question: '可以去除照片上的日期水印吗？',
                    answer: '可以！AI 能识别日期/时间水印的数字字体，并在还原背景风景的同时将其移除。',
                },
                {
                    question: '复杂背景也能去掉吗？',
                    answer: '可以。它能理解纹理走向，即使在复杂背景上也能去除文字并还原自然效果。',
                },
            ],
            feature_title1: '服装与设计素材清理',
            feature_desc1: '适合做电商 Mockup：在二手服饰转卖或做商品图时，可去掉 T 恤模特图上的现有 Logo、标语或图案，为你的设计留出干净画面。',
            feature_title2: '回忆照片修复',
            feature_desc2: '去掉日期水印：无损去除老照片或旅行照上刺眼的橙色日期水印，不破坏原有风景细节。',
            feature_title3: '智能 AI 修复',
            feature_desc3: '无缝填充背景：不同于只会留模糊的普通橡皮擦，微鲤AI 用生成式 AI 在擦除区域“补画”草地、天空、山脉等真实纹理。',
        },
        imgExtender: {
            title: '立即免费扩展图像 - AI 图像扩展器 | 微鲤AI',
            description: '使用 微鲤AI 的免费 AI 图像扩展器，立即突破照片原始边界进行扩展。我们的 AI 图像扩展工具能生成与上传图像完美融合的新像素，让您将人像转化为广角照片，同时保留原始外观与画质。',
            keywords: 'AI图像扩展器, 免费图像扩展, 广角照片生成, 突破照片边界, 无缝融合, 保留原始画质',
            og_title: '立即免费扩展图像 - AI 图像扩展器 | 微鲤AI',
            og_description: '使用我们的 AI 图像扩展器将您的照片扩展至新尺寸并生成其他合适的内容。立即免费试用我们的 AI 图像扩展器。',
            twitter_title: '立即免费扩展图像 - AI 图像扩展器 | 微鲤AI',
            twitter_description: '使用我们的 AI 图像扩展器将您的照片扩展至新尺寸并生成其他合适的内容。立即免费试用我们的 AI 图像扩展器。',
            featureList: [
                'AI图像扩展器, 免费图像扩展, 广角照片生成, 保留原始画质',
            ],
            page: {
                title1: '强大的AI图像扩展器，呈现惊艳效果',
                title2: '只需简单点击，即可轻松突破照片原始边界进行扩展。我们的AI图像扩展工具能生成与上传图像完美融合的新像素，让您将人像转化为广角照片，同时保留原始外观与画质。',
                feature_title: 'WeryAI图像扩展器特色之处',
                faq: [
                    {
                        question: '什么是AI图像扩展器？',
                        answer: '基于先进AI算法，此工具可通过智能填充缺失内容扩展图像边界，生成更大尺寸版本，适用于营销、电商、社交媒体发布等多种场景',
                    },
                    {
                        question: '为什么要使用我们的 AI 图像扩展器？',
                        answer: 'WeryAI采用最顶尖的AI算法智能分析图像特征，无缝填充周边区域并保持自然高清效果。',
                    },
                    {
                        question: '我们的 AI 图像扩展器免费吗？',
                        answer: '是的。您可以通过试用积分免费使用我们的 AI 图像扩展器。这使其成为一款经济高效的工具，任何预算有限的用户都可以将其添加到他们的图像编辑工作流程中。',
                    },
                    {
                        question: '我们的 AI 图像扩展器处理照片的速度有多快？',
                        answer: '通常数秒内完成扩展，无延迟或错误。这使得我们的 AI 扩展图像工具非常适合帮助您处理各种批量图像编辑任务。',
                    },
                    {
                        question: 'AI图像扩展器会影响分辨率或质量吗？',
                        answer: '完全不会。工具在扩展过程中保持分辨率、清晰度与细节完整性，个人或专业用途皆可放心使用。',
                    },
                    {
                        question: '我上传的图片会保持私密吗？',
                        answer: '绝对安全！采用行业标准加密技术保障数据隐私，严格政策确保图像绝不外泄第三方，确保您的隐私安全。',
                    },
                    {
                        question: '我们的 AI 图像扩展器支持哪些图像格式？',
                        answer: '支持JPG、PNG、WebP等主流格式，单文件最大10MB，无需预先转换格式。',
                    },
                ],
            },
            faq: [
                {
                    question: '什么是AI图像扩展器？',
                    answer: '基于先进AI算法，此工具可通过智能填充缺失内容扩展图像边界，生成更大尺寸版本，适用于营销、电商、社交媒体发布等多种场景',
                },
                {
                    question: '为什么要使用我们的 AI 图像扩展器？',
                    answer: 'WeryAI采用最顶尖的AI算法智能分析图像特征，无缝填充周边区域并保持自然高清效果。',
                },
                {
                    question: '我们的 AI 图像扩展器免费吗？',
                    answer: '是的。您可以通过试用积分免费使用我们的 AI 图像扩展器。这使其成为一款经济高效的工具，任何预算有限的用户都可以将其添加到他们的图像编辑工作流程中。',
                },
                {
                    question: '我们的 AI 图像扩展器处理照片的速度有多快？',
                    answer: '通常数秒内完成扩展，无延迟或错误。这使得我们的 AI 扩展图像工具非常适合帮助您处理各种批量图像编辑任务。',
                },
                {
                    question: 'AI图像扩展器会影响分辨率或质量吗？',
                    answer: '完全不会。工具在扩展过程中保持分辨率、清晰度与细节完整性，个人或专业用途皆可放心使用。',
                },
                {
                    question: '我上传的图片会保持私密吗？',
                    answer: '绝对安全！采用行业标准加密技术保障数据隐私，严格政策确保图像绝不外泄第三方，确保您的隐私安全。',
                },
                {
                    question: '我们的 AI 图像扩展器支持哪些图像格式？',
                    answer: '支持JPG、PNG、WebP等主流格式，单文件最大10MB，无需预先转换格式。',
                },
            ],
            feature_title1: '修复缺失细节与背景',
            feature_desc1: '若您有裁剪过的图片，可通过智能填充缺失细节使画面更完整。工具支持外绘补全功能，甚至能还原老照片中缺失元素，增强画面纪念价值。',
            feature_title2: '提升产品图质量以促进销售',
            feature_desc2: '通过AI图像扩展工具扩展产品图周边区域，可添加互补性背景元素。您也可将产品图调整为更宽幅画面，更全面地展示产品细节，从而提升销量。',
            feature_title3: '创作独特视觉杰作',
            feature_desc3: '无论您是摄影师、内容创作者还是艺术家，都能通过AI图像扩展工具突破创意边界。扩展原始照片边缘，打造令人惊叹的视觉杰作，将您的构思提升至新高度。',
            feature_title4: '为社交媒体优化画面比例',
            feature_desc4: '我们的AI图像扩展工具可将图片扩展至适配Instagram、X（原Twitter）、Facebook等平台的任意比例。工具会智能保持图像清晰度与细节，确保最终效果依然吸睛。',
            textRemoverHowToUseTitle: '我们的AI图像扩展器如何使用',
            textRemoverHowToUseDesc: '简单三步，让您的照片突破边界',
            textRemoverHowToUseStep1Title: '上传图片',
            textRemoverHowToUseStep1Desc: '点击或拖拽一张您想要扩展的图片。',
            textRemoverHowToUseStep2Title: 'AI 自动处理',
            textRemoverHowToUseStep2Desc: '上传后，AI 将自动检测并扩展图片的边界。',
            textRemoverHowToUseStep3Title: '下载扩展后的图片',
            textRemoverHowToUseStep3Desc: '处理完成后，即可预览/下载一张扩展后的图片！',
        },
        photoRestoration: {
            title: '免费 AI 照片修复 - 黑白照片上色和修复划痕',
            description: '使用 微鲤AI 的免费 AI 照片修复功能，让旧家庭回忆重获新生。自动为黑白照片上色，去除划痕、撕裂和模糊，瞬间恢复人脸。',
            keywords: '老照片修复, 照片上色, 修复划痕照片, AI 照片修复, 恢复旧照片, 黑白转彩色, AI 图像修复',
            og_title: '免费 AI 照片修复 - 黑白照片上色和修复划痕',
            og_description: '使用 微鲤AI 的免费 AI 照片修复功能，让旧家庭回忆重获新生。自动为黑白照片上色，去除划痕、撕裂和模糊，瞬间恢复人脸。',
            twitter_title: '免费 AI 照片修复 - 黑白照片上色和修复划痕',
            twitter_description: '使用 微鲤AI 的免费 AI 照片修复功能，让旧家庭回忆重获新生。自动为黑白照片上色，去除划痕、撕裂和模糊，瞬间恢复人脸。',
            page: {
                title1: '免费 AI 老照片修复和上色工具',
                title2: '让您的历史重获新生。无论是褪色的黑白婚纱照还是划痕累累的童年肖像，我们的 AI 都能在几秒钟内分析并修复受损区域，锐化人脸，智能添加逼真的颜色。',
                faq: [
                    {
                        question: '如何为黑白照片上色？',
                        answer: '只需将您的黑白图像上传到 微鲤AI。工具会自动检测它是灰度图像，并应用"上色"功能，立即添加逼真的颜色。',
                    },
                    {
                        question: '可以修复撕裂或划痕的照片吗？',
                        answer: '可以。我们的 AI 经过训练，能够识别划痕、撕裂和折痕。它会用与周围纹理匹配的像素填充这些受损区域。',
                    },
                    {
                        question: '修复后的照片会看起来很假吗？',
                        answer: '我们的目标是真实感。虽然人脸增强会添加细节，但我们努力保持人物身份的可识别性。对于上色，AI 会选择适合该时代的自然色调。',
                    },
                    {
                        question: '如果照片非常小怎么办？',
                        answer: '没问题。修复过程还包括放大功能，可以提高小尺寸钱包照片的分辨率，用于数字查看或打印。',
                    },
                    {
                        question: '我的隐私是否受到保护？',
                        answer: '是的。我们理解旧照片是私人的。您的图像会被安全处理，不会永久存储在我们的服务器上。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何为黑白照片上色？',
                    answer: '只需将您的黑白图像上传到 微鲤AI。工具会自动检测它是灰度图像，并应用"上色"功能，立即添加逼真的颜色。',
                },
                {
                    question: '可以修复撕裂或划痕的照片吗？',
                    answer: '可以。我们的 AI 经过训练，能够识别划痕、撕裂和折痕。它会用与周围纹理匹配的像素填充这些受损区域。',
                },
                {
                    question: '修复后的照片会看起来很假吗？',
                    answer: '我们的目标是真实感。虽然人脸增强会添加细节，但我们努力保持人物身份的可识别性。对于上色，AI 会选择适合该时代的自然色调。',
                },
            ],
            feature_title1: '划痕和撕裂去除',
            feature_desc1: '擦除时间的痕迹：自动检测并填充折痕、划痕、撕裂和灰尘斑点。我们的 AI 重建缺失的面部细节，让照片看起来焕然一新。',
            feature_title2: '智能上色',
            feature_desc2: '黑白转彩色：不仅仅是棕褐色滤镜。我们的深度学习模型理解上下文（天空、皮肤、织物），为黑白照片添加历史上准确且生动的颜色。',
            feature_title3: '人脸增强',
            feature_desc3: '去模糊人脸：旧照片经常遭受运动模糊或低焦点问题。微鲤AI 锐化面部特征（眼睛、鼻子、嘴巴），揭示您祖先的真实面貌。',
        },
        photoEffects: {
            title: 'AI 图片特效 - AI 图片特效生成器 | 微鲤AI',
            description: '使用微鲤AI的图片特效模板一键生成新风格：动漫化、滤镜风格、艺术化与创意变换等快速出图。上传照片或选择模板，几步制作社媒爆款图片与头像素材，适用于节日营销与内容运营；支持高清下载与分享，立即免费试用。',
            keywords: 'AI 图片特效, 图像特效, 照片滤镜, AI 图像变换, 图像风格转换',
        },
    },
    ja: {
        textToImage: {
            title: 'テキストから画像生成 - 無料 AI 画像ジェネレーター | 微鲤AI',
            description: 'テキストプロンプトからAIで美しい画像を生成。写実的な画像、イラスト、アートスタイルなど多彩な表現に対応し、クリエイティブ制作やデザインプロジェクトに最適です。',
            keywords: 'テキストから画像, AI画像ジェネレーター, 画像生成, AI画像作成, テキストtoイメージ, AIイラスト',
            og_title: 'テキストから画像生成 - 無料 AI 画像ジェネレーター | 微鲤AI',
            og_description: 'WeryAIのテキストから画像生成ツールで、テキストプロンプトを美しいビジュアルに変換。高忠実度の結果を実現するNano Banana Proモデルを搭載。1K/2K/4K解像度と9:16/16:9アスペクト比をサポート。無料・オンライン。',
            twitter_title: 'テキストから画像生成 - 無料 AI 画像ジェネレーター | 微鲤AI',
            twitter_description: 'WeryAIのテキストから画像生成ツールで、テキストプロンプトを美しいビジュアルに変換。高忠実度の結果を実現するNano Banana Proモデルを搭載。1K/2K/4K解像度と9:16/16:9アスペクト比をサポート。無料・オンライン。',
            faq: [
                {
                    question: '4K AI画像を生成するにはどうすればよいですか？',
                    answer: 'プロンプトを入力し、左パネルの画像サイズ設定で「4K」を選択してから、作成をクリックするだけです。',
                },
                {
                    question: 'どのアスペクト比がサポートされていますか？',
                    answer: '1:1、9:16（モバイル）、16:9（デスクトップ）、4:3、3:2など、あらゆるプラットフォームに対応する主要な比率をサポートしています。',
                },
                {
                    question: '画像を商用利用できますか？',
                    answer: 'はい。WeryAIプランで生成された画像には、通常、広告や商品に適した商用ライセンスが付属しています。',
                },
            ],
            page: {
                title1: '無料 AI テキストから画像生成ツール',
                title2: '数秒で息を呑むようなアート、写実的な画像、ユニークな壁紙を作成。見たいものを説明するだけで、高度な Nano Banana Pro モデルがプロンプトに完璧に一致する高忠実度 4K 画像を生成します。',
                resolution: 'ぼやけた AI 画像に妥協するのはやめましょう。微鲤AI では、印刷や高解像度ディスプレイに最適な、鮮明な 1K、2K、4K 画像を直接生成できます。',
                aspectRatio: 'TikTok の背景用 9:16 画像、YouTube のサムネイル用 16:9、Instagram 用 1:1 など、あらゆるソーシャルプラットフォーム用のプリセットをご用意しています。',
                online_search: '最新のコンテキストが必要ですか？「オンライン検索」を有効にして、AI にウェブを閲覧させ、プロンプト内の最新イベントや特定の参照をより良く理解させることができます。',
                faq: [
                    {
                        question: 'テキストから高品質な画像を生成するにはどうすればよいですか？',
                        answer: '被写体、照明、スタイルを説明する詳細なプロンプトを入力します。最も鮮明なディテールを得るには、画像サイズ設定で「4K」を選択してください。',
                    },
                    {
                        question: 'Nano Banana Pro モデルとは何ですか？',
                        answer: 'Nano Banana Pro は、プロンプト遵守と写実性に最適化された、当社の最高忠実度モデルです。品質面では Midjourney v6 や Flux などのトップモデルに匹敵します。',
                    },
                    {
                        question: '画像を商用目的で使用できますか？',
                        answer: 'はい。微鲤AI（有料プラン）で生成された画像には商用ライセンスが付属しており、広告、ウェブサイト、商品に使用できます。',
                    },
                    {
                        question: '一度に何枚の画像を生成できますか？',
                        answer: '同時に最大 4 枚の画像を生成できます（「出力画像数」設定に示されている通り）。これにより、アイデアを迅速に反復できます。',
                    },
                    {
                        question: '無料ですか？',
                        answer: 'はい、無料の毎日のクレジットを使用して画像を生成できます。より高い解像度（4K）には、より多くのクレジットが必要な場合があります。',
                    },
                ],
            },
        },
        imageToImage: {
            title: '無料 AI 画像から画像生成器 - 写真をアート & 4K に変換 | 微鲤AI',
            description: '参考写真をアップロードし、WeryAIの画像から画像AIで変換します。スケッチをリアルなアートに変換し、スタイルを変更したり、元の構図を保ちながらバリエーションを生成します。4K解像度に対応。',
            keywords: '画像から画像 ai, img2img, 写真を絵画に変換, ai画像バリエーション, スケッチから画像, 写真リミックス ai, 無料 aiアート生成器',
            og_title: '無料 AI 画像から画像生成器 - 写真をアート & 4K に変換 | 微鲤AI',
            og_description: '参考写真をアップロードし、WeryAIの画像から画像AIで変換します。スケッチをリアルなアートに変換し、スタイルを変更したり、元の構図を保ちながらバリエーションを生成します。4K解像度に対応。',
            twitter_title: '無料 AI 画像から画像生成器 - 写真をアート & 4K に変換 | 微鲤AI',
            twitter_description: '参考写真をアップロードし、WeryAIの画像から画像AIで変換します。スケッチをリアルなアートに変換し、スタイルを変更したり、元の構図を保ちながらバリエーションを生成します。4K解像度に対応。',
            faq: [
                {
                    question: '画像から画像AIとは？',
                    answer: '画像から画像（Img2Img）は、アップロードした画像を参照として、テキストプロンプトと組み合わせて新しい画像を生成する技術です。視覚的な入力と創造的な説明を融合させます。',
                },
                {
                    question: 'スケッチをリアルな写真に変換するには？',
                    answer: 'スケッチをアップロードし、シーンを説明するプロンプトを入力します（例：「フォトリアルな建物」）。作成をクリックします。',
                },
                {
                    question: '元の顔は保持されますか？',
                    answer: '構造とポーズは保持されます。顔の同一性を正確に保持するには、写真顔スワップツールをご利用ください。',
                },
            ],
            page: {
                title1: '無料 AI 画像から画像生成器',
                title2: '既存の画像を青写真として使用します。写真、スケッチ、またはレイアウトをアップロードし、テキストプロンプトに基づいてAIが全く新しいスタイルで再生成します。構図を保ちながら無限のアートバリエーションを探索するのに最適です。',
                title3: 'AIスタイル転送で写真を変換',
                title4: 'なぜ画像から画像（Img2Img）を使用するのか？',
                upload_image: 'ポーズやレイアウトを言葉で説明するのに苦労していますか？参考画像をアップロードするだけです。当社のImg2Imgエンジンは元の写真の構造を保持しながら、詳細を再描画します。',
                resolution: '粗い落書きやワイヤーフレームを数秒でフォトリアルなレンダリングや高品質なイラストに変換します。デザイナーや建築家に最適です。',
                output: '本番対応のアセットを生成します。小さな画像を出力する他のツールとは異なり、WeryAIは鮮明なディテールのために1K、2K、4K解像度をサポートしています。',
                faq: [
                    {
                        question: '画像から画像AIとは？',
                        answer: '画像から画像（Img2Img）は、アップロードした画像を「参照」として、テキストプロンプトと組み合わせて新しい画像を生成する技術です。視覚的な入力と創造的な説明を融合させます。',
                    },
                    {
                        question: 'スケッチをリアルな写真に変換するには？',
                        answer: 'スケッチを「画像」エリアにアップロードします。「プロンプト」ボックスに、スケッチが表す内容を記述します（例：「モダンな別荘、夕日、フォトリアル、8k」）。作成をクリックして結果を確認します。',
                    },
                    {
                        question: '元の顔/人物は保持されますか？',
                        answer: '一般的な構造とポーズは保持しようとします。ただし、顔を正確に保持するには、専用の「写真顔スワップ」ツールの使用をお勧めします。',
                    },
                    {
                        question: 'どのアスペクト比がサポートされていますか？',
                        answer: '9:16（ストーリー）、16:9（シネマ）、3:4、1:1など、幅広い比率をサポートしており、生成されたアートがあらゆるプラットフォームに完璧に適合します。',
                    },
                    {
                        question: '無料ですか？',
                        answer: 'はい、毎日のクレジットを使用して無料でバリエーションを生成できます。',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: '無料 AI 画像拡張・リサイズツール - 写真のクロップ解除と拡張',
            description: 'Instagram、TikTok、YouTube用に画像をクロップせずにリサイズ。WeryAIのAI画像拡張ツールは生成フィル（拡張）を使用して画像背景をインテリジェントに拡張します。アスペクト比をシームレスに変更。',
            keywords: 'ai画像拡張, クロップ解除, ai拡張, 画像リサイザーai, 画像背景拡張, オンライン生成フィル, 縦写真作成',
            og_title: '無料 AI 画像拡張・リサイズツール - 写真のクロップ解除と拡張',
            og_description: 'Instagram、TikTok、YouTube用に画像をクロップせずにリサイズ。WeryAIのAI画像拡張ツールは生成フィル（拡張）を使用して画像背景をインテリジェントに拡張します。アスペクト比をシームレスに変更。',
            twitter_title: '無料 AI 画像拡張・リサイズツール - 写真のクロップ解除と拡張',
            twitter_description: 'Instagram、TikTok、YouTube用に画像をクロップせずにリサイズ。WeryAIのAI画像拡張ツールは生成フィル（拡張）を使用して画像背景をインテリジェントに拡張します。アスペクト比をシームレスに変更。',
            page: {
                title1: '無料 AI 画像拡張・リサイズツール',
                title2: 'お気に入りの写真をソーシャルメディアに合わせてクロップするのをやめましょう。横長の写真を縦のストーリーに変換したり、正方形の画像を16:9に拡張したりする必要がある場合、当社のAI画像拡張ツールは、あらゆるアスペクト比に完璧に適合するように新しい背景詳細（拡張）を魔法のように生成します。',
                faq: [
                    {
                        question: 'クロップせずに画像をリサイズするには？',
                        answer: 'WeryAIのAI画像拡張ツールを使用します。写真をアップロードし、ターゲットアスペクト比（例：9:16）を選択すると、AIが自動的に画像をクロップする代わりに、欠落している背景領域を生成（拡張）します。',
                    },
                    {
                        question: 'AI拡張とは何ですか？',
                        answer: '拡張は、元のスタイルに一致する新しいコンテンツを予測して描画することで画像の境界を拡張する生成AI技術で、効果的に写真の「クロップ解除」を行います。',
                    },
                    {
                        question: '横長の写真を縦長に変換できますか？',
                        answer: 'はい！横長（風景）の写真をアップロードし、9:16の比率を選択するだけです。AIが画像の上部と下部を拡張して縦のフレームを埋めます。',
                    },
                    {
                        question: '拡張された背景は不自然に見えますか？',
                        answer: 'WeryAIは大規模なデータセットで訓練された高度な生成モデルを使用して、拡張された背景が元の照明とテクスチャと自然に融合するようにします。',
                    },
                    {
                        question: '無料で使用できますか？',
                        answer: 'はい、ユーザーは無料クレジットを受け取り、AIスマートリサイズと拡張機能を試すことができます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'クロップせずに画像をリサイズするには？',
                    answer: 'WeryAIのAI画像拡張ツールを使用します。写真をアップロードし、ターゲットアスペクト比（例：9:16）を選択すると、AIが自動的に画像をクロップする代わりに、欠落している背景領域を生成（拡張）します。',
                },
                {
                    question: 'AI拡張とは何ですか？',
                    answer: '拡張は、元のスタイルに一致する新しいコンテンツを予測して描画することで画像の境界を拡張する生成AI技術で、効果的に写真の「クロップ解除」を行います。',
                },
                {
                    question: '横長の写真を縦長に変換できますか？',
                    answer: 'はい！横長（風景）の写真をアップロードし、9:16の比率を選択するだけです。AIが画像の上部と下部を拡張して縦のフレームを埋めます。',
                },
                {
                    question: '拡張された背景は不自然に見えますか？',
                    answer: 'WeryAIは大規模なデータセットで訓練された高度な生成モデルを使用して、拡張された背景が元の照明とテクスチャと自然に融合するようにします。',
                },
                {
                    question: '無料で使用できますか？',
                    answer: 'はい、ユーザーは無料クレジットを受け取り、AIスマートリサイズと拡張機能を試すことができます。',
                },
            ],
            feature_title1: 'スマート背景拡張',
            feature_desc1: 'マジック拡張：AIは画像のコンテキストを理解し、元の境界を超えて新しいピクセルを描画します。風景、部屋、またはテクスチャをシームレスに拡張してフレームを埋めます。',
            feature_title2: 'センターステージ保護',
            feature_desc2: '被写体を決してクロップしない：当社のAIは主要な人物またはオブジェクトを自動的に識別し、中央にロックして、リサイズプロセス中に決して切り取られないようにします。',
            feature_title3: 'ソーシャルメディア対応',
            feature_desc3: 'Instagram Stories (9:16)、YouTube サムネイル (16:9)、投稿 (4:5) のワンクリックプリセット。すべてのプラットフォームでコンテンツを即座に再利用できます。',
        },
        imageTextTranslate: {
            title: '無料 AI 画像翻訳器 - 写真、漫画、コミックのテキストを翻訳',
            description: '元の視覚スタイルを保持しながら、画像内のテキストを瞬時に翻訳。WeryAIのAI画像翻訳器は、元のテキストを自動的に消去し、翻訳を再描画します。漫画、マンガ、マーケティングポスターに最適。',
            keywords: 'ai画像翻訳器, 画像内テキスト翻訳, 画像翻訳器, 漫画翻訳器, 漫画翻訳, ocr翻訳器, 画像テキスト置換',
            og_title: '無料 AI 画像翻訳器 - 写真、漫画、コミックのテキストを翻訳',
            og_description: '元の視覚スタイルを保持しながら、画像内のテキストを瞬時に翻訳。WeryAIのAI画像翻訳器は、元のテキストを自動的に消去し、翻訳を再描画します。漫画、マンガ、マーケティングポスターに最適。',
            twitter_title: '無料 AI 画像翻訳器 - 写真、漫画、コミックのテキストを翻訳',
            twitter_description: '元の視覚スタイルを保持しながら、画像内のテキストを瞬時に翻訳。WeryAIのAI画像翻訳器は、元のテキストを自動的に消去し、翻訳を再描画します。漫画、マンガ、マーケティングポスターに最適。',
            page: {
                title1: '無料 AI 画像翻訳器とテキスト置換器',
                title2: 'ポスター、メニュー、漫画、スクリーンショットを数秒で翻訳。テキストを単にオーバーレイする標準的な翻訳器とは異なり、WeryAIは生成AIを使用して元のテキストを消去し、背景を再描画し、翻訳されたテキストが元のデザインの一部のように見えるようにします。',
                faq: [
                    {
                        question: '画像内のテキストを翻訳するには？',
                        answer: '画像（JPG、PNG）をWeryAIにアップロードします。ソース言語（または自動検出を使用）とターゲット言語を選択します。「作成」をクリックして、AIにテキストを置換させます。',
                    },
                    {
                        question: '翻訳されたテキストは自然に見えますか？',
                        answer: 'はい。WeryAIは元のテキストのフォントサイズとスタイルに一致させようとします。重要なのは、テキストの背後にある背景を再描画するため、翻訳がシームレスに融合することです。',
                    },
                    {
                        question: 'これを使って漫画やマンファを翻訳できますか？',
                        answer: 'もちろんです。これは最良のユースケースの一つです。AIは吹き出しと垂直テキスト（日本語で一般的）を検出し、水平翻訳テキストに置き換えます。',
                    },
                    {
                        question: 'どの言語がサポートされていますか？',
                        answer: '英語、スペイン語、中国語、日本語、韓国語、フランス語、ドイツ語など、主要なグローバル言語間の翻訳をサポートしています。',
                    },
                    {
                        question: '手書きテキストで動作しますか？',
                        answer: '印刷テキストで最もよく機能しますが、高度なOCRエンジンは、ホワイトボードやメモ上の明確な手書きテキストを認識できます。',
                    },
                    {
                        question: '無料ですか？',
                        answer: '毎日のクレジットを使用して画像を無料で翻訳できます。',
                    },
                ],
            },
            faq: [
                {
                    question: '画像内のテキストを翻訳するには？',
                    answer: '画像をWeryAIにアップロードします。ターゲット言語を選択し、「作成」をクリックします。AIが元のテキストを翻訳に置き換えます。',
                },
                {
                    question: '翻訳されたテキストは自然に見えますか？',
                    answer: 'はい。WeryAIはテキストの背後にある背景を再描画し、フォントスタイルに一致させようとし、翻訳がシームレスに融合するようにします。',
                },
                {
                    question: 'これを使って漫画やマンファを翻訳できますか？',
                    answer: 'もちろんです。これは最良のユースケースの一つです。AIは吹き出しと垂直テキスト（日本語で一般的）を検出し、水平翻訳テキストに置き換えます。',
                },
            ],
            feature_title1: 'スマート修復と再描画',
            feature_desc1: 'シームレスなテキスト置換：当社のAIは、テキストの背後にある背景テクスチャを分析します。元の単語を消去し、空白をインテリジェントに埋めてから翻訳を追加し、見苦しいテキストボックスが画像を覆わないようにします。',
            feature_title2: '漫画とコミック翻訳',
            feature_desc2: '生の漫画を即座に読む：アニメファンに最適。生の漫画ページ（日本語/韓国語）をアップロードすると、吹き出し内に完璧に収まる即座の英語翻訳が得られます。',
            feature_title3: 'グローバルマーケティングローカライゼーション',
            feature_desc3: 'ワンクリックローカライゼーション：グローバルに製品を発売していますか？元のPSDファイルなしで、マーケティングポスター、バナー、UIスクリーンショットを30以上の言語に翻訳できます。',
        },
        aiBackgroundChanger: {
            title: '無料AI背景チェンジャー - テキストで背景を生成',
            description: 'AIで写真の背景を即座に変更。欲しいシーンを言葉で説明するだけで、WeryAIが商品撮影、LinkedInのヘッドショット、クリエイティブなポートレート向けにリアルな背景を生成します。無料・オンライン。',
            keywords: '写真 背景 変更, AI 背景 生成, 商品撮影 AI, 白背景 作成, オンライン 背景 置換, 生成塗りつぶし 背景',
            og_title: '無料AI背景チェンジャー - テキストで背景を生成',
            og_description: 'AIで写真の背景を即座に変更。欲しいシーンを言葉で説明するだけで、WeryAIが商品撮影、LinkedInのヘッドショット、クリエイティブなポートレート向けにリアルな背景を生成します。無料・オンライン。',
            twitter_title: '無料AI背景チェンジャー - テキストで背景を生成',
            twitter_description: 'AIで写真の背景を即座に変更。欲しいシーンを言葉で説明するだけで、WeryAIが商品撮影、LinkedInのヘッドショット、クリエイティブなポートレート向けにリアルな背景を生成します。無料・オンライン。',
            page: {
                title1: '無料AI背景チェンジャー＆ジェネレーター',
                title2: '背景を「消す」だけでなく、もっと良い背景に「置き換え」ましょう。写真をアップロードし、任意のシーン（例：「高級大理石スタジオ」「オフィスのスカイライン」）を説明してください。生成AIが光と遠近感を理解し、被写体を新しい環境に自然に合成します。',
                faq: [
                    {
                        question: 'テキストで背景を変更するには？',
                        answer: '画像をアップロードし、「背景プロンプト」欄に欲しいシーン（例：「居心地のいいカフェ」）を入力します。[作成]をクリックするとAIがその背景を生成します。',
                    },
                    {
                        question: '背景を真っ白にできますか？',
                        answer: 'はい。プロンプトに「純白の背景」または「スタジオホワイト」と入力するだけです。Amazon/eBayの商品画像や証明写真に最適です。',
                    },
                    {
                        question: '商品撮影に向いていますか？',
                        answer: 'もちろんです。WeryAIは商品の角度を解析し、適切な影と光を持つ背景を生成して、プロのスタジオ撮影のように見せます。',
                    },
                    {
                        question: '光は自然に見えますか？',
                        answer: '当社の生成AI（Adobe FireflyやSDXLに近い）は、生成背景の光を被写体に合わせるように試み、違和感なく馴染ませます。',
                    },
                    {
                        question: '無料で使えますか？',
                        answer: 'はい。毎日の無料クレジットで新しい背景を無料で生成できます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'テキストで背景を変更するには？',
                    answer: '画像をアップロードし、「背景プロンプト」欄に欲しいシーン（例：「居心地のいいカフェ」）を入力します。[作成]をクリックするとAIがその背景を生成します。',
                },
                {
                    question: '背景を真っ白にできますか？',
                    answer: 'はい。プロンプトに「純白の背景」または「スタジオホワイト」と入力するだけです。Amazon/eBayの商品画像や証明写真に最適です。',
                },
                {
                    question: '商品撮影に向いていますか？',
                    answer: 'もちろんです。WeryAIは商品の角度を解析し、適切な影と光を持つ背景を生成して、プロのスタジオ撮影のように見せます。',
                },
                {
                    question: '光は自然に見えますか？',
                    answer: '当社の生成AI（Adobe FireflyやSDXLに近い）は、生成背景の光を被写体に合わせるように試み、違和感なく馴染ませます。',
                },
                {
                    question: '無料で使えますか？',
                    answer: 'はい。毎日の無料クレジットで新しい背景を無料で生成できます。',
                },
            ],
            feature_title1: 'プロ仕様の証明写真・プロフィール写真',
            feature_desc1: 'DIY LinkedInヘッドショット：何気ない自撮りをプロのプロフィール写真に。散らかった部屋の背景を、清潔なオフィスやスタジオグレーに一瞬で変更。',
            feature_title2: '即席の商品撮影',
            feature_desc2: 'EC売上アップ：撮影費を大幅に節約。木のテーブル、砂浜、台座などにテキストだけで商品を配置。AIがリアルな影や反射を追加します。',
            feature_title3: 'クリエイティブな瞬間移動',
            feature_desc3: 'パリやサイバーパンクの未来へ行きたい？入力するだけ。元の写真の光を保ちながら背景を置き換えます。',
        },
        imageUpscaler: {
            title: '無料 AI 画像拡大ツール - 4K まで拡大 & 古い写真を復元',
            description: '微鲤AI の無料 AI 画像強化ツールで、低解像度画像を 2 倍、4 倍、4K に即座に拡大。ぼやけた写真を修正し、ノイズを除去し、古い家族写真をオンラインで復元。ロスレス品質。',
            keywords: 'ai画像拡大ツール, 写真強化ツール, 画像を4kに拡大, 画像のぼかし除去, 古い写真復元, ピクセル化した写真を修正, 画像解像度を向上',
            og_title: '無料 AI 画像拡大ツール - 4K まで拡大 & 古い写真を復元',
            og_description: '微鲤AI の無料 AI 画像強化ツールで、低解像度画像を 2 倍、4 倍、4K に即座に拡大。ぼやけた写真を修正し、ノイズを除去し、古い家族写真をオンラインで復元。ロスレス品質。',
            twitter_title: '無料 AI 画像拡大ツール - 4K まで拡大 & 古い写真を復元',
            twitter_description: '微鲤AI の無料 AI 画像強化ツールで、低解像度画像を 2 倍、4 倍、4K に即座に拡大。ぼやけた写真を修正し、ノイズを除去し、古い家族写真をオンラインで復元。ロスレス品質。',
            page: {
                title1: '無料 AI 画像拡大ツール & 強化ツール',
                title2: 'ピクセル化、ぼやけた、または古い写真を高解像度の傑作に変換。微鲤AI は高度な AI を使用して、画像解像度を最大 400%（4K）まで拡大し、失われたディテールを回復し、ノイズを修正し、古い家族の肖像画の顔を復元します。',
                faq: [
                    {
                        question: '低解像度画像を印刷用に拡大できますか？',
                        answer: 'はい！微鲤AI は画像の解像度（ピクセル数）を 4K まで向上させ、ポスター、キャンバス、またはマーケティング資料での高品質印刷に適しています。',
                    },
                    {
                        question: 'AI 古い写真復元はどのように機能しますか？',
                        answer: 'AI は古い写真の損傷またはぼやけた部分を分析し、ディープラーニングを使用して顔のディテール、テクスチャ、背景を予測および再構築し、効果的に画像を「修復」します。',
                    },
                    {
                        question: 'どの形式がサポートされていますか？',
                        answer: 'JPG、PNG、WEBP などの一般的な形式をサポートしています。出力は高品質の PNG または JPG になります。',
                    },
                    {
                        question: 'アニメ/漫画で動作しますか？',
                        answer: 'はい。当社の AI はアニメとイラスト（waifu2x スタイル）の拡大に優れており、アーティファクトなしで線をシャープに、色を鮮やかに保ちます。',
                    },
                    {
                        question: '無料ですか？',
                        answer: 'はい、毎日のクレジットを使用して画像を無料で強化できます。',
                    },
                ],
            },
            faq: [
                {
                    question: '低解像度画像を印刷用に拡大できますか？',
                    answer: 'はい！微鲤AI は解像度を 4K まで向上させ、画像を高品質印刷に適したものにします。',
                },
                {
                    question: 'AI 古い写真復元はどのように機能しますか？',
                    answer: 'AI は損傷した領域を分析し、ディープラーニングを使用して顔のディテールとテクスチャを再構築し、画像を修復します。',
                },
                {
                    question: 'アニメで動作しますか？',
                    answer: 'はい。当社の AI はアニメとイラストの拡大に優れており、アーティファクトなしで線をシャープに保ちます。',
                },
            ],
            feature_title1: 'ロスレス 4K 拡大',
            feature_desc1: '印刷準備完了の品質：小さな画像を印刷する必要がありますか？品質を失うことなく 4K または 8K に拡大します。ポスター、eコマース製品写真、壁紙に最適です。',
            feature_title2: 'スマートノイズ除去 & ぼかし修正',
            feature_desc2: '夜景写真を修正：低照度写真からデジタルノイズとグレインを除去します。ぼやけたエッジを即座にシャープにして、写真を鮮明でプロフェッショナルに見せます。',
            feature_title3: '古い写真復元',
            feature_desc3: '思い出を蘇らせる：古い、損傷した、または白黒の写真がありますか？当社の AI は新しいピクセルを作成して傷を修復し、顔をシャープにし、大切な思い出に明確さを取り戻します。',
        },
        photoFaceSwap: {
            title: '無料AI顔交換オンライン - リアルな写真顔チェンジャー',
            description: 'WeryAIの無料AI顔交換ツールで、写真の顔を瞬時に交換。面白いミーム、芸術的な肖像画（モナ・リザ）、または高リアリズムのプロフェッショナルなヘッドショットを作成。100%プライベートで安全。',
            keywords: 'ai顔交換, オンライン顔交換, 写真顔チェンジャー, 無料リフェース, 画像で顔を置き換え, ディープフェイク写真, aiミームメーカー',
            og_title: '無料AI顔交換オンライン - リアルな写真顔チェンジャー',
            og_description: 'WeryAIの無料AI顔交換ツールで、写真の顔を瞬時に交換。面白いミーム、芸術的な肖像画（モナ・リザ）、または高リアリズムのプロフェッショナルなヘッドショットを作成。100%プライベートで安全。',
            twitter_title: '無料AI顔交換オンライン - リアルな写真顔チェンジャー',
            twitter_description: 'WeryAIの無料AI顔交換ツールで、写真の顔を瞬時に交換。面白いミーム、芸術的な肖像画（モナ・リザ）、または高リアリズムのプロフェッショナルなヘッドショットを作成。100%プライベートで安全。',
            page: {
                title1: '無料AI写真顔交換',
                title2: '宇宙飛行士、映画スター、または古典的な絵画の中の自分を見てみたいですか？ベース写真とターゲット顔をアップロードすると、AIが顔の特徴、照明、肌のトーンをシームレスにブレンドし、数秒で超リアルな顔交換を実現します。',
                faq: [
                    {
                        question: 'WeryAI顔交換は無料で使用できますか？',
                        answer: 'はい、オンラインで写真の顔を交換するための無料の毎日のクレジットを提供しています。インストールやクレジットカードは不要です。',
                    },
                    {
                        question: '私のデータは安全ですか？',
                        answer: '絶対に安全です。私たちはあなたのプライバシーを最優先にしています。アップロードした写真は交換プロセスのみに使用され、短期間後にサーバーから自動的に削除されます。',
                    },
                    {
                        question: '最高の結果を得るにはどうすればよいですか？',
                        answer: '最もリアルな交換のために、「ベース画像」と「顔画像」の両方が明確で、正面を向いており、良好な照明があることを確認してください。顔が髪や手で隠れている写真は避けてください。',
                    },
                    {
                        question: '集合写真で顔を交換できますか？',
                        answer: '現在、私たちのツールは単一顔交換の精度に焦点を当てています。集合写真の場合は、画像をクロップするか、今後の複数顔機能をご利用ください。',
                    },
                    {
                        question: 'ミームに使用できますか？',
                        answer: 'はい！面白いミームを作成するのに最適です。友達の顔を映画ポスターやバイラルミームテンプレートに瞬時に交換できます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'WeryAI顔交換は無料で使用できますか？',
                    answer: 'はい、オンラインで写真の顔を交換するための無料の毎日のクレジットを提供しています。インストールやクレジットカードは不要です。',
                },
                {
                    question: '私のデータは安全ですか？',
                    answer: '絶対に安全です。私たちはあなたのプライバシーを最優先にしています。アップロードした写真は交換プロセスのみに使用され、短期間後にサーバーから自動的に削除されます。',
                },
                {
                    question: '最高の結果を得るにはどうすればよいですか？',
                    answer: '両方の写真が明確で、正面を向いており、十分に照明されていることを確認してください。髪や眼鏡で顔が隠れている写真は避けてください。',
                },
            ],
            feature_title1: '芸術的な傑作',
            feature_desc1: 'タイムトラベル：モナ・リザや真珠の耳飾りの少女などの古典的な油絵に顔を交換。ユニークなビンテージアバターを瞬時に作成。',
            feature_title2: 'プロフェッショナルでクールなアバター',
            feature_desc2: '夢の職業：コスチュームを購入することなく、レーシングスーツ、宇宙飛行士の装備、またはビジネススーツの自分を見ることができます。目立つプロフィール写真を作成するのに最適です。',
            feature_title3: '超リアルなブレンディング',
            feature_desc3: '「貼り付け」効果なし：単純な切り貼りツールとは異なり、WeryAIは角度、照明、肌の質感を分析し、交換された顔が100%自然で、偽物に見えないようにします。',
        },
        removeTextFromImage: {
            title: '無料AI画像テキスト削除 - 透かし＆日付スタンプを消去',
            description: 'WeryAIの無料AIテキスト消しゴムで、画像内のテキスト、日付スタンプ、ロゴ、キャプションを瞬時に削除。AIインペインティングで背景を自然に復元し、写真の整理やEC用モックアップに最適です。',
            keywords: '画像 テキスト 削除, AI テキスト 消去, 日付スタンプ 削除, オンライン 透かし 除去, 画像 クリーンアップ, AI インペインティング, ロゴ 削除',
            og_title: '無料AI画像テキスト削除 - 透かし＆日付スタンプを消去',
            og_description: 'WeryAIの無料AIテキスト消しゴムで、画像内のテキスト、日付スタンプ、ロゴ、キャプションを瞬時に削除。AIインペインティングで背景を自然に復元し、写真の整理やEC用モックアップに最適です。',
            twitter_title: '無料AI画像テキスト削除 - 透かし＆日付スタンプを消去',
            twitter_description: 'WeryAIの無料AIテキスト消しゴムで、画像内のテキスト、日付スタンプ、ロゴ、キャプションを瞬時に削除。AIインペインティングで背景を自然に復元し、写真の整理やEC用モックアップに最適です。',
            page: {
                title1: '無料AI画像テキスト削除',
                title2: '不要な文字が気になりますか？画像をアップロードするだけで、AIが文字・ロゴ・日付スタンプ・キャプションを自動検出して即座に消去します。周囲のピクセルを解析して背景を再構築し、痕跡を残しません。',
                faq: [
                    {
                        question: 'ぼかさずに写真の文字を消すには？',
                        answer: 'WeryAIのAIテキスト消しゴムを使ってください。ぼかしではなく、AIインペインティングで周囲を解析し、新しいピクセルを生成して自然に埋めます。',
                    },
                    {
                        question: '写真の日付スタンプは削除できますか？',
                        answer: 'はい。日付/時刻スタンプのデジタルフォントを認識して消去し、背後の風景を復元します。',
                    },
                    {
                        question: '複雑な背景でも使えますか？',
                        answer: 'はい。山脈や柄物の服など、複雑な背景でもテクスチャの流れを理解して文字を除去できます。',
                    },
                    {
                        question: '人物や物体の削除にも使えますか？',
                        answer: '文字に最適化されていますが、基盤技術（インペインティング）は小さな不要物、肌のシミ、散らかりの除去にも有効です。',
                    },
                    {
                        question: '無料ですか？',
                        answer: 'はい。毎日の無料クレジットでAIテキスト削除をお試しいただけます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'ぼかさずに写真の文字を消すには？',
                    answer: 'WeryAIのAIテキスト消しゴムを使ってください。AIインペインティングで周囲を解析し、新しいピクセルを生成して自然に埋めます。',
                },
                {
                    question: '写真の日付スタンプは削除できますか？',
                    answer: 'はい。日付/時刻スタンプを認識して消去し、背後の風景を復元します。',
                },
                {
                    question: '複雑な背景でも使えますか？',
                    answer: 'はい。テクスチャの流れを理解して、複雑な背景でも自然に除去できます。',
                },
            ],
            feature_title1: 'アパレル＆デザインのクリーンアップ',
            feature_desc1: 'モックアップに最適：服をオンラインで販売する場合、Tシャツ写真のロゴ・スローガン・グラフィックを削除して、自分のデザイン用に“まっさら”にできます。',
            feature_title2: '思い出写真の復元',
            feature_desc2: '日付スタンプ消去：古い家族写真や旅行写真のオレンジ色の日付スタンプを、景色を傷つけずに除去できます。',
            feature_title3: 'インテリジェントなインペインティング',
            feature_desc3: '背景を自然に補完：ただぼかす消しゴムと違い、WeryAIは生成AIで草・空・山などのリアルな質感を“描き足し”ます。',
        },
        imgExtender: {
            title: '画像を今すぐ無料で拡張 - AI 画像拡張ツール | 微鲤AI',
            description: 'WeryAIの無料AI画像拡張ツールで、写真の元の境界をすぐに広げられます。AIが新しいピクセルを生成してアップロード画像と自然に融合し、人物写真を広角写真にしても元の見た目と画質を保ちます。',
            keywords: 'AI 画像拡張, 無料 画像拡張, 広角写真 生成, 写真 境界 拡張, シームレス 外描き, 画質 維持',
            og_title: '画像を今すぐ無料で拡張 - AI 画像拡張ツール | 微鲤AI',
            og_description: '写真を新しいサイズに拡張し、違和感のない内容を生成します。AI画像拡張ツールを今すぐ無料でお試しください。',
            twitter_title: '画像を今すぐ無料で拡張 - AI 画像拡張ツール | 微鲤AI',
            twitter_description: '写真を新しいサイズに拡張し、違和感のない内容を生成します。AI画像拡張ツールを今すぐ無料でお試しください。',
            featureList: [
                'AI 画像拡張, 無料 画像拡張, 広角写真 生成, 画質 維持',
            ],
            page: {
                title1: '強力なAI画像拡張ツールで驚きの仕上がり',
                title2: '数クリックで写真の境界を簡単に拡張。AIが新しいピクセルを生成して自然に融合し、人物写真を広角写真にしても元の見た目と画質を保ちます。',
                feature_title: 'WeryAI画像拡張ツールの特長',
                faq: [
                    {
                        question: 'AI画像拡張ツールとは？',
                        answer: '高度なAIで、元画像の外側をインテリジェントに補完して境界を拡張するツールです。マーケティング、EC、SNS投稿など幅広い用途に使えます。',
                    },
                    {
                        question: 'なぜWeryAIのAI画像拡張ツールを使うべき？',
                        answer: '最先端のAIが画像の特徴を分析し、周辺領域を自然で高精細に外描きして違和感なく仕上げます。',
                    },
                    {
                        question: '無料で使えますか？',
                        answer: 'はい。トライアルクレジットで無料利用できます。コストを抑えて編集ワークフローに組み込めます。',
                    },
                    {
                        question: '処理速度はどのくらい？',
                        answer: '通常は数秒で完了します。手早い編集にも、まとめて処理する用途にも最適です。',
                    },
                    {
                        question: '解像度や画質は落ちますか？',
                        answer: 'いいえ。拡張中も解像度・シャープさ・ディテールを保つよう設計されており、個人/業務用途どちらでも安心です。',
                    },
                    {
                        question: 'アップロードした画像のプライバシーは守られますか？',
                        answer: 'はい。業界標準のセキュリティと厳格なプライバシーポリシーで、第三者への共有を行いません。',
                    },
                    {
                        question: '対応形式は？',
                        answer: 'JPG/PNG/WebPなど主要形式に対応。最大10MBで、事前変換は不要です。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI画像拡張ツールとは？',
                    answer: '高度なAIで、元画像の外側をインテリジェントに補完して境界を拡張するツールです。マーケティング、EC、SNS投稿など幅広い用途に使えます。',
                },
                {
                    question: 'なぜWeryAIのAI画像拡張ツールを使うべき？',
                    answer: '最先端のAIが画像の特徴を分析し、周辺領域を自然で高精細に外描きして違和感なく仕上げます。',
                },
                {
                    question: '無料で使えますか？',
                    answer: 'はい。トライアルクレジットで無料利用できます。コストを抑えて編集ワークフローに組み込めます。',
                },
                {
                    question: '処理速度はどのくらい？',
                    answer: '通常は数秒で完了します。手早い編集にも、まとめて処理する用途にも最適です。',
                },
                {
                    question: '解像度や画質は落ちますか？',
                    answer: 'いいえ。拡張中も解像度・シャープさ・ディテールを保つよう設計されています。',
                },
                {
                    question: 'アップロードした画像のプライバシーは守られますか？',
                    answer: 'はい。業界標準のセキュリティで保護し、第三者へ共有しません。',
                },
                {
                    question: '対応形式は？',
                    answer: 'JPG/PNG/WebPなど主要形式に対応。最大10MBで、事前変換は不要です。',
                },
            ],
            feature_title1: '欠けたディテールと背景を補完',
            feature_desc1: 'トリミングされた写真でも、足りない部分を賢く補ってフレームを完成させます。外描き補完で古い写真の欠損要素を復元し、思い出の価値を高めます。',
            feature_title2: '商品画像の質を上げて売上UP',
            feature_desc2: '商品写真の周辺を拡張して相性のよい背景要素を追加。よりワイドな構図で商品ディテールを見せ、コンバージョン改善に役立ちます。',
            feature_title3: '唯一無二のビジュアル作品を創作',
            feature_desc3: '写真家・クリエイター・アーティストの方も、境界の外側まで拡張して表現の幅を広げ、驚きのビジュアルに仕上げられます。',
            feature_title4: 'SNS向けに比率を最適化',
            feature_desc4: 'Instagram、X（旧Twitter）、Facebookなどに合う任意の比率へ拡張可能。AIがディテールを保ち、最後まで魅力的に仕上げます。',
            textRemoverHowToUseTitle: 'AI画像拡張ツールの使い方',
            textRemoverHowToUseDesc: '3ステップで写真の境界を拡張',
            textRemoverHowToUseStep1Title: '画像をアップロード',
            textRemoverHowToUseStep1Desc: '拡張したい画像をクリックまたはドラッグ＆ドロップします。',
            textRemoverHowToUseStep2Title: 'AIが自動処理',
            textRemoverHowToUseStep2Desc: 'アップロード後、AIが自動で境界を検出して拡張します。',
            textRemoverHowToUseStep3Title: '拡張画像をダウンロード',
            textRemoverHowToUseStep3Desc: '処理完了後、プレビューして拡張した画像をダウンロードできます！',
        },
        photoRestoration: {
            title: '無料AI写真修復 - 白黒写真をカラー化＆傷を修復',
            description: 'WeryAIの無料AI写真修復で、古い家族の思い出を蘇らせましょう。白黒写真を自動でカラー化し、傷・破れ・ぼやけを除去して顔を瞬時に復元します。',
            keywords: '古い写真 修復, 写真 カラー化, 傷 写真 修復, AI 写真修復, 古い写真 復元, 白黒 カラー, 画像修復 AI',
            og_title: '無料AI写真修復 - 白黒写真をカラー化＆傷を修復',
            og_description: 'WeryAIの無料AI写真修復で、古い家族の思い出を蘇らせましょう。白黒写真を自動でカラー化し、傷・破れ・ぼやけを除去して顔を瞬時に復元します。',
            twitter_title: '無料AI写真修復 - 白黒写真をカラー化＆傷を修復',
            twitter_description: 'WeryAIの無料AI写真修復で、古い家族の思い出を蘇らせましょう。白黒写真を自動でカラー化し、傷・破れ・ぼやけを除去して顔を瞬時に復元します。',
            page: {
                title1: '無料AI古い写真修復＆カラー化',
                title2: 'あなたの歴史をもう一度、鮮やかに。色あせた白黒の結婚写真でも、傷だらけの子どもの頃の肖像でも、AIが損傷箇所を解析して修復し、顔をシャープにし、数秒で自然な色を賢く追加します。',
                faq: [
                    {
                        question: '白黒写真をカラー化するには？',
                        answer: '白黒画像をWeryAIにアップロードするだけ。ツールがグレースケールを自動検出し、「カラー化」機能でリアルな色をすぐに付けます。',
                    },
                    {
                        question: '破れや傷のある写真も修復できますか？',
                        answer: 'はい。AIは傷、破れ、折り目を認識できるよう学習しています。周囲の質感に合うピクセルで損傷部分を自然に埋めます。',
                    },
                    {
                        question: '修復後の写真が不自然に見えませんか？',
                        answer: '私たちの目標はリアルさです。顔の補正でディテールは増えますが、本人らしさが分かるように調整します。カラー化も年代に合う自然な色味を選びます。',
                    },
                    {
                        question: '写真がとても小さい場合は？',
                        answer: '問題ありません。修復プロセスにはアップスケールも含まれ、小さな写真の解像度を上げて閲覧や印刷に使えるようにします。',
                    },
                    {
                        question: 'プライバシーは守られますか？',
                        answer: 'はい。古い写真はとても個人的なものだと理解しています。画像は安全に処理され、サーバーに永久保存しません。',
                    },
                ],
            },
            faq: [
                {
                    question: '白黒写真をカラー化するには？',
                    answer: '白黒画像をWeryAIにアップロードするだけ。ツールが自動で検出し、「カラー化」機能でリアルな色を追加します。',
                },
                {
                    question: '破れや傷のある写真も修復できますか？',
                    answer: 'はい。AIが傷や破れを認識し、周囲の質感に合うピクセルで自然に埋めます。',
                },
                {
                    question: '修復後の写真が不自然に見えませんか？',
                    answer: 'リアルさを重視しています。本人らしさを保ちつつ、自然な補正とカラー化を行います。',
                },
            ],
            feature_title1: '傷・破れの除去',
            feature_desc1: '時間の痕跡を消す：折り目、傷、破れ、ホコリ汚れを自動検出して補完。失われた顔のディテールも再構築し、写真を新品のように見せます。',
            feature_title2: 'スマートカラー化',
            feature_desc2: '白黒→カラー：セピアフィルターではありません。深層学習モデルが文脈（空、肌、布地）を理解し、歴史的に自然で鮮やかな色を追加します。',
            feature_title3: '顔の鮮明化',
            feature_desc3: 'ぼやけた顔をくっきり：古い写真は手ブレやピント不足が起きがち。WeryAIが目・鼻・口などの特徴をシャープにし、家族の面影をはっきり蘇らせます。',
        },
        photoEffects: {
            title: '画像エフェクト - AI画像エフェクトジェネレーター | 微鲤AI',
            description: 'AIパワードのエフェクトで写真を変換。オンラインで無料で素晴らしい画像フィルター、スタイル、変換を作成。',
            keywords: 'AI画像エフェクト, 画像エフェクト, 写真フィルター, AI画像変換, 画像スタイル転送',
        },
    },
    ko: {
        textToImage: {
            title: '텍스트로 이미지 만들기 - 무료 AI 이미지 생성기 | 微鲤AI',
            description: '텍스트 프롬프트만으로 AI가 멋진 이미지를 생성합니다. 현실적인 사진, 일러스트, 아트 스타일 등 다양한 표현을 지원하며, 크리에이티브 디자인과 콘텐츠 제작에 적합합니다.',
            keywords: '텍스트로 이미지, AI 이미지 생성기, 이미지 생성, AI 이미지 제작, 텍스트 투 이미지, AI 일러스트',
            og_title: '텍스트로 이미지 만들기 - 무료 AI 이미지 생성기 | 微鲤AI',
            og_description: 'WeryAI의 텍스트-이미지 생성기로 텍스트 프롬프트를 멋진 비주얼로 변환하세요. 고품질 결과를 위한 Nano Banana Pro 모델을 특징으로 합니다. 1K/2K/4K 해상도와 9:16/16:9 종횡비를 지원합니다. 무료 및 온라인.',
            twitter_title: '텍스트로 이미지 만들기 - 무료 AI 이미지 생성기 | 微鲤AI',
            twitter_description: 'WeryAI의 텍스트-이미지 생성기로 텍스트 프롬프트를 멋진 비주얼로 변환하세요. 고품질 결과를 위한 Nano Banana Pro 모델을 특징으로 합니다. 1K/2K/4K 해상도와 9:16/16:9 종횡비를 지원합니다. 무료 및 온라인.',
            faq: [
                {
                    question: '4K AI 이미지를 생성하는 방법은 무엇인가요?',
                    answer: '프롬프트를 입력하고 왼쪽 패널의 이미지 크기 설정에서 "4K"를 선택한 후 생성 버튼을 클릭하기만 하면 됩니다.',
                },
                {
                    question: '어떤 종횡비가 지원되나요?',
                    answer: '1:1, 9:16(모바일), 16:9(데스크톱), 4:3, 3:2 등 모든 주요 종횡비를 지원하여 모든 플랫폼에 맞출 수 있습니다.',
                },
                {
                    question: '이미지를 상업적으로 사용할 수 있나요?',
                    answer: '네. 微鲤AI 플랜에서 생성된 이미지는 일반적으로 광고 및 상품에 적합한 상업적 라이선스가 포함되어 있습니다.',
                },
            ],
            page: {
                title1: '무료 AI 텍스트-이미지 생성기',
                title2: '몇 초 만에 숨막히는 예술 작품, 사실적인 이미지, 독특한 배경화면을 만드세요. 원하는 것을 설명하기만 하면, 고급 Nano Banana Pro 모델이 프롬프트와 완벽하게 일치하는 고품질 4K 이미지를 생성합니다.',
                resolution: '흐릿한 AI 이미지에 만족하지 마세요. WeryAI를 사용하면 인쇄나 고해상도 디스플레이에 완벽한 선명한 1K, 2K, 4K 이미지를 직접 생성할 수 있습니다.',
                aspectRatio: 'TikTok 배경용 9:16 이미지, YouTube 썸네일용 16:9, Instagram용 1:1 등 모든 소셜 플랫폼을 위한 사전 설정이 있습니다.',
                online_search: '최신 컨텍스트가 필요하신가요? "온라인 검색"을 활성화하여 AI가 웹을 탐색하고 프롬프트의 최신 이벤트나 특정 참조를 더 잘 이해할 수 있도록 하세요.',
                faq: [
                    {
                        question: '텍스트에서 고품질 이미지를 생성하는 방법은 무엇인가요?',
                        answer: '주제, 조명, 스타일을 설명하는 자세한 프롬프트를 입력하세요. 가장 선명한 디테일을 위해 이미지 크기 설정에서 "4K"를 선택하세요.',
                    },
                    {
                        question: 'Nano Banana Pro 모델이란 무엇인가요?',
                        answer: 'Nano Banana Pro는 프롬프트 준수와 사진 사실감에 최적화된 최고 품질 모델입니다. 품질 면에서 Midjourney v6 및 Flux와 같은 최고 모델과 경쟁합니다.',
                    },
                    {
                        question: '이미지를 상업적 목적으로 사용할 수 있나요?',
                        answer: '네. 微鲤AI(유료 플랜)에서 생성된 이미지는 상업적 라이선스가 포함되어 있어 광고, 웹사이트, 상품에 사용할 수 있습니다.',
                    },
                    {
                        question: '한 번에 몇 개의 이미지를 생성할 수 있나요?',
                        answer: '최대 4개의 이미지를 동시에 생성할 수 있습니다("출력 이미지 수" 설정에 표시된 대로). 이를 통해 아이디어를 빠르게 반복할 수 있습니다.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네, 무료 일일 크레딧을 사용하여 이미지를 생성할 수 있습니다. 더 높은 해상도(4K)는 더 많은 크레딧이 필요할 수 있습니다.',
                    },
                ],
            },
        },
        imageToImage: {
            title: '무료 AI 이미지로 이미지 생성기 - 사진을 예술 & 4K로 변환 | 微鲤AI',
            description: '참조 사진을 업로드하고 WeryAI의 이미지로 이미지 AI로 변환하세요. 스케치를 사실적인 예술로 변환하고, 스타일을 변경하거나 원본 구도를 유지하면서 변형을 생성합니다. 4K 해상도 지원.',
            keywords: '이미지로 이미지 ai, img2img, 사진을 그림으로 변환, ai 이미지 변형, 스케치를 이미지로, 사진 리믹스 ai, 무료 ai 아트 생성기',
            og_title: '무료 AI 이미지로 이미지 생성기 - 사진을 예술 & 4K로 변환 | 微鲤AI',
            og_description: '참조 사진을 업로드하고 WeryAI의 이미지로 이미지 AI로 변환하세요. 스케치를 사실적인 예술로 변환하고, 스타일을 변경하거나 원본 구도를 유지하면서 변형을 생성합니다. 4K 해상도 지원.',
            twitter_title: '무료 AI 이미지로 이미지 생성기 - 사진을 예술 & 4K로 변환 | 微鲤AI',
            twitter_description: '참조 사진을 업로드하고 WeryAI의 이미지로 이미지 AI로 변환하세요. 스케치를 사실적인 예술로 변환하고, 스타일을 변경하거나 원본 구도를 유지하면서 변형을 생성합니다. 4K 해상도 지원.',
            faq: [
                {
                    question: '이미지로 이미지 AI란 무엇인가요?',
                    answer: '이미지로 이미지(Img2Img)는 업로드한 이미지를 참조로 사용하여 텍스트 프롬프트와 함께 새 이미지를 생성하는 기술입니다. 시각적 입력과 창의적인 설명을 결합합니다.',
                },
                {
                    question: '스케치를 사실적인 사진으로 변환하는 방법은?',
                    answer: `스케치를 업로드하고 장면을 설명하는 프롬프트를 입력하세요(예: '사실적인 건물'). 생성 버튼을 클릭하세요.`,
                },
                {
                    question: '원본 얼굴이 유지되나요?',
                    answer: '구조와 포즈는 유지됩니다. 정확한 얼굴 정체성 유지를 위해서는 사진 얼굴 교체 도구를 사용해 주세요.',
                },
            ],
            page: {
                title1: '무료 AI 이미지로 이미지 생성기',
                title2: '기존 이미지를 청사진으로 사용하세요. 사진, 스케치 또는 레이아웃을 업로드하고 텍스트 프롬프트를 기반으로 AI가 완전히 새로운 스타일로 재생성합니다. 구도를 보존하면서 무한한 예술적 변형을 탐색하기에 완벽합니다.',
                title3: 'AI 스타일 전송으로 사진 변환',
                title4: '왜 이미지로 이미지(Img2Img)를 사용하나요?',
                upload_image: '포즈나 레이아웃을 말로 설명하기 어려우신가요? 참조 이미지만 업로드하세요. 저희 Img2Img 엔진은 원본 사진의 구조를 유지하면서 세부 사항을 다시 그립니다.',
                resolution: '거친 낙서나 와이어프레임을 몇 초 만에 사실적인 렌더링이나 고품질 일러스트로 변환합니다. 디자이너와 건축가에게 이상적입니다.',
                output: '프로덕션 준비가 된 자산을 생성합니다. 작은 이미지를 출력하는 다른 도구와 달리 WeryAI는 선명한 디테일을 위해 1K, 2K, 4K 해상도를 지원합니다.',
                faq: [
                    {
                        question: '이미지로 이미지 AI란 무엇인가요?',
                        answer: '이미지로 이미지(Img2Img)는 업로드한 이미지를 "참조"로 사용하여 텍스트 프롬프트와 함께 새 이미지를 생성하는 기술입니다. 시각적 입력과 창의적인 설명을 결합합니다.',
                    },
                    {
                        question: '스케치를 사실적인 사진으로 변환하는 방법은?',
                        answer: '스케치를 "이미지" 영역에 업로드하세요. "프롬프트" 상자에 스케치가 나타내는 내용을 설명하세요(예: "모던 빌라, 일몰, 사실적, 8k"). 생성 버튼을 클릭하여 결과를 확인하세요.',
                    },
                    {
                        question: '원본 얼굴/인물이 유지되나요?',
                        answer: '일반적인 구조와 포즈는 유지하려고 합니다. 그러나 정확한 얼굴 유지를 위해서는 특정 "사진 얼굴 교체" 도구를 사용하는 것을 권장합니다.',
                    },
                    {
                        question: '어떤 종횡비가 지원되나요?',
                        answer: '9:16(스토리), 16:9(시네마), 3:4, 1:1을 포함한 다양한 비율을 지원하여 생성된 예술 작품이 모든 플랫폼에 완벽하게 맞습니다.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네, 일일 크레딧을 사용하여 무료로 변형을 생성할 수 있습니다.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: '무료 AI 이미지 확장 및 리사이저 - 사진 자르기 해제 및 확장',
            description: 'Instagram, TikTok, YouTube용으로 이미지를 자르지 않고 리사이즈합니다. WeryAI의 AI 이미지 확장기는 생성 채우기(확장)를 사용하여 이미지 배경을 지능적으로 확장합니다. 종횡비를 원활하게 변경합니다.',
            keywords: 'ai 이미지 확장기, 자르기 해제, ai 확장, 이미지 리사이저 ai, 이미지 배경 확장, 온라인 생성 채우기, 세로 사진 만들기',
            og_title: '무료 AI 이미지 확장 및 리사이저 - 사진 자르기 해제 및 확장',
            og_description: 'Instagram, TikTok, YouTube용으로 이미지를 자르지 않고 리사이즈합니다. WeryAI의 AI 이미지 확장기는 생성 채우기(확장)를 사용하여 이미지 배경을 지능적으로 확장합니다. 종횡비를 원활하게 변경합니다.',
            twitter_title: '무료 AI 이미지 확장 및 리사이저 - 사진 자르기 해제 및 확장',
            twitter_description: 'Instagram, TikTok, YouTube용으로 이미지를 자르지 않고 리사이즈합니다. WeryAI의 AI 이미지 확장기는 생성 채우기(확장)를 사용하여 이미지 배경을 지능적으로 확장합니다. 종횡비를 원활하게 변경합니다.',
            page: {
                title1: '무료 AI 이미지 확장 및 리사이저',
                title2: '소셜 미디어에 맞추기 위해 좋아하는 사진을 자르는 것을 중단하세요. 가로 사진을 세로 스토리로 변환하거나 정사각형 이미지를 16:9로 확장해야 하는 경우, 저희 AI 이미지 확장기는 모든 종횡비에 완벽하게 맞도록 새로운 배경 세부 사항(확장)을 마법처럼 생성합니다.',
                faq: [
                    {
                        question: '이미지를 자르지 않고 리사이즈하는 방법은?',
                        answer: 'WeryAI의 AI 이미지 확장기를 사용하세요. 사진을 업로드하고 대상 종횡비(예: 9:16)를 선택하면 AI가 이미지를 자르는 대신 누락된 배경 영역을 자동으로 생성(확장)합니다.',
                    },
                    {
                        question: 'AI 확장이란 무엇인가요?',
                        answer: '확장은 원본 스타일과 일치하는 새로운 콘텐츠를 예측하고 그려서 이미지의 경계를 확장하는 생성 AI 기술로, 효과적으로 사진의 "자르기 해제"를 수행합니다.',
                    },
                    {
                        question: '가로 사진을 세로 사진으로 변환할 수 있나요?',
                        answer: '네! 가로(풍경) 사진을 업로드하고 9:16 비율을 선택하기만 하면 됩니다. AI가 이미지의 상단과 하단을 확장하여 세로 프레임을 채웁니다.',
                    },
                    {
                        question: '확장된 배경이 가짜처럼 보일까요?',
                        answer: 'WeryAI는 대규모 데이터셋으로 훈련된 고급 생성 모델을 사용하여 확장된 배경이 원본 조명과 질감과 자연스럽게 융합되도록 합니다.',
                    },
                    {
                        question: '무료로 사용할 수 있나요?',
                        answer: '네, 사용자는 무료 크레딧을 받아 AI 스마트 리사이즈 및 확장 기능을 시도할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '이미지를 자르지 않고 리사이즈하는 방법은?',
                    answer: 'WeryAI의 AI 이미지 확장기를 사용하세요. 사진을 업로드하고 대상 종횡비(예: 9:16)를 선택하면 AI가 이미지를 자르는 대신 누락된 배경 영역을 자동으로 생성(확장)합니다.',
                },
                {
                    question: 'AI 확장이란 무엇인가요?',
                    answer: '확장은 원본 스타일과 일치하는 새로운 콘텐츠를 예측하고 그려서 이미지의 경계를 확장하는 생성 AI 기술로, 효과적으로 사진의 "자르기 해제"를 수행합니다.',
                },
                {
                    question: '가로 사진을 세로 사진으로 변환할 수 있나요?',
                    answer: '네! 가로(풍경) 사진을 업로드하고 9:16 비율을 선택하기만 하면 됩니다. AI가 이미지의 상단과 하단을 확장하여 세로 프레임을 채웁니다.',
                },
                {
                    question: '확장된 배경이 가짜처럼 보일까요?',
                    answer: 'WeryAI는 대규모 데이터셋으로 훈련된 고급 생성 모델을 사용하여 확장된 배경이 원본 조명과 질감과 자연스럽게 융합되도록 합니다.',
                },
                {
                    question: '무료로 사용할 수 있나요?',
                    answer: '네, 사용자는 무료 크레딧을 받아 AI 스마트 리사이즈 및 확장 기능을 시도할 수 있습니다.',
                },
            ],
            feature_title1: '스마트 배경 확장',
            feature_desc1: '마법 확장: AI는 이미지의 컨텍스트를 이해하고 원본 경계를 넘어 새로운 픽셀을 그립니다. 풍경, 방 또는 질감을 원활하게 확장하여 프레임을 채웁니다.',
            feature_title2: '중앙 보호',
            feature_desc2: '주체를 절대 자르지 않음: 당사의 AI는 주요 인물 또는 객체를 자동으로 식별하고 중앙에 고정하여 리사이징 과정에서 절대 잘리지 않도록 합니다.',
            feature_title3: '소셜 미디어 준비 완료',
            feature_desc3: 'Instagram Stories (9:16), YouTube 썸네일 (16:9) 및 게시물 (4:5)을 위한 원클릭 사전 설정. 모든 플랫폼에서 콘텐츠를 즉시 재사용할 수 있습니다.',
        },
        imageTextTranslate: {
            title: '무료 AI 이미지 번역기 - 사진, 만화 및 코믹스의 텍스트 번역',
            description: '원본 시각적 스타일을 유지하면서 이미지의 텍스트를 즉시 번역합니다. WeryAI의 AI 이미지 번역기는 원본 텍스트를 자동으로 지우고 번역을 다시 그립니다. 만화, 만화 및 마케팅 포스터에 완벽합니다.',
            keywords: 'ai 이미지 번역기, 이미지 텍스트 번역, 이미지 번역기, 만화 번역기, 만화 번역, ocr 번역기, 이미지 텍스트 교체',
            og_title: '무료 AI 이미지 번역기 - 사진, 만화 및 코믹스의 텍스트 번역',
            og_description: '원본 시각적 스타일을 유지하면서 이미지의 텍스트를 즉시 번역합니다. WeryAI의 AI 이미지 번역기는 원본 텍스트를 자동으로 지우고 번역을 다시 그립니다. 만화, 만화 및 마케팅 포스터에 완벽합니다.',
            twitter_title: '무료 AI 이미지 번역기 - 사진, 만화 및 코믹스의 텍스트 번역',
            twitter_description: '원본 시각적 스타일을 유지하면서 이미지의 텍스트를 즉시 번역합니다. WeryAI의 AI 이미지 번역기는 원본 텍스트를 자동으로 지우고 번역을 다시 그립니다. 만화, 만화 및 마케팅 포스터에 완벽합니다.',
            page: {
                title1: '무료 AI 이미지 번역기 및 텍스트 교체기',
                title2: '포스터, 메뉴, 만화 및 스크린샷을 몇 초 만에 번역합니다. 텍스트를 단순히 오버레이하는 표준 번역기와 달리 WeryAI는 생성 AI를 사용하여 원본 텍스트를 지우고 배경을 다시 그려 번역된 텍스트가 원본 디자인의 일부처럼 보이도록 합니다.',
                faq: [
                    {
                        question: '이미지 내 텍스트를 번역하는 방법은?',
                        answer: '이미지(JPG, PNG)를 WeryAI에 업로드합니다. 소스 언어(또는 자동 감지 사용)와 대상 언어를 선택합니다. "생성"을 클릭하여 AI가 텍스트를 교체하도록 합니다.',
                    },
                    {
                        question: '번역된 텍스트가 자연스럽게 보일까요?',
                        answer: '네. WeryAI는 원본 텍스트의 글꼴 크기와 스타일을 일치시키려고 합니다. 중요한 것은 텍스트 뒤의 배경을 다시 그리므로 번역이 완벽하게 융합됩니다.',
                    },
                    {
                        question: '이것으로 만화나 만화를 번역할 수 있나요?',
                        answer: '물론입니다. 이것은 최고의 사용 사례 중 하나입니다. AI는 말풍선과 세로 텍스트(일본어에서 일반적)를 감지하고 가로 번역 텍스트로 교체합니다.',
                    },
                    {
                        question: '어떤 언어가 지원되나요?',
                        answer: '영어, 스페인어, 중국어, 일본어, 한국어, 프랑스어, 독일어 등 주요 글로벌 언어 간 번역을 지원합니다.',
                    },
                    {
                        question: '손글씨 텍스트에서 작동하나요?',
                        answer: '인쇄된 텍스트에서 가장 잘 작동하지만, 고급 OCR 엔진은 화이트보드나 메모의 명확한 손글씨 텍스트를 인식할 수 있습니다.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '일일 크레딧을 사용하여 이미지를 무료로 번역할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '이미지 내 텍스트를 번역하는 방법은?',
                    answer: '이미지를 WeryAI에 업로드합니다. 대상 언어를 선택하고 "생성"을 클릭합니다. AI가 원본 텍스트를 번역으로 교체합니다.',
                },
                {
                    question: '번역된 텍스트가 자연스럽게 보일까요?',
                    answer: '네. WeryAI는 텍스트 뒤의 배경을 다시 그리고 글꼴 스타일을 일치시키려고 하여 번역이 완벽하게 융합되도록 합니다.',
                },
                {
                    question: '이것으로 만화나 만화를 번역할 수 있나요?',
                    answer: '물론입니다. 이것은 최고의 사용 사례 중 하나입니다. AI는 말풍선과 세로 텍스트(일본어에서 일반적)를 감지하고 가로 번역 텍스트로 교체합니다.',
                },
            ],
            feature_title1: '스마트 인페인팅 및 다시 그리기',
            feature_desc1: '완벽한 텍스트 교체: 당사의 AI는 텍스트 뒤의 배경 질감을 분석합니다. 원본 단어를 지우고 공백을 지능적으로 채운 다음 번역을 추가하여 보기 흉한 텍스트 상자가 이미지를 덮지 않도록 합니다.',
            feature_title2: '만화 및 코믹스 번역',
            feature_desc2: '원본 만화 즉시 읽기: 애니메 팬에게 완벽합니다. 원본 만화 페이지(일본어/한국어)를 업로드하면 말풍선 내에 완벽하게 맞는 즉시 영어 번역을 얻을 수 있습니다.',
            feature_title3: '글로벌 마케팅 현지화',
            feature_desc3: '원클릭 현지화: 전 세계적으로 제품을 출시하고 계신가요? 원본 PSD 파일 없이 마케팅 포스터, 배너 및 UI 스크린샷을 30개 이상의 언어로 번역할 수 있습니다.',
        },
        aiBackgroundChanger: {
            title: '무료 AI 배경 교체기 - 텍스트에서 배경 생성 | 微鲤AI',
            description: 'AI로 사진 배경을 즉시 변경하세요. 원하는 장면을 설명하면 WeryAI가 제품 사진, LinkedIn 헤드샷 및 창의적인 초상화를 위한 사실적인 배경을 생성합니다. 무료 및 온라인.',
            keywords: '사진 배경 변경, AI 배경 생성기, 제품 사진 AI, 흰색 배경 제작기, 온라인 배경 교체, 생성 채우기 배경',
            og_title: '무료 AI 배경 교체기 - 텍스트에서 배경 생성',
            og_description: 'AI로 사진 배경을 즉시 변경하세요. 원하는 장면을 설명하면 WeryAI가 제품 사진, LinkedIn 헤드샷 및 창의적인 초상화를 위한 사실적인 배경을 생성합니다. 무료 및 온라인.',
            twitter_title: '무료 AI 배경 교체기 - 텍스트에서 배경 생성',
            twitter_description: 'AI로 사진 배경을 즉시 변경하세요. 원하는 장면을 설명하면 WeryAI가 제품 사진, LinkedIn 헤드샷 및 창의적인 초상화를 위한 사실적인 배경을 생성합니다. 무료 및 온라인.',
            page: {
                title1: '무료 AI 배경 교체기 및 생성기',
                title2: '배경을 제거하는 것이 아니라 더 나은 것으로 교체하세요. 사진을 업로드하고 원하는 장면을 설명하세요(예: "고급 대리석 스튜디오", "오피스 스카이라인"). 저희 생성 AI는 조명과 원근법을 이해하여 피사체를 새로운 환경에 완벽하게 블렌딩합니다.',
                faq: [
                    {
                        question: '텍스트를 사용하여 배경을 변경하는 방법은?',
                        answer: '이미지를 업로드하고 "배경 프롬프트" 상자에 원하는 장면을 설명하세요(예: "아늑한 커피숍"). 만들기를 클릭하면 AI가 해당 배경을 생성합니다.',
                    },
                    {
                        question: '배경을 순백색으로 변경할 수 있나요?',
                        answer: '예. 프롬프트 상자에 "순수한 흰색 배경" 또는 "스튜디오 화이트"를 입력하기만 하면 됩니다. Amazon/eBay 제품 목록 및 공식 ID 사진에 완벽합니다.',
                    },
                    {
                        question: '제품 사진에 좋은가요?',
                        answer: '물론입니다. WeryAI는 제품의 각도를 분석하고 올바른 그림자와 조명이 있는 배경을 생성하여 전문 스튜디오 촬영처럼 보이게 합니다.',
                    },
                    {
                        question: '조명이 자연스럽게 보이나요?',
                        answer: '저희 생성 AI(Adobe Firefly 또는 SDXL과 유사)는 생성된 배경의 조명을 피사체와 일치시키려고 시도하여 매끄럽게 블렌딩합니다.',
                    },
                    {
                        question: '무료로 사용할 수 있나요?',
                        answer: '예, 매일 무료 크레딧을 사용하여 새 배경을 무료로 생성할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '텍스트를 사용하여 배경을 변경하는 방법은?',
                    answer: '이미지를 업로드하고 "배경 프롬프트" 상자에 원하는 장면을 설명하세요(예: "아늑한 커피숍"). 만들기를 클릭하면 AI가 해당 배경을 생성합니다.',
                },
                {
                    question: '배경을 순백색으로 변경할 수 있나요?',
                    answer: '예. 프롬프트 상자에 "순수한 흰색 배경" 또는 "스튜디오 화이트"를 입력하기만 하면 됩니다. Amazon/eBay 제품 목록 및 공식 ID 사진에 완벽합니다.',
                },
                {
                    question: '제품 사진에 좋은가요?',
                    answer: '물론입니다. WeryAI는 제품의 각도를 분석하고 올바른 그림자와 조명이 있는 배경을 생성하여 전문 스튜디오 촬영처럼 보이게 합니다.',
                },
                {
                    question: '조명이 자연스럽게 보이나요?',
                    answer: '저희 생성 AI(Adobe Firefly 또는 SDXL과 유사)는 생성된 배경의 조명을 피사체와 일치시키려고 시도하여 매끄럽게 블렌딩합니다.',
                },
                {
                    question: '무료로 사용할 수 있나요?',
                    answer: '예, 매일 무료 크레딧을 사용하여 새 배경을 무료로 생성할 수 있습니다.',
                },
            ],
            feature_title1: '전문 ID 사진',
            feature_desc1: 'DIY LinkedIn 헤드샷: 캐주얼한 셀카를 전문 프로필 사진으로 바꾸세요. 지저분한 침실 배경을 깨끗한 사무실 또는 스튜디오 회색 배경으로 즉시 변경합니다.',
            feature_title2: '즉시 제품 사진',
            feature_desc2: '전자상거래 판매 증대: 사진 촬영에 수천 달러를 절약하세요. 간단한 텍스트 프롬프트로 제품을 나무 테이블, 모래 해변 또는 연단에 배치하세요. AI가 사실적인 그림자와 반사를 추가합니다.',
            feature_title3: '창의적 텔레포테이션',
            feature_desc3: '어디든 여행: 파리나 사이버펑크 미래에 있고 싶으신가요? 입력하기만 하면 됩니다. 저희 AI는 원본 사진의 조명과 일관성을 유지하면서 배경을 교체합니다.',
        },
        imageUpscaler: {
            title: '무료 AI 이미지 업스케일러 - 4K로 확대 & 오래된 사진 복원',
            description: 'WeryAI의 무료 AI 이미지 향상기로 저해상도 이미지를 2배, 4배, 최대 4K까지 즉시 확대하세요. 흐릿한 사진을 선명하게 하고 노이즈를 제거하며 오래된 가족 사진을 온라인에서 복원합니다. 무손실 품질.',
            keywords: 'AI 이미지 업스케일러, 사진 향상, 이미지 4K 업스케일, 흐림 제거, 오래된 사진 복원, 픽셀 깨짐 수정, 이미지 해상도 올리기',
            og_title: '무료 AI 이미지 업스케일러 - 4K로 확대 & 오래된 사진 복원',
            og_description: 'WeryAI의 무료 AI 이미지 향상기로 저해상도 이미지를 2배, 4배, 최대 4K까지 즉시 확대하세요. 흐릿한 사진을 선명하게 하고 노이즈를 제거하며 오래된 가족 사진을 온라인에서 복원합니다. 무손실 품질.',
            twitter_title: '무료 AI 이미지 업스케일러 - 4K로 확대 & 오래된 사진 복원',
            twitter_description: 'WeryAI의 무료 AI 이미지 향상기로 저해상도 이미지를 2배, 4배, 최대 4K까지 즉시 확대하세요. 흐릿한 사진을 선명하게 하고 노이즈를 제거하며 오래된 가족 사진을 온라인에서 복원합니다. 무손실 품질.',
            page: {
                title1: '무료 AI 이미지 업스케일러 & 향상기',
                title2: '픽셀 깨짐, 흐림, 또는 오래된 사진을 고해상도 작품으로 바꿔보세요. WeryAI는 고급 AI로 해상도를 최대 400%(4K)까지 높이면서 잃어버린 디테일을 복원하고 노이즈를 수정하며 오래된 가족 초상화의 얼굴을 선명하게 복원합니다.',
                faq: [
                    {
                        question: '인쇄용으로 저해상도 이미지를 업스케일할 수 있나요?',
                        answer: '네! WeryAI는 이미지의 해상도(픽셀 수)를 최대 4K까지 올려 포스터, 캔버스, 마케팅 자료 등 고품질 인쇄에 적합하게 만듭니다.',
                    },
                    {
                        question: 'AI 오래된 사진 복원은 어떻게 작동하나요?',
                        answer: 'AI가 오래된 사진의 손상되거나 흐릿한 부분을 분석하고, 딥러닝으로 얼굴 디테일, 질감, 배경을 예측·재구성해 사진을 효과적으로 “복원”합니다.',
                    },
                    {
                        question: '어떤 파일 형식을 지원하나요?',
                        answer: 'JPG, PNG, WEBP 등 일반적인 형식을 지원합니다. 결과물은 고품질 PNG 또는 JPG로 출력됩니다.',
                    },
                    {
                        question: '애니/만화에도 잘 되나요?',
                        answer: '네. 저희 AI는 애니메이션과 일러스트(waifu2x 스타일) 업스케일에 강해 선을 또렷하게 유지하고 색을 선명하게 살리며 아티팩트를 최소화합니다.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네, 매일 제공되는 크레딧으로 이미지를 무료로 향상할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '인쇄용으로 저해상도 이미지를 업스케일할 수 있나요?',
                    answer: '네! WeryAI는 해상도를 최대 4K까지 높여 고품질 인쇄에 적합하게 만듭니다.',
                },
                {
                    question: 'AI 오래된 사진 복원은 어떻게 작동하나요?',
                    answer: 'AI가 손상된 영역을 분석하고 딥러닝으로 얼굴 디테일과 질감을 재구성해 사진을 복원합니다.',
                },
                {
                    question: '애니에도 잘 되나요?',
                    answer: '네. 저희 AI는 애니/일러스트 업스케일에 강해 선을 또렷하게 유지하며 아티팩트를 줄입니다.',
                },
            ],
            feature_title1: '무손실 4K 업스케일링',
            feature_desc1: '인쇄용 퀄리티: 작은 이미지를 인쇄해야 하나요? 품질 손실 없이 4K 또는 8K로 업스케일하세요. 포스터, 전자상거래 제품 사진, 배경화면에 완벽합니다.',
            feature_title2: '스마트 노이즈 제거 & 선명화',
            feature_desc2: '야간 사진 복원: 저조도 사진의 디지털 노이즈와 입자를 제거합니다. 흐릿한 가장자리를 즉시 선명하게 만들어 사진을 또렷하고 전문적으로 보이게 합니다.',
            feature_title3: '오래된 사진 복원',
            feature_desc3: '추억 되살리기: 오래되었거나 손상되었거나 흑백인 사진이 있나요? AI가 새 픽셀을 생성해 스크래치를 복구하고 얼굴을 선명하게 하며 소중한 추억에 다시 또렷함을 되돌립니다.',
        },
        photoFaceSwap: {
            title: '무료 AI 얼굴 바꾸기 온라인 - 자연스러운 사진 얼굴 교체',
            description: 'WeryAI의 무료 AI 얼굴 교체기로 사진에서 얼굴을 즉시 바꿔보세요. 웃긴 밈, 예술적인 초상화(모나리자), 또는 고현실감 프로필 사진을 만들 수 있습니다. 100% 프라이버시 보호 및 안전.',
            keywords: 'AI 얼굴 바꾸기, 온라인 얼굴 교체, 사진 얼굴 교체, 얼굴 변경, 딥페이크 사진, 밈 만들기, 얼굴 스왑',
            og_title: '무료 AI 얼굴 바꾸기 온라인 - 자연스러운 사진 얼굴 교체',
            og_description: 'WeryAI의 무료 AI 얼굴 교체기로 사진에서 얼굴을 즉시 바꿔보세요. 웃긴 밈, 예술적인 초상화(모나리자), 또는 고현실감 프로필 사진을 만들 수 있습니다. 100% 프라이버시 보호 및 안전.',
            twitter_title: '무료 AI 얼굴 바꾸기 온라인 - 자연스러운 사진 얼굴 교체',
            twitter_description: 'WeryAI의 무료 AI 얼굴 교체기로 사진에서 얼굴을 즉시 바꿔보세요. 웃긴 밈, 예술적인 초상화(모나리자), 또는 고현실감 프로필 사진을 만들 수 있습니다. 100% 프라이버시 보호 및 안전.',
            page: {
                title1: '무료 AI 사진 얼굴 바꾸기',
                title2: '우주비행사, 영화 스타, 혹은 클래식 명화 속 내 모습을 보고 싶나요? 베이스 사진과 얼굴 사진을 업로드하면, AI가 얼굴 특징·조명·피부 톤을 자연스럽게 블렌딩해 몇 초 만에 초현실적인 얼굴 교체를 만들어 줍니다.',
                faq: [
                    {
                        question: '微鲤AI 얼굴 교체는 무료인가요?',
                        answer: '네. 온라인 사진 얼굴 교체를 위해 매일 무료 크레딧을 제공합니다. 설치나 카드 등록이 필요 없습니다.',
                    },
                    {
                        question: '내 데이터는 안전한가요?',
                        answer: '물론입니다. 우리는 개인정보를 최우선으로 합니다. 업로드한 사진은 얼굴 교체 과정에만 사용되며, 짧은 시간 후 서버에서 자동 삭제됩니다.',
                    },
                    {
                        question: '최고의 결과를 얻으려면 어떻게 해야 하나요?',
                        answer: '가장 자연스럽게 바꾸려면 “베이스 이미지”와 “얼굴 이미지”가 모두 선명하고 정면이며 조명이 좋은지 확인하세요. 머리카락이나 손이 얼굴을 가린 사진은 피하세요.',
                    },
                    {
                        question: '단체 사진에서도 얼굴을 바꿀 수 있나요?',
                        answer: '현재는 단일 얼굴 교체 정확도에 집중하고 있습니다. 단체 사진은 먼저 크롭하거나, 곧 출시될 다중 얼굴 기능을 이용해 주세요.',
                    },
                    {
                        question: '밈(짤)로도 쓸 수 있나요?',
                        answer: '네! 웃긴 밈 제작에 딱입니다. 친구 얼굴을 영화 포스터나 유행 밈 템플릿에 즉시 교체해 보세요.',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI 얼굴 교체는 무료인가요?',
                    answer: '네. 온라인 얼굴 교체를 위한 매일 무료 크레딧을 제공합니다. 설치나 카드 등록이 필요 없습니다.',
                },
                {
                    question: '내 데이터는 안전한가요?',
                    answer: '물론입니다. 업로드한 사진은 교체 과정에만 사용되며, 짧은 시간 후 서버에서 자동 삭제됩니다.',
                },
                {
                    question: '최고의 결과를 얻으려면 어떻게 해야 하나요?',
                    answer: '두 사진 모두 선명하고 정면이며 조명이 좋아야 합니다. 머리카락이나 안경이 얼굴을 가리는 사진은 피하세요.',
                },
            ],
            feature_title1: '예술 작품 스타일',
            feature_desc1: '시간여행: 모나리자나 진주 귀걸이를 한 소녀 같은 고전 명화에 내 얼굴을 바꿔 넣어, 독특한 빈티지 아바타를 즉시 만들어 보세요.',
            feature_title2: '프로필에 딱 맞는 아바타',
            feature_desc2: '드림 직업 콘셉트: 레이싱 슈트, 우주복, 비즈니스 정장 등—옷을 사지 않아도 내 모습을 확인할 수 있어요. 눈에 띄는 프로필 사진에 완벽합니다.',
            feature_title3: '초현실적 자연 합성',
            feature_desc3: '붙여넣기 느낌 0: 단순한 잘라붙이기와 달리, WeryAI는 각도·조명·피부 질감을 분석해 얼굴이 100% 자연스럽게 보이도록 만듭니다.',
        },
        removeTextFromImage: {
            title: '무료 AI 이미지 텍스트 제거 - 워터마크 & 날짜 스탬프 삭제',
            description: 'WeryAI의 무료 AI 텍스트 지우개로 이미지의 텍스트, 날짜 스탬프, 로고, 캡션을 즉시 제거하세요. AI 인페인팅으로 배경을 자연스럽게 복원해 사진 정리와 이커머스 목업에 최적입니다.',
            keywords: '이미지 텍스트 제거, AI 텍스트 지우개, 날짜 스탬프 제거, 온라인 워터마크 제거, 사진 클린업, AI 인페인팅, 사진 로고 제거',
            og_title: '무료 AI 이미지 텍스트 제거 - 워터마크 & 날짜 스탬프 삭제',
            og_description: 'WeryAI의 무료 AI 텍스트 지우개로 이미지의 텍스트, 날짜 스탬프, 로고, 캡션을 즉시 제거하세요. AI 인페인팅으로 배경을 자연스럽게 복원해 사진 정리와 이커머스 목업에 최적입니다.',
            twitter_title: '무료 AI 이미지 텍스트 제거 - 워터마크 & 날짜 스탬프 삭제',
            twitter_description: 'WeryAI의 무료 AI 텍스트 지우개로 이미지의 텍스트, 날짜 스탬프, 로고, 캡션을 즉시 제거하세요. AI 인페인팅으로 배경을 자연스럽게 복원해 사진 정리와 이커머스 목업에 최적입니다.',
            page: {
                title1: '무료 AI 이미지 텍스트 제거',
                title2: '원치 않는 텍스트가 거슬리나요? 이미지를 업로드하면 AI가 텍스트·로고·날짜 스탬프·캡션을 즉시 감지해 지웁니다. 주변 픽셀을 분석해 배경을 재구성하여 흔적을 남기지 않습니다.',
                faq: [
                    {
                        question: '블러 없이 사진의 텍스트를 지우려면?',
                        answer: '微鲤AI AI 텍스트 지우개를 사용하세요. 블러 처리 대신 AI 인페인팅으로 주변을 분석하고 새 픽셀을 생성해 자연스럽게 메웁니다.',
                    },
                    {
                        question: '사진에서 날짜 스탬프를 제거할 수 있나요?',
                        answer: '네! 날짜/시간 스탬프의 디지털 폰트를 쉽게 인식해 제거하고, 뒤의 풍경을 복원합니다.',
                    },
                    {
                        question: '복잡한 배경에서도 되나요?',
                        answer: '네. 산맥이나 패턴 의류처럼 복잡한 배경에서도 텍스처 흐름을 이해해 텍스트를 제거할 수 있습니다.',
                    },
                    {
                        question: '사람이나 물체 제거에도 쓸 수 있나요?',
                        answer: '텍스트에 최적화되어 있지만, 기반 기술(인페인팅)은 작은 불필요한 물체, 피부 잡티, 잡동사니 제거에도 유용합니다.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네, 매일 제공되는 크레딧으로 무료로 사용할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '블러 없이 사진의 텍스트를 지우려면?',
                    answer: '微鲤AI AI 텍스트 지우개를 사용하세요. AI 인페인팅으로 주변을 분석하고 새 픽셀을 생성해 자연스럽게 메웁니다.',
                },
                {
                    question: '사진에서 날짜 스탬프를 제거할 수 있나요?',
                    answer: '네! 날짜/시간 스탬프를 인식해 제거하면서 뒤의 배경을 복원합니다.',
                },
                {
                    question: '복잡한 배경에서도 되나요?',
                    answer: '네. 텍스처 흐름을 이해해 복잡한 배경에서도 자연스럽게 제거합니다.',
                },
            ],
            feature_title1: '의류·디자인 목업 정리',
            feature_desc1: '목업에 딱: 의류를 온라인에서 판매하나요? 티셔츠 모델 사진의 로고/문구/그래픽을 지워 내 디자인을 위한 깨끗한 캔버스를 만들 수 있습니다.',
            feature_title2: '추억 사진 복원',
            feature_desc2: '날짜 스탬프 삭제: 오래된 가족 사진이나 여행 사진의 주황색 날짜 스탬프를 풍경 손상 없이 제거하세요.',
            feature_title3: '지능형 인페인팅',
            feature_desc3: '자연스러운 배경 채움: 단순 지우개처럼 블러를 남기지 않고, WeryAI는 생성형 AI로 잔디·하늘·산 같은 질감을 자연스럽게 “그려 넣습니다”.',
        },
        imgExtender: {
            title: '지금 무료로 이미지 확장 - AI 이미지 확장기 | 微鲤AI',
            description: 'WeryAI의 무료 AI 이미지 확장기로 사진의 원래 경계를 즉시 넓혀보세요. AI가 업로드한 이미지와 자연스럽게 이어지는 새 픽셀을 생성해, 인물 사진을 광각 사진으로 확장해도 원본 느낌과 화질을 유지합니다.',
            keywords: 'AI 이미지 확장기, 무료 이미지 확장, 광각 사진 생성, 사진 경계 확장, 자연스러운 아웃페인팅, 원본 화질 유지',
            og_title: '지금 무료로 이미지 확장 - AI 이미지 확장기 | 微鲤AI',
            og_description: '사진을 원하는 새 크기로 확장하고 어울리는 콘텐츠를 생성하세요. AI 이미지 확장기를 지금 무료로 체험해보세요.',
            twitter_title: '지금 무료로 이미지 확장 - AI 이미지 확장기 | 微鲤AI',
            twitter_description: '사진을 원하는 새 크기로 확장하고 어울리는 콘텐츠를 생성하세요. AI 이미지 확장기를 지금 무료로 체험해보세요.',
            featureList: [
                'AI 이미지 확장기, 무료 이미지 확장, 광각 사진 생성, 원본 화질 유지',
            ],
            page: {
                title1: '강력한 AI 이미지 확장기로 놀라운 결과',
                title2: '몇 번의 클릭만으로 사진의 경계를 손쉽게 확장하세요. AI가 새 픽셀을 생성해 업로드 이미지와 매끄럽게 합성하며, 인물 사진을 광각 사진으로 바꿔도 원본 느낌과 화질을 유지합니다.',
                feature_title: '微鲤AI 이미지 확장기의 특별함',
                faq: [
                    {
                        question: 'AI 이미지 확장기란 무엇인가요?',
                        answer: '고급 AI가 이미지 바깥쪽을 지능적으로 채워 경계를 확장하는 도구입니다. 마케팅, 이커머스, SNS 게시물 등 다양한 용도에 적합합니다.',
                    },
                    {
                        question: '왜 微鲤AI 이미지 확장기를 사용해야 하나요?',
                        answer: '최신 AI가 이미지 특징을 분석해 주변 영역을 자연스럽고 고해상도로 아웃페인팅하여 깔끔하게 확장합니다.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네. 체험 크레딧으로 무료로 사용할 수 있어 예산이 적은 사용자도 이미지 편집 워크플로우에 쉽게 추가할 수 있습니다.',
                    },
                    {
                        question: '처리 속도는 얼마나 빠른가요?',
                        answer: '보통 몇 초 내에 완료됩니다. 빠른 편집은 물론 배치 작업에도 적합합니다.',
                    },
                    {
                        question: '해상도나 품질에 영향이 있나요?',
                        answer: '전혀 없습니다. 확장 과정에서도 해상도, 선명도, 디테일을 유지해 개인/전문 용도 모두 안심하고 사용할 수 있습니다.',
                    },
                    {
                        question: '업로드한 이미지는 안전하게 보호되나요?',
                        answer: '네. 업계 표준 보안과 엄격한 정책으로 데이터를 보호하며, 이미지를 제3자에게 공유하지 않습니다.',
                    },
                    {
                        question: '어떤 이미지 포맷을 지원하나요?',
                        answer: 'JPG, PNG, WebP 등 주요 포맷을 지원합니다. 단일 파일 최대 10MB이며 변환이 필요 없습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 이미지 확장기란 무엇인가요?',
                    answer: '고급 AI가 이미지 바깥쪽을 지능적으로 채워 경계를 확장하는 도구입니다. 마케팅, 이커머스, SNS 게시물 등 다양한 용도에 적합합니다.',
                },
                {
                    question: '왜 微鲤AI 이미지 확장기를 사용해야 하나요?',
                    answer: '최신 AI가 이미지 특징을 분석해 주변 영역을 자연스럽고 고해상도로 아웃페인팅하여 깔끔하게 확장합니다.',
                },
                {
                    question: '무료인가요?',
                    answer: '네. 체험 크레딧으로 무료로 사용할 수 있습니다.',
                },
                {
                    question: '처리 속도는 얼마나 빠른가요?',
                    answer: '보통 몇 초 내에 완료됩니다.',
                },
                {
                    question: '해상도나 품질에 영향이 있나요?',
                    answer: '전혀 없습니다. 해상도와 디테일을 유지합니다.',
                },
                {
                    question: '업로드한 이미지는 안전하게 보호되나요?',
                    answer: '네. 업계 표준 보안으로 보호되며 제3자와 공유되지 않습니다.',
                },
                {
                    question: '어떤 이미지 포맷을 지원하나요?',
                    answer: 'JPG, PNG, WebP 등 주요 포맷 지원(최대 10MB).',
                },
            ],
            feature_title1: '누락된 디테일과 배경 보완',
            feature_desc1: '잘린 사진도 부족한 디테일을 지능적으로 채워 화면을 더 완성도 있게 만듭니다. 아웃페인팅으로 오래된 사진의 누락 요소를 복원해 추억의 가치를 높일 수 있어요.',
            feature_title2: '제품 사진 퀄리티를 높여 판매 촉진',
            feature_desc2: '제품 사진 주변을 확장해 어울리는 배경 요소를 추가할 수 있습니다. 더 와이드한 구도로 제품 디테일을 보여 판매 전환에 도움을 줍니다.',
            feature_title3: '독창적인 비주얼 작품 만들기',
            feature_desc3: '사진가·콘텐츠 크리에이터·아티스트라면, 사진의 가장자리를 확장해 창의적 경계를 넓히고 멋진 비주얼을 완성할 수 있습니다.',
            feature_title4: 'SNS 비율 최적화',
            feature_desc4: 'Instagram, X(구 Twitter), Facebook 등 어떤 비율에도 맞게 확장할 수 있습니다. AI가 선명도와 디테일을 유지해 결과물이 더욱 돋보입니다.',
            textRemoverHowToUseTitle: 'AI 이미지 확장기 사용법',
            textRemoverHowToUseDesc: '3단계로 사진의 경계를 확장하세요',
            textRemoverHowToUseStep1Title: '이미지 업로드',
            textRemoverHowToUseStep1Desc: '확장하고 싶은 이미지를 클릭하거나 드래그 앤 드롭하세요.',
            textRemoverHowToUseStep2Title: 'AI 자동 처리',
            textRemoverHowToUseStep2Desc: '업로드 후 AI가 자동으로 경계를 감지하고 확장합니다.',
            textRemoverHowToUseStep3Title: '확장 이미지 다운로드',
            textRemoverHowToUseStep3Desc: '완료되면 미리보기/다운로드로 확장된 이미지를 저장하세요!',
        },
        photoRestoration: {
            title: '무료 AI 사진 복원 - 흑백 사진 컬러화 & 스크래치 복원',
            description: 'WeryAI의 무료 AI 사진 복원으로 오래된 가족의 추억을 되살리세요. 흑백 사진을 자동으로 컬러화하고, 스크래치·찢김·흐림을 제거해 얼굴을 즉시 복원합니다.',
            keywords: 'AI 사진 복원, 흑백 사진 컬러화, 오래된 사진 복구, 스크래치 제거, 찢어진 사진 복원, AI 사진 수리, 이미지 복원 AI',
            og_title: '무료 AI 사진 복원 - 흑백 사진 컬러화 & 스크래치 복원',
            og_description: 'WeryAI의 무료 AI 사진 복원으로 오래된 가족의 추억을 되살리세요. 흑백 사진을 자동으로 컬러화하고, 스크래치·찢김·흐림을 제거해 얼굴을 즉시 복원합니다.',
            twitter_title: '무료 AI 사진 복원 - 흑백 사진 컬러화 & 스크래치 복원',
            twitter_description: 'WeryAI의 무료 AI 사진 복원으로 오래된 가족의 추억을 되살리세요. 흑백 사진을 자동으로 컬러화하고, 스크래치·찢김·흐림을 제거해 얼굴을 즉시 복원합니다.',
            page: {
                title1: '무료 AI 오래된 사진 복원 & 컬러라이저',
                title2: '당신의 역사를 다시 생생하게. 바랜 흑백 결혼사진이든, 스크래치가 가득한 어린 시절 초상이든, AI가 손상 부위를 분석해 복원하고 얼굴을 선명하게 만들며 몇 초 만에 자연스러운 색을 똑똑하게 더합니다.',
                faq: [
                    {
                        question: '흑백 사진을 컬러로 바꾸려면 어떻게 하나요?',
                        answer: '흑백 이미지를 WeryAI에 업로드만 하세요. 도구가 그레이스케일을 자동 감지하고 “컬러화” 기능을 적용해 현실적인 색을 즉시 입힙니다.',
                    },
                    {
                        question: '찢어지거나 스크래치 난 사진도 고칠 수 있나요?',
                        answer: '네. AI는 스크래치, 찢김, 접힘을 인식하도록 학습되어 있으며, 주변 텍스처에 맞는 픽셀로 손상 부위를 자연스럽게 채웁니다.',
                    },
                    {
                        question: '복원 결과가 가짜처럼 보이지 않나요?',
                        answer: '목표는 ‘현실감’입니다. 얼굴 향상은 디테일을 더하지만 인물이 알아볼 수 있게 유지합니다. 컬러화도 시대감에 맞는 자연스러운 톤을 선택합니다.',
                    },
                    {
                        question: '사진이 매우 작아도 되나요?',
                        answer: '문제없습니다. 복원 과정에는 업스케일링도 포함되어 작은 지갑 사진도 해상도를 높여 디지털 감상이나 인쇄에 사용할 수 있습니다.',
                    },
                    {
                        question: '개인정보는 보호되나요?',
                        answer: '네. 오래된 사진은 개인적이라는 점을 이해합니다. 이미지는 안전하게 처리되며 서버에 영구 저장되지 않습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '흑백 사진을 컬러로 바꾸려면 어떻게 하나요?',
                    answer: '흑백 이미지를 업로드하면 자동 감지 후 “컬러화” 기능으로 현실적인 색을 즉시 입힙니다.',
                },
                {
                    question: '찢어지거나 스크래치 난 사진도 고칠 수 있나요?',
                    answer: '네. AI가 손상 부위를 인식해 주변 텍스처에 맞게 자연스럽게 복원합니다.',
                },
                {
                    question: '복원 결과가 가짜처럼 보이지 않나요?',
                    answer: '현실감을 우선합니다. 인물의 정체성을 유지하면서 자연스럽게 보정합니다.',
                },
            ],
            feature_title1: '스크래치 & 찢김 제거',
            feature_desc1: '시간의 흔적 지우기: 접힘, 스크래치, 찢김, 먼지 얼룩을 자동 감지해 채웁니다. AI가 사라진 얼굴 디테일까지 재구성해 새 사진처럼 만듭니다.',
            feature_title2: '지능형 컬러라이징',
            feature_desc2: '흑백→컬러: 단순 세피아 필터가 아닙니다. 딥러닝이 맥락(하늘, 피부, 천)을 이해해 시대에 자연스럽고 선명한 색을 더합니다.',
            feature_title3: '얼굴 선명화',
            feature_desc3: '흐린 얼굴 복원: 오래된 사진은 흔들림이나 초점 부족이 많습니다. WeryAI가 눈·코·입 등 특징을 선명하게 만들어 가족의 모습을 또렷하게 되살립니다.',
        },
        photoEffects: {
            title: '이미지 효과 - AI 이미지 효과 생성기 | 微鲤AI',
            description: 'AI 기반 효과로 사진을 변환하세요. 온라인에서 무료로 멋진 이미지 필터, 스타일 및 변환을 만드세요.',
            keywords: 'AI 이미지 효과, 이미지 효과, 사진 필터, AI 이미지 변환, 이미지 스타일 전환',
        },
    },
    es: {
        textToImage: {
            title: 'Texto a Imagen - Generador de Imágenes IA Gratis | 微鲤AI',
            description: 'Genera imágenes sorprendentes a partir de descripciones de texto con IA. Crea fotos realistas, ilustraciones y obras artísticas con modelos avanzados, ideal para contenido creativo y proyectos de diseño.',
            keywords: 'texto a imagen, generador imágenes IA, generación de imágenes, creación imágenes IA, texto a foto, herramienta IA de imágenes',
            og_title: 'Generador de Imágenes IA Gratis desde Texto - Crea Arte 4K y Fotos Realistas | 微鲤AI',
            og_description: 'Convierte descripciones de texto en visuales impresionantes con el Generador de Imágenes de Texto de 微鲤AI. Incluye el modelo Nano Banana Pro para resultados de alta fidelidad. Soporta resolución 1K/2K/4K y proporciones 9:16/16:9. Gratis y en línea.',
            twitter_title: 'Generador de Imágenes IA Gratis desde Texto - Crea Arte 4K y Fotos Realistas | 微鲤AI',
            twitter_description: 'Convierte descripciones de texto en visuales impresionantes con el Generador de Imágenes de Texto de 微鲤AI. Incluye el modelo Nano Banana Pro para resultados de alta fidelidad. Soporta resolución 1K/2K/4K y proporciones 9:16/16:9. Gratis y en línea.',
            faq: [
                {
                    question: '¿Cómo genero imágenes IA en 4K?',
                    answer: 'Simplemente ingresa tu descripción y selecciona "4K" en la configuración de Tamaño de Imagen en el panel izquierdo antes de hacer clic en Crear.',
                },
                {
                    question: '¿Qué proporciones de aspecto se admiten?',
                    answer: 'Admitimos todas las proporciones principales, incluyendo 1:1, 9:16 (Móvil), 16:9 (Escritorio), 4:3 y 3:2 para adaptarse a cualquier plataforma.',
                },
                {
                    question: '¿Puedo usar las imágenes comercialmente?',
                    answer: 'Sí. Las imágenes generadas en los planes de 微鲤AI generalmente vienen con una licencia comercial adecuada para anuncios y productos.',
                },
            ],
            page: {
                title1: 'Generador Gratuito de Imágenes IA desde Texto',
                title2: 'Crea arte impresionante, imágenes fotorrealistas y fondos de pantalla únicos en segundos. Solo describe lo que quieres ver, y nuestro modelo avanzado Nano Banana Pro generará imágenes 4K de alta fidelidad que coincidan perfectamente con tu descripción.',
                resolution: 'Deja de conformarte con imágenes IA borrosas. 微鲤AI te permite generar imágenes nítidas de 1K, 2K y 4K directamente, perfectas para impresión o pantallas de alta resolución.',
                aspectRatio: 'Ya sea que necesites una imagen 9:16 para fondos de TikTok, 16:9 para miniaturas de YouTube, o 1:1 para Instagram, tenemos preajustes para cada plataforma social.',
                online_search: '¿Necesitas contexto actualizado? Activa "Búsqueda en línea" para permitir que la IA navegue por la web y comprenda mejor eventos actuales o referencias específicas en tu descripción.',
                faq: [
                    {
                        question: '¿Cómo genero imágenes de alta calidad desde texto?',
                        answer: 'Ingresa una descripción detallada que describa el sujeto, la iluminación y el estilo. Selecciona "4K" en la configuración de Tamaño de Imagen para obtener los detalles más nítidos.',
                    },
                    {
                        question: '¿Qué es el modelo Nano Banana Pro?',
                        answer: 'Nano Banana Pro es nuestro modelo de mayor fidelidad, optimizado para adherencia al prompt y fotorrealismo. Rivaliza en calidad con modelos top como Midjourney v6 y Flux.',
                    },
                    {
                        question: '¿Puedo usar las imágenes con fines comerciales?',
                        answer: 'Sí. Las imágenes generadas en 微鲤AI (planes de pago) vienen con una licencia comercial, lo que te permite usarlas para anuncios, sitios web y productos.',
                    },
                    {
                        question: '¿Cuántas imágenes puedo generar a la vez?',
                        answer: 'Puedes generar hasta 4 imágenes simultáneamente (como se muestra en la configuración "Número de Imágenes de Salida"), lo que te permite iterar rápidamente sobre ideas.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes generar imágenes usando nuestros créditos diarios gratuitos. Las resoluciones más altas (4K) pueden requerir más créditos.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Generador Gratuito de Imagen a Imagen IA - Convierte Fotos en Arte y 4K | 微鲤AI',
            description: 'Sube una foto de referencia y transfórmala con la IA de Imagen a Imagen de 微鲤AI. Convierte bocetos en arte realista, cambia estilos o genera variaciones manteniendo la composición original. Soporta resolución 4K.',
            keywords: 'imagen a imagen ai, img2img, convertir foto en dibujo, variación imagen ai, boceto a imagen, remix foto ai, generador arte ai gratis',
            og_title: 'Generador Gratuito de Imagen a Imagen IA - Convierte Fotos en Arte y 4K | 微鲤AI',
            og_description: 'Sube una foto de referencia y transfórmala con la IA de Imagen a Imagen de 微鲤AI. Convierte bocetos en arte realista, cambia estilos o genera variaciones manteniendo la composición original. Soporta resolución 4K.',
            twitter_title: 'Generador Gratuito de Imagen a Imagen IA - Convierte Fotos en Arte y 4K | 微鲤AI',
            twitter_description: 'Sube una foto de referencia y transfórmala con la IA de Imagen a Imagen de 微鲤AI. Convierte bocetos en arte realista, cambia estilos o genera variaciones manteniendo la composición original. Soporta resolución 4K.',
            faq: [
                {
                    question: '¿Qué es la IA de Imagen a Imagen?',
                    answer: 'Imagen a Imagen (Img2Img) utiliza una imagen subida como referencia junto con un prompt de texto para generar una nueva imagen, combinando la entrada visual con la descripción creativa.',
                },
                {
                    question: '¿Cómo convierto un boceto en una foto realista?',
                    answer: `Sube tu boceto, ingresa un prompt que describa la escena (por ejemplo, 'edificio fotorrealista') y haz clic en Crear.`,
                },
                {
                    question: '¿Mantiene el rostro original?',
                    answer: 'Preserva la estructura y la pose. Para una retención precisa de la identidad facial, por favor usa nuestra herramienta de Intercambio de Rostro en Fotos.',
                },
            ],
            page: {
                title1: 'Generador Gratuito de Imagen a Imagen IA',
                title2: 'Usa tus imágenes existentes como plano. Sube una foto, boceto o diseño, y deja que nuestra IA lo regenere en un estilo completamente nuevo basado en tu prompt de texto. Perfecto para preservar la composición mientras exploras variaciones artísticas infinitas.',
                title3: 'Transforma Tus Fotos con Transferencia de Estilo IA',
                title4: '¿Por Qué Usar Imagen a Imagen (Img2Img)?',
                upload_image: '¿Tienes problemas para describir una pose o diseño con palabras? Simplemente sube una imagen de referencia. Nuestro motor Img2Img mantiene la estructura de tu foto original pero repinta los detalles.',
                resolution: 'Convierte un garabato o wireframe en un renderizado fotorrealista o ilustración de alta calidad en segundos. Ideal para diseñadores y arquitectos.',
                output: 'Genera recursos listos para producción. A diferencia de otras herramientas que generan imágenes pequeñas, 微鲤AI soporta resoluciones 1K, 2K y 4K para detalles nítidos.',
                faq: [
                    {
                        question: '¿Qué es la IA de Imagen a Imagen?',
                        answer: 'Imagen a Imagen (Img2Img) es una tecnología que utiliza una imagen subida como "referencia" junto con un prompt de texto para generar una nueva imagen. Combina tu entrada visual con tu descripción creativa.',
                    },
                    {
                        question: '¿Cómo convierto un boceto en una foto realista?',
                        answer: 'Sube tu boceto al área de "Imagen". En el cuadro de "Prompt", describe lo que representa el boceto (por ejemplo, "Una villa moderna, atardecer, fotorrealista, 8k"). Haz clic en Crear para ver la magia.',
                    },
                    {
                        question: '¿Mantiene el rostro/persona original?',
                        answer: 'Intenta preservar la estructura general y la pose. Sin embargo, para una retención precisa del rostro, recomendamos usar nuestra herramienta específica de "Intercambio de Rostro en Fotos" en su lugar.',
                    },
                    {
                        question: '¿Qué proporciones se soportan?',
                        answer: 'Soportamos una amplia gama de proporciones incluyendo 9:16 (Historia), 16:9 (Cinematográfico), 3:4 y 1:1, asegurando que tu arte generado se ajuste perfectamente a cualquier plataforma.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes generar variaciones gratis usando tus créditos diarios.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Extensor y Redimensionador de Imagen IA Gratis - Descortar y Extender Fotos',
            description: 'Redimensiona imágenes para Instagram, TikTok y YouTube sin recortar. El Extensor de Imagen IA de 微鲤AI usa relleno generativo (extensión) para expandir fondos de imagen de forma inteligente. Cambia proporciones sin problemas.',
            keywords: 'extensor imagen ai, descortar imagen, extensión ai, redimensionador imagen ai, expandir fondo imagen, relleno generativo online, hacer foto vertical',
            og_title: 'Extensor y Redimensionador de Imagen IA Gratis - Descortar y Extender Fotos',
            og_description: 'Redimensiona imágenes para Instagram, TikTok y YouTube sin recortar. El Extensor de Imagen IA de 微鲤AI usa relleno generativo (extensión) para expandir fondos de imagen de forma inteligente. Cambia proporciones sin problemas.',
            twitter_title: 'Extensor y Redimensionador de Imagen IA Gratis - Descortar y Extender Fotos',
            twitter_description: 'Redimensiona imágenes para Instagram, TikTok y YouTube sin recortar. El Extensor de Imagen IA de 微鲤AI usa relleno generativo (extensión) para expandir fondos de imagen de forma inteligente. Cambia proporciones sin problemas.',
            page: {
                title1: 'Extensor y Redimensionador de Imagen IA Gratis',
                title2: 'Deja de recortar tus fotos favoritas para que encajen en redes sociales. Ya sea que necesites convertir una foto horizontal en una Historia vertical o expandir una imagen cuadrada a 16:9, nuestro Extensor de Imagen IA genera mágicamente nuevos detalles de fondo (Extensión) para ajustarse perfectamente a cualquier proporción.',
                faq: [
                    {
                        question: '¿Cómo redimensiono una imagen sin recortar?',
                        answer: 'Usa el Extensor de Imagen IA de 微鲤AI. Sube tu foto, selecciona la proporción objetivo (por ejemplo, 9:16), y la IA generará automáticamente (extenderá) las áreas de fondo faltantes en lugar de recortar tu imagen.',
                    },
                    {
                        question: '¿Qué es la Extensión IA?',
                        answer: 'La extensión es una tecnología de IA generativa que expande los bordes de una imagen prediciendo y dibujando nuevo contenido que coincide con el estilo original, efectivamente "descortando" la foto.',
                    },
                    {
                        question: '¿Puedo convertir una foto horizontal en vertical?',
                        answer: '¡Sí! Simplemente sube tu foto horizontal (paisaje) y selecciona la proporción 9:16. La IA extenderá la parte superior e inferior de la imagen para llenar el marco vertical.',
                    },
                    {
                        question: '¿Se verá falso el fondo expandido?',
                        answer: '微鲤AI usa modelos generativos avanzados entrenados en conjuntos de datos masivos para asegurar que el fondo expandido se mezcle naturalmente con la iluminación y textura originales.',
                    },
                    {
                        question: '¿Es gratis usarlo?',
                        answer: 'Sí, los usuarios reciben créditos gratuitos para probar las funciones de Redimensionamiento Inteligente IA y Extensión.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo redimensiono una imagen sin recortar?',
                    answer: 'Usa el Extensor de Imagen IA de 微鲤AI. Sube tu foto, selecciona la proporción objetivo (por ejemplo, 9:16), y la IA generará automáticamente (extenderá) las áreas de fondo faltantes en lugar de recortar tu imagen.',
                },
                {
                    question: '¿Qué es la Extensión IA?',
                    answer: 'La extensión es una tecnología de IA generativa que expande los bordes de una imagen prediciendo y dibujando nuevo contenido que coincide con el estilo original, efectivamente "descortando" la foto.',
                },
                {
                    question: '¿Puedo convertir una foto horizontal en vertical?',
                    answer: '¡Sí! Simplemente sube tu foto horizontal (paisaje) y selecciona la proporción 9:16. La IA extenderá la parte superior e inferior de la imagen para llenar el marco vertical.',
                },
                {
                    question: '¿Se verá falso el fondo expandido?',
                    answer: '微鲤AI usa modelos generativos avanzados entrenados en conjuntos de datos masivos para asegurar que el fondo expandido se mezcle naturalmente con la iluminación y textura originales.',
                },
                {
                    question: '¿Es gratis usarlo?',
                    answer: 'Sí, los usuarios reciben créditos gratuitos para probar las funciones de Redimensionamiento Inteligente IA y Extensión.',
                },
            ],
            feature_title1: 'Extensión Inteligente de Fondo',
            feature_desc1: 'Extensión Mágica: La IA entiende el contexto de tu imagen y pinta nuevos píxeles más allá de los bordes originales. Expande paisajes, habitaciones o texturas sin problemas para llenar el marco.',
            feature_title2: 'Protección del Centro',
            feature_desc2: 'Nunca Recortes el Sujeto: Nuestra IA identifica automáticamente a la persona u objeto principal y los bloquea en el centro, asegurando que nunca se corten durante el proceso de redimensionamiento.',
            feature_title3: 'Listo para Redes Sociales',
            feature_desc3: 'Presets de un clic para Instagram Stories (9:16), Miniaturas de YouTube (16:9) y Publicaciones (4:5). Reutiliza tu contenido en todas las plataformas al instante.',
        },
        imageTextTranslate: {
            title: 'Traductor de Imagen IA Gratis - Traduce Texto en Fotos, Manga y Cómics',
            description: 'Traduce texto en imágenes al instante mientras preservas el estilo visual original. El Traductor de Imagen IA de 微鲤AI borra automáticamente el texto original y redibuja las traducciones. Perfecto para cómics, manga y carteles de marketing.',
            keywords: 'traductor imagen ai, traducir texto en imagen, traductor de imágenes, traductor manga, traducir cómics, traductor ocr, reemplazo texto imagen',
            og_title: 'Traductor de Imagen IA Gratis - Traduce Texto en Fotos, Manga y Cómics',
            og_description: 'Traduce texto en imágenes al instante mientras preservas el estilo visual original. El Traductor de Imagen IA de 微鲤AI borra automáticamente el texto original y redibuja las traducciones. Perfecto para cómics, manga y carteles de marketing.',
            twitter_title: 'Traductor de Imagen IA Gratis - Traduce Texto en Fotos, Manga y Cómics',
            twitter_description: 'Traduce texto en imágenes al instante mientras preservas el estilo visual original. El Traductor de Imagen IA de 微鲤AI borra automáticamente el texto original y redibuja las traducciones. Perfecto para cómics, manga y carteles de marketing.',
            page: {
                title1: 'Traductor de Imagen IA Gratis y Reemplazador de Texto',
                title2: 'Traduce carteles, menús, cómics y capturas de pantalla en segundos. A diferencia de los traductores estándar que solo superponen texto, 微鲤AI usa IA Generativa para borrar el texto original y redibujar el fondo, haciendo que el texto traducido parezca parte del diseño original.',
                faq: [
                    {
                        question: '¿Cómo traduzco texto dentro de una imagen?',
                        answer: 'Sube tu imagen (JPG, PNG) a 微鲤AI. Selecciona el idioma de origen (o usa Detección Automática) y el idioma objetivo. Haz clic en "Crear" para que la IA reemplace el texto.',
                    },
                    {
                        question: '¿Se verá natural el texto traducido?',
                        answer: 'Sí. 微鲤AI intenta coincidir con el tamaño y estilo de fuente del texto original. Es crucial que redibuja el fondo detrás del texto para que la traducción se integre perfectamente.',
                    },
                    {
                        question: '¿Puedo usar esto para traducir Manga o Manhwa?',
                        answer: 'Absolutamente. Este es uno de los mejores casos de uso. La IA detecta globos de diálogo y texto vertical (común en japonés), reemplazándolos con texto traducido horizontal.',
                    },
                    {
                        question: '¿Qué idiomas están soportados?',
                        answer: 'Soportamos traducción entre los principales idiomas globales incluyendo inglés, español, chino, japonés, coreano, francés, alemán y más.',
                    },
                    {
                        question: '¿Funciona con texto escrito a mano?',
                        answer: 'Funciona mejor con texto impreso, pero nuestro motor OCR avanzado puede reconocer texto escrito a mano claro en pizarras o notas.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Puedes traducir imágenes gratis usando tus créditos diarios.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo traduzco texto dentro de una imagen?',
                    answer: `Sube tu imagen a 微鲤AI. Selecciona el idioma objetivo y haz clic en 'Crear'. La IA reemplazará el texto original con la traducción.`,
                },
                {
                    question: '¿Se verá natural el texto traducido?',
                    answer: 'Sí. 微鲤AI redibuja el fondo detrás del texto e intenta coincidir con el estilo de fuente, asegurando que la traducción se integre perfectamente.',
                },
                {
                    question: '¿Puedo usar esto para traducir Manga o Manhwa?',
                    answer: 'Absolutamente. Este es uno de los mejores casos de uso. La IA detecta globos de diálogo y texto vertical (común en japonés), reemplazándolos con texto traducido horizontal.',
                },
            ],
            feature_title1: 'Inpainting y Redibujo Inteligente',
            feature_desc1: 'Reemplazo de Texto Perfecto: Nuestra IA analiza la textura del fondo detrás del texto. Borra las palabras originales y llena el espacio inteligentemente antes de agregar la traducción, asegurando que no haya cajas de texto feas cubriendo tu imagen.',
            feature_title2: 'Traducción de Manga y Cómics',
            feature_desc2: 'Lee Manga Crudo al Instante: Perfecto para fanáticos del anime. Sube páginas de manga crudo (japonés/coreano) y obtén traducciones instantáneas al inglés que encajan perfectamente dentro de los globos de diálogo.',
            feature_title3: 'Localización de Marketing Global',
            feature_desc3: 'Localización con Un Clic: ¿Lanzando productos globalmente? Traduce tus carteles de marketing, banners y capturas de pantalla de UI a más de 30 idiomas sin necesidad de los archivos PSD originales.',
        },
        aiBackgroundChanger: {
            title: 'Cambiador de Fondo IA Gratis - Genera Fondos desde Texto',
            description: 'Cambia el fondo de tus fotos al instante con IA. Describe la escena que quieres y 微鲤AI generará fondos realistas para fotografía de producto, fotos profesionales tipo LinkedIn y retratos creativos. Gratis y online.',
            keywords: 'cambiar fondo de foto, generador de fondos IA, fotografía de producto IA, fondo blanco, reemplazar fondo online, relleno generativo de fondo',
            og_title: 'Cambiador de Fondo IA Gratis - Genera Fondos desde Texto',
            og_description: 'Cambia el fondo de tus fotos al instante con IA. Describe la escena que quieres y 微鲤AI generará fondos realistas para fotografía de producto, fotos profesionales tipo LinkedIn y retratos creativos. Gratis y online.',
            twitter_title: 'Cambiador de Fondo IA Gratis - Genera Fondos desde Texto',
            twitter_description: 'Cambia el fondo de tus fotos al instante con IA. Describe la escena que quieres y 微鲤AI generará fondos realistas para fotografía de producto, fotos profesionales tipo LinkedIn y retratos creativos. Gratis y online.',
            page: {
                title1: 'Cambiador de Fondo IA Gratis y Generador',
                title2: 'No solo elimines el fondo: cámbialo por uno mejor. Sube tu foto y describe cualquier escena (p. ej., "estudio de mármol de lujo", "skyline de oficina"). Nuestra IA generativa entiende la luz y la perspectiva para integrar tu sujeto perfectamente en el nuevo entorno.',
                faq: [
                    {
                        question: '¿Cómo cambio el fondo usando texto?',
                        answer: 'Sube tu imagen y, en el cuadro de "Prompt de Fondo", describe la escena que quieres (p. ej., "una cafetería acogedora"). Haz clic en Crear y la IA generará ese fondo para ti.',
                    },
                    {
                        question: '¿Puedo cambiar el fondo a blanco liso?',
                        answer: 'Sí. Solo escribe "fondo blanco puro" o "blanco de estudio" en el prompt. Es perfecto para listados de productos de Amazon/eBay y fotos de identificación.',
                    },
                    {
                        question: '¿Es bueno para fotografía de producto?',
                        answer: 'Totalmente. 微鲤AI analiza el ángulo de tu producto y genera fondos con sombras e iluminación correctas, haciendo que parezca una sesión profesional de estudio.',
                    },
                    {
                        question: '¿La iluminación se verá natural?',
                        answer: 'Nuestra IA generativa (similar a Adobe Firefly o SDXL) intenta igualar la iluminación del fondo generado con tu sujeto para que se integren de forma natural.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes generar nuevos fondos gratis con tus créditos diarios.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo cambio el fondo usando texto?',
                    answer: 'Sube tu imagen y, en el cuadro de "Prompt de Fondo", describe la escena que quieres (p. ej., "una cafetería acogedora"). Haz clic en Crear y la IA generará ese fondo para ti.',
                },
                {
                    question: '¿Puedo cambiar el fondo a blanco liso?',
                    answer: 'Sí. Solo escribe "fondo blanco puro" o "blanco de estudio" en el prompt. Es perfecto para listados de productos de Amazon/eBay y fotos de identificación.',
                },
                {
                    question: '¿Es bueno para fotografía de producto?',
                    answer: 'Totalmente. 微鲤AI analiza el ángulo de tu producto y genera fondos con sombras e iluminación correctas, haciendo que parezca una sesión profesional de estudio.',
                },
                {
                    question: '¿La iluminación se verá natural?',
                    answer: 'Nuestra IA generativa (similar a Adobe Firefly o SDXL) intenta igualar la iluminación del fondo generado con tu sujeto para que se integren de forma natural.',
                },
                {
                    question: '¿Es gratis?',
                    answer: 'Sí, puedes generar nuevos fondos gratis con tus créditos diarios.',
                },
            ],
            feature_title1: 'Fotos de ID Profesionales',
            feature_desc1: 'Headshots DIY para LinkedIn: Convierte una selfie casual en una foto de perfil profesional. Cambia un fondo desordenado de dormitorio por una oficina limpia o un fondo gris de estudio al instante.',
            feature_title2: 'Fotografía de Producto Instantánea',
            feature_desc2: 'Aumenta ventas en e-commerce: Ahorra miles en sesiones. Coloca tu producto sobre una mesa de madera, una playa de arena o un podio con simples prompts. La IA añade sombras y reflejos realistas.',
            feature_title3: 'Teletransportación Creativa',
            feature_desc3: 'Viaja a cualquier lugar: ¿Quieres estar en París o en un futuro cyberpunk? Solo escríbelo. Nuestra IA reemplaza el fondo manteniendo la coherencia de la iluminación de tu foto original.',
        },
        imageUpscaler: {
            title: 'Escalador de Imágenes IA Gratis - Amplía a 4K y Restaura Fotos Antiguas',
            description: 'Amplía al instante imágenes de baja resolución a 2x, 4x y hasta 4K con el Mejorador de Imágenes IA Gratis de 微鲤AI. Arregla fotos borrosas, elimina ruido y restaura fotos familiares antiguas en línea. Calidad sin pérdida.',
            keywords: 'escalador de imágenes IA, mejorador de fotos, ampliar imagen a 4k, quitar desenfoque, restauración de fotos antiguas, arreglar foto pixelada, aumentar resolución de imagen',
            og_title: 'Escalador de Imágenes IA Gratis - Amplía a 4K y Restaura Fotos Antiguas',
            og_description: 'Amplía al instante imágenes de baja resolución a 2x, 4x y hasta 4K con el Mejorador de Imágenes IA Gratis de 微鲤AI. Arregla fotos borrosas, elimina ruido y restaura fotos familiares antiguas en línea. Calidad sin pérdida.',
            twitter_title: 'Escalador de Imágenes IA Gratis - Amplía a 4K y Restaura Fotos Antiguas',
            twitter_description: 'Amplía al instante imágenes de baja resolución a 2x, 4x y hasta 4K con el Mejorador de Imágenes IA Gratis de 微鲤AI. Arregla fotos borrosas, elimina ruido y restaura fotos familiares antiguas en línea. Calidad sin pérdida.',
            page: {
                title1: 'Escalador y Mejorador de Imágenes IA Gratis',
                title2: 'Convierte fotos pixeladas, borrosas o antiguas en obras maestras en alta definición. 微鲤AI usa IA avanzada para aumentar la resolución hasta un 400% (4K), recuperando detalles perdidos, corrigiendo ruido y restaurando rostros en retratos familiares antiguos.',
                faq: [
                    {
                        question: '¿Puedo ampliar imágenes de baja resolución para imprimir?',
                        answer: '¡Sí! 微鲤AI aumenta la resolución (cantidad de píxeles) de tu imagen hasta 4K, haciéndola apta para impresión de alta calidad en pósters, lienzos o materiales de marketing.',
                    },
                    {
                        question: '¿Cómo funciona la restauración de fotos antiguas con IA?',
                        answer: 'La IA analiza las partes dañadas o borrosas de la foto antigua y usa aprendizaje profundo para predecir y reconstruir detalles faciales, texturas y fondos, “curando” la imagen.',
                    },
                    {
                        question: '¿Qué formatos se admiten?',
                        answer: 'Admitimos formatos comunes como JPG, PNG y WEBP. La salida será un PNG o JPG de alta calidad.',
                    },
                    {
                        question: '¿Funciona en anime/cómics?',
                        answer: 'Sí. Nuestra IA destaca al ampliar anime e ilustraciones (estilo waifu2x), manteniendo líneas nítidas y colores vibrantes sin artefactos.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes mejorar imágenes gratis usando tus créditos diarios.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Puedo ampliar imágenes de baja resolución para imprimir?',
                    answer: '¡Sí! 微鲤AI aumenta la resolución hasta 4K, haciendo las imágenes aptas para impresión de alta calidad.',
                },
                {
                    question: '¿Cómo funciona la restauración de fotos antiguas con IA?',
                    answer: 'La IA analiza áreas dañadas y reconstruye detalles faciales y texturas con aprendizaje profundo para “curar” la imagen.',
                },
                {
                    question: '¿Funciona en anime?',
                    answer: 'Sí. Nuestra IA destaca al ampliar anime e ilustraciones, manteniendo líneas nítidas sin artefactos.',
                },
            ],
            feature_title1: 'Ampliación sin Pérdida hasta 4K',
            feature_desc1: 'Calidad Lista para Imprimir: ¿Necesitas imprimir una imagen pequeña? Amplíala a 4K u 8K sin perder calidad. Perfecto para pósters, fotos de producto para e-commerce y fondos de pantalla.',
            feature_title2: 'Reducción de Ruido y Desenfoque Inteligente',
            feature_desc2: 'Arregla Fotos Nocturnas: Elimina ruido digital y granulado en fotos con poca luz. Enfoca bordes borrosos al instante para que se vean nítidas y profesionales.',
            feature_title3: 'Restauración de Fotos Antiguas',
            feature_desc3: 'Revive Recuerdos: ¿Tienes fotos antiguas, dañadas o en blanco y negro? Nuestra IA crea nuevos píxeles para reparar arañazos, enfocar rostros y devolver claridad a tus recuerdos.',
        },
        photoFaceSwap: {
            title: 'Intercambio de Rostros IA Gratis - Face Swap Realista Online | 微鲤AI',
            description: 'Cambia rostros en fotos al instante con el Face Swapper IA Gratis de 微鲤AI. Crea memes divertidos, retratos artísticos (Mona Lisa) o headshots profesionales con gran realismo. 100% privado y seguro.',
            keywords: 'face swap IA, intercambio de rostros online, cambiador de cara, reface gratis, reemplazar cara en imagen, deepfake foto, creador de memes IA',
            og_title: 'Intercambio de Rostros IA Gratis - Face Swap Realista Online | 微鲤AI',
            og_description: 'Cambia rostros en fotos al instante con el Face Swapper IA Gratis de 微鲤AI. Crea memes divertidos, retratos artísticos (Mona Lisa) o headshots profesionales con gran realismo. 100% privado y seguro.',
            twitter_title: 'Intercambio de Rostros IA Gratis - Face Swap Realista Online | 微鲤AI',
            twitter_description: 'Cambia rostros en fotos al instante con el Face Swapper IA Gratis de 微鲤AI. Crea memes divertidos, retratos artísticos (Mona Lisa) o headshots profesionales con gran realismo. 100% privado y seguro.',
            page: {
                title1: 'Intercambio de Rostros en Fotos con IA Gratis',
                title2: '¿Quieres verte como astronauta, estrella de cine o dentro de una pintura clásica? Sube una foto base y un rostro objetivo, y deja que nuestra IA mezcle rasgos faciales, iluminación y tonos de piel para un face swap hiperrealista en segundos.',
                faq: [
                    {
                        question: '¿微鲤AI Face Swap es gratis?',
                        answer: 'Sí, ofrecemos créditos diarios gratuitos para que puedas intercambiar rostros en fotos online. No necesitas instalar nada ni usar tarjeta.',
                    },
                    {
                        question: '¿Mis datos están seguros?',
                        answer: 'Totalmente. Priorizamos tu privacidad. Las fotos que subes se usan solo para el proceso de intercambio y se eliminan automáticamente de nuestros servidores tras un corto periodo.',
                    },
                    {
                        question: '¿Cómo obtengo los mejores resultados?',
                        answer: 'Para un resultado más realista, asegúrate de que la “Imagen Base” y la “Imagen de Rostro” sean claras, de frente y con buena luz. Evita fotos donde el rostro esté tapado por cabello o manos.',
                    },
                    {
                        question: '¿Puedo intercambiar rostros en fotos grupales?',
                        answer: 'Actualmente nos enfocamos en la precisión de intercambio de un solo rostro. Para fotos grupales, recorta la imagen o espera nuestra próxima función de múltiples rostros.',
                    },
                    {
                        question: '¿Puedo usarlo para memes?',
                        answer: '¡Sí! Es perfecto para crear memes divertidos. Cambia la cara de tu amigo en un póster de película o en una plantilla viral al instante.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿微鲤AI Face Swap es gratis?',
                    answer: 'Sí, ofrecemos créditos diarios gratuitos para intercambiar rostros en fotos online. Sin instalación ni tarjeta.',
                },
                {
                    question: '¿Mis datos están seguros?',
                    answer: 'Sí. Las fotos se usan solo para el intercambio y se eliminan automáticamente tras un corto periodo.',
                },
                {
                    question: '¿Cómo obtengo los mejores resultados?',
                    answer: 'Asegúrate de que ambas fotos sean claras, de frente y con buena iluminación. Evita rostros cubiertos por cabello o gafas.',
                },
            ],
            feature_title1: 'Obras Maestras Artísticas',
            feature_desc1: 'Viaje en el Tiempo: Cambia tu rostro en pinturas clásicas como la Mona Lisa o La joven de la perla. Crea avatares vintage únicos al instante.',
            feature_title2: 'Avatares Profesionales y Cool',
            feature_desc2: 'Trabajos Soñados: Mírate con traje de carreras, equipo de astronauta o ropa formal sin comprar el disfraz. Perfecto para fotos de perfil que destacan.',
            feature_title3: 'Mezcla Hiperrealista',
            feature_desc3: 'Sin efecto “pegado”: A diferencia de herramientas de cortar y pegar, 微鲤AI analiza ángulo, luz y textura de piel para que el rostro se vea 100% natural, no falso.',
        },
        removeTextFromImage: {
            title: 'Eliminador de Texto IA Gratis - Borra Marcas de Agua y Fecha | 微鲤AI',
            description: 'Elimina al instante texto, sellos de fecha, logos y subtítulos con el Borrador de Texto IA Gratis de 微鲤AI. Restaura fondos perfectamente con IA Inpainting. Ideal para limpiar fotos y mockups de e-commerce.',
            keywords: 'eliminar texto de imagen, borrador de texto IA, quitar sello de fecha, eliminar marca de agua online, limpiar fotos, IA inpainting, eliminar logo de foto',
            og_title: 'Eliminador de Texto IA Gratis - Borra Marcas de Agua y Fecha | 微鲤AI',
            og_description: 'Elimina al instante texto, sellos de fecha, logos y subtítulos con el Borrador de Texto IA Gratis de 微鲤AI. Restaura fondos perfectamente con IA Inpainting. Ideal para limpiar fotos y mockups de e-commerce.',
            twitter_title: 'Eliminador de Texto IA Gratis - Borra Marcas de Agua y Fecha | 微鲤AI',
            twitter_description: 'Elimina al instante texto, sellos de fecha, logos y subtítulos con el Borrador de Texto IA Gratis de 微鲤AI. Restaura fondos perfectamente con IA Inpainting. Ideal para limpiar fotos y mockups de e-commerce.',
            page: {
                title1: 'Eliminador de Texto IA Gratis',
                title2: '¿Te distrae texto no deseado? Sube tu imagen y nuestra IA detectará y borrará texto, logos, sellos de fecha o subtítulos al instante. Analiza los píxeles alrededor para reconstruir el fondo, sin dejar rastro.',
                faq: [
                    {
                        question: '¿Cómo quito texto de una foto sin que se vea borroso?',
                        answer: 'Usa el Eliminador de Texto IA de 微鲤AI. En lugar de difuminar, utiliza IA Inpainting para analizar el entorno y generar nuevos píxeles que rellenan el hueco de forma natural.',
                    },
                    {
                        question: '¿Puedo quitar sellos de fecha de las fotos?',
                        answer: '¡Sí! Es un caso de uso perfecto. La IA reconoce la tipografía digital de fecha/hora y la elimina mientras restaura el paisaje de fondo.',
                    },
                    {
                        question: '¿Funciona en fondos complejos?',
                        answer: 'Sí. Puede eliminar texto incluso en fondos complejos como montañas o ropa con patrones, entendiendo el flujo de la textura.',
                    },
                    {
                        question: '¿Puedo usarlo para quitar personas u objetos?',
                        answer: 'Aunque está optimizado para texto, la tecnología base (Inpainting) también sirve para eliminar objetos pequeños, imperfecciones de piel o desorden.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes usarlo gratis con créditos diarios.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo quito texto de una foto sin que se vea borroso?',
                    answer: 'Usa el Eliminador de Texto IA de 微鲤AI. Con IA Inpainting analiza el entorno y genera nuevos píxeles para rellenar el hueco.',
                },
                {
                    question: '¿Puedo quitar sellos de fecha de las fotos?',
                    answer: '¡Sí! La IA reconoce la tipografía digital de fecha/hora y la elimina mientras restaura el fondo.',
                },
                {
                    question: '¿Funciona en fondos complejos?',
                    answer: 'Sí. Puede eliminar texto incluso en fondos complejos entendiendo el flujo de la textura.',
                },
            ],
            feature_title1: 'Limpieza de Ropa y Diseño',
            feature_desc1: 'Perfecto para Mockups: ¿Revendes ropa online? Elimina logos, eslóganes o gráficos de fotos de camisetas para dejar un lienzo limpio para tus diseños.',
            feature_title2: 'Restauración de Recuerdos',
            feature_desc2: 'Borra Sellos de Fecha: Quita los sellos naranjas de fecha en fotos familiares antiguas o de viaje sin dañar el paisaje.',
            feature_title3: 'Inpainting Inteligente',
            feature_desc3: 'Relleno de Fondo Sin Costuras: A diferencia de borradores básicos que dejan borrosidad, 微鲤AI usa IA generativa para “pintar” texturas realistas (césped, cielo o montañas) en el área borrada.',
        },
        imgExtender: {
            title: 'Extiende Imágenes Gratis al Instante - Extensor de Imágenes con IA | 微鲤AI',
            description: 'Con el Extensor de Imágenes con IA gratis de 微鲤AI, rompe al instante los límites originales de tu foto. Nuestra herramienta genera nuevos píxeles que se integran perfectamente con tu imagen, convirtiendo retratos en tomas gran angulares sin perder el aspecto y la calidad original.',
            keywords: 'extensor de imágenes IA, ampliar imagen gratis, generador de foto gran angular, expandir bordes de foto, outpainting sin costuras, mantener calidad original',
            og_title: 'Extiende Imágenes Gratis al Instante - Extensor de Imágenes con IA | 微鲤AI',
            og_description: 'Amplía tus fotos a nuevos tamaños y genera contenido que encaje. Prueba nuestro Extensor de Imágenes con IA gratis hoy.',
            twitter_title: 'Extiende Imágenes Gratis al Instante - Extensor de Imágenes con IA | 微鲤AI',
            twitter_description: 'Amplía tus fotos a nuevos tamaños y genera contenido que encaje. Prueba nuestro Extensor de Imágenes con IA gratis hoy.',
            featureList: [
                'extensor de imágenes IA, ampliar imagen gratis, foto gran angular, mantener calidad original',
            ],
            page: {
                title1: 'Un potente extensor de imágenes con IA, resultados increíbles',
                title2: 'Con solo unos clics, amplía más allá de los bordes originales. Nuestra IA genera nuevos píxeles que se mezclan sin costuras con tu imagen, convirtiendo retratos en fotos gran angulares sin perder calidad.',
                feature_title: 'Por qué el Extensor de Imágenes de 微鲤AI destaca',
                faq: [
                    {
                        question: '¿Qué es un extensor de imágenes con IA?',
                        answer: 'Es una herramienta que usa IA avanzada para ampliar una imagen rellenando de forma inteligente el contenido faltante más allá de sus bordes. Ideal para marketing, e-commerce y redes sociales.',
                    },
                    {
                        question: '¿Por qué usar nuestro extensor de imágenes con IA?',
                        answer: '微鲤AI analiza las características de la imagen y realiza outpainting de manera natural y en alta definición para una extensión sin cortes.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí. Puedes usarlo gratis con créditos de prueba, una opción económica para cualquier flujo de edición.',
                    },
                    {
                        question: '¿Qué tan rápido es?',
                        answer: 'Normalmente se completa en segundos, perfecto para ediciones rápidas o trabajos por lotes.',
                    },
                    {
                        question: '¿Afecta la resolución o la calidad?',
                        answer: 'No. Mantiene resolución, nitidez y detalles durante la expansión.',
                    },
                    {
                        question: '¿Mis imágenes son privadas?',
                        answer: 'Sí. Usamos seguridad estándar de la industria y políticas estrictas para proteger tu privacidad.',
                    },
                    {
                        question: '¿Qué formatos soporta?',
                        answer: 'JPG, PNG, WebP y formatos comunes. Tamaño máximo por archivo: 10MB. No requiere conversión.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Qué es un extensor de imágenes con IA?',
                    answer: 'Es una herramienta que usa IA avanzada para ampliar una imagen rellenando de forma inteligente el contenido faltante más allá de sus bordes. Ideal para marketing, e-commerce y redes sociales.',
                },
                {
                    question: '¿Por qué usar nuestro extensor de imágenes con IA?',
                    answer: '微鲤AI analiza las características de la imagen y realiza outpainting de manera natural y en alta definición para una extensión sin cortes.',
                },
                {
                    question: '¿Es gratis?',
                    answer: 'Sí. Puedes usarlo gratis con créditos de prueba.',
                },
                {
                    question: '¿Qué tan rápido es?',
                    answer: 'Normalmente se completa en segundos.',
                },
                {
                    question: '¿Afecta la resolución o la calidad?',
                    answer: 'No. Mantiene resolución, nitidez y detalles.',
                },
                {
                    question: '¿Mis imágenes son privadas?',
                    answer: 'Sí. Protegemos tus datos con seguridad estándar y políticas estrictas.',
                },
                {
                    question: '¿Qué formatos soporta?',
                    answer: 'JPG, PNG, WebP (máx. 10MB).',
                },
            ],
            feature_title1: 'Repara detalles y fondos faltantes',
            feature_desc1: 'Si tienes una imagen recortada, rellena inteligentemente los detalles faltantes para completar la escena. También sirve para outpainting y restaurar elementos perdidos en fotos antiguas.',
            feature_title2: 'Mejora fotos de producto para vender más',
            feature_desc2: 'Amplía el área alrededor de la foto del producto para añadir fondos complementarios. También puedes crear composiciones más anchas para mostrar más detalles y mejorar conversiones.',
            feature_title3: 'Crea obras visuales únicas',
            feature_desc3: 'Fotógrafos, creadores y artistas pueden ampliar los bordes y llevar sus ideas a un nuevo nivel con resultados sorprendentes.',
            feature_title4: 'Optimiza la proporción para redes sociales',
            feature_desc4: 'Amplía imágenes a cualquier proporción para Instagram, X (antes Twitter), Facebook y más. La IA mantiene la nitidez y los detalles para un resultado llamativo.',
            textRemoverHowToUseTitle: 'Cómo usar nuestro Extensor de Imágenes con IA',
            textRemoverHowToUseDesc: '3 pasos simples para ampliar tu foto',
            textRemoverHowToUseStep1Title: 'Sube una imagen',
            textRemoverHowToUseStep1Desc: 'Haz clic o arrastra y suelta la imagen que quieres ampliar.',
            textRemoverHowToUseStep2Title: 'Procesamiento automático con IA',
            textRemoverHowToUseStep2Desc: 'Tras subirla, la IA detecta y amplía automáticamente los bordes.',
            textRemoverHowToUseStep3Title: 'Descarga la imagen ampliada',
            textRemoverHowToUseStep3Desc: 'Cuando termine, previsualiza y descarga tu imagen ampliada.',
        },
        photoRestoration: {
            title: 'Restauración de Fotos IA Gratis - Coloriza B&N y Repara Rayones | 微鲤AI',
            description: 'Revive recuerdos familiares con la Restauración de Fotos IA Gratis de 微鲤AI. Coloriza automáticamente fotos en blanco y negro, elimina rayones, roturas y desenfoque para restaurar rostros al instante.',
            keywords: 'restauración de fotos antiguas, colorizar fotos, reparar fotos rayadas, reparación de fotos IA, restaurar fotos viejas, blanco y negro a color, restauración de imágenes IA',
            og_title: 'Restauración de Fotos IA Gratis - Coloriza B&N y Repara Rayones | 微鲤AI',
            og_description: 'Revive recuerdos familiares con la Restauración de Fotos IA Gratis de 微鲤AI. Coloriza automáticamente fotos en blanco y negro, elimina rayones, roturas y desenfoque para restaurar rostros al instante.',
            twitter_title: 'Restauración de Fotos IA Gratis - Coloriza B&N y Repara Rayones | 微鲤AI',
            twitter_description: 'Revive recuerdos familiares con la Restauración de Fotos IA Gratis de 微鲤AI. Coloriza automáticamente fotos en blanco y negro, elimina rayones, roturas y desenfoque para restaurar rostros al instante.',
            page: {
                title1: 'Restauración y Colorizador de Fotos Antiguas con IA Gratis',
                title2: 'Devuelve tu historia a la vida. Ya sea una foto de boda en blanco y negro desvanecida o un retrato infantil rayado, nuestra IA analiza y restaura áreas dañadas, afina rostros y añade colores realistas en segundos.',
                faq: [
                    {
                        question: '¿Cómo colorizo una foto en blanco y negro?',
                        answer: 'Solo sube tu imagen B&N a 微鲤AI. La herramienta detecta automáticamente que es en escala de grises y aplica la función “Colorizar” para añadir colores realistas al instante.',
                    },
                    {
                        question: '¿Puede arreglar fotos rasgadas o rayadas?',
                        answer: 'Sí. Nuestra IA está entrenada para reconocer rayones, roturas y pliegues. Rellena esas zonas dañadas con píxeles que coinciden con la textura alrededor.',
                    },
                    {
                        question: '¿La foto restaurada se verá falsa?',
                        answer: 'Nuestro objetivo es el realismo. La mejora facial añade detalles, pero buscamos mantener la identidad reconocible. En la colorización, la IA elige tonos naturales adecuados para la época.',
                    },
                    {
                        question: '¿Qué pasa si la foto es muy pequeña?',
                        answer: 'No hay problema. El proceso también incluye Upscaling, que aumenta la resolución de fotos pequeñas tipo billetera para verlas o imprimirlas.',
                    },
                    {
                        question: '¿Mi privacidad está protegida?',
                        answer: 'Sí. Sabemos que las fotos antiguas son personales. Tus imágenes se procesan de forma segura y no se almacenan permanentemente en nuestros servidores.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo colorizo una foto en blanco y negro?',
                    answer: 'Sube tu imagen B&N a 微鲤AI y la función “Colorizar” añadirá colores realistas al instante.',
                },
                {
                    question: '¿Puede arreglar fotos rasgadas o rayadas?',
                    answer: 'Sí. La IA detecta daños como rayones y roturas y los rellena de forma natural según la textura alrededor.',
                },
                {
                    question: '¿La foto restaurada se verá falsa?',
                    answer: 'Buscamos realismo: mantener la identidad y aplicar colores naturales apropiados.',
                },
            ],
            feature_title1: 'Eliminación de Rayones y Roturas',
            feature_desc1: 'Borra las marcas del tiempo: Detecta y rellena pliegues, rayones, roturas y manchas de polvo automáticamente. La IA reconstruye detalles faciales perdidos para que la foto se vea como nueva.',
            feature_title2: 'Colorización Inteligente',
            feature_desc2: 'De B&N a Color: No es solo un filtro sepia. Nuestro modelo entiende el contexto (cielo, piel, tela) para añadir colores vivos y realistas a fotos antiguas.',
            feature_title3: 'Mejora de Rostro',
            feature_desc3: 'Desenfoca Caras: Las fotos antiguas suelen tener movimiento o poco enfoque. 微鲤AI afina rasgos (ojos, nariz, boca) para revelar el parecido real.',
        },
        photoEffects: {
            title: 'Efectos de Imagen - Generador de Efectos de Imagen IA | 微鲤AI',
            description: 'Transforma tus fotos con efectos impulsados por IA. Crea filtros de imagen, estilos y transformaciones impresionantes en línea gratis.',
            keywords: 'efectos de imagen IA, efectos de imagen, filtro de foto, transformación de imagen IA, transferencia de estilo de imagen',
        },
    },
    fr: {
        textToImage: {
            title: `Générateur d'Images IA Gratuit depuis le Texte - Créez de l'Art 4K et des Photos Réalistes | 微鲤AI`,
            description: `Transformez des descriptions de texte en visuels époustouflants avec le Générateur d'Images de Texte de 微鲤AI. Comprend le modèle Nano Banana Pro pour des résultats haute fidélité. Prend en charge la résolution 1K/2K/4K et les proportions 9:16/16:9. Gratuit et en ligne.`,
            keywords: `texte vers image, générateur d'images IA, générateur d'art IA, images IA 4k, modèle nano banana, flux ai gratuit, générateur de fond d'écran, créer des images à partir de texte`,
            og_title: `Générateur d'Images IA Gratuit depuis le Texte - Créez de l'Art 4K et des Photos Réalistes | 微鲤AI`,
            og_description: `Transformez des descriptions de texte en visuels époustouflants avec le Générateur d'Images de Texte de 微鲤AI. Comprend le modèle Nano Banana Pro pour des résultats haute fidélité. Prend en charge la résolution 1K/2K/4K et les proportions 9:16/16:9. Gratuit et en ligne.`,
            twitter_title: `Générateur d'Images IA Gratuit depuis le Texte - Créez de l'Art 4K et des Photos Réalistes | 微鲤AI`,
            twitter_description: `Transformez des descriptions de texte en visuels époustouflants avec le Générateur d'Images de Texte de 微鲤AI. Comprend le modèle Nano Banana Pro pour des résultats haute fidélité. Prend en charge la résolution 1K/2K/4K et les proportions 9:16/16:9. Gratuit et en ligne.`,
            faq: [
                {
                    question: 'Comment générer des images IA en 4K ?',
                    answer: `Entrez simplement votre description et sélectionnez '4K' dans les paramètres de Taille d'Image du panneau de gauche avant de cliquer sur Créer.`,
                },
                {
                    question: 'Quelles proportions sont prises en charge ?',
                    answer: `Nous prenons en charge toutes les proportions principales, y compris 1:1, 9:16 (Mobile), 16:9 (Bureau), 4:3 et 3:2 pour s'adapter à n'importe quelle plateforme.`,
                },
                {
                    question: 'Puis-je utiliser les images commercialement ?',
                    answer: 'Oui. Les images générées sur les plans 微鲤AI incluent généralement une licence commerciale adaptée aux publicités et aux produits.',
                },
            ],
            page: {
                title1: `Générateur Gratuit d'Images IA depuis Texte`,
                title2: `Créez des œuvres d'art époustouflantes, des images photoréalistes et des fonds d'écran uniques en quelques secondes. Décrivez simplement ce que vous voulez voir, et notre modèle avancé Nano Banana Pro générera des images 4K haute fidélité qui correspondent parfaitement à votre description.`,
                resolution: `Arrêtez de vous contenter d'images IA floues. 微鲤AI vous permet de générer directement des images nettes de 1K, 2K et 4K, parfaites pour l'impression ou les écrans haute résolution.`,
                aspectRatio: `Que vous ayez besoin d'une image 9:16 pour les arrière-plans TikTok, 16:9 pour les miniatures YouTube, ou 1:1 pour Instagram, nous avons des préréglages pour chaque plateforme sociale.`,
                online_search: `Besoin d'un contexte à jour ? Activez "Recherche en ligne" pour permettre à l'IA de naviguer sur le web et mieux comprendre les événements actuels ou les références spécifiques dans votre description.`,
                faq: [
                    {
                        question: 'Comment générer des images de haute qualité depuis du texte ?',
                        answer: `Entrez une description détaillée décrivant le sujet, l'éclairage et le style. Sélectionnez "4K" dans les paramètres de Taille d'Image pour obtenir les détails les plus nets.`,
                    },
                    {
                        question: `Qu'est-ce que le modèle Nano Banana Pro ?`,
                        answer: `Nano Banana Pro est notre modèle de plus haute fidélité, optimisé pour l'adhérence au prompt et le photoréalisme. Il rivalise en qualité avec les meilleurs modèles comme Midjourney v6 et Flux.`,
                    },
                    {
                        question: 'Puis-je utiliser les images à des fins commerciales ?',
                        answer: `Oui. Les images générées sur 微鲤AI (plans payants) sont accompagnées d'une licence commerciale, vous permettant de les utiliser pour des publicités, des sites web et des produits.`,
                    },
                    {
                        question: `Combien d'images puis-je générer à la fois ?`,
                        answer: `Vous pouvez générer jusqu'à 4 images simultanément (comme indiqué dans le paramètre "Nombre d'Images de Sortie"), vous permettant d'itérer rapidement sur les idées.`,
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: 'Oui, vous pouvez générer des images en utilisant nos crédits quotidiens gratuits. Les résolutions plus élevées (4K) peuvent nécessiter plus de crédits.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Générateur Gratuit IA Image vers Image - Transformez Photos en Art et 4K | 微鲤AI',
            description: `Téléchargez une photo de référence et transformez-la avec l'IA Image vers Image de 微鲤AI. Transformez des croquis en art réaliste, changez les styles ou générez des variations tout en conservant la composition originale. Prend en charge la résolution 4K.`,
            keywords: 'image vers image ai, img2img, transformer photo en dessin, variation image ai, croquis en image, remix photo ai, générateur art ai gratuit',
            og_title: 'Générateur Gratuit IA Image vers Image - Transformez Photos en Art et 4K | 微鲤AI',
            og_description: `Téléchargez une photo de référence et transformez-la avec l'IA Image vers Image de 微鲤AI. Transformez des croquis en art réaliste, changez les styles ou générez des variations tout en conservant la composition originale. Prend en charge la résolution 4K.`,
            twitter_title: 'Générateur Gratuit IA Image vers Image - Transformez Photos en Art et 4K | 微鲤AI',
            twitter_description: `Téléchargez une photo de référence et transformez-la avec l'IA Image vers Image de 微鲤AI. Transformez des croquis en art réaliste, changez les styles ou générez des variations tout en conservant la composition originale. Prend en charge la résolution 4K.`,
            faq: [
                {
                    question: `Qu'est-ce que l'IA Image vers Image ?`,
                    answer: `Image vers Image (Img2Img) utilise une image téléchargée comme référence avec un prompt de texte pour générer une nouvelle image, combinant l'entrée visuelle avec la description créative.`,
                },
                {
                    question: 'Comment transformer un croquis en photo réaliste ?',
                    answer: `Téléchargez votre croquis, entrez un prompt décrivant la scène (par exemple, 'bâtiment photoréaliste') et cliquez sur Créer.`,
                },
                {
                    question: 'Conserve-t-il le visage original ?',
                    answer: `Il préserve la structure et la pose. Pour une rétention précise de l'identité faciale, veuillez utiliser notre outil d'Échange de Visage Photo.`,
                },
            ],
            page: {
                title1: 'Générateur Gratuit IA Image vers Image',
                title2: 'Utilisez vos images existantes comme modèle. Téléchargez une photo, un croquis ou une mise en page, et laissez notre IA le régénérer dans un style complètement nouveau basé sur votre prompt de texte. Parfait pour préserver la composition tout en explorant des variations artistiques infinies.',
                title3: 'Transformez Vos Photos avec Transfert de Style IA',
                title4: 'Pourquoi Utiliser Image vers Image (Img2Img) ?',
                upload_image: 'Vous avez du mal à décrire une pose ou une mise en page en mots ? Téléchargez simplement une image de référence. Notre moteur Img2Img conserve la structure de votre photo originale mais repeint les détails.',
                resolution: 'Transformez un croquis approximatif ou un wireframe en rendu photoréaliste ou illustration de haute qualité en quelques secondes. Idéal pour les designers et architectes.',
                output: 'Générez des ressources prêtes pour la production. Contrairement aux autres outils qui génèrent de petites images, 微鲤AI prend en charge les résolutions 1K, 2K et 4K pour des détails nets.',
                faq: [
                    {
                        question: `Qu'est-ce que l'IA Image vers Image ?`,
                        answer: 'Image vers Image (Img2Img) est une technologie qui utilise une image téléchargée comme "référence" avec un prompt de texte pour générer une nouvelle image. Elle combine votre entrée visuelle avec votre description créative.',
                    },
                    {
                        question: 'Comment transformer un croquis en photo réaliste ?',
                        answer: 'Téléchargez votre croquis dans la zone "Image". Dans la boîte "Prompt", décrivez ce que représente le croquis (par exemple, "Une villa moderne, coucher de soleil, photoréaliste, 8k"). Cliquez sur Créer pour voir la magie.',
                    },
                    {
                        question: 'Conserve-t-il le visage/personne originale ?',
                        answer: `Il essaie de préserver la structure générale et la pose. Cependant, pour une rétention précise du visage, nous recommandons d'utiliser notre outil spécifique "Échange de Visage Photo" à la place.`,
                    },
                    {
                        question: 'Quels ratios sont pris en charge ?',
                        answer: `Nous prenons en charge une large gamme de ratios incluant 9:16 (Histoire), 16:9 (Cinématographique), 3:4 et 1:1, garantissant que votre art généré s'adapte parfaitement à n'importe quelle plateforme.`,
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: 'Oui, vous pouvez générer des variations gratuitement en utilisant vos crédits quotidiens.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: `Extenseur et Redimensionneur d'Image IA Gratuit - Découper et Étendre des Photos`,
            description: `Redimensionnez les images pour Instagram, TikTok et YouTube sans recadrer. L'Extenseur d'Image IA de 微鲤AI utilise le remplissage génératif (extension) pour étendre intelligemment les arrière-plans d'image. Changez les ratios sans effort.`,
            keywords: 'extenseur image ai, découper image, extension ai, redimensionneur image ai, étendre arrière-plan image, remplissage génératif en ligne, faire photo verticale',
            og_title: `Extenseur et Redimensionneur d'Image IA Gratuit - Découper et Étendre des Photos`,
            og_description: `Redimensionnez les images pour Instagram, TikTok et YouTube sans recadrer. L'Extenseur d'Image IA de 微鲤AI utilise le remplissage génératif (extension) pour étendre intelligemment les arrière-plans d'image. Changez les ratios sans effort.`,
            twitter_title: `Extenseur et Redimensionneur d'Image IA Gratuit - Découper et Étendre des Photos`,
            twitter_description: `Redimensionnez les images pour Instagram, TikTok et YouTube sans recadrer. L'Extenseur d'Image IA de 微鲤AI utilise le remplissage génératif (extension) pour étendre intelligemment les arrière-plans d'image. Changez les ratios sans effort.`,
            page: {
                title1: `Extenseur et Redimensionneur d'Image IA Gratuit`,
                title2: `Arrêtez de recadrer vos photos préférées pour qu'elles s'adaptent aux réseaux sociaux. Que vous ayez besoin de transformer une photo horizontale en Histoire verticale ou d'étendre une image carrée en 16:9, notre Extenseur d'Image IA génère magiquement de nouveaux détails d'arrière-plan (Extension) pour s'adapter parfaitement à n'importe quel ratio.`,
                faq: [
                    {
                        question: 'Comment redimensionner une image sans recadrer ?',
                        answer: `Utilisez l'Extenseur d'Image IA de 微鲤AI. Téléchargez votre photo, sélectionnez le ratio cible (par exemple, 9:16), et l'IA générera automatiquement (étendra) les zones d'arrière-plan manquantes au lieu de recadrer votre image.`,
                    },
                    {
                        question: `Qu'est-ce que l'Extension IA ?`,
                        answer: `L'extension est une technologie d'IA générative qui étend les bordures d'une image en prédisant et en dessinant un nouveau contenu qui correspond au style original, "découpant" efficacement la photo.`,
                    },
                    {
                        question: 'Puis-je transformer une photo horizontale en verticale ?',
                        answer: `Oui ! Téléchargez simplement votre photo horizontale (paysage) et sélectionnez le ratio 9:16. L'IA étendra le haut et le bas de l'image pour remplir le cadre vertical.`,
                    },
                    {
                        question: `L'arrière-plan étendu aura-t-il l'air faux ?`,
                        answer: `微鲤AI utilise des modèles génératifs avancés entraînés sur des ensembles de données massifs pour s'assurer que l'arrière-plan étendu se mélange naturellement avec l'éclairage et la texture originaux.`,
                    },
                    {
                        question: 'Est-ce gratuit à utiliser ?',
                        answer: `Oui, les utilisateurs reçoivent des crédits gratuits pour essayer les fonctionnalités de Redimensionnement Intelligent IA et d'Extension.`,
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment redimensionner une image sans recadrer ?',
                    answer: `Utilisez l'Extenseur d'Image IA de 微鲤AI. Téléchargez votre photo, sélectionnez le ratio cible (par exemple, 9:16), et l'IA générera automatiquement (étendra) les zones d'arrière-plan manquantes au lieu de recadrer votre image.`,
                },
                {
                    question: `Qu'est-ce que l'Extension IA ?`,
                    answer: `L'extension est une technologie d'IA générative qui étend les bordures d'une image en prédisant et en dessinant un nouveau contenu qui correspond au style original, "découpant" efficacement la photo.`,
                },
                {
                    question: 'Puis-je transformer une photo horizontale en verticale ?',
                    answer: `Oui ! Téléchargez simplement votre photo horizontale (paysage) et sélectionnez le ratio 9:16. L'IA étendra le haut et le bas de l'image pour remplir le cadre vertical.`,
                },
                {
                    question: `L'arrière-plan étendu aura-t-il l'air faux ?`,
                    answer: `微鲤AI utilise des modèles génératifs avancés entraînés sur des ensembles de données massifs pour s'assurer que l'arrière-plan étendu se mélange naturellement avec l'éclairage et la texture originaux.`,
                },
                {
                    question: 'Est-ce gratuit à utiliser ?',
                    answer: `Oui, les utilisateurs reçoivent des crédits gratuits pour essayer les fonctionnalités de Redimensionnement Intelligent IA et d'Extension.`,
                },
            ],
            feature_title1: `Extension Intelligente d'Arrière-plan`,
            feature_desc1: `Extension Magique : L'IA comprend le contexte de votre image et peint de nouveaux pixels au-delà des bordures originales. Étendez les paysages, les pièces ou les textures sans problème pour remplir le cadre.`,
            feature_title2: 'Protection du Centre',
            feature_desc2: `Ne Jamais Recadrer le Sujet : Notre IA identifie automatiquement la personne ou l'objet principal et les verrouille au centre, garantissant qu'ils ne sont jamais coupés pendant le processus de redimensionnement.`,
            feature_title3: 'Prêt pour les Réseaux Sociaux',
            feature_desc3: 'Préréglages en un clic pour Instagram Stories (9:16), Miniatures YouTube (16:9) et Publications (4:5). Réutilisez votre contenu sur toutes les plateformes instantanément.',
        },
        imageTextTranslate: {
            title: `Traducteur d'Image IA Gratuit - Traduire le Texte dans les Photos, Manga et Bandes Dessinées`,
            description: `Traduisez instantanément le texte dans les images tout en préservant le style visuel original. Le Traducteur d'Image IA de 微鲤AI efface automatiquement le texte original et redessine les traductions. Parfait pour les bandes dessinées, manga et affiches marketing.`,
            keywords: `traducteur image ai, traduire texte image, traducteur d'images, traducteur manga, traduire bandes dessinées, traducteur ocr, remplacement texte image`,
            og_title: `Traducteur d'Image IA Gratuit - Traduire le Texte dans les Photos, Manga et Bandes Dessinées`,
            og_description: `Traduisez instantanément le texte dans les images tout en préservant le style visuel original. Le Traducteur d'Image IA de 微鲤AI efface automatiquement le texte original et redessine les traductions. Parfait pour les bandes dessinées, manga et affiches marketing.`,
            twitter_title: `Traducteur d'Image IA Gratuit - Traduire le Texte dans les Photos, Manga et Bandes Dessinées`,
            twitter_description: `Traduisez instantanément le texte dans les images tout en préservant le style visuel original. Le Traducteur d'Image IA de 微鲤AI efface automatiquement le texte original et redessine les traductions. Parfait pour les bandes dessinées, manga et affiches marketing.`,
            page: {
                title1: `Traducteur d'Image IA Gratuit et Remplaceur de Texte`,
                title2: `Traduisez des affiches, menus, bandes dessinées et captures d'écran en quelques secondes. Contrairement aux traducteurs standard qui superposent simplement le texte, 微鲤AI utilise l'IA Générative pour effacer le texte original et redessiner l'arrière-plan, faisant paraître le texte traduit comme faisant partie du design original.`,
                faq: [
                    {
                        question: 'Comment traduire le texte dans une image ?',
                        answer: `Téléchargez votre image (JPG, PNG) sur 微鲤AI. Sélectionnez la langue source (ou utilisez la Détection Automatique) et la langue cible. Cliquez sur "Créer" pour laisser l'IA remplacer le texte.`,
                    },
                    {
                        question: `Le texte traduit aura-t-il l'air naturel ?`,
                        answer: `Oui. 微鲤AI tente de correspondre à la taille et au style de police du texte original. Il est crucial qu'il redessine l'arrière-plan derrière le texte pour que la traduction se fonde parfaitement.`,
                    },
                    {
                        question: 'Puis-je utiliser cela pour traduire Manga ou Manhwa ?',
                        answer: `Absolument. C'est l'un des meilleurs cas d'usage. L'IA détecte les bulles de dialogue et le texte vertical (commun en japonais), les remplaçant par du texte traduit horizontal.`,
                    },
                    {
                        question: 'Quelles langues sont prises en charge ?',
                        answer: `Nous prenons en charge la traduction entre les principales langues mondiales incluant l'anglais, l'espagnol, le chinois, le japonais, le coréen, le français, l'allemand et plus.`,
                    },
                    {
                        question: 'Fonctionne-t-il sur le texte manuscrit ?',
                        answer: 'Il fonctionne mieux sur le texte imprimé, mais notre moteur OCR avancé peut reconnaître le texte manuscrit clair sur les tableaux blancs ou les notes.',
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: 'Vous pouvez traduire des images gratuitement en utilisant vos crédits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment traduire le texte dans une image ?',
                    answer: `Téléchargez votre image sur 微鲤AI. Sélectionnez la langue cible et cliquez sur 'Créer'. L'IA remplacera le texte original par la traduction.`,
                },
                {
                    question: `Le texte traduit aura-t-il l'air naturel ?`,
                    answer: `Oui. 微鲤AI redessine l'arrière-plan derrière le texte et tente de correspondre au style de police, assurant que la traduction se fonde parfaitement.`,
                },
                {
                    question: 'Puis-je utiliser cela pour traduire Manga ou Manhwa ?',
                    answer: `Absolument. C'est l'un des meilleurs cas d'usage. L'IA détecte les bulles de dialogue et le texte vertical (commun en japonais), les remplaçant par du texte traduit horizontal.`,
                },
            ],
            feature_title1: 'Inpainting et Redessin Intelligents',
            feature_desc1: `Remplacement de Texte Parfait : Notre IA analyse la texture de l'arrière-plan derrière le texte. Elle efface les mots originaux et remplit l'espace intelligemment avant d'ajouter la traduction, assurant qu'aucune boîte de texte laide ne couvre votre image.`,
            feature_title2: 'Traduction de Manga et Bandes Dessinées',
            feature_desc2: `Lisez le Manga Brut Instantanément : Parfait pour les fans d'anime. Téléchargez des pages de manga brut (japonais/coréen) et obtenez des traductions instantanées en anglais qui s'adaptent parfaitement dans les bulles de dialogue.`,
            feature_title3: 'Localisation Marketing Mondiale',
            feature_desc3: `Localisation en Un Clic : Lancez des produits mondialement ? Traduisez vos affiches marketing, bannières et captures d'écran UI en plus de 30 langues sans avoir besoin des fichiers PSD originaux.`,
        },
        aiBackgroundChanger: {
            title: 'Changeur de Fond IA Gratuit - Générez des Fonds à partir de Texte',
            description: `Changez instantanément l'arrière-plan de vos photos avec l'IA. Décrivez la scène souhaitée et 微鲤AI générera des fonds réalistes pour la photo produit, les portraits LinkedIn et les portraits créatifs. Gratuit et en ligne.`,
            keywords: 'changer fond photo, générateur de fond IA, photo produit IA, fond blanc, remplacer fond en ligne, remplissage génératif fond',
            og_title: 'Changeur de Fond IA Gratuit - Générez des Fonds à partir de Texte',
            og_description: `Changez instantanément l'arrière-plan de vos photos avec l'IA. Décrivez la scène souhaitée et 微鲤AI générera des fonds réalistes pour la photo produit, les portraits LinkedIn et les portraits créatifs. Gratuit et en ligne.`,
            twitter_title: 'Changeur de Fond IA Gratuit - Générez des Fonds à partir de Texte',
            twitter_description: `Changez instantanément l'arrière-plan de vos photos avec l'IA. Décrivez la scène souhaitée et 微鲤AI générera des fonds réalistes pour la photo produit, les portraits LinkedIn et les portraits créatifs. Gratuit et en ligne.`,
            page: {
                title1: 'Changeur de Fond IA Gratuit & Générateur',
                title2: `Ne vous contentez pas de supprimer l'arrière-plan — remplacez-le par quelque chose de mieux. Téléchargez votre photo et décrivez n'importe quelle scène (ex. "studio en marbre luxueux", "skyline de bureaux"). Notre IA générative comprend la lumière et la perspective pour intégrer votre sujet parfaitement dans le nouvel environnement.`,
                faq: [
                    {
                        question: `Comment changer l'arrière-plan avec du texte ?`,
                        answer: `Téléchargez votre image et, dans le champ "Prompt d'arrière-plan", décrivez la scène souhaitée (ex. "un café chaleureux"). Cliquez sur Créer et l'IA générera cet arrière-plan pour vous.`,
                    },
                    {
                        question: 'Puis-je mettre un fond blanc uni ?',
                        answer: `Oui. Tapez simplement "fond blanc pur" ou "blanc studio" dans le prompt. C'est idéal pour les fiches produits Amazon/eBay et les photos d'identité.`,
                    },
                    {
                        question: 'Est-ce adapté à la photo produit ?',
                        answer: `Absolument. 微鲤AI analyse l'angle de votre produit et génère des fonds avec des ombres et une lumière cohérentes, comme un shooting studio.`,
                    },
                    {
                        question: `L'éclairage paraîtra-t-il naturel ?`,
                        answer: `Notre IA générative (similaire à Adobe Firefly ou SDXL) essaie d'aligner l'éclairage du fond généré avec celui de votre sujet pour un rendu harmonieux.`,
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: 'Oui, vous pouvez générer de nouveaux fonds gratuitement avec vos crédits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: `Comment changer l'arrière-plan avec du texte ?`,
                    answer: `Téléchargez votre image et, dans le champ "Prompt d'arrière-plan", décrivez la scène souhaitée (ex. "un café chaleureux"). Cliquez sur Créer et l'IA générera cet arrière-plan pour vous.`,
                },
                {
                    question: 'Puis-je mettre un fond blanc uni ?',
                    answer: `Oui. Tapez simplement "fond blanc pur" ou "blanc studio" dans le prompt. C'est idéal pour les fiches produits Amazon/eBay et les photos d'identité.`,
                },
                {
                    question: 'Est-ce adapté à la photo produit ?',
                    answer: `Absolument. 微鲤AI analyse l'angle de votre produit et génère des fonds avec des ombres et une lumière cohérentes, comme un shooting studio.`,
                },
                {
                    question: `L'éclairage paraîtra-t-il naturel ?`,
                    answer: `Notre IA générative (similaire à Adobe Firefly ou SDXL) essaie d'aligner l'éclairage du fond généré avec celui de votre sujet pour un rendu harmonieux.`,
                },
                {
                    question: 'Est-ce gratuit ?',
                    answer: 'Oui, vous pouvez générer de nouveaux fonds gratuitement avec vos crédits quotidiens.',
                },
            ],
            feature_title1: `Photos d'Identité Professionnelles`,
            feature_desc1: 'Headshots LinkedIn DIY : Transformez une selfie en photo de profil professionnelle. Remplacez instantanément un arrière-plan de chambre encombrée par un bureau propre ou un fond gris studio.',
            feature_title2: 'Photo Produit Instantanée',
            feature_desc2: `Boostez vos ventes e-commerce : Économisez des milliers en séances photo. Placez votre produit sur une table en bois, une plage de sable ou un podium avec de simples prompts. L'IA ajoute des ombres et reflets réalistes.`,
            feature_title3: 'Téléportation Créative',
            feature_desc3: `Voyagez partout : Vous voulez être à Paris ou dans un futur cyberpunk ? Tapez-le. Notre IA remplace l'arrière-plan tout en gardant une lumière cohérente avec votre photo d'origine.`,
        },
        imageUpscaler: {
            title: `Agrandisseur d'Image IA Gratuit - Agrandissez en 4K & Restaurez les Vieilles Photos`,
            description: `Agrandissez instantanément des images basse résolution en 2x, 4x et jusqu'à 4K avec l'Améliorateur d'Image IA Gratuit de 微鲤AI. Corrigez les photos floues, supprimez le bruit et restaurez en ligne vos anciennes photos de famille. Qualité sans perte.`,
            keywords: `agrandisseur d'image ia, améliorateur de photos, agrandir image en 4k, déflouter image, restauration de vieilles photos, corriger photo pixelisée, augmenter résolution image`,
            og_title: `Agrandisseur d'Image IA Gratuit - Agrandissez en 4K & Restaurez les Vieilles Photos`,
            og_description: `Agrandissez instantanément des images basse résolution en 2x, 4x et jusqu'à 4K avec l'Améliorateur d'Image IA Gratuit de 微鲤AI. Corrigez les photos floues, supprimez le bruit et restaurez en ligne vos anciennes photos de famille. Qualité sans perte.`,
            twitter_title: `Agrandisseur d'Image IA Gratuit - Agrandissez en 4K & Restaurez les Vieilles Photos`,
            twitter_description: `Agrandissez instantanément des images basse résolution en 2x, 4x et jusqu'à 4K avec l'Améliorateur d'Image IA Gratuit de 微鲤AI. Corrigez les photos floues, supprimez le bruit et restaurez en ligne vos anciennes photos de famille. Qualité sans perte.`,
            page: {
                title1: `Agrandisseur & Améliorateur d'Image IA Gratuit`,
                title2: `Transformez des photos pixelisées, floues ou anciennes en chefs-d'œuvre haute définition. 微鲤AI utilise une IA avancée pour augmenter la résolution jusqu'à 400% (4K) tout en récupérant les détails perdus, en corrigeant le bruit et en restaurant les visages sur les portraits de famille anciens.`,
                faq: [
                    {
                        question: `Puis-je agrandir des images basse résolution pour l'impression ?`,
                        answer: `Oui ! 微鲤AI augmente la résolution (nombre de pixels) jusqu'à 4K, ce qui convient à une impression de haute qualité sur posters, toiles ou supports marketing.`,
                    },
                    {
                        question: 'Comment fonctionne la restauration de vieilles photos par IA ?',
                        answer: `L'IA analyse les zones abîmées ou floues et utilise le deep learning pour prédire et reconstruire les détails du visage, les textures et l'arrière-plan, "réparant" ainsi l'image.`,
                    },
                    {
                        question: 'Quels formats sont pris en charge ?',
                        answer: 'Nous prenons en charge des formats courants comme JPG, PNG et WEBP. La sortie sera un PNG ou JPG de haute qualité.',
                    },
                    {
                        question: `Est-ce que ça marche sur l'anime / les cartoons ?`,
                        answer: 'Oui. Notre IA excelle pour agrandir les animes et illustrations (style waifu2x), en gardant des lignes nettes et des couleurs vibrantes sans artefacts.',
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: 'Oui, vous pouvez améliorer des images gratuitement avec vos crédits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: `Puis-je agrandir des images basse résolution pour l'impression ?`,
                    answer: `Oui ! 微鲤AI augmente la résolution jusqu'à 4K, rendant l'image adaptée à une impression de haute qualité.`,
                },
                {
                    question: 'Comment fonctionne la restauration de vieilles photos par IA ?',
                    answer: `L'IA analyse les zones endommagées et reconstruit les détails du visage et les textures grâce au deep learning.`,
                },
                {
                    question: `Est-ce que ça marche sur l'anime ?`,
                    answer: 'Oui. Notre IA excelle pour agrandir les animes et illustrations, en gardant des lignes nettes sans artefacts.',
                },
            ],
            feature_title1: `Agrandissement Sans Perte jusqu'à 4K`,
            feature_desc1: `Qualité prête à imprimer : Besoin d'imprimer une petite image ? Agrandissez-la en 4K ou 8K sans perdre en qualité. Parfait pour posters, photos produit e-commerce et fonds d'écran.`,
            feature_title2: 'Débruitage & Défloutage Intelligents',
            feature_desc2: 'Corrigez les photos de nuit : Supprimez le bruit numérique et le grain des photos en faible luminosité. Affûtez les bords flous instantanément pour un rendu net et professionnel.',
            feature_title3: 'Restauration de Vieilles Photos',
            feature_desc3: 'Ravivez vos souvenirs : Photos anciennes, abîmées ou en noir et blanc ? Notre IA crée de nouveaux pixels pour réparer les rayures, affiner les visages et redonner de la clarté à vos souvenirs.',
        },
        photoFaceSwap: {
            title: 'Échange de Visage IA Gratuit - Face Swap Réaliste en Ligne | 微鲤AI',
            description: `Échangez des visages sur vos photos instantanément avec l'outil Face Swap IA gratuit de 微鲤AI. Créez des memes, des portraits artistiques (Mona Lisa) ou des headshots professionnels ultra réalistes. 100% privé et sécurisé.`,
            keywords: 'face swap IA, échange de visage en ligne, changeur de visage photo, reface gratuit, remplacer visage sur image, deepfake photo, créateur de memes IA',
            og_title: 'Échange de Visage IA Gratuit - Face Swap Réaliste en Ligne | 微鲤AI',
            og_description: `Échangez des visages sur vos photos instantanément avec l'outil Face Swap IA gratuit de 微鲤AI. Créez des memes, des portraits artistiques (Mona Lisa) ou des headshots professionnels ultra réalistes. 100% privé et sécurisé.`,
            twitter_title: 'Échange de Visage IA Gratuit - Face Swap Réaliste en Ligne | 微鲤AI',
            twitter_description: `Échangez des visages sur vos photos instantanément avec l'outil Face Swap IA gratuit de 微鲤AI. Créez des memes, des portraits artistiques (Mona Lisa) ou des headshots professionnels ultra réalistes. 100% privé et sécurisé.`,
            page: {
                title1: 'Échange de Visage Photo IA Gratuit',
                title2: 'Envie de vous voir en astronaute, star de cinéma ou dans une peinture classique ? Téléchargez une photo de base et un visage cible : notre IA fusionne traits du visage, éclairage et tons de peau pour un face swap hyper réaliste en quelques secondes.',
                faq: [
                    {
                        question: '微鲤AI Face Swap est-il gratuit ?',
                        answer: 'Oui, nous offrons des crédits quotidiens gratuits pour échanger des visages en ligne. Aucune installation ni carte bancaire requise.',
                    },
                    {
                        question: 'Mes données sont-elles en sécurité ?',
                        answer: `Absolument. Nous priorisons votre confidentialité. Les photos envoyées ne servent qu'au face swap et sont automatiquement supprimées de nos serveurs après un court délai.`,
                    },
                    {
                        question: 'Comment obtenir les meilleurs résultats ?',
                        answer: `Pour un rendu réaliste, assurez-vous que l'“Image de base” et l'“Image visage” soient nettes, de face et bien éclairées. Évitez les photos où le visage est caché par les cheveux ou les mains.`,
                    },
                    {
                        question: 'Puis-je échanger des visages sur des photos de groupe ?',
                        answer: `Pour le moment, notre outil se concentre sur la précision d'un seul visage. Pour les groupes, recadrez l'image ou utilisez notre future fonction multi-visages.`,
                    },
                    {
                        question: `Puis-je l'utiliser pour des memes ?`,
                        answer: `Oui ! Parfait pour créer des memes amusants. Remplacez le visage d'un ami sur une affiche de film ou un modèle viral en un instant.`,
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI Face Swap est-il gratuit ?',
                    answer: 'Oui, nous offrons des crédits quotidiens gratuits pour échanger des visages en ligne, sans installation ni carte bancaire.',
                },
                {
                    question: 'Mes données sont-elles en sécurité ?',
                    answer: `Oui. Les photos ne sont utilisées que pour l'échange et sont supprimées automatiquement après un court délai.`,
                },
                {
                    question: 'Comment obtenir les meilleurs résultats ?',
                    answer: 'Assurez-vous que les deux photos soient nettes, de face et bien éclairées. Évitez les visages masqués par des cheveux ou des lunettes.',
                },
            ],
            feature_title1: `Chefs-d'œuvre Artistiques`,
            feature_desc1: 'Voyage dans le temps : Insérez votre visage dans des tableaux classiques comme la Mona Lisa ou La Jeune Fille à la Perle. Créez instantanément des avatars vintage uniques.',
            feature_title2: 'Avatars Pros & Stylés',
            feature_desc2: `Jobs de rêve : Voyez-vous en combinaison de course, tenue d'astronaute ou costume business sans acheter de déguisement. Idéal pour des photos de profil qui ressortent.`,
            feature_title3: 'Fusion Hyper Réaliste',
            feature_desc3: `Aucun effet “collé” : Contrairement aux outils copier-coller, 微鲤AI analyse l'angle, la lumière et la texture de peau pour un rendu 100% naturel, pas fake.`,
        },
        removeTextFromImage: {
            title: 'Suppresseur de Texte IA Gratuit - Effacer Filigranes & Dates | 微鲤AI',
            description: `Supprimez instantanément texte, dates, logos et légendes avec la Gomme à Texte IA gratuite de 微鲤AI. Restaurez l'arrière-plan parfaitement grâce à l'Inpainting IA. Idéal pour nettoyer des photos et des mockups e-commerce.`,
            keywords: 'supprimer texte image, gomme à texte IA, supprimer date, supprimer filigrane en ligne, nettoyer photo, IA inpainting, supprimer logo photo',
            og_title: 'Suppresseur de Texte IA Gratuit - Effacer Filigranes & Dates | 微鲤AI',
            og_description: `Supprimez instantanément texte, dates, logos et légendes avec la Gomme à Texte IA gratuite de 微鲤AI. Restaurez l'arrière-plan parfaitement grâce à l'Inpainting IA. Idéal pour nettoyer des photos et des mockups e-commerce.`,
            twitter_title: 'Suppresseur de Texte IA Gratuit - Effacer Filigranes & Dates | 微鲤AI',
            twitter_description: `Supprimez instantanément texte, dates, logos et légendes avec la Gomme à Texte IA gratuite de 微鲤AI. Restaurez l'arrière-plan parfaitement grâce à l'Inpainting IA. Idéal pour nettoyer des photos et des mockups e-commerce.`,
            page: {
                title1: 'Suppresseur de Texte IA Gratuit',
                title2: `Gêné par du texte indésirable ? Téléchargez simplement votre image : notre IA détecte et efface texte, logos, dates ou légendes instantanément. Elle analyse les pixels autour pour reconstruire l'arrière-plan, sans laisser de trace.`,
                faq: [
                    {
                        question: `Comment supprimer du texte sans flouter l'image ?`,
                        answer: `Utilisez le Suppresseur de Texte IA de 微鲤AI. Au lieu de flouter, l'outil utilise l'Inpainting IA pour analyser l'environnement et générer de nouveaux pixels afin de combler l'espace naturellement.`,
                    },
                    {
                        question: 'Puis-je supprimer des dates sur des photos ?',
                        answer: `Oui ! Cas d'usage parfait. L'IA reconnaît la police numérique des dates/heures et l'efface tout en restaurant le paysage derrière.`,
                    },
                    {
                        question: 'Ça marche sur des arrière-plans complexes ?',
                        answer: `Oui. L'IA peut enlever du texte même sur des fonds complexes (montagnes, vêtements à motifs) en comprenant le flux des textures.`,
                    },
                    {
                        question: 'Puis-je enlever des personnes ou des objets ?',
                        answer: 'Optimisé pour le texte, mais la technologie (Inpainting) fonctionne aussi pour retirer de petits objets, imperfections de peau ou du bazar.',
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: `Oui, vous pouvez l'utiliser gratuitement avec des crédits quotidiens.`,
                    },
                ],
            },
            faq: [
                {
                    question: `Comment supprimer du texte sans flouter l'image ?`,
                    answer: `Utilisez le Suppresseur de Texte IA de 微鲤AI. L'Inpainting IA génère de nouveaux pixels pour combler l'espace de façon naturelle.`,
                },
                {
                    question: 'Puis-je supprimer des dates sur des photos ?',
                    answer: `Oui ! L'IA reconnaît les dates/heures et les efface tout en restaurant le fond.`,
                },
                {
                    question: 'Ça marche sur des arrière-plans complexes ?',
                    answer: 'Oui. Elle comprend le flux des textures et enlève le texte même sur des fonds complexes.',
                },
            ],
            feature_title1: 'Nettoyage Vêtements & Design',
            feature_desc1: 'Parfait pour les mockups : Vous revendez des vêtements en ligne ? Supprimez logos, slogans ou graphiques sur des photos de T-shirt pour repartir sur une base propre.',
            feature_title2: 'Restauration de Souvenirs',
            feature_desc2: 'Effacer les dates : Retirez les dates numériques orange sur vos vieilles photos de famille ou de voyage sans abîmer le décor.',
            feature_title3: 'Inpainting Intelligent',
            feature_desc3: `Remplissage de fond seamless : Contrairement aux gommes basiques qui laissent du flou, 微鲤AI utilise l'IA générative pour “peindre” des textures réalistes (herbe, ciel, montagnes) dans la zone effacée.`,
        },
        imgExtender: {
            title: 'Étendre une Image Gratuitement - Extenseur d’Image IA | 微鲤AI',
            description: 'Avec l’extenseur d’image IA gratuit de 微鲤AI, dépassez instantanément les bordures d’origine de vos photos. Notre outil génère de nouveaux pixels parfaitement fusionnés avec votre image pour transformer un portrait en vue grand angle tout en conservant l’apparence et la qualité.',
            keywords: `extenseur d'image IA, agrandir image gratuit, générateur grand angle, étendre bordures photo, outpainting seamless, préserver la qualité`,
            og_title: 'Étendre une Image Gratuitement - Extenseur d’Image IA | 微鲤AI',
            og_description: 'Agrandissez vos photos à de nouveaux formats et générez un contenu cohérent. Essayez notre Extenseur d’Image IA gratuitement.',
            twitter_title: 'Étendre une Image Gratuitement - Extenseur d’Image IA | 微鲤AI',
            twitter_description: 'Agrandissez vos photos à de nouveaux formats et générez un contenu cohérent. Essayez notre Extenseur d’Image IA gratuitement.',
            featureList: [
                `extenseur d'image IA, agrandir image gratuit, grand angle, préserver la qualité`,
            ],
            page: {
                title1: 'Un extendeur d’image IA puissant, résultats bluffants',
                title2: 'En quelques clics, étendez votre image au-delà de ses bordures. L’IA génère de nouveaux pixels qui se fondent naturellement avec votre photo pour un rendu grand angle tout en gardant la qualité d’origine.',
                feature_title: 'Ce qui rend l’Extenseur d’Image 微鲤AI unique',
                faq: [
                    {
                        question: 'Qu’est-ce qu’un extendeur d’image IA ?',
                        answer: 'C’est un outil qui utilise une IA avancée pour étendre les bords d’une image en complétant intelligemment le contenu manquant. Idéal pour le marketing, l’e-commerce et les réseaux sociaux.',
                    },
                    {
                        question: 'Pourquoi utiliser notre extendeur d’image IA ?',
                        answer: '微鲤AI analyse les caractéristiques de l’image et réalise un outpainting naturel en haute définition pour une extension sans raccord visible.',
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: 'Oui. Vous pouvez l’utiliser gratuitement avec des crédits d’essai, une solution économique pour votre workflow d’édition.',
                    },
                    {
                        question: 'À quelle vitesse ça fonctionne ?',
                        answer: 'Généralement en quelques secondes, parfait pour des retouches rapides ou en lot.',
                    },
                    {
                        question: 'La résolution ou la qualité diminuent-elles ?',
                        answer: 'Non. L’outil préserve la résolution, la netteté et les détails pendant l’extension.',
                    },
                    {
                        question: 'Mes images restent-elles privées ?',
                        answer: 'Oui. Nous appliquons une sécurité standard de l’industrie et des politiques strictes pour protéger vos données.',
                    },
                    {
                        question: 'Quels formats sont pris en charge ?',
                        answer: 'JPG, PNG, WebP et formats courants. Taille max : 10MB. Aucune conversion requise.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Qu’est-ce qu’un extendeur d’image IA ?',
                    answer: 'C’est un outil qui utilise une IA avancée pour étendre les bords d’une image en complétant intelligemment le contenu manquant. Idéal pour le marketing, l’e-commerce et les réseaux sociaux.',
                },
                {
                    question: 'Pourquoi utiliser notre extendeur d’image IA ?',
                    answer: '微鲤AI analyse les caractéristiques de l’image et réalise un outpainting naturel en haute définition pour une extension sans raccord visible.',
                },
                {
                    question: 'Est-ce gratuit ?',
                    answer: 'Oui. Utilisable gratuitement avec des crédits d’essai.',
                },
                {
                    question: 'À quelle vitesse ça fonctionne ?',
                    answer: 'En général en quelques secondes.',
                },
                {
                    question: 'La résolution ou la qualité diminuent-elles ?',
                    answer: 'Non. La résolution et les détails sont préservés.',
                },
                {
                    question: 'Mes images restent-elles privées ?',
                    answer: 'Oui. Vos données sont protégées et non partagées.',
                },
                {
                    question: 'Quels formats sont pris en charge ?',
                    answer: 'JPG, PNG, WebP (10MB max).',
                },
            ],
            feature_title1: 'Réparer des détails et arrière-plans manquants',
            feature_desc1: 'Si votre image a été recadrée, complétez intelligemment les zones manquantes pour une composition plus complète. L’outpainting peut aussi restaurer des éléments perdus sur d’anciennes photos.',
            feature_title2: 'Améliorer les visuels produits pour vendre plus',
            feature_desc2: 'Étendez les zones autour d’un produit pour ajouter un décor cohérent, ou créez un cadrage plus large pour mieux montrer les détails et augmenter les ventes.',
            feature_title3: 'Créer des œuvres visuelles uniques',
            feature_desc3: 'Photographes, créateurs et artistes peuvent repousser les limites et transformer leurs idées en visuels impressionnants.',
            feature_title4: 'Optimiser le format pour les réseaux sociaux',
            feature_desc4: 'Adaptez vos images à n’importe quel ratio pour Instagram, X (ex‑Twitter), Facebook, etc. L’IA conserve netteté et détails pour un résultat accrocheur.',
            textRemoverHowToUseTitle: 'Comment utiliser notre Extenseur d’Image IA',
            textRemoverHowToUseDesc: '3 étapes simples pour étendre votre photo au‑delà de ses bordures',
            textRemoverHowToUseStep1Title: 'Télécharger une image',
            textRemoverHowToUseStep1Desc: 'Cliquez ou glissez‑déposez l’image que vous souhaitez étendre.',
            textRemoverHowToUseStep2Title: 'Traitement automatique par IA',
            textRemoverHowToUseStep2Desc: 'Après l’envoi, l’IA détecte et étend automatiquement les bordures.',
            textRemoverHowToUseStep3Title: 'Télécharger l’image étendue',
            textRemoverHowToUseStep3Desc: 'Une fois terminé, prévisualisez et téléchargez votre image étendue !',
        },
        photoRestoration: {
            title: 'Restauration Photo IA Gratuite - Coloriser le N&B & Réparer les Rayures | 微鲤AI',
            description: 'Ravivez vos souvenirs familiaux avec la Restauration Photo IA gratuite de 微鲤AI. Colorisez automatiquement les photos noir et blanc, supprimez rayures, déchirures et flou pour restaurer les visages instantanément.',
            keywords: `restauration photo ancienne, coloriser photo, réparer photo rayée, réparation photo IA, restaurer vieilles photos, noir et blanc en couleur, restauration d'image IA`,
            og_title: 'Restauration Photo IA Gratuite - Coloriser le N&B & Réparer les Rayures | 微鲤AI',
            og_description: 'Ravivez vos souvenirs familiaux avec la Restauration Photo IA gratuite de 微鲤AI. Colorisez automatiquement les photos noir et blanc, supprimez rayures, déchirures et flou pour restaurer les visages instantanément.',
            twitter_title: 'Restauration Photo IA Gratuite - Coloriser le N&B & Réparer les Rayures | 微鲤AI',
            twitter_description: 'Ravivez vos souvenirs familiaux avec la Restauration Photo IA gratuite de 微鲤AI. Colorisez automatiquement les photos noir et blanc, supprimez rayures, déchirures et flou pour restaurer les visages instantanément.',
            page: {
                title1: 'Restauration & Colorisation de Vieilles Photos par IA (Gratuit)',
                title2: `Redonnez vie à votre histoire. Qu'il s'agisse d'une photo de mariage noir et blanc délavée ou d'un portrait d'enfance rayé, notre IA analyse et restaure les zones abîmées, affine les visages et ajoute des couleurs réalistes en quelques secondes.`,
                faq: [
                    {
                        question: 'Comment coloriser une photo noir et blanc ?',
                        answer: `Téléchargez simplement votre image N&B sur 微鲤AI. L'outil détecte automatiquement le gris et applique la fonction « Coloriser » pour ajouter des couleurs réalistes instantanément.`,
                    },
                    {
                        question: 'Peut-il réparer une photo déchirée ou rayée ?',
                        answer: 'Oui. Notre IA est entraînée à reconnaître rayures, déchirures et plis. Elle comble ces zones avec des pixels qui correspondent à la texture environnante.',
                    },
                    {
                        question: 'La photo restaurée risque-t-elle de paraître fausse ?',
                        answer: `Notre objectif est le réalisme. L'amélioration du visage ajoute des détails tout en gardant l'identité reconnaissable. Pour la colorisation, l'IA choisit des tons naturels adaptés à l'époque.`,
                    },
                    {
                        question: 'Et si la photo est très petite ?',
                        answer: `Aucun souci. Le processus inclut aussi l'Upscaling, qui augmente la résolution des petites photos pour l'affichage numérique ou l'impression.`,
                    },
                    {
                        question: 'Ma confidentialité est-elle protégée ?',
                        answer: 'Oui. Nous savons que les vieilles photos sont personnelles. Vos images sont traitées de façon sécurisée et ne sont pas stockées de manière permanente sur nos serveurs.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment coloriser une photo noir et blanc ?',
                    answer: 'Téléchargez votre image N&B sur 微鲤AI : la fonction « Coloriser » ajoute des couleurs réalistes instantanément.',
                },
                {
                    question: 'Peut-il réparer une photo déchirée ou rayée ?',
                    answer: `Oui. L'IA détecte les dommages et les reconstruit en respectant la texture environnante.`,
                },
                {
                    question: 'La photo restaurée risque-t-elle de paraître fausse ?',
                    answer: 'Nous privilégions le réalisme : identité reconnaissable et couleurs naturelles adaptées.',
                },
            ],
            feature_title1: 'Suppression des Rayures & Déchirures',
            feature_desc1: `Effacez les marques du temps : détection et remplissage automatiques des plis, rayures, déchirures et poussières. L'IA reconstruit les détails manquants pour un rendu comme neuf.`,
            feature_title2: 'Colorisation Intelligente',
            feature_desc2: 'N&B vers Couleur : pas un simple filtre sépia. Notre modèle comprend le contexte (ciel, peau, tissu) pour ajouter des couleurs vives et réalistes.',
            feature_title3: 'Amélioration du Visage',
            feature_desc3: 'Défloutez les visages : les vieilles photos souffrent souvent de flou de mouvement ou de mise au point. 微鲤AI affine les traits (yeux, nez, bouche) pour révéler la ressemblance.',
        },
        photoEffects: {
            title: `Effets d'Image - Générateur d'Effets d'Image IA | 微鲤AI`,
            description: `Transformez vos photos avec des effets alimentés par l'IA. Créez des filtres d'image, des styles et des transformations époustouflants en ligne gratuitement.`,
            keywords: `effets d'image IA, effets d'image, filtre photo, transformation d'image IA, transfert de style d'image`,
        },
    },
    de: {
        textToImage: {
            title: 'Text zu Bild - Kostenloser KI-Bildgenerator | 微鲤AI',
            description: 'Erzeugen Sie beeindruckende Bilder aus Textbeschreibungen mit KI. Erstellen Sie realistische Fotos, Illustrationen und Kunstwerke mit fortschrittlichen Modellen – ideal für kreative Inhalte und Designprojekte.',
            keywords: 'Text zu Bild, KI-Bildgenerator, Bildgenerierung, Bild mit KI erstellen, Text zu Foto, KI-Bild-Tool',
            og_title: 'Kostenloser KI-Bildgenerator aus Text - Erstellen Sie 4K-Kunst & Realistische Fotos | 微鲤AI',
            og_description: 'Verwandeln Sie Textbeschreibungen in beeindruckende Visuals mit WeryAIs Text-zu-Bild-Generator. Enthält das Nano Banana Pro-Modell für hochwertige Ergebnisse. Unterstützt 1K/2K/4K-Auflösung und 9:16/16:9-Seitenverhältnisse. Kostenlos & Online.',
            twitter_title: 'Kostenloser KI-Bildgenerator aus Text - Erstellen Sie 4K-Kunst & Realistische Fotos | 微鲤AI',
            twitter_description: 'Verwandeln Sie Textbeschreibungen in beeindruckende Visuals mit WeryAIs Text-zu-Bild-Generator. Enthält das Nano Banana Pro-Modell für hochwertige Ergebnisse. Unterstützt 1K/2K/4K-Auflösung und 9:16/16:9-Seitenverhältnisse. Kostenlos & Online.',
            faq: [
                {
                    question: 'Wie generiere ich 4K-KI-Bilder?',
                    answer: 'Geben Sie einfach Ihre Beschreibung ein und wählen Sie "4K" in den Bildeinstellungen im linken Bereich, bevor Sie auf Erstellen klicken.',
                },
                {
                    question: 'Welche Seitenverhältnisse werden unterstützt?',
                    answer: 'Wir unterstützen alle gängigen Verhältnisse, einschließlich 1:1, 9:16 (Mobil), 16:9 (Desktop), 4:3 und 3:2, um auf jeder Plattform zu passen.',
                },
                {
                    question: 'Kann ich die Bilder kommerziell nutzen?',
                    answer: 'Ja. Auf 微鲤AI-Plänen generierte Bilder enthalten in der Regel eine kommerzielle Lizenz, die für Werbung und Merchandise geeignet ist.',
                },
            ],
            page: {
                title1: 'Kostenloser KI-Text-zu-Bild-Generator',
                title2: 'Erstellen Sie atemberaubende Kunstwerke, fotorealistische Bilder und einzigartige Hintergrundbilder in Sekunden. Beschreiben Sie einfach, was Sie sehen möchten, und unser fortschrittliches Nano Banana Pro-Modell generiert hochwertige 4K-Bilder, die perfekt zu Ihrer Beschreibung passen.',
                resolution: 'Hören Sie auf, sich mit unscharfen KI-Bildern zufrieden zu geben. 微鲤AI ermöglicht es Ihnen, kristallklare 1K-, 2K- und 4K-Bilder direkt zu generieren, perfekt für den Druck oder hochauflösende Displays.',
                aspectRatio: 'Ob Sie ein 9:16-Bild für TikTok-Hintergründe, 16:9 für YouTube-Miniaturansichten oder 1:1 für Instagram benötigen, wir haben Voreinstellungen für jede Social-Media-Plattform.',
                online_search: 'Benötigen Sie aktuellen Kontext? Aktivieren Sie "Online-Suche", damit die KI im Web surft, um aktuelle Ereignisse oder spezifische Referenzen in Ihrer Beschreibung besser zu verstehen.',
                faq: [
                    {
                        question: 'Wie generiere ich hochwertige Bilder aus Text?',
                        answer: 'Geben Sie eine detaillierte Beschreibung ein, die das Motiv, die Beleuchtung und den Stil beschreibt. Wählen Sie "4K" in den Bildeinstellungen für die schärfsten Details.',
                    },
                    {
                        question: 'Was ist das Nano Banana Pro-Modell?',
                        answer: 'Nano Banana Pro ist unser Modell mit der höchsten Qualität, optimiert für Beschreibungsgenauigkeit und Fotorealismus. Es konkurriert in der Qualität mit Top-Modellen wie Midjourney v6 und Flux.',
                    },
                    {
                        question: 'Kann ich die Bilder für kommerzielle Zwecke verwenden?',
                        answer: 'Ja. Auf 微鲤AI (kostenpflichtige Pläne) generierte Bilder werden mit einer kommerziellen Lizenz geliefert, die es Ihnen ermöglicht, sie für Werbung, Websites und Merchandise zu verwenden.',
                    },
                    {
                        question: 'Wie viele Bilder kann ich gleichzeitig generieren?',
                        answer: 'Sie können bis zu 4 Bilder gleichzeitig generieren (wie in der Einstellung "Anzahl der Ausgabebilder" angezeigt), was es Ihnen ermöglicht, schnell über Ideen zu iterieren.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können Bilder mit unseren kostenlosen täglichen Credits generieren. Höhere Auflösungen (4K) erfordern möglicherweise mehr Credits.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Kostenloser KI Bild-zu-Bild Generator - Foto in Kunst & 4K verwandeln | 微鲤AI',
            description: 'Laden Sie ein Referenzfoto hoch und transformieren Sie es mit WeryAIs Bild-zu-Bild KI. Wandeln Sie Skizzen in realistische Kunst um, ändern Sie Stile oder generieren Sie Variationen, während die ursprüngliche Komposition erhalten bleibt. Unterstützt 4K-Auflösung.',
            keywords: 'bild zu bild ai, img2img, foto in zeichnung verwandeln, ai bild variation, skizze zu bild, foto remix ai, kostenloser ai kunst generator',
            og_title: 'Kostenloser KI Bild-zu-Bild Generator - Foto in Kunst & 4K verwandeln | 微鲤AI',
            og_description: 'Laden Sie ein Referenzfoto hoch und transformieren Sie es mit WeryAIs Bild-zu-Bild KI. Wandeln Sie Skizzen in realistische Kunst um, ändern Sie Stile oder generieren Sie Variationen, während die ursprüngliche Komposition erhalten bleibt. Unterstützt 4K-Auflösung.',
            twitter_title: 'Kostenloser KI Bild-zu-Bild Generator - Foto in Kunst & 4K verwandeln | 微鲤AI',
            twitter_description: 'Laden Sie ein Referenzfoto hoch und transformieren Sie es mit WeryAIs Bild-zu-Bild KI. Wandeln Sie Skizzen in realistische Kunst um, ändern Sie Stile oder generieren Sie Variationen, während die ursprüngliche Komposition erhalten bleibt. Unterstützt 4K-Auflösung.',
            faq: [
                {
                    question: 'Was ist Bild-zu-Bild KI?',
                    answer: 'Bild-zu-Bild (Img2Img) verwendet ein hochgeladenes Bild als Referenz zusammen mit einer Textaufforderung, um ein neues Bild zu generieren, wobei visuelle Eingabe mit kreativer Beschreibung kombiniert wird.',
                },
                {
                    question: 'Wie verwandle ich eine Skizze in ein realistisches Foto?',
                    answer: `Laden Sie Ihre Skizze hoch, geben Sie eine Aufforderung ein, die die Szene beschreibt (z. B. 'fotorealistisches Gebäude'), und klicken Sie auf Erstellen.`,
                },
                {
                    question: 'Behält es das ursprüngliche Gesicht?',
                    answer: 'Es bewahrt Struktur und Pose. Für eine präzise Gesichtsidentitätserhaltung verwenden Sie bitte unser Foto-Gesichtstausch-Tool.',
                },
            ],
            page: {
                title1: 'Kostenloser KI Bild-zu-Bild Generator',
                title2: 'Verwenden Sie Ihre vorhandenen Bilder als Vorlage. Laden Sie ein Foto, eine Skizze oder ein Layout hoch und lassen Sie unsere KI es basierend auf Ihrer Textaufforderung in einem völlig neuen Stil regenerieren. Perfekt, um die Komposition zu bewahren, während Sie unendliche künstlerische Variationen erkunden.',
                title3: 'Transformieren Sie Ihre Fotos mit KI-Stiltransfer',
                title4: 'Warum Bild-zu-Bild (Img2Img) verwenden?',
                upload_image: 'Haben Sie Schwierigkeiten, eine Pose oder ein Layout in Worten zu beschreiben? Laden Sie einfach ein Referenzbild hoch. Unsere Img2Img-Engine behält die Struktur Ihres Originalfotos bei, malt aber die Details neu.',
                resolution: 'Verwandeln Sie eine grobe Skizze oder ein Wireframe in Sekunden in ein fotorealistisches Rendering oder eine hochwertige Illustration. Ideal für Designer und Architekten.',
                output: 'Generieren Sie produktionsreife Assets. Im Gegensatz zu anderen Tools, die kleine Bilder ausgeben, unterstützt 微鲤AI 1K-, 2K- und 4K-Auflösungen für scharfe Details.',
                faq: [
                    {
                        question: 'Was ist Bild-zu-Bild KI?',
                        answer: 'Bild-zu-Bild (Img2Img) ist eine Technologie, die ein hochgeladenes Bild als "Referenz" zusammen mit einer Textaufforderung verwendet, um ein neues Bild zu generieren. Sie kombiniert Ihre visuelle Eingabe mit Ihrer kreativen Beschreibung.',
                    },
                    {
                        question: 'Wie verwandle ich eine Skizze in ein realistisches Foto?',
                        answer: 'Laden Sie Ihre Skizze in den "Bild"-Bereich hoch. Beschreiben Sie im "Prompt"-Feld, was die Skizze darstellt (z. B. "Eine moderne Villa, Sonnenuntergang, fotorealistisch, 8k"). Klicken Sie auf Erstellen, um die Magie zu sehen.',
                    },
                    {
                        question: 'Behält es das ursprüngliche Gesicht/Person?',
                        answer: 'Es versucht, die allgemeine Struktur und Pose zu bewahren. Für eine präzise Gesichtserhaltung empfehlen wir jedoch, stattdessen unser spezifisches "Foto-Gesichtstausch"-Tool zu verwenden.',
                    },
                    {
                        question: 'Welche Seitenverhältnisse werden unterstützt?',
                        answer: 'Wir unterstützen eine breite Palette von Verhältnissen einschließlich 9:16 (Story), 16:9 (Kinematisch), 3:4 und 1:1, sodass Ihre generierte Kunst perfekt auf jede Plattform passt.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können Variationen kostenlos mit Ihren täglichen Credits generieren.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Kostenloser KI-Bild-Erweiterer & Größenänderer - Zuschneiden Aufheben & Erweitern',
            description: 'Ändern Sie die Bildgröße für Instagram, TikTok und YouTube ohne Zuschneiden. WeryAIs KI-Bild-Erweiterer verwendet generatives Füllen (Erweiterung), um Bildhintergründe intelligent zu erweitern. Ändern Sie Seitenverhältnisse nahtlos.',
            keywords: 'ki bild erweiterer, zuschneiden aufheben, ki erweiterung, bild größenänderer ki, bildhintergrund erweitern, generatives füllen online, foto vertikal machen',
            og_title: 'Kostenloser KI-Bild-Erweiterer & Größenänderer - Zuschneiden Aufheben & Erweitern',
            og_description: 'Ändern Sie die Bildgröße für Instagram, TikTok und YouTube ohne Zuschneiden. WeryAIs KI-Bild-Erweiterer verwendet generatives Füllen (Erweiterung), um Bildhintergründe intelligent zu erweitern. Ändern Sie Seitenverhältnisse nahtlos.',
            twitter_title: 'Kostenloser KI-Bild-Erweiterer & Größenänderer - Zuschneiden Aufheben & Erweitern',
            twitter_description: 'Ändern Sie die Bildgröße für Instagram, TikTok und YouTube ohne Zuschneiden. WeryAIs KI-Bild-Erweiterer verwendet generatives Füllen (Erweiterung), um Bildhintergründe intelligent zu erweitern. Ändern Sie Seitenverhältnisse nahtlos.',
            page: {
                title1: 'Kostenloser KI-Bild-Erweiterer & Größenänderer',
                title2: 'Hören Sie auf, Ihre Lieblingsfotos zuzuschneiden, damit sie in soziale Medien passen. Ob Sie ein horizontales Foto in eine vertikale Story verwandeln oder ein quadratisches Bild auf 16:9 erweitern müssen, unser KI-Bild-Erweiterer generiert magisch neue Hintergrunddetails (Erweiterung), um perfekt zu jedem Seitenverhältnis zu passen.',
                faq: [
                    {
                        question: 'Wie ändere ich die Bildgröße ohne Zuschneiden?',
                        answer: 'Verwenden Sie WeryAIs KI-Bild-Erweiterer. Laden Sie Ihr Foto hoch, wählen Sie das Zielseitenverhältnis (z. B. 9:16), und die KI generiert automatisch (erweitert) die fehlenden Hintergrundbereiche, anstatt Ihr Bild zuzuschneiden.',
                    },
                    {
                        question: 'Was ist KI-Erweiterung?',
                        answer: 'Erweiterung ist eine generative KI-Technologie, die die Ränder eines Bildes erweitert, indem sie neuen Inhalt vorhersagt und zeichnet, der zum ursprünglichen Stil passt, und das Foto effektiv "entschneidet".',
                    },
                    {
                        question: 'Kann ich ein horizontales Foto in ein vertikales verwandeln?',
                        answer: 'Ja! Laden Sie einfach Ihr horizontales (Querformat-)Foto hoch und wählen Sie das Verhältnis 9:16. Die KI erweitert den oberen und unteren Teil des Bildes, um den vertikalen Rahmen zu füllen.',
                    },
                    {
                        question: 'Wird der erweiterte Hintergrund falsch aussehen?',
                        answer: '微鲤AI verwendet fortschrittliche generative Modelle, die auf massiven Datensätzen trainiert wurden, um sicherzustellen, dass der erweiterte Hintergrund natürlich mit der ursprünglichen Beleuchtung und Textur verschmilzt.',
                    },
                    {
                        question: 'Ist es kostenlos zu verwenden?',
                        answer: 'Ja, Benutzer erhalten kostenlose Credits, um die KI-Smart-Größenänderung und Erweiterungsfunktionen zu testen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie ändere ich die Bildgröße ohne Zuschneiden?',
                    answer: 'Verwenden Sie WeryAIs KI-Bild-Erweiterer. Laden Sie Ihr Foto hoch, wählen Sie das Zielseitenverhältnis (z. B. 9:16), und die KI generiert automatisch (erweitert) die fehlenden Hintergrundbereiche, anstatt Ihr Bild zuzuschneiden.',
                },
                {
                    question: 'Was ist KI-Erweiterung?',
                    answer: 'Erweiterung ist eine generative KI-Technologie, die die Ränder eines Bildes erweitert, indem sie neuen Inhalt vorhersagt und zeichnet, der zum ursprünglichen Stil passt, und das Foto effektiv "entschneidet".',
                },
                {
                    question: 'Kann ich ein horizontales Foto in ein vertikales verwandeln?',
                    answer: 'Ja! Laden Sie einfach Ihr horizontales (Querformat-)Foto hoch und wählen Sie das Verhältnis 9:16. Die KI erweitert den oberen und unteren Teil des Bildes, um den vertikalen Rahmen zu füllen.',
                },
                {
                    question: 'Wird der erweiterte Hintergrund falsch aussehen?',
                    answer: '微鲤AI verwendet fortschrittliche generative Modelle, die auf massiven Datensätzen trainiert wurden, um sicherzustellen, dass der erweiterte Hintergrund natürlich mit der ursprünglichen Beleuchtung und Textur verschmilzt.',
                },
                {
                    question: 'Ist es kostenlos zu verwenden?',
                    answer: 'Ja, Benutzer erhalten kostenlose Credits, um die KI-Smart-Größenänderung und Erweiterungsfunktionen zu testen.',
                },
            ],
            feature_title1: 'Intelligente Hintergrunderweiterung',
            feature_desc1: 'Magische Erweiterung: Die KI versteht den Kontext Ihres Bildes und malt neue Pixel über die ursprünglichen Grenzen hinaus. Erweitern Sie Landschaften, Räume oder Texturen nahtlos, um den Rahmen zu füllen.',
            feature_title2: 'Zentrumsschutz',
            feature_desc2: 'Subjekt Niemals Zuschneiden: Unsere KI identifiziert automatisch die Hauptperson oder das Hauptobjekt und sperrt sie in der Mitte, sodass sie während des Größenänderungsprozesses niemals abgeschnitten werden.',
            feature_title3: 'Bereit für Soziale Medien',
            feature_desc3: 'Ein-Klick-Voreinstellungen für Instagram Stories (9:16), YouTube-Miniaturansichten (16:9) und Beiträge (4:5). Nutzen Sie Ihre Inhalte sofort auf allen Plattformen wieder.',
        },
        imageTextTranslate: {
            title: 'Kostenloser KI-Bildübersetzer - Text in Fotos, Manga und Comics Übersetzen',
            description: 'Übersetzen Sie Text in Bildern sofort, während der ursprüngliche visuelle Stil erhalten bleibt. WeryAIs KI-Bildübersetzer löscht automatisch den ursprünglichen Text und zeichnet Übersetzungen neu. Perfekt für Comics, Manga und Marketing-Poster.',
            keywords: 'ki bildübersetzer, text in bild übersetzen, bildübersetzer, manga übersetzer, comics übersetzen, ocr übersetzer, bildtext ersetzung',
            og_title: 'Kostenloser KI-Bildübersetzer - Text in Fotos, Manga und Comics Übersetzen',
            og_description: 'Übersetzen Sie Text in Bildern sofort, während der ursprüngliche visuelle Stil erhalten bleibt. WeryAIs KI-Bildübersetzer löscht automatisch den ursprünglichen Text und zeichnet Übersetzungen neu. Perfekt für Comics, Manga und Marketing-Poster.',
            twitter_title: 'Kostenloser KI-Bildübersetzer - Text in Fotos, Manga und Comics Übersetzen',
            twitter_description: 'Übersetzen Sie Text in Bildern sofort, während der ursprüngliche visuelle Stil erhalten bleibt. WeryAIs KI-Bildübersetzer löscht automatisch den ursprünglichen Text und zeichnet Übersetzungen neu. Perfekt für Comics, Manga und Marketing-Poster.',
            page: {
                title1: 'Kostenloser KI-Bildübersetzer und Textersetzter',
                title2: 'Übersetzen Sie Poster, Menüs, Comics und Screenshots in Sekunden. Im Gegensatz zu Standard-Übersetzern, die Text nur überlagern, verwendet 微鲤AI Generative KI, um den ursprünglichen Text zu löschen und den Hintergrund neu zu zeichnen, sodass der übersetzte Text wie Teil des ursprünglichen Designs aussieht.',
                faq: [
                    {
                        question: 'Wie übersetze ich Text in einem Bild?',
                        answer: 'Laden Sie Ihr Bild (JPG, PNG) auf 微鲤AI hoch. Wählen Sie die Quellsprache (oder verwenden Sie Auto-Erkennung) und die Zielsprache. Klicken Sie auf "Erstellen", damit die KI den Text ersetzt.',
                    },
                    {
                        question: 'Wird der übersetzte Text natürlich aussehen?',
                        answer: 'Ja. 微鲤AI versucht, Schriftgröße und -stil des ursprünglichen Textes zu entsprechen. Entscheidend ist, dass es den Hintergrund hinter dem Text neu zeichnet, damit die Übersetzung nahtlos integriert wird.',
                    },
                    {
                        question: 'Kann ich dies verwenden, um Manga oder Manhwa zu übersetzen?',
                        answer: 'Absolut. Dies ist einer der besten Anwendungsfälle. Die KI erkennt Sprechblasen und vertikalen Text (häufig in Japanisch) und ersetzt sie durch horizontalen übersetzten Text.',
                    },
                    {
                        question: 'Welche Sprachen werden unterstützt?',
                        answer: 'Wir unterstützen Übersetzungen zwischen den wichtigsten globalen Sprachen einschließlich Englisch, Spanisch, Chinesisch, Japanisch, Koreanisch, Französisch, Deutsch und mehr.',
                    },
                    {
                        question: 'Funktioniert es bei handgeschriebenem Text?',
                        answer: 'Es funktioniert am besten bei gedrucktem Text, aber unsere fortschrittliche OCR-Engine kann klaren handgeschriebenen Text auf Whiteboards oder Notizen erkennen.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Sie können Bilder kostenlos mit Ihren täglichen Credits übersetzen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie übersetze ich Text in einem Bild?',
                    answer: `Laden Sie Ihr Bild auf 微鲤AI hoch. Wählen Sie die Zielsprache und klicken Sie auf 'Erstellen'. Die KI ersetzt den ursprünglichen Text durch die Übersetzung.`,
                },
                {
                    question: 'Wird der übersetzte Text natürlich aussehen?',
                    answer: 'Ja. 微鲤AI zeichnet den Hintergrund hinter dem Text neu und versucht, den Schriftstil zu entsprechen, sodass die Übersetzung nahtlos integriert wird.',
                },
                {
                    question: 'Kann ich dies verwenden, um Manga oder Manhwa zu übersetzen?',
                    answer: 'Absolut. Dies ist einer der besten Anwendungsfälle. Die KI erkennt Sprechblasen und vertikalen Text (häufig in Japanisch) und ersetzt sie durch horizontalen übersetzten Text.',
                },
            ],
            feature_title1: 'Intelligentes Inpainting und Neuziechnung',
            feature_desc1: 'Nahtlose Textersetzung: Unsere KI analysiert die Hintergrundtextur hinter dem Text. Sie löscht die ursprünglichen Wörter und füllt die Lücke intelligent, bevor sie die Übersetzung hinzufügt, sodass keine hässlichen Textboxen Ihr Bild verdecken.',
            feature_title2: 'Manga und Comic-Übersetzung',
            feature_desc2: 'Lesen Sie Rohen Manga Sofort: Perfekt für Anime-Fans. Laden Sie rohe Manga-Seiten (Japanisch/Koreanisch) hoch und erhalten Sie sofortige englische Übersetzungen, die perfekt in die Sprechblasen passen.',
            feature_title3: 'Globale Marketing-Lokalisierung',
            feature_desc3: 'Ein-Klick-Lokalisierung: Produkte global starten? Übersetzen Sie Ihre Marketing-Poster, Banner und UI-Screenshots in über 30 Sprachen, ohne die ursprünglichen PSD-Dateien zu benötigen.',
        },
        aiBackgroundChanger: {
            title: 'Kostenloser KI-Hintergrundwechsler - Hintergründe aus Text erzeugen',
            description: 'Ändern Sie Foto-Hintergründe sofort mit KI. Beschreiben Sie die gewünschte Szene, und 微鲤AI erzeugt realistische Hintergründe für Produktfotos, LinkedIn-Headshots und kreative Porträts. Kostenlos & online.',
            keywords: 'foto hintergrund ändern, KI hintergrund generator, produktfotografie KI, weißer hintergrund, hintergrund online ersetzen, generatives füllen hintergrund',
            og_title: 'Kostenloser KI-Hintergrundwechsler - Hintergründe aus Text erzeugen',
            og_description: 'Ändern Sie Foto-Hintergründe sofort mit KI. Beschreiben Sie die gewünschte Szene, und 微鲤AI erzeugt realistische Hintergründe für Produktfotos, LinkedIn-Headshots und kreative Porträts. Kostenlos & online.',
            twitter_title: 'Kostenloser KI-Hintergrundwechsler - Hintergründe aus Text erzeugen',
            twitter_description: 'Ändern Sie Foto-Hintergründe sofort mit KI. Beschreiben Sie die gewünschte Szene, und 微鲤AI erzeugt realistische Hintergründe für Produktfotos, LinkedIn-Headshots und kreative Porträts. Kostenlos & online.',
            page: {
                title1: 'Kostenloser KI-Hintergrundwechsler & Generator',
                title2: 'Entfernen Sie den Hintergrund nicht nur – ersetzen Sie ihn durch etwas Besseres. Laden Sie Ihr Foto hoch und beschreiben Sie eine Szene (z. B. „luxuriöses Marmor-Studio“, „Office-Skyline“). Unsere Generative KI versteht Licht und Perspektive und blendet Ihr Motiv perfekt in die neue Umgebung ein.',
                faq: [
                    {
                        question: 'Wie ändere ich den Hintergrund mit Text?',
                        answer: 'Laden Sie Ihr Bild hoch und beschreiben Sie im Feld „Background Prompt“ die gewünschte Szene (z. B. „ein gemütliches Café“). Klicken Sie auf Erstellen – die KI generiert den Hintergrund für Sie.',
                    },
                    {
                        question: 'Kann ich den Hintergrund auf reines Weiß ändern?',
                        answer: 'Ja. Tippen Sie einfach „pure white background“ oder „studio white“ in das Prompt-Feld. Perfekt für Amazon/eBay-Produktbilder und Ausweisfotos.',
                    },
                    {
                        question: 'Ist das gut für Produktfotografie?',
                        answer: 'Absolut. 微鲤AI analysiert den Winkel Ihres Produkts und erzeugt Hintergründe mit passenden Schatten und Beleuchtung – wie bei einem professionellen Studio-Shooting.',
                    },
                    {
                        question: 'Wirkt die Beleuchtung natürlich?',
                        answer: 'Unsere Generative KI (ähnlich Adobe Firefly oder SDXL) versucht, die Beleuchtung des generierten Hintergrunds an Ihr Motiv anzupassen, damit alles nahtlos wirkt.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können neue Hintergründe kostenlos mit Ihren täglichen Credits generieren.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie ändere ich den Hintergrund mit Text?',
                    answer: 'Laden Sie Ihr Bild hoch und beschreiben Sie im Feld „Background Prompt“ die gewünschte Szene (z. B. „ein gemütliches Café“). Klicken Sie auf Erstellen – die KI generiert den Hintergrund für Sie.',
                },
                {
                    question: 'Kann ich den Hintergrund auf reines Weiß ändern?',
                    answer: 'Ja. Tippen Sie einfach „pure white background“ oder „studio white“ in das Prompt-Feld. Perfekt für Amazon/eBay-Produktbilder und Ausweisfotos.',
                },
                {
                    question: 'Ist das gut für Produktfotografie?',
                    answer: 'Absolut. 微鲤AI analysiert den Winkel Ihres Produkts und erzeugt Hintergründe mit passenden Schatten und Beleuchtung – wie bei einem professionellen Studio-Shooting.',
                },
                {
                    question: 'Wirkt die Beleuchtung natürlich?',
                    answer: 'Unsere Generative KI (ähnlich Adobe Firefly oder SDXL) versucht, die Beleuchtung des generierten Hintergrunds an Ihr Motiv anzupassen, damit alles nahtlos wirkt.',
                },
                {
                    question: 'Ist es kostenlos?',
                    answer: 'Ja, Sie können neue Hintergründe kostenlos mit Ihren täglichen Credits generieren.',
                },
            ],
            feature_title1: 'Professionelle Ausweisfotos',
            feature_desc1: 'DIY LinkedIn-Headshots: Machen Sie aus einer einfachen Selfie ein professionelles Profilbild. Tauschen Sie einen unordentlichen Schlafzimmerhintergrund sofort gegen ein sauberes Büro oder Studio-Grau.',
            feature_title2: 'Sofortige Produktfotografie',
            feature_desc2: 'Mehr E-Commerce-Umsatz: Sparen Sie tausende Euro an Fotoshootings. Platzieren Sie Ihr Produkt per Textprompt auf einem Holztisch, am Strand oder auf einem Podest. Die KI fügt realistische Schatten und Reflexionen hinzu.',
            feature_title3: 'Kreative Teleportation',
            feature_desc3: 'Reisen Sie überallhin: Paris oder eine Cyberpunk-Zukunft? Einfach eintippen. Unsere KI ersetzt den Hintergrund und hält die Beleuchtung Ihrer Originalaufnahme konsistent.',
        },
        imageUpscaler: {
            title: 'Kostenloser KI-Bild-Upscaler - Bis 4K Hochskalieren & Alte Fotos Wiederherstellen',
            description: 'Skalieren Sie niedrig aufgelöste Bilder sofort auf 2x, 4x und bis zu 4K mit WeryAIs kostenlosem KI-Bildverbesserer. Schärfen Sie unscharfe Fotos, entfernen Sie Rauschen und stellen Sie alte Familienfotos online wieder her. Verlustfreie Qualität.',
            keywords: 'KI Bild Upscaler, Foto-Verbesserer, Bild auf 4K hochskalieren, Bild entblurren, alte Fotos wiederherstellen, pixelige Fotos reparieren, Bildauflösung erhöhen',
            og_title: 'Kostenloser KI-Bild-Upscaler - Bis 4K Hochskalieren & Alte Fotos Wiederherstellen',
            og_description: 'Skalieren Sie niedrig aufgelöste Bilder sofort auf 2x, 4x und bis zu 4K mit WeryAIs kostenlosem KI-Bildverbesserer. Schärfen Sie unscharfe Fotos, entfernen Sie Rauschen und stellen Sie alte Familienfotos online wieder her. Verlustfreie Qualität.',
            twitter_title: 'Kostenloser KI-Bild-Upscaler - Bis 4K Hochskalieren & Alte Fotos Wiederherstellen',
            twitter_description: 'Skalieren Sie niedrig aufgelöste Bilder sofort auf 2x, 4x und bis zu 4K mit WeryAIs kostenlosem KI-Bildverbesserer. Schärfen Sie unscharfe Fotos, entfernen Sie Rauschen und stellen Sie alte Familienfotos online wieder her. Verlustfreie Qualität.',
            page: {
                title1: 'Kostenloser KI-Bild-Upscaler & -Verbesserer',
                title2: 'Verwandeln Sie pixelige, unscharfe oder alte Fotos in hochauflösende Meisterwerke. 微鲤AI nutzt fortschrittliche KI, um die Auflösung um bis zu 400% (4K) zu erhöhen, während verlorene Details wiederhergestellt, Rauschen korrigiert und Gesichter in alten Familienporträts rekonstruiert werden.',
                faq: [
                    {
                        question: 'Kann ich niedrig aufgelöste Bilder fürs Drucken hochskalieren?',
                        answer: 'Ja! 微鲤AI erhöht die Auflösung (Pixelanzahl) bis zu 4K und macht Ihr Bild damit geeignet für hochwertige Drucke auf Postern, Leinwand oder Marketingmaterialien.',
                    },
                    {
                        question: 'Wie funktioniert die KI-Restaurierung alter Fotos?',
                        answer: 'Die KI analysiert beschädigte oder unscharfe Bereiche und nutzt Deep Learning, um Gesichtdetails, Texturen und Hintergründe vorherzusagen und zu rekonstruieren – sie „heilt“ das Bild effektiv.',
                    },
                    {
                        question: 'Welche Formate werden unterstützt?',
                        answer: 'Wir unterstützen gängige Formate wie JPG, PNG und WEBP. Das Ergebnis wird als hochwertiges PNG oder JPG ausgegeben.',
                    },
                    {
                        question: 'Funktioniert es bei Anime/Cartoons?',
                        answer: 'Ja. Unsere KI eignet sich hervorragend zum Hochskalieren von Anime und Illustrationen (waifu2x-Stil) und hält Linien scharf sowie Farben lebendig – ohne Artefakte.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können Bilder mit Ihren täglichen Credits kostenlos verbessern.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Kann ich niedrig aufgelöste Bilder fürs Drucken hochskalieren?',
                    answer: 'Ja! 微鲤AI erhöht die Auflösung bis zu 4K, sodass Bilder für hochwertigen Druck geeignet sind.',
                },
                {
                    question: 'Wie funktioniert die KI-Restaurierung alter Fotos?',
                    answer: 'Die KI analysiert beschädigte Bereiche und rekonstruiert Gesichtdetails und Texturen mit Deep Learning, um das Bild zu „heilen“.',
                },
                {
                    question: 'Funktioniert es bei Anime?',
                    answer: 'Ja. Unsere KI skaliert Anime und Illustrationen hervorragend hoch und hält Linien scharf – ohne Artefakte.',
                },
            ],
            feature_title1: 'Verlustfreies Hochskalieren bis 4K',
            feature_desc1: 'Druckfertige Qualität: Müssen Sie ein kleines Bild drucken? Skalieren Sie es auf 4K oder 8K hoch, ohne Qualität zu verlieren. Perfekt für Poster, E-Commerce-Produktshots und Wallpaper.',
            feature_title2: 'Smartes Entrauschen & Entschärfen',
            feature_desc2: 'Nachtaufnahmen reparieren: Entfernen Sie digitales Rauschen und Körnung aus Low-Light-Fotos. Schärfen Sie unscharfe Kanten sofort, damit Ihre Fotos knackig und professionell aussehen.',
            feature_title3: 'Restaurierung Alter Fotos',
            feature_desc3: 'Erinnerungen wiederbeleben: Alte, beschädigte oder schwarz-weiße Fotos? Unsere KI erzeugt neue Pixel, repariert Kratzer, schärft Gesichter und bringt Klarheit in Ihre wertvollen Erinnerungen zurück.',
        },
        photoFaceSwap: {
            title: 'Kostenloser KI-Face Swap Online - Realistischer Foto-Gesichtstausch | 微鲤AI',
            description: 'Tauschen Sie Gesichter in Fotos sofort mit WeryAIs kostenlosem KI-Face-Swapper. Erstellen Sie lustige Memes, künstlerische Porträts (Mona Lisa) oder professionelle Headshots mit hoher Realistik. 100% privat & sicher.',
            keywords: 'KI face swap, gesicht online tauschen, foto gesicht wechseln, reface kostenlos, gesicht in bild ersetzen, deepfake foto, meme maker KI',
            og_title: 'Kostenloser KI-Face Swap Online - Realistischer Foto-Gesichtstausch | 微鲤AI',
            og_description: 'Tauschen Sie Gesichter in Fotos sofort mit WeryAIs kostenlosem KI-Face-Swapper. Erstellen Sie lustige Memes, künstlerische Porträts (Mona Lisa) oder professionelle Headshots mit hoher Realistik. 100% privat & sicher.',
            twitter_title: 'Kostenloser KI-Face Swap Online - Realistischer Foto-Gesichtstausch | 微鲤AI',
            twitter_description: 'Tauschen Sie Gesichter in Fotos sofort mit WeryAis kostenlosem KI-Face-Swapper. Erstellen Sie lustige Memes, künstlerische Porträts (Mona Lisa) oder professionelle Headshots mit hoher Realistik. 100% privat & sicher.',
            page: {
                title1: 'Kostenloser KI-Foto-Face Swap',
                title2: 'Wollten Sie sich schon immer als Astronaut, Filmstar oder in einem klassischen Gemälde sehen? Laden Sie ein Basisfoto und ein Zielgesicht hoch – unsere KI blendet Gesichtszüge, Licht und Hautton nahtlos, für einen hyperrealistischen Face Swap in Sekunden.',
                faq: [
                    {
                        question: 'Ist 微鲤AI Face Swap kostenlos?',
                        answer: 'Ja, wir bieten tägliche Gratis-Credits, damit Sie online Gesichter tauschen können. Keine Installation und keine Kreditkarte nötig.',
                    },
                    {
                        question: 'Sind meine Daten sicher?',
                        answer: 'Absolut. Ihre Privatsphäre hat Priorität. Hochgeladene Fotos werden nur für den Tausch verwendet und nach kurzer Zeit automatisch von unseren Servern gelöscht.',
                    },
                    {
                        question: 'Wie bekomme ich die besten Ergebnisse?',
                        answer: 'Für den realistischsten Tausch sollten sowohl „Basisbild“ als auch „Gesichtsbild“ klar, frontal und gut ausgeleuchtet sein. Vermeiden Sie Fotos, bei denen das Gesicht von Haaren oder Händen verdeckt ist.',
                    },
                    {
                        question: 'Kann ich Gesichter in Gruppenfotos tauschen?',
                        answer: 'Aktuell konzentrieren wir uns auf höchste Präzision bei einem einzelnen Gesicht. Für Gruppenfotos bitte zuschneiden oder unsere kommende Multi-Face-Funktion nutzen.',
                    },
                    {
                        question: 'Kann ich es für Memes nutzen?',
                        answer: 'Ja! Perfekt für lustige Memes. Tauschen Sie das Gesicht eines Freundes auf ein Filmplakat oder ein virales Meme-Template – sofort.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Ist 微鲤AI Face Swap kostenlos?',
                    answer: 'Ja, wir bieten tägliche Gratis-Credits für den Online-Face-Swap – ohne Installation oder Kreditkarte.',
                },
                {
                    question: 'Sind meine Daten sicher?',
                    answer: 'Ja. Ihre Fotos werden nur für den Tausch genutzt und nach kurzer Zeit automatisch gelöscht.',
                },
                {
                    question: 'Wie bekomme ich die besten Ergebnisse?',
                    answer: 'Achten Sie auf klare, frontale und gut beleuchtete Fotos. Vermeiden Sie verdeckte Gesichter (Haare/Brille).',
                },
            ],
            feature_title1: 'Künstlerische Meisterwerke',
            feature_desc1: 'Zeitreise: Tauschen Sie Ihr Gesicht in klassische Ölgemälde wie die Mona Lisa oder das Mädchen mit dem Perlenohrring. Erstellen Sie sofort einzigartige Vintage-Avatare.',
            feature_title2: 'Professionelle & Coole Avatare',
            feature_desc2: 'Traumjobs: Sehen Sie sich im Rennanzug, Astronauten-Outfit oder Business-Look – ohne Kostümkauf. Perfekt für auffällige Profilbilder.',
            feature_title3: 'Hyperrealistisches Blending',
            feature_desc3: 'Kein „Aufklebe“-Effekt: Anders als einfache Cut-and-Paste-Tools analysiert 微鲤AI Winkel, Licht und Hauttextur, damit das Ergebnis 100% natürlich wirkt – nicht fake.',
        },
        removeTextFromImage: {
            title: 'Kostenloser KI-Textentferner - Wasserzeichen & Datumsstempel Löschen | 微鲤AI',
            description: 'Entfernen Sie sofort Text, Datumsstempel, Logos und Beschriftungen aus Bildern mit WeryAIs kostenlosem KI-Text-Radiergummi. Stellen Sie Hintergründe perfekt mit KI-Inpainting wieder her. Ideal zum Aufräumen von Fotos und E-Commerce-Mockups.',
            keywords: 'text aus bild entfernen, KI textentferner, datumsstempel entfernen, wasserzeichen online entfernen, bilder aufräumen, KI inpainting, logo aus foto entfernen',
            og_title: 'Kostenloser KI-Textentferner - Wasserzeichen & Datumsstempel Löschen | 微鲤AI',
            og_description: 'Entfernen Sie sofort Text, Datumsstempel, Logos und Beschriftungen aus Bildern mit WeryAIs kostenlosem KI-Text-Radiergummi. Stellen Sie Hintergründe perfekt mit KI-Inpainting wieder her. Ideal zum Aufräumen von Fotos und E-Commerce-Mockups.',
            twitter_title: 'Kostenloser KI-Textentferner - Wasserzeichen & Datumsstempel Löschen | 微鲤AI',
            twitter_description: 'Entfernen Sie sofort Text, Datumsstempel, Logos und Beschriftungen aus Bildern mit WeryAIs kostenlosem KI-Text-Radiergummi. Stellen Sie Hintergründe perfekt mit KI-Inpainting wieder her. Ideal zum Aufräumen von Fotos und E-Commerce-Mockups.',
            page: {
                title1: 'Kostenloser KI-Textentferner aus Bildern',
                title2: 'Stört Sie unerwünschter Text? Laden Sie Ihr Bild hoch – unsere KI erkennt und entfernt Text, Logos, Datumsstempel oder Captions sofort. Sie analysiert die umliegenden Pixel und rekonstruiert den Hintergrund, ohne Spuren zu hinterlassen.',
                faq: [
                    {
                        question: 'Wie entferne ich Text ohne Unschärfe?',
                        answer: 'Nutzen Sie WeryAIs KI-Textentferner. Statt zu verwischen, verwendet das Tool KI-Inpainting, analysiert die Umgebung und erzeugt neue Pixel, um die Lücke nahtlos zu füllen.',
                    },
                    {
                        question: 'Kann ich Datumsstempel von Fotos entfernen?',
                        answer: 'Ja! Perfekter Anwendungsfall. Die KI erkennt die digitale Schrift von Datum/Uhrzeit und entfernt sie, während die Landschaft dahinter wiederhergestellt wird.',
                    },
                    {
                        question: 'Funktioniert es bei komplexen Hintergründen?',
                        answer: 'Ja. Es kann Text sogar auf komplexen Hintergründen wie Berglandschaften oder gemusterten Kleidern entfernen, indem es den Texturfluss versteht.',
                    },
                    {
                        question: 'Kann ich auch Personen oder Objekte entfernen?',
                        answer: 'Obwohl auf Text optimiert, eignet sich die Basistechnologie (Inpainting) auch zum Entfernen kleiner unerwünschter Objekte, Hautunreinheiten oder Unordnung.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können das Tool mit täglichen Credits kostenlos nutzen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie entferne ich Text ohne Unschärfe?',
                    answer: 'Nutzen Sie WeryAIs KI-Textentferner. KI-Inpainting erzeugt neue Pixel, um die Lücke nahtlos zu füllen.',
                },
                {
                    question: 'Kann ich Datumsstempel von Fotos entfernen?',
                    answer: 'Ja! Die KI erkennt Datums-/Zeitstempel und entfernt sie, während der Hintergrund wiederhergestellt wird.',
                },
                {
                    question: 'Funktioniert es bei komplexen Hintergründen?',
                    answer: 'Ja. Es versteht den Texturfluss und entfernt Text auch auf komplexen Hintergründen.',
                },
            ],
            feature_title1: 'Kleidung & Design Cleanup',
            feature_desc1: 'Perfekt für Mockups: Verkaufen Sie Kleidung online weiter? Entfernen Sie Logos, Slogans oder Grafiken von T-Shirt-Fotos, um eine saubere Fläche für eigene Designs zu schaffen.',
            feature_title2: 'Erinnerungen Wiederherstellen',
            feature_desc2: 'Datumsstempel löschen: Entfernen Sie störende orange Datumsstempel aus alten Familien- oder Reiseschnappschüssen, ohne die Landschaft zu beschädigen.',
            feature_title3: 'Intelligentes Inpainting',
            feature_desc3: 'Nahtloses Hintergrund-Füllen: Anders als einfache Radierer, die Unschärfe hinterlassen, nutzt 微鲤AI Generative KI, um realistische Texturen (Gras, Himmel, Berge) in die gelöschte Fläche zu „malen“.',
        },
        imgExtender: {
            title: 'Bild sofort kostenlos erweitern - KI Bild-Erweiterer | 微鲤AI',
            description: 'Mit WeryAIs kostenlosem KI Bild-Erweiterer sprengen Sie die ursprünglichen Bildränder Ihrer Fotos in Sekunden. Unser Outpainting-Tool erzeugt neue Pixel, die sich nahtlos mit Ihrem Upload verbinden – so werden Porträts zu Weitwinkelbildern, ohne Look und Qualität zu verlieren.',
            keywords: 'KI bild erweitern, bild erweitern kostenlos, weitwinkel foto generator, foto ränder erweitern, nahtloses outpainting, originalqualität behalten',
            og_title: 'Bild sofort kostenlos erweitern - KI Bild-Erweiterer | 微鲤AI',
            og_description: 'Erweitern Sie Fotos auf neue Größen und generieren Sie passend ergänzenden Inhalt. Testen Sie unseren KI Bild-Erweiterer kostenlos.',
            twitter_title: 'Bild sofort kostenlos erweitern - KI Bild-Erweiterer | 微鲤AI',
            twitter_description: 'Erweitern Sie Fotos auf neue Größen und generieren Sie passend ergänzenden Inhalt. Testen Sie unseren KI Bild-Erweiterer kostenlos.',
            featureList: [
                'KI bild erweitern, bild erweitern kostenlos, weitwinkel foto, originalqualität behalten',
            ],
            page: {
                title1: 'Leistungsstarker KI Bild-Erweiterer für beeindruckende Ergebnisse',
                title2: 'Mit wenigen Klicks erweitern Sie Ihr Foto über die ursprünglichen Ränder hinaus. Die KI erzeugt neue Pixel, die perfekt mit dem Upload verschmelzen – für Weitwinkel-Looks bei gleichbleibender Qualität.',
                feature_title: 'Was den 微鲤AI Bild-Erweiterer besonders macht',
                faq: [
                    {
                        question: 'Was ist ein KI Bild-Erweiterer?',
                        answer: 'Ein Tool, das mit fortschrittlicher KI Bildränder erweitert, indem es fehlenden Inhalt intelligent ergänzt. Ideal für Marketing, E‑Commerce und Social Media.',
                    },
                    {
                        question: 'Warum unseren KI Bild-Erweiterer nutzen?',
                        answer: '微鲤AI analysiert Bildmerkmale und outpaintet die Umgebung natürlich und in hoher Qualität – ohne sichtbare Nähte.',
                    },
                    {
                        question: 'Ist der KI Bild-Erweiterer kostenlos?',
                        answer: 'Ja. Sie können ihn mit Test-Credits kostenlos nutzen – eine budgetfreundliche Ergänzung für jeden Bild-Workflow.',
                    },
                    {
                        question: 'Wie schnell ist die Erweiterung?',
                        answer: 'In der Regel dauert es nur wenige Sekunden. Ideal für schnelle Edits und Batch-Bearbeitung.',
                    },
                    {
                        question: 'Beeinflusst das Auflösung oder Qualität?',
                        answer: 'Nein. Auflösung, Schärfe und Details bleiben während der Erweiterung erhalten.',
                    },
                    {
                        question: 'Bleiben meine Uploads privat?',
                        answer: 'Ja. Wir schützen Ihre Daten mit branchenüblicher Sicherheit und strengen Datenschutzrichtlinien.',
                    },
                    {
                        question: 'Welche Bildformate werden unterstützt?',
                        answer: 'JPG, PNG, WebP und gängige Formate. Max. Dateigröße: 10MB – keine Konvertierung nötig.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Was ist ein KI Bild-Erweiterer?',
                    answer: 'Ein Tool, das mit fortschrittlicher KI Bildränder erweitert, indem es fehlenden Inhalt intelligent ergänzt. Ideal für Marketing, E‑Commerce und Social Media.',
                },
                {
                    question: 'Warum unseren KI Bild-Erweiterer nutzen?',
                    answer: '微鲤AI analysiert Bildmerkmale und outpaintet die Umgebung natürlich und in hoher Qualität – ohne sichtbare Nähte.',
                },
                {
                    question: 'Ist der KI Bild-Erweiterer kostenlos?',
                    answer: 'Ja. Kostenlos nutzbar mit Test-Credits.',
                },
                {
                    question: 'Wie schnell ist die Erweiterung?',
                    answer: 'Meist in wenigen Sekunden erledigt.',
                },
                {
                    question: 'Beeinflusst das Auflösung oder Qualität?',
                    answer: 'Nein. Qualität und Details bleiben erhalten.',
                },
                {
                    question: 'Bleiben meine Uploads privat?',
                    answer: 'Ja. Ihre Bilder werden geschützt und nicht an Dritte weitergegeben.',
                },
                {
                    question: 'Welche Bildformate werden unterstützt?',
                    answer: 'JPG, PNG, WebP (max. 10MB).',
                },
            ],
            feature_title1: 'Fehlende Details & Hintergründe ergänzen',
            feature_desc1: 'Wenn Ihr Bild zugeschnitten ist, füllt die KI fehlende Bereiche intelligent auf und macht das Motiv vollständiger. Outpainting kann sogar fehlende Elemente in alten Fotos wiederherstellen.',
            feature_title2: 'Produktfotos verbessern und Verkäufe steigern',
            feature_desc2: 'Erweitern Sie den Bereich um Produktbilder, um passende Hintergründe hinzuzufügen. Breitere Kompositionen zeigen mehr Details und können die Conversion erhöhen.',
            feature_title3: 'Einzigartige visuelle Meisterwerke schaffen',
            feature_desc3: 'Ob Fotograf, Creator oder Künstler: Erweitern Sie Bildränder, sprengen Sie kreative Grenzen und verwandeln Sie Ideen in beeindruckende Visuals.',
            feature_title4: 'Seitenverhältnis für Social Media optimieren',
            feature_desc4: 'Erweitern Sie Bilder für jedes Format auf Instagram, X (ehemals Twitter), Facebook und mehr. Die KI hält Details scharf, damit das Ergebnis auffällt.',
            textRemoverHowToUseTitle: 'So nutzen Sie unseren KI Bild-Erweiterer',
            textRemoverHowToUseDesc: 'In 3 einfachen Schritten Foto-Ränder erweitern',
            textRemoverHowToUseStep1Title: 'Bild hochladen',
            textRemoverHowToUseStep1Desc: 'Klicken oder ziehen Sie das Bild per Drag & Drop, das Sie erweitern möchten.',
            textRemoverHowToUseStep2Title: 'KI verarbeitet automatisch',
            textRemoverHowToUseStep2Desc: 'Nach dem Upload erkennt und erweitert die KI automatisch die Bildränder.',
            textRemoverHowToUseStep3Title: 'Erweitertes Bild herunterladen',
            textRemoverHowToUseStep3Desc: 'Nach der Verarbeitung können Sie das Ergebnis ansehen und herunterladen.',
        },
        photoRestoration: {
            title: 'Kostenlose KI-Fotorestauration - S/W kolorieren & Kratzer reparieren | 微鲤AI',
            description: 'Beleben Sie alte Familienerinnerungen mit WeryAIs kostenloser KI-Fotorestauration. Kolorieren Sie Schwarz-Weiß-Fotos automatisch und entfernen Sie Kratzer, Risse und Unschärfe – Gesichter werden sofort wiederhergestellt.',
            keywords: 'alte fotos restaurieren, foto kolorieren, zerkratzte fotos reparieren, KI fotorestauration, schwarz weiß zu farbe, bild reparatur KI, foto aufbereitung',
            og_title: 'Kostenlose KI-Fotorestauration - S/W kolorieren & Kratzer reparieren | 微鲤AI',
            og_description: 'Beleben Sie alte Familienerinnerungen mit WeryAIs kostenloser KI-Fotorestauration. Kolorieren Sie Schwarz-Weiß-Fotos automatisch und entfernen Sie Kratzer, Risse und Unschärfe – Gesichter werden sofort wiederhergestellt.',
            twitter_title: 'Kostenlose KI-Fotorestauration - S/W kolorieren & Kratzer reparieren | 微鲤AI',
            twitter_description: 'Beleben Sie alte Familienerinnerungen mit WeryAIs kostenloser KI-Fotorestauration. Kolorieren Sie Schwarz-Weiß-Fotos automatisch und entfernen Sie Kratzer, Risse und Unschärfe – Gesichter werden sofort wiederhergestellt.',
            page: {
                title1: 'Kostenlose KI-Restauration & Kolorierung alter Fotos',
                title2: 'Bringen Sie Ihre Geschichte zurück. Ob verblasstes Schwarz-Weiß-Hochzeitsfoto oder zerkratztes Kinderporträt: Unsere KI analysiert und repariert beschädigte Bereiche, schärft Gesichter und fügt in Sekunden realistische Farben hinzu.',
                faq: [
                    {
                        question: 'Wie koloriert man ein Schwarz-Weiß-Foto?',
                        answer: 'Laden Sie Ihr S/W-Bild bei 微鲤AI hoch. Das Tool erkennt automatisch Graustufen und wendet die Funktion „Kolorieren“ an, um sofort realistische Farben hinzuzufügen.',
                    },
                    {
                        question: 'Kann es zerrissene oder zerkratzte Fotos reparieren?',
                        answer: 'Ja. Unsere KI erkennt Kratzer, Risse und Knicke und füllt die beschädigten Stellen mit Pixeln, die zur umliegenden Textur passen.',
                    },
                    {
                        question: 'Sieht das restaurierte Foto künstlich aus?',
                        answer: 'Unser Ziel ist Realismus. Die Gesichtsverbesserung fügt Details hinzu, ohne die Identität zu verfälschen. Bei der Kolorierung wählt die KI natürliche Farbtöne passend zur Epoche.',
                    },
                    {
                        question: 'Was, wenn das Foto sehr klein ist?',
                        answer: 'Kein Problem. Der Prozess enthält auch Upscaling, wodurch die Auflösung kleiner Fotos für die digitale Ansicht oder den Druck erhöht wird.',
                    },
                    {
                        question: 'Ist meine Privatsphäre geschützt?',
                        answer: 'Ja. Wir wissen, dass alte Fotos persönlich sind. Ihre Bilder werden sicher verarbeitet und nicht dauerhaft auf unseren Servern gespeichert.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie koloriert man ein Schwarz-Weiß-Foto?',
                    answer: 'Einfach S/W-Foto hochladen – die Funktion „Kolorieren“ fügt sofort realistische Farben hinzu.',
                },
                {
                    question: 'Kann es zerrissene oder zerkratzte Fotos reparieren?',
                    answer: 'Ja. Die KI erkennt Schäden und rekonstruiert sie passend zur umgebenden Textur.',
                },
                {
                    question: 'Sieht das restaurierte Foto künstlich aus?',
                    answer: 'Wir priorisieren Realismus und eine erkennbare Identität – mit natürlichen, passenden Farben.',
                },
            ],
            feature_title1: 'Kratzer- & Riss-Entfernung',
            feature_desc1: 'Spuren der Zeit löschen: Knicke, Kratzer, Risse und Staubflecken automatisch erkennen und füllen. Die KI rekonstruiert fehlende Gesichtsdetails, damit das Foto wieder wie neu wirkt.',
            feature_title2: 'Intelligente Kolorierung',
            feature_desc2: 'S/W zu Farbe: Nicht nur ein Sepia-Filter. Das Deep-Learning-Modell versteht Kontext (Himmel, Haut, Stoff) und fügt lebendige, natürliche Farben hinzu.',
            feature_title3: 'Gesichtsverbesserung',
            feature_desc3: 'Gesichter entblurren: Alte Fotos leiden oft unter Bewegungsunschärfe oder schlechtem Fokus. 微鲤AI schärft Gesichtszüge (Augen, Nase, Mund) und bringt das echte Aussehen zurück.',
        },
        photoEffects: {
            title: 'Bildeffekte - KI-Bildeffekte-Generator | 微鲤AI',
            description: 'Verwandeln Sie Ihre Fotos mit KI-gestützten Effekten. Erstellen Sie kostenlos online atemberaubende Bildfilter, Stile und Transformationen.',
            keywords: 'KI-Bildeffekte, Bildeffekte, Fotofilter, KI-Bildtransformation, Bildstilübertragung',
        },
    },
    ru: {
        textToImage: {
            title: 'Текст в Изображение - Бесплатный Генератор Изображений с ИИ | 微鲤AI',
            description: 'Создавайте впечатляющие изображения по текстовым описаниям с помощью ИИ. Генерируйте реалистичные картинки, иллюстрации и арт-работы на базе продвинутых моделей — идеально для креативного контента и дизайн‑проектов.',
            keywords: 'текст в изображение, генератор изображений ИИ, генерация изображений, создание изображений с ИИ, текст в фото, ИИ для изображений',
            og_title: 'Бесплатный Генератор Изображений ИИ из Текста - Создавайте 4K Арт и Реалистичные Фото | 微鲤AI',
            og_description: 'Превращайте текстовые описания в потрясающие визуалы с помощью Генератора Изображений из Текста 微鲤AI. Включает модель Nano Banana Pro для высококачественных результатов. Поддерживает разрешение 1K/2K/4K и соотношения сторон 9:16/16:9. Бесплатно и онлайн.',
            twitter_title: 'Бесплатный Генератор Изображений ИИ из Текста - Создавайте 4K Арт и Реалистичные Фото | 微鲤AI',
            twitter_description: 'Превращайте текстовые описания в потрясающие визуалы с помощью Генератора Изображений из Текста 微鲤AI. Включает модель Nano Banana Pro для высококачественных результатов. Поддерживает разрешение 1K/2K/4K и соотношения сторон 9:16/16:9. Бесплатно и онлайн.',
            faq: [
                {
                    question: 'Как создать изображения ИИ в 4K?',
                    answer: 'Просто введите описание и выберите "4K" в настройках Размера изображения на левой панели перед нажатием кнопки Создать.',
                },
                {
                    question: 'Какие соотношения сторон поддерживаются?',
                    answer: 'Мы поддерживаем все основные соотношения, включая 1:1, 9:16 (Мобильное), 16:9 (Десктоп), 4:3 и 3:2, чтобы соответствовать любой платформе.',
                },
                {
                    question: 'Могу ли я использовать изображения в коммерческих целях?',
                    answer: 'Да. Изображения, созданные на планах 微鲤AI, обычно поставляются с коммерческой лицензией, подходящей для рекламы и товаров.',
                },
            ],
            page: {
                title1: 'Бесплатный Генератор Изображений ИИ из Текста',
                title2: 'Создавайте потрясающие произведения искусства, фотореалистичные изображения и уникальные обои за секунды. Просто опишите, что вы хотите увидеть, и наша продвинутая модель Nano Banana Pro создаст высококачественные 4K изображения, которые идеально соответствуют вашему описанию.',
                resolution: 'Перестаньте мириться с размытыми изображениями ИИ. 微鲤AI позволяет напрямую генерировать четкие изображения 1K, 2K и 4K, идеально подходящие для печати или дисплеев высокого разрешения.',
                aspectRatio: 'Нужно ли вам изображение 9:16 для фонов TikTok, 16:9 для миниатюр YouTube или 1:1 для Instagram, у нас есть предустановки для каждой социальной платформы.',
                online_search: 'Нужен актуальный контекст? Включите "Онлайн-поиск", чтобы позволить ИИ просматривать веб-страницы для лучшего понимания текущих событий или конкретных ссылок в вашем описании.',
                faq: [
                    {
                        question: 'Как создать высококачественные изображения из текста?',
                        answer: 'Введите подробное описание, описывающее объект, освещение и стиль. Выберите "4K" в настройках Размера изображения для самых четких деталей.',
                    },
                    {
                        question: 'Что такое модель Nano Banana Pro?',
                        answer: 'Nano Banana Pro — это наша модель с наивысшим качеством, оптимизированная для точности следования описанию и фотореализма. Она конкурирует по качеству с топовыми моделями, такими как Midjourney v6 и Flux.',
                    },
                    {
                        question: 'Могу ли я использовать изображения в коммерческих целях?',
                        answer: 'Да. Изображения, созданные на 微鲤AI (платные планы), поставляются с коммерческой лицензией, позволяющей использовать их для рекламы, веб-сайтов и товаров.',
                    },
                    {
                        question: 'Сколько изображений я могу создать одновременно?',
                        answer: 'Вы можете создать до 4 изображений одновременно (как показано в настройке "Количество выходных изображений"), что позволяет быстро итерировать идеи.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, вы можете создавать изображения, используя наши бесплатные ежедневные кредиты. Более высокие разрешения (4K) могут потребовать больше кредитов.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Бесплатный Генератор ИИ Изображение в Изображение - Превратите Фото в Искусство и 4K | 微鲤AI',
            description: 'Загрузите эталонное фото и преобразуйте его с помощью ИИ 微鲤AI "Изображение в Изображение". Превратите наброски в реалистичное искусство, измените стили или создайте вариации, сохраняя исходную композицию. Поддержка разрешения 4K.',
            keywords: 'изображение в изображение ai, img2img, превратить фото в рисунок, вариация изображения ai, набросок в изображение, ремикс фото ai, бесплатный генератор искусства ai',
            og_title: 'Бесплатный Генератор ИИ Изображение в Изображение - Превратите Фото в Искусство и 4K | 微鲤AI',
            og_description: 'Загрузите эталонное фото и преобразуйте его с помощью ИИ 微鲤AI "Изображение в Изображение". Превратите наброски в реалистичное искусство, измените стили или создайте вариации, сохраняя исходную композицию. Поддержка разрешения 4K.',
            twitter_title: 'Бесплатный Генератор ИИ Изображение в Изображение - Превратите Фото в Искусство и 4K | 微鲤AI',
            twitter_description: 'Загрузите эталонное фото и преобразуйте его с помощью ИИ 微鲤AI "Изображение в Изображение". Превратите наброски в реалистичное искусство, измените стили или создайте вариации, сохраняя исходную композицию. Поддержка разрешения 4K.',
            faq: [
                {
                    question: 'Что такое ИИ "Изображение в Изображение"?',
                    answer: 'Изображение в Изображение (Img2Img) использует загруженное изображение в качестве эталона вместе с текстовым запросом для создания нового изображения, объединяя визуальный ввод с творческим описанием.',
                },
                {
                    question: 'Как превратить набросок в реалистичное фото?',
                    answer: 'Загрузите свой набросок, введите запрос, описывающий сцену (например, "фотореалистичное здание"), и нажмите "Создать".',
                },
                {
                    question: 'Сохраняется ли исходное лицо?',
                    answer: 'Сохраняется структура и поза. Для точного сохранения идентичности лица, пожалуйста, используйте наш инструмент "Замена лица на фото".',
                },
            ],
            page: {
                title1: 'Бесплатный Генератор ИИ Изображение в Изображение',
                title2: 'Используйте свои существующие изображения в качестве шаблона. Загрузите фото, набросок или макет, и позвольте нашему ИИ пересоздать его в совершенно новом стиле на основе вашего текстового запроса. Идеально для сохранения композиции при изучении бесконечных художественных вариаций.',
                title3: 'Преобразуйте Свои Фото с Помощью ИИ Трансфера Стиля',
                title4: 'Зачем Использовать Изображение в Изображение (Img2Img)?',
                upload_image: 'Трудно описать позу или макет словами? Просто загрузите эталонное изображение. Наш движок Img2Img сохраняет структуру вашего исходного фото, но перерисовывает детали.',
                resolution: 'Превратите грубый набросок или каркас в фотореалистичный рендер или высококачественную иллюстрацию за секунды. Идеально для дизайнеров и архитекторов.',
                output: 'Создавайте ресурсы, готовые к использованию. В отличие от других инструментов, которые выводят маленькие изображения, 微鲤AI поддерживает разрешения 1K, 2K и 4K для четких деталей.',
                faq: [
                    {
                        question: 'Что такое ИИ "Изображение в Изображение"?',
                        answer: 'Изображение в Изображение (Img2Img) — это технология, которая использует загруженное изображение в качестве "эталона" вместе с текстовым запросом для создания нового изображения. Она объединяет ваш визуальный ввод с вашим творческим описанием.',
                    },
                    {
                        question: 'Как превратить набросок в реалистичное фото?',
                        answer: 'Загрузите свой набросок в область "Изображение". В поле "Запрос" опишите, что представляет набросок (например, "Современная вилла, закат, фотореалистично, 8k"). Нажмите "Создать", чтобы увидеть результат.',
                    },
                    {
                        question: 'Сохраняется ли исходное лицо/человек?',
                        answer: 'Он пытается сохранить общую структуру и позу. Однако для точного сохранения лица мы рекомендуем использовать наш специальный инструмент "Замена лица на фото".',
                    },
                    {
                        question: 'Какие соотношения сторон поддерживаются?',
                        answer: 'Мы поддерживаем широкий диапазон соотношений, включая 9:16 (История), 16:9 (Кинематографическое), 3:4 и 1:1, обеспечивая идеальное соответствие вашего созданного искусства любой платформе.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, вы можете создавать вариации бесплатно, используя свои ежедневные кредиты.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Бесплатный Расширитель и Изменение Размера Изображения ИИ - Отменить Обрезку и Расширить Фото',
            description: 'Измените размер изображений для Instagram, TikTok и YouTube без обрезки. Расширитель Изображений ИИ 微鲤AI использует генеративное заполнение (расширение) для интеллектуального расширения фонов изображений. Бесшовно изменяйте соотношения сторон.',
            keywords: 'расширитель изображения ai, отменить обрезку, расширение ai, изменение размера изображения ai, расширить фон изображения, генеративное заполнение онлайн, сделать фото вертикальным',
            og_title: 'Бесплатный Расширитель и Изменение Размера Изображения ИИ - Отменить Обрезку и Расширить Фото',
            og_description: 'Измените размер изображений для Instagram, TikTok и YouTube без обрезки. Расширитель Изображений ИИ 微鲤AI использует генеративное заполнение (расширение) для интеллектуального расширения фонов изображений. Бесшовно изменяйте соотношения сторон.',
            twitter_title: 'Бесплатный Расширитель и Изменение Размера Изображения ИИ - Отменить Обрезку и Расширить Фото',
            twitter_description: 'Измените размер изображений для Instagram, TikTok и YouTube без обрезки. Расширитель Изображений ИИ 微鲤AI использует генеративное заполнение (расширение) для интеллектуального расширения фонов изображений. Бесшовно изменяйте соотношения сторон.',
            page: {
                title1: 'Бесплатный Расширитель и Изменение Размера Изображения ИИ',
                title2: 'Перестаньте обрезать свои любимые фотографии, чтобы они подходили для социальных сетей. Нужно ли вам превратить горизонтальный снимок в вертикальную Историю или расширить квадратное изображение до 16:9, наш Расширитель Изображений ИИ волшебным образом генерирует новые детали фона (Расширение), чтобы идеально подходить к любому соотношению сторон.',
                faq: [
                    {
                        question: 'Как изменить размер изображения без обрезки?',
                        answer: 'Используйте Расширитель Изображений ИИ 微鲤AI. Загрузите свою фотографию, выберите целевое соотношение сторон (например, 9:16), и ИИ автоматически сгенерирует (расширит) недостающие области фона вместо обрезки вашего изображения.',
                    },
                    {
                        question: 'Что такое Расширение ИИ?',
                        answer: 'Расширение — это генеративная технология ИИ, которая расширяет границы изображения, предсказывая и рисуя новый контент, соответствующий оригинальному стилю, эффективно "отменяя обрезку" фотографии.',
                    },
                    {
                        question: 'Могу ли я превратить горизонтальную фотографию в вертикальную?',
                        answer: 'Да! Просто загрузите свою горизонтальную (пейзажную) фотографию и выберите соотношение 9:16. ИИ расширит верхнюю и нижнюю части изображения, чтобы заполнить вертикальный кадр.',
                    },
                    {
                        question: 'Будет ли расширенный фон выглядеть фальшиво?',
                        answer: '微鲤AI использует передовые генеративные модели, обученные на массивных наборах данных, чтобы гарантировать, что расширенный фон естественно смешивается с оригинальным освещением и текстурой.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, пользователи получают бесплатные кредиты, чтобы попробовать функции Умного Изменения Размера ИИ и Расширения.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как изменить размер изображения без обрезки?',
                    answer: 'Используйте Расширитель Изображений ИИ 微鲤AI. Загрузите свою фотографию, выберите целевое соотношение сторон (например, 9:16), и ИИ автоматически сгенерирует (расширит) недостающие области фона вместо обрезки вашего изображения.',
                },
                {
                    question: 'Что такое Расширение ИИ?',
                    answer: 'Расширение — это генеративная технология ИИ, которая расширяет границы изображения, предсказывая и рисуя новый контент, соответствующий оригинальному стилю, эффективно "отменяя обрезку" фотографии.',
                },
                {
                    question: 'Могу ли я превратить горизонтальную фотографию в вертикальную?',
                    answer: 'Да! Просто загрузите свою горизонтальную (пейзажную) фотографию и выберите соотношение 9:16. ИИ расширит верхнюю и нижнюю части изображения, чтобы заполнить вертикальный кадр.',
                },
                {
                    question: 'Будет ли расширенный фон выглядеть фальшиво?',
                    answer: '微鲤AI использует передовые генеративные модели, обученные на массивных наборах данных, чтобы гарантировать, что расширенный фон естественно смешивается с оригинальным освещением и текстурой.',
                },
                {
                    question: 'Это бесплатно?',
                    answer: 'Да, пользователи получают бесплатные кредиты, чтобы попробовать функции Умного Изменения Размера ИИ и Расширения.',
                },
            ],
            feature_title1: 'Умное Расширение Фона',
            feature_desc1: 'Волшебное Расширение: ИИ понимает контекст вашего изображения и рисует новые пиксели за пределами исходных границ. Бесшовно расширяйте пейзажи, комнаты или текстуры, чтобы заполнить кадр.',
            feature_title2: 'Защита Центра',
            feature_desc2: 'Никогда Не Обрезайте Объект: Наш ИИ автоматически определяет основного человека или объект и фиксирует их в центре, гарантируя, что они никогда не будут обрезаны в процессе изменения размера.',
            feature_title3: 'Готово для Социальных Сетей',
            feature_desc3: 'Одноразовые пресеты для Instagram Stories (9:16), Миниатюр YouTube (16:9) и Публикаций (4:5). Мгновенно перепрофилируйте свой контент на всех платформах.',
        },
        imageTextTranslate: {
            title: 'Бесплатный Переводчик Изображений ИИ - Переведите Текст в Фото, Манга и Комиксах',
            description: 'Мгновенно переводите текст на изображениях, сохраняя оригинальный визуальный стиль. Переводчик Изображений ИИ 微鲤AI автоматически стирает оригинальный текст и перерисовывает переводы. Идеально для комиксов, манга и маркетинговых постеров.',
            keywords: 'переводчик изображений ai, перевести текст в изображении, переводчик изображений, переводчик манга, перевести комиксы, переводчик ocr, замена текста изображения',
            og_title: 'Бесплатный Переводчик Изображений ИИ - Переведите Текст в Фото, Манга и Комиксах',
            og_description: 'Мгновенно переводите текст на изображениях, сохраняя оригинальный визуальный стиль. Переводчик Изображений ИИ 微鲤AI автоматически стирает оригинальный текст и перерисовывает переводы. Идеально для комиксов, манга и маркетинговых постеров.',
            twitter_title: 'Бесплатный Переводчик Изображений ИИ - Переведите Текст в Фото, Манга и Комиксах',
            twitter_description: 'Мгновенно переводите текст на изображениях, сохраняя оригинальный визуальный стиль. Переводчик Изображений ИИ 微鲤AI автоматически стирает оригинальный текст и перерисовывает переводы. Идеально для комиксов, манга и маркетинговых постеров.',
            page: {
                title1: 'Бесплатный Переводчик Изображений ИИ и Замена Текста',
                title2: 'Переводите постеры, меню, комиксы и скриншоты за секунды. В отличие от стандартных переводчиков, которые просто накладывают текст, 微鲤AI использует Генеративный ИИ для стирания оригинального текста и перерисовки фона, делая переведенный текст похожим на часть оригинального дизайна.',
                faq: [
                    {
                        question: 'Как перевести текст внутри изображения?',
                        answer: 'Загрузите ваше изображение (JPG, PNG) на 微鲤AI. Выберите исходный язык (или используйте Автоопределение) и целевой язык. Нажмите "Создать", чтобы ИИ заменил текст.',
                    },
                    {
                        question: 'Будет ли переведенный текст выглядеть естественно?',
                        answer: 'Да. 微鲤AI пытается соответствовать размеру и стилю шрифта оригинального текста. Важно, что он перерисовывает фон за текстом, чтобы перевод идеально вписывался.',
                    },
                    {
                        question: 'Могу ли я использовать это для перевода Манга или Манхва?',
                        answer: 'Абсолютно. Это один из лучших случаев использования. ИИ обнаруживает речевые пузыри и вертикальный текст (распространенный в японском), заменяя их горизонтальным переведенным текстом.',
                    },
                    {
                        question: 'Какие языки поддерживаются?',
                        answer: 'Мы поддерживаем перевод между основными глобальными языками, включая английский, испанский, китайский, японский, корейский, французский, немецкий и другие.',
                    },
                    {
                        question: 'Работает ли это на рукописном тексте?',
                        answer: 'Оно лучше всего работает на печатном тексте, но наш продвинутый OCR-движок может распознавать четкий рукописный текст на досках или заметках.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Вы можете переводить изображения бесплатно, используя ваши ежедневные кредиты.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как перевести текст внутри изображения?',
                    answer: `Загрузите ваше изображение на 微鲤AI. Выберите целевой язык и нажмите 'Создать'. ИИ заменит оригинальный текст на перевод.`,
                },
                {
                    question: 'Будет ли переведенный текст выглядеть естественно?',
                    answer: 'Да. 微鲤AI перерисовывает фон за текстом и пытается соответствовать стилю шрифта, обеспечивая идеальное вписывание перевода.',
                },
                {
                    question: 'Могу ли я использовать это для перевода Манга или Манхва?',
                    answer: 'Абсолютно. Это один из лучших случаев использования. ИИ обнаруживает речевые пузыри и вертикальный текст (распространенный в японском), заменяя их горизонтальным переведенным текстом.',
                },
            ],
            feature_title1: 'Умное Восстановление и Перерисовка',
            feature_desc1: 'Бесшовная Замена Текста: Наш ИИ анализирует текстуру фона за текстом. Он стирает оригинальные слова и умно заполняет пробел перед добавлением перевода, гарантируя, что никакие уродливые текстовые блоки не покрывают ваше изображение.',
            feature_title2: 'Перевод Манга и Комиксов',
            feature_desc2: 'Читайте Сырую Манга Мгновенно: Идеально для фанатов аниме. Загрузите страницы сырой манга (японский/корейский) и получите мгновенные английские переводы, которые идеально вписываются в речевые пузыри.',
            feature_title3: 'Глобальная Маркетинговая Локализация',
            feature_desc3: 'Локализация Одним Кликом: Запускаете продукты глобально? Переведите ваши маркетинговые постеры, баннеры и скриншоты UI на более чем 30 языков без необходимости в оригинальных PSD-файлах.',
        },
        aiBackgroundChanger: {
            title: 'Бесплатный ИИ-Сменщик Фона - Генерируйте Фоны по Тексту',
            description: 'Мгновенно меняйте фон на фото с помощью ИИ. Опишите нужную сцену, и 微鲤AI создаст реалистичные фоны для предметной съемки, деловых фото для LinkedIn и креативных портретов. Бесплатно и онлайн.',
            keywords: 'сменить фон фото, генератор фона ИИ, предметная съемка ИИ, сделать белый фон, заменить фон онлайн, генеративная заливка фона',
            og_title: 'Бесплатный ИИ-Сменщик Фона - Генерируйте Фоны по Тексту',
            og_description: 'Мгновенно меняйте фон на фото с помощью ИИ. Опишите нужную сцену, и 微鲤AI создаст реалистичные фоны для предметной съемки, деловых фото для LinkedIn и креативных портретов. Бесплатно и онлайн.',
            twitter_title: 'Бесплатный ИИ-Сменщик Фона - Генерируйте Фоны по Тексту',
            twitter_description: 'Мгновенно меняйте фон на фото с помощью ИИ. Опишите нужную сцену, и 微鲤AI создаст реалистичные фоны для предметной съемки, деловых фото для LinkedIn и креативных портретов. Бесплатно и онлайн.',
            page: {
                title1: 'Бесплатный ИИ-Сменщик Фона и Генератор',
                title2: 'Не просто удаляйте фон — заменяйте его на более подходящий. Загрузите фото и опишите любую сцену (например, «роскошная мраморная студия», «офисный скайлайн»). Наша генеративная ИИ понимает свет и перспективу, чтобы идеально вписать ваш объект в новую среду.',
                faq: [
                    {
                        question: 'Как изменить фон с помощью текста?',
                        answer: 'Загрузите изображение и в поле «Промпт фона» опишите нужную сцену (например, «уютная кофейня»). Нажмите «Создать», и ИИ сгенерирует фон.',
                    },
                    {
                        question: 'Можно ли сделать фон чисто белым?',
                        answer: 'Да. Просто введите в промпт «pure white background» или «studio white». Это идеально для карточек товаров на Amazon/eBay и фото на документы.',
                    },
                    {
                        question: 'Подходит ли это для предметной съемки?',
                        answer: 'Конечно. 微鲤AI анализирует угол вашего товара и генерирует фон с правильными тенями и освещением, как в профессиональной студии.',
                    },
                    {
                        question: 'Будет ли освещение выглядеть естественно?',
                        answer: 'Наша генеративная ИИ (похожа на Adobe Firefly или SDXL) старается согласовать освещение фона с объектом, чтобы результат выглядел цельно.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, вы можете бесплатно генерировать новые фоны, используя ежедневные кредиты.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как изменить фон с помощью текста?',
                    answer: 'Загрузите изображение и в поле «Промпт фона» опишите нужную сцену (например, «уютная кофейня»). Нажмите «Создать», и ИИ сгенерирует фон.',
                },
                {
                    question: 'Можно ли сделать фон чисто белым?',
                    answer: 'Да. Просто введите в промпт «pure white background» или «studio white». Это идеально для карточек товаров на Amazon/eBay и фото на документы.',
                },
                {
                    question: 'Подходит ли это для предметной съемки?',
                    answer: 'Конечно. 微鲤AI анализирует угол вашего товара и генерирует фон с правильными тенями и освещением, как в профессиональной студии.',
                },
                {
                    question: 'Будет ли освещение выглядеть естественно?',
                    answer: 'Наша генеративная ИИ (похожа на Adobe Firefly или SDXL) старается согласовать освещение фона с объектом, чтобы результат выглядел цельно.',
                },
                {
                    question: 'Это бесплатно?',
                    answer: 'Да, вы можете бесплатно генерировать новые фоны, используя ежедневные кредиты.',
                },
            ],
            feature_title1: 'Профессиональные Фото для Документов',
            feature_desc1: 'DIY LinkedIn-Headshots: Превратите обычное селфи в профессиональное фото профиля. Мгновенно замените фон спальни на чистый офис или студийный серый.',
            feature_title2: 'Мгновенная Предметная Съемка',
            feature_desc2: 'Рост продаж в e-commerce: Сэкономьте тысячи на фотосессиях. Разместите товар на деревянном столе, на пляже или на подиуме с помощью простых промптов — ИИ добавит реалистичные тени и отражения.',
            feature_title3: 'Креативная Телепортация',
            feature_desc3: 'Путешествуйте куда угодно: Хотите оказаться в Париже или в киберпанк-будущем? Просто напишите это. Наша ИИ заменит фон, сохранив согласованное освещение с оригинальным фото.',
        },
        imageUpscaler: {
            title: 'Бесплатный ИИ-Апскейлер Изображений - Увеличьте до 4K и Восстановите Старые Фото',
            description: 'Мгновенно увеличивайте изображения низкого разрешения в 2x, 4x и до 4K с бесплатным ИИ-улучшителем изображений 微鲤AI. Исправляйте размытые фото, удаляйте шум и восстанавливайте старые семейные фотографии онлайн. Без потери качества.',
            keywords: 'апскейлер изображений ИИ, улучшитель фото, увеличить изображение до 4k, убрать размытость, восстановление старых фото, исправить пикселизацию, увеличить разрешение изображения',
            og_title: 'Бесплатный ИИ-Апскейлер Изображений - Увеличьте до 4K и Восстановите Старые Фото',
            og_description: 'Мгновенно увеличивайте изображения низкого разрешения в 2x, 4x и до 4K с бесплатным ИИ-улучшителем изображений 微鲤AI. Исправляйте размытые фото, удаляйте шум и восстанавливайте старые семейные фотографии онлайн. Без потери качества.',
            twitter_title: 'Бесплатный ИИ-Апскейлер Изображений - Увеличьте до 4K и Восстановите Старые Фото',
            twitter_description: 'Мгновенно увеличивайте изображения низкого разрешения в 2x, 4x и до 4K с бесплатным ИИ-улучшителем изображений 微鲤AI. Исправляйте размытые фото, удаляйте шум и восстанавливайте старые семейные фотографии онлайн. Без потери качества.',
            page: {
                title1: 'Бесплатный ИИ-Апскейлер и Улучшитель Изображений',
                title2: 'Превратите пикселизированные, размытые или старые фотографии в шедевры высокой четкости. 微鲤AI использует продвинутый ИИ, чтобы увеличить разрешение до 400% (4K), восстанавливая потерянные детали, устраняя шум и восстанавливая лица на старых семейных портретах.',
                faq: [
                    {
                        question: 'Можно ли увеличить изображения низкого разрешения для печати?',
                        answer: 'Да! 微鲤AI увеличивает разрешение (количество пикселей) до 4K, делая изображение пригодным для качественной печати на постерах, холсте и маркетинговых материалах.',
                    },
                    {
                        question: 'Как работает восстановление старых фото с ИИ?',
                        answer: 'ИИ анализирует поврежденные или размытые участки и с помощью deep learning предсказывает и реконструирует детали лица, текстуры и фон, эффективно “исцеляя” изображение.',
                    },
                    {
                        question: 'Какие форматы поддерживаются?',
                        answer: 'Мы поддерживаем распространенные форматы JPG, PNG и WEBP. Результат будет в высококачественном PNG или JPG.',
                    },
                    {
                        question: 'Работает ли это с аниме/мультфильмами?',
                        answer: 'Да. Наш ИИ отлично апскейлит аниме и иллюстрации (в стиле waifu2x), сохраняя четкие линии и яркие цвета без артефактов.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, вы можете улучшать изображения бесплатно, используя ежедневные кредиты.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Можно ли увеличить изображения низкого разрешения для печати?',
                    answer: 'Да! 微鲤AI повышает разрешение до 4K, делая изображения пригодными для качественной печати.',
                },
                {
                    question: 'Как работает восстановление старых фото с ИИ?',
                    answer: 'ИИ анализирует поврежденные области и реконструирует детали лица и текстуры с помощью deep learning, чтобы “исцелить” изображение.',
                },
                {
                    question: 'Работает ли это с аниме?',
                    answer: 'Да. Наш ИИ отлично апскейлит аниме и иллюстрации, сохраняя четкие линии без артефактов.',
                },
            ],
            feature_title1: 'Апскейл Без Потери Качества до 4K',
            feature_desc1: 'Качество для печати: Нужно распечатать маленькое изображение? Увеличьте до 4K или 8K без потери качества. Идеально для постеров, фото товаров для e-commerce и обоев.',
            feature_title2: 'Умное Удаление Шума и Размытия',
            feature_desc2: 'Исправляйте ночные снимки: Удаляйте цифровой шум и зернистость на фото при слабом освещении. Мгновенно повышайте резкость размытых краев, чтобы фото выглядели четкими и профессиональными.',
            feature_title3: 'Восстановление Старых Фото',
            feature_desc3: 'Возродите воспоминания: Есть старые, поврежденные или черно-белые фото? Наш ИИ создает новые пиксели, чтобы убрать царапины, повысить резкость лиц и вернуть четкость вашим дорогим воспоминаниям.',
        },
        photoFaceSwap: {
            title: 'Бесплатный ИИ Face Swap Онлайн - Реалистичная Замена Лица на Фото | 微鲤AI',
            description: 'Меняйте лица на фото мгновенно с бесплатным ИИ Face Swapper от 微鲤AI. Создавайте смешные мемы, художественные портреты (Мона Лиза) или профессиональные headshots с высокой реалистичностью. 100% приватно и безопасно.',
            keywords: 'face swap ИИ, замена лица онлайн, поменять лицо на фото, reface бесплатно, заменить лицо на изображении, deepfake фото, мемы ИИ',
            og_title: 'Бесплатный ИИ Face Swap Онлайн - Реалистичная Замена Лица на Фото | 微鲤AI',
            og_description: 'Меняйте лица на фото мгновенно с бесплатным ИИ Face Swapper от 微鲤AI. Создавайте смешные мемы, художественные портреты (Мона Лиза) или профессиональные headshots с высокой реалистичностью. 100% приватно и безопасно.',
            twitter_title: 'Бесплатный ИИ Face Swap Онлайн - Реалистичная Замена Лица на Фото | 微鲤AI',
            twitter_description: 'Меняйте лица на фото мгновенно с бесплатным ИИ Face Swapper от 微鲤AI. Создавайте смешные мемы, художественные портреты (Мона Лиза) или профессиональные headshots с высокой реалистичностью. 100% приватно и безопасно.',
            page: {
                title1: 'Бесплатный ИИ Face Swap для Фото',
                title2: 'Хотите увидеть себя астронавтом, кинозвездой или в классической картине? Загрузите базовое фото и целевое лицо — наш ИИ бесшовно смешает черты лица, освещение и тон кожи, создавая гиперреалистичный face swap за секунды.',
                faq: [
                    {
                        question: '微鲤AI Face Swap бесплатный?',
                        answer: 'Да, мы даем ежедневные бесплатные кредиты для замены лиц на фото онлайн. Никакой установки и банковской карты не нужно.',
                    },
                    {
                        question: 'Мои данные в безопасности?',
                        answer: 'Абсолютно. Мы ставим приватность на первое место. Загруженные фото используются только для обмена и автоматически удаляются с серверов спустя короткое время.',
                    },
                    {
                        question: 'Как получить лучший результат?',
                        answer: 'Для максимально реалистичного результата убедитесь, что и “Базовое фото”, и “Фото лица” четкие, анфас и с хорошим освещением. Избегайте кадров, где лицо закрыто волосами или руками.',
                    },
                    {
                        question: 'Можно ли менять лица на групповых фото?',
                        answer: 'Сейчас мы фокусируемся на точности замены одного лица. Для групповых фото — обрежьте изображение или дождитесь нашей функции multi-face.',
                    },
                    {
                        question: 'Можно ли делать мемы?',
                        answer: 'Да! Идеально для смешных мемов. Поменяйте лицо друга на киноафише или в вирусном шаблоне мемов за секунды.',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI Face Swap бесплатный?',
                    answer: 'Да, у нас есть ежедневные бесплатные кредиты для face swap онлайн — без установки и карты.',
                },
                {
                    question: 'Мои данные в безопасности?',
                    answer: 'Да. Фото используются только для замены и автоматически удаляются спустя короткое время.',
                },
                {
                    question: 'Как получить лучший результат?',
                    answer: 'Убедитесь, что обе фотографии четкие, анфас и хорошо освещены. Избегайте лиц, закрытых волосами или очками.',
                },
            ],
            feature_title1: 'Художественные Шедевры',
            feature_desc1: 'Путешествие во времени: Поместите свое лицо в классические картины вроде Моны Лизы или Девушки с жемчужной сережкой. Создайте уникальные винтажные аватары мгновенно.',
            feature_title2: 'Профессиональные и Стильные Аватары',
            feature_desc2: 'Работа мечты: Увидьте себя в гоночном костюме, снаряжении астронавта или деловой одежде без покупки костюма. Идеально для выделяющихся фото профиля.',
            feature_title3: 'Гиперреалистичное Смешивание',
            feature_desc3: 'Без эффекта “вставки”: В отличие от простого вырезания и вставки, 微鲤AI анализирует угол, освещение и текстуру кожи, чтобы лицо выглядело 100% естественно, а не фальшиво.',
        },
        removeTextFromImage: {
            title: 'Бесплатный ИИ-Удалитель Текста - Уберите Водяные Знаки и Дату | 微鲤AI',
            description: 'Мгновенно удаляйте текст, штампы даты, логотипы и подписи с помощью бесплатного ИИ-текст-ластика 微鲤AI. Идеально восстанавливайте фон через AI Inpainting. Отлично для очистки фото и e-commerce мокапов.',
            keywords: 'удалить текст с изображения, ИИ удалитель текста, удалить штамп даты, убрать водяной знак онлайн, очистить фото, ИИ inpainting, удалить логотип с фото',
            og_title: 'Бесплатный ИИ-Удалитель Текста - Уберите Водяные Знаки и Дату | 微鲤AI',
            og_description: 'Мгновенно удаляйте текст, штампы даты, логотипы и подписи с помощью бесплатного ИИ-текст-ластика 微鲤AI. Идеально восстанавливайте фон через AI Inpainting. Отлично для очистки фото и e-commerce мокапов.',
            twitter_title: 'Бесплатный ИИ-Удалитель Текста - Уберите Водяные Знаки и Дату | 微鲤AI',
            twitter_description: 'Мгновенно удаляйте текст, штампы даты, логотипы и подписи с помощью бесплатного ИИ-текст-ластика 微鲤AI. Идеально восстанавливайте фон через AI Inpainting. Отлично для очистки фото и e-commerce мокапов.',
            page: {
                title1: 'Бесплатный ИИ-Удалитель Текста с Изображений',
                title2: 'Мешает лишний текст? Просто загрузите изображение — ИИ мгновенно обнаружит и удалит текст, логотипы, штампы даты или подписи. Он анализирует пиксели вокруг и восстанавливает фон без следов.',
                faq: [
                    {
                        question: 'Как удалить текст без размытия?',
                        answer: 'Используйте ИИ-удалитель текста 微鲤AI. Вместо размытия инструмент применяет AI Inpainting, анализирует окружение и генерирует новые пиксели для бесшовного заполнения.',
                    },
                    {
                        question: 'Можно ли убрать штампы даты с фото?',
                        answer: 'Да! ИИ распознаёт цифровой шрифт даты/времени и удаляет его, восстанавливая пейзаж позади.',
                    },
                    {
                        question: 'Работает ли на сложном фоне?',
                        answer: 'Да. Он может удалить текст даже со сложных фонов (горы, узорчатая одежда), понимая направление текстур.',
                    },
                    {
                        question: 'Можно ли удалять людей или объекты?',
                        answer: 'Хотя инструмент оптимизирован для текста, базовая технология (Inpainting) подходит и для удаления небольших объектов, дефектов кожи или лишнего “мусора”.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, вы можете пользоваться инструментом бесплатно с ежедневными кредитами.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как удалить текст без размытия?',
                    answer: 'Используйте ИИ-удалитель текста 微鲤AI. AI Inpainting генерирует новые пиксели, чтобы заполнить область естественно.',
                },
                {
                    question: 'Можно ли убрать штампы даты с фото?',
                    answer: 'Да! ИИ распознаёт дату/время и удаляет, восстанавливая фон.',
                },
                {
                    question: 'Работает ли на сложном фоне?',
                    answer: 'Да. Он понимает направление текстур и удаляет текст даже на сложных фонах.',
                },
            ],
            feature_title1: 'Очистка Одежды и Дизайна',
            feature_desc1: 'Идеально для мокапов: Перепродаёте одежду онлайн? Удаляйте логотипы, слоганы или графику с фото футболок, чтобы получить чистую основу для своих дизайнов.',
            feature_title2: 'Восстановление Воспоминаний',
            feature_desc2: 'Удаление штампов даты: Уберите отвлекающие оранжевые цифровые даты со старых семейных или туристических фото без повреждения пейзажа.',
            feature_title3: 'Интеллектуальный Inpainting',
            feature_desc3: 'Бесшовное заполнение фона: В отличие от простых ластиков, оставляющих размытие, 微鲤AI использует генеративный ИИ, чтобы “дорисовать” реалистичные текстуры (трава, небо, горы) в очищенной области.',
        },
        imgExtender: {
            title: 'Расширяйте изображения бесплатно — AI расширитель изображений | 微鲤AI',
            description: 'Используйте бесплатный AI расширитель изображений 微鲤AI, чтобы мгновенно выйти за пределы исходных границ фото. Наш инструмент outpainting генерирует новые пиксели, которые идеально сливаются с исходным изображением — превращайте портреты в широкоугольные кадры, сохраняя стиль и качество.',
            keywords: 'расширить изображение, AI расширитель изображений, расширить фото бесплатно, широкоугольное фото, расширить границы фото, бесшовный outpainting, сохранить качество',
            og_title: 'Расширяйте изображения бесплатно — AI расширитель изображений | 微鲤AI',
            og_description: 'Расширяйте фото до новых размеров и генерируйте подходящее окружение. Попробуйте AI расширитель изображений бесплатно.',
            twitter_title: 'Расширяйте изображения бесплатно — AI расширитель изображений | 微鲤AI',
            twitter_description: 'Расширяйте фото до новых размеров и генерируйте подходящее окружение. Попробуйте AI расширитель изображений бесплатно.',
            featureList: [
                'AI расширитель изображений, расширить фото бесплатно, широкоугольный эффект, сохранить качество',
            ],
            page: {
                title1: 'Мощный AI расширитель изображений для впечатляющих результатов',
                title2: 'Пара кликов — и вы легко расширяете фото за исходные границы. AI создаёт новые пиксели, которые бесшовно смешиваются с загрузкой, сохраняя внешний вид и качество.',
                feature_title: 'Почему 微鲤AI расширитель изображений особенный',
                faq: [
                    {
                        question: 'Что такое AI расширитель изображений?',
                        answer: 'Это инструмент, который расширяет границы изображения, интеллектуально дорисовывая недостающий контент за пределами исходного кадра. Подходит для маркетинга, e-commerce и соцсетей.',
                    },
                    {
                        question: 'Почему стоит выбрать 微鲤AI?',
                        answer: '微鲤AI анализирует особенности изображения и естественно дорисовывает окружающую область в высоком качестве без заметных швов.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да. Вы можете использовать инструмент бесплатно с пробными кредитами — это экономичное решение для любого workflow.',
                    },
                    {
                        question: 'Насколько быстро это работает?',
                        answer: 'Обычно расширение занимает несколько секунд — подходит и для быстрых правок, и для пакетной обработки.',
                    },
                    {
                        question: 'Пострадает ли качество или разрешение?',
                        answer: 'Нет. Инструмент сохраняет разрешение, чёткость и детали при расширении.',
                    },
                    {
                        question: 'Мои изображения будут приватными?',
                        answer: 'Да. Мы используем стандарты безопасности индустрии и строгие политики, чтобы ваши данные не передавались третьим лицам.',
                    },
                    {
                        question: 'Какие форматы поддерживаются?',
                        answer: 'JPG, PNG, WebP и другие популярные форматы. Максимальный размер файла — 10MB, конвертация не нужна.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Что такое AI расширитель изображений?',
                    answer: 'Это инструмент, который расширяет границы изображения, интеллектуально дорисовывая недостающий контент за пределами исходного кадра. Подходит для маркетинга, e-commerce и соцсетей.',
                },
                {
                    question: 'Почему стоит выбрать 微鲤AI?',
                    answer: '微鲤AI анализирует особенности изображения и естественно дорисовывает окружающую область в высоком качестве без заметных швов.',
                },
                {
                    question: 'Это бесплатно?',
                    answer: 'Да. Бесплатно с пробными кредитами.',
                },
                {
                    question: 'Насколько быстро это работает?',
                    answer: 'Обычно за несколько секунд.',
                },
                {
                    question: 'Пострадает ли качество или разрешение?',
                    answer: 'Нет. Чёткость и детали сохраняются.',
                },
                {
                    question: 'Мои изображения будут приватными?',
                    answer: 'Да. Мы защищаем данные и не делимся ими.',
                },
                {
                    question: 'Какие форматы поддерживаются?',
                    answer: 'JPG, PNG, WebP (до 10MB).',
                },
            ],
            feature_title1: 'Восстановление недостающих деталей и фона',
            feature_desc1: 'Если фото было обрезано, AI может дорисовать недостающие области и сделать кадр более цельным. Также подходит для восстановления утраченных элементов на старых фото.',
            feature_title2: 'Улучшайте товарные фото для роста продаж',
            feature_desc2: 'Расширяйте пространство вокруг товара и добавляйте гармоничный фон. Широкие композиции показывают больше деталей и помогают повысить конверсию.',
            feature_title3: 'Создавайте уникальные визуальные шедевры',
            feature_desc3: 'Фотографы, контент‑креаторы и художники могут расширять границы изображения и воплощать идеи в впечатляющих визуалах.',
            feature_title4: 'Оптимизируйте формат для соцсетей',
            feature_desc4: 'Расширяйте изображения под любые пропорции для Instagram, X (бывш. Twitter), Facebook и других платформ. AI сохраняет резкость и детали.',
            textRemoverHowToUseTitle: 'Как пользоваться AI расширителем изображений',
            textRemoverHowToUseDesc: '3 простых шага, чтобы расширить границы фото',
            textRemoverHowToUseStep1Title: 'Загрузите изображение',
            textRemoverHowToUseStep1Desc: 'Нажмите или перетащите изображение, которое хотите расширить.',
            textRemoverHowToUseStep2Title: 'AI обработает автоматически',
            textRemoverHowToUseStep2Desc: 'После загрузки AI автоматически определит границы и расширит изображение.',
            textRemoverHowToUseStep3Title: 'Скачайте расширенное изображение',
            textRemoverHowToUseStep3Desc: 'После завершения вы сможете просмотреть и скачать расширенную картинку.',
        },
        photoRestoration: {
            title: 'Бесплатное AI-восстановление фото - Раскрасьте Ч/Б и уберите царапины | 微鲤AI',
            description: 'Оживите семейные воспоминания с бесплатным AI-восстановлением фото от 微鲤AI. Автоматически раскрашивайте черно-белые снимки, удаляйте царапины, разрывы и размытость — лица восстанавливаются мгновенно.',
            keywords: 'восстановление старых фото, раскрасить ч/б фото, убрать царапины фото, AI ремонт фото, восстановить старые фотографии, черно-белое в цвет, восстановление изображений AI',
            og_title: 'Бесплатное AI-восстановление фото - Раскрасьте Ч/Б и уберите царапины | 微鲤AI',
            og_description: 'Оживите семейные воспоминания с бесплатным AI-восстановлением фото от 微鲤AI. Автоматически раскрашивайте черно-белые снимки, удаляйте царапины, разрывы и размытость — лица восстанавливаются мгновенно.',
            twitter_title: 'Бесплатное AI-восстановление фото - Раскрасьте Ч/Б и уберите царапины | 微鲤AI',
            twitter_description: 'Оживите семейные воспоминания с бесплатным AI-восстановлением фото от 微鲤AI. Автоматически раскрашивайте черно-белые снимки, удаляйте царапины, разрывы и размытость — лица восстанавливаются мгновенно.',
            page: {
                title1: 'Бесплатное восстановление и раскраска старых фото с AI',
                title2: 'Верните историю к жизни. Будь то выцветшее черно-белое свадебное фото или поцарапанный детский портрет — AI анализирует и восстанавливает повреждения, повышает резкость лиц и добавляет реалистичные цвета за секунды.',
                faq: [
                    {
                        question: 'Как раскрасить черно-белое фото?',
                        answer: 'Просто загрузите Ч/Б изображение в 微鲤AI. Инструмент сам определит градации серого и применит функцию «Colorize», чтобы добавить реалистичные цвета мгновенно.',
                    },
                    {
                        question: 'Можно ли исправить порванные или поцарапанные фото?',
                        answer: 'Да. AI обучен распознавать царапины, разрывы и заломы и заполняет поврежденные области пикселями, которые совпадают с окружающей текстурой.',
                    },
                    {
                        question: 'Фото после восстановления будет выглядеть “ненастоящим”?',
                        answer: 'Мы стремимся к реалистичности. Улучшение лица добавляет детали, но сохраняет узнаваемость. При раскраске AI выбирает естественные тона, подходящие для эпохи.',
                    },
                    {
                        question: 'Что если фото очень маленькое?',
                        answer: 'Не проблема. Процесс включает Upscaling — повышение разрешения маленьких фото для цифрового просмотра или печати.',
                    },
                    {
                        question: 'Защищена ли моя приватность?',
                        answer: 'Да. Мы понимаем, что старые фото — личные. Изображения обрабатываются безопасно и не хранятся на серверах постоянно.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как раскрасить черно-белое фото?',
                    answer: 'Загрузите Ч/Б фото — функция «Colorize» добавит реалистичные цвета мгновенно.',
                },
                {
                    question: 'Можно ли исправить порванные или поцарапанные фото?',
                    answer: 'Да. AI распознаёт повреждения и восстанавливает их с учетом текстуры вокруг.',
                },
                {
                    question: 'Фото после восстановления будет выглядеть “ненастоящим”?',
                    answer: 'Мы приоритизируем реализм и узнаваемость — с естественной цветокоррекцией.',
                },
            ],
            feature_title1: 'Удаление царапин и разрывов',
            feature_desc1: 'Стереть следы времени: автоматически обнаруживаем и заполняем заломы, царапины, разрывы и пыль. AI восстанавливает утраченные детали лица, чтобы фото выглядело как новое.',
            feature_title2: 'Интеллектуальная раскраска',
            feature_desc2: 'Ч/Б → цвет: не просто сепия. Модель понимает контекст (небо, кожа, ткань) и добавляет живые, естественные цвета старым снимкам.',
            feature_title3: 'Улучшение лица',
            feature_desc3: 'Убрать размытость: старые фото часто страдают от смаза и плохого фокуса. 微鲤AI повышает резкость черт (глаза, нос, рот), возвращая настоящее сходство.',
        },
        photoEffects: {
            title: 'Эффекты Изображения - Генератор Эффектов Изображения ИИ | 微鲤AI',
            description: 'Преобразуйте свои фотографии с помощью эффектов на базе ИИ. Создавайте потрясающие фильтры, стили и трансформации изображений онлайн бесплатно.',
            keywords: 'эффекты изображения ИИ, эффекты изображения, фото фильтр, трансформация изображения ИИ, перенос стиля изображения',
        },
    },
    pt: {
        textToImage: {
            title: 'Texto para Imagem - Gerador de Imagens IA Gratuito | 微鲤AI',
            description: 'Gere imagens impressionantes a partir de descrições de texto com IA. Crie fotos realistas, ilustrações e obras de arte usando modelos avançados, ideal para criação de conteúdo e projetos de design.',
            keywords: 'texto para imagem, gerador de imagens IA, geração de imagens, criação de imagens IA, texto para foto, ferramenta IA de imagens',
            og_title: 'Gerador de Imagens IA Gratuito a partir de Texto - Crie Arte 4K e Fotos Realistas | 微鲤AI',
            og_description: 'Transforme descrições de texto em visuais impressionantes com o Gerador de Imagens de Texto da 微鲤AI. Inclui o modelo Nano Banana Pro para resultados de alta fidelidade. Suporta resolução 1K/2K/4K e proporções 9:16/16:9. Gratuito e online.',
            twitter_title: 'Gerador de Imagens IA Gratuito a partir de Texto - Crie Arte 4K e Fotos Realistas | 微鲤AI',
            twitter_description: 'Transforme descrições de texto em visuais impressionantes com o Gerador de Imagens de Texto da 微鲤AI. Inclui o modelo Nano Banana Pro para resultados de alta fidelidade. Suporta resolução 1K/2K/4K e proporções 9:16/16:9. Gratuito e online.',
            faq: [
                {
                    question: 'Como gerar imagens IA em 4K?',
                    answer: 'Simplesmente insira sua descrição e selecione "4K" nas configurações de Tamanho da Imagem no painel esquerdo antes de clicar em Criar.',
                },
                {
                    question: 'Quais proporções de aspecto são suportadas?',
                    answer: 'Suportamos todas as proporções principais, incluindo 1:1, 9:16 (Mobile), 16:9 (Desktop), 4:3 e 3:2 para se adequar a qualquer plataforma.',
                },
                {
                    question: 'Posso usar as imagens comercialmente?',
                    answer: 'Sim. As imagens geradas nos planos 微鲤AI geralmente vêm com uma licença comercial adequada para anúncios e produtos.',
                },
            ],
            page: {
                title1: 'Gerador Gratuito de Imagens IA a partir de Texto',
                title2: 'Crie arte impressionante, imagens fotorrealistas e papéis de parede únicos em segundos. Basta descrever o que você quer ver, e nosso modelo avançado Nano Banana Pro gerará imagens 4K de alta fidelidade que correspondem perfeitamente à sua descrição.',
                resolution: 'Pare de se contentar com imagens IA desfocadas. 微鲤AI permite gerar imagens nítidas de 1K, 2K e 4K diretamente, perfeitas para impressão ou telas de alta resolução.',
                aspectRatio: 'Seja uma imagem 9:16 para fundos do TikTok, 16:9 para miniaturas do YouTube ou 1:1 para Instagram, temos predefinições para cada plataforma social.',
                online_search: 'Precisa de contexto atualizado? Ative "Busca Online" para permitir que a IA navegue na web para melhor compreensão de eventos atuais ou referências específicas em sua descrição.',
                faq: [
                    {
                        question: 'Como gerar imagens de alta qualidade a partir de texto?',
                        answer: 'Digite uma descrição detalhada descrevendo o assunto, iluminação e estilo. Selecione "4K" nas configurações de Tamanho da Imagem para obter os detalhes mais nítidos.',
                    },
                    {
                        question: 'O que é o modelo Nano Banana Pro?',
                        answer: 'Nano Banana Pro é nosso modelo de maior fidelidade, otimizado para aderência ao prompt e fotorrealismo. Ele rivaliza em qualidade com modelos top como Midjourney v6 e Flux.',
                    },
                    {
                        question: 'Posso usar as imagens para fins comerciais?',
                        answer: 'Sim. As imagens geradas no 微鲤AI (planos pagos) vêm com uma licença comercial, permitindo que você as use para anúncios, sites e produtos.',
                    },
                    {
                        question: 'Quantas imagens posso gerar de uma vez?',
                        answer: 'Você pode gerar até 4 imagens simultaneamente (conforme mostrado na configuração "Número de Imagens de Saída"), permitindo iterar rapidamente sobre ideias.',
                    },
                    {
                        question: 'É gratuito?',
                        answer: 'Sim, você pode gerar imagens usando nossos créditos diários gratuitos. Resoluções mais altas (4K) podem exigir mais créditos.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Gerador Gratuito de Imagem para Imagem IA - Transforme Fotos em Arte e 4K | 微鲤AI',
            description: 'Envie uma foto de referência e transforme-a com a IA de Imagem para Imagem da 微鲤AI. Transforme esboços em arte realista, mude estilos ou gere variações mantendo a composição original. Suporta resolução 4K.',
            keywords: 'imagem para imagem ai, img2img, transformar foto em desenho, variação imagem ai, esboço para imagem, remix foto ai, gerador arte ai gratuito',
            og_title: 'Gerador Gratuito de Imagem para Imagem IA - Transforme Fotos em Arte e 4K | 微鲤AI',
            og_description: 'Envie uma foto de referência e transforme-a com a IA de Imagem para Imagem da 微鲤AI. Transforme esboços em arte realista, mude estilos ou gere variações mantendo a composição original. Suporta resolução 4K.',
            twitter_title: 'Gerador Gratuito de Imagem para Imagem IA - Transforme Fotos em Arte e 4K | 微鲤AI',
            twitter_description: 'Envie uma foto de referência e transforme-a com a IA de Imagem para Imagem da 微鲤AI. Transforme esboços em arte realista, mude estilos ou gere variações mantendo a composição original. Suporta resolução 4K.',
            faq: [
                {
                    question: 'O que é IA de Imagem para Imagem?',
                    answer: 'Imagem para Imagem (Img2Img) usa uma imagem enviada como referência junto com um prompt de texto para gerar uma nova imagem, combinando entrada visual com descrição criativa.',
                },
                {
                    question: 'Como transformo um esboço em uma foto realista?',
                    answer: `Envie seu esboço, insira um prompt descrevendo a cena (por exemplo, 'edifício fotorrealista') e clique em Criar.`,
                },
                {
                    question: 'Ele mantém o rosto original?',
                    answer: 'Preserva estrutura e pose. Para retenção precisa da identidade facial, por favor use nossa ferramenta de Troca de Rosto em Fotos.',
                },
            ],
            page: {
                title1: 'Gerador Gratuito de Imagem para Imagem IA',
                title2: 'Use suas imagens existentes como modelo. Envie uma foto, esboço ou layout, e deixe nossa IA regenerá-la em um estilo completamente novo baseado em seu prompt de texto. Perfeito para preservar a composição enquanto explora variações artísticas infinitas.',
                title3: 'Transforme Suas Fotos com Transferência de Estilo IA',
                title4: 'Por Que Usar Imagem para Imagem (Img2Img)?',
                upload_image: 'Tem dificuldade para descrever uma pose ou layout em palavras? Basta enviar uma imagem de referência. Nosso motor Img2Img mantém a estrutura da sua foto original, mas repinta os detalhes.',
                resolution: 'Transforme um rabisco ou wireframe em uma renderização fotorrealista ou ilustração de alta qualidade em segundos. Ideal para designers e arquitetos.',
                output: 'Gere recursos prontos para produção. Diferente de outras ferramentas que geram imagens pequenas, a 微鲤AI suporta resoluções 1K, 2K e 4K para detalhes nítidos.',
                faq: [
                    {
                        question: 'O que é IA de Imagem para Imagem?',
                        answer: 'Imagem para Imagem (Img2Img) é uma tecnologia que usa uma imagem enviada como "referência" junto com um prompt de texto para gerar uma nova imagem. Ela combina sua entrada visual com sua descrição criativa.',
                    },
                    {
                        question: 'Como transformo um esboço em uma foto realista?',
                        answer: 'Envie seu esboço para a área "Imagem". Na caixa "Prompt", descreva o que o esboço representa (por exemplo, "Uma vila moderna, pôr do sol, fotorrealista, 8k"). Clique em Criar para ver a mágica.',
                    },
                    {
                        question: 'Ele mantém o rosto/pessoa original?',
                        answer: 'Tenta preservar a estrutura geral e a pose. No entanto, para retenção precisa do rosto, recomendamos usar nossa ferramenta específica de "Troca de Rosto em Fotos" em vez disso.',
                    },
                    {
                        question: 'Quais proporções são suportadas?',
                        answer: 'Suportamos uma ampla gama de proporções incluindo 9:16 (História), 16:9 (Cinematográfico), 3:4 e 1:1, garantindo que sua arte gerada se ajuste perfeitamente a qualquer plataforma.',
                    },
                    {
                        question: 'É gratuito?',
                        answer: 'Sim, você pode gerar variações gratuitamente usando seus créditos diários.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Extensor e Redimensionador de Imagem IA Gratuito - Desrecortar e Estender Fotos',
            description: 'Redimensione imagens para Instagram, TikTok e YouTube sem recortar. O Extensor de Imagem IA da 微鲤AI usa preenchimento generativo (extensão) para expandir fundos de imagem de forma inteligente. Altere proporções perfeitamente.',
            keywords: 'extensor imagem ai, desrecortar imagem, extensão ai, redimensionador imagem ai, expandir fundo imagem, preenchimento generativo online, fazer foto vertical',
            og_title: 'Extensor e Redimensionador de Imagem IA Gratuito - Desrecortar e Estender Fotos',
            og_description: 'Redimensione imagens para Instagram, TikTok e YouTube sem recortar. O Extensor de Imagem IA da 微鲤AI usa preenchimento generativo (extensão) para expandir fundos de imagem de forma inteligente. Altere proporções perfeitamente.',
            twitter_title: 'Extensor e Redimensionador de Imagem IA Gratuito - Desrecortar e Estender Fotos',
            twitter_description: 'Redimensione imagens para Instagram, TikTok e YouTube sem recortar. O Extensor de Imagem IA da 微鲤AI usa preenchimento generativo (extensão) para expandir fundos de imagem de forma inteligente. Altere proporções perfeitamente.',
            page: {
                title1: 'Extensor e Redimensionador de Imagem IA Gratuito',
                title2: 'Pare de recortar suas fotos favoritas para caber nas redes sociais. Seja para transformar uma foto horizontal em uma História vertical ou expandir uma imagem quadrada para 16:9, nosso Extensor de Imagem IA gera magicamente novos detalhes de fundo (Extensão) para se ajustar perfeitamente a qualquer proporção.',
                faq: [
                    {
                        question: 'Como redimensionar uma imagem sem recortar?',
                        answer: 'Use o Extensor de Imagem IA da 微鲤AI. Envie sua foto, selecione a proporção alvo (por exemplo, 9:16), e a IA gerará automaticamente (estenderá) as áreas de fundo faltantes em vez de recortar sua imagem.',
                    },
                    {
                        question: 'O que é Extensão IA?',
                        answer: 'Extensão é uma tecnologia de IA generativa que expande as bordas de uma imagem prevendo e desenhando novo conteúdo que corresponde ao estilo original, efetivamente "desrecortando" a foto.',
                    },
                    {
                        question: 'Posso transformar uma foto horizontal em vertical?',
                        answer: 'Sim! Basta enviar sua foto horizontal (paisagem) e selecionar a proporção 9:16. A IA estenderá a parte superior e inferior da imagem para preencher o quadro vertical.',
                    },
                    {
                        question: 'O fundo expandido parecerá falso?',
                        answer: '微鲤AI usa modelos generativos avançados treinados em conjuntos de dados massivos para garantir que o fundo expandido se misture naturalmente com a iluminação e textura originais.',
                    },
                    {
                        question: 'É gratuito usar?',
                        answer: 'Sim, os usuários recebem créditos gratuitos para experimentar os recursos de Redimensionamento Inteligente IA e Extensão.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como redimensionar uma imagem sem recortar?',
                    answer: 'Use o Extensor de Imagem IA da 微鲤AI. Envie sua foto, selecione a proporção alvo (por exemplo, 9:16), e a IA gerará automaticamente (estenderá) as áreas de fundo faltantes em vez de recortar sua imagem.',
                },
                {
                    question: 'O que é Extensão IA?',
                    answer: 'Extensão é uma tecnologia de IA generativa que expande as bordas de uma imagem prevendo e desenhando novo conteúdo que corresponde ao estilo original, efetivamente "desrecortando" a foto.',
                },
                {
                    question: 'Posso transformar uma foto horizontal em vertical?',
                    answer: 'Sim! Basta enviar sua foto horizontal (paisagem) e selecionar a proporção 9:16. A IA estenderá a parte superior e inferior da imagem para preencher o quadro vertical.',
                },
                {
                    question: 'O fundo expandido parecerá falso?',
                    answer: '微鲤AI usa modelos generativos avançados treinados em conjuntos de dados massivos para garantir que o fundo expandido se misture naturalmente com a iluminação e textura originais.',
                },
                {
                    question: 'É gratuito usar?',
                    answer: 'Sim, os usuários recebem créditos gratuitos para experimentar os recursos de Redimensionamento Inteligente IA e Extensão.',
                },
            ],
            feature_title1: 'Extensão Inteligente de Fundo',
            feature_desc1: 'Extensão Mágica: A IA entende o contexto da sua imagem e pinta novos pixels além das bordas originais. Expanda paisagens, salas ou texturas perfeitamente para preencher o quadro.',
            feature_title2: 'Proteção do Centro',
            feature_desc2: 'Nunca Recorte o Assunto: Nossa IA identifica automaticamente a pessoa ou objeto principal e os bloqueia no centro, garantindo que nunca sejam cortados durante o processo de redimensionamento.',
            feature_title3: 'Pronto para Redes Sociais',
            feature_desc3: 'Predefinições de um clique para Instagram Stories (9:16), Miniaturas do YouTube (16:9) e Publicações (4:5). Reutilize seu conteúdo em todas as plataformas instantaneamente.',
        },
        imageTextTranslate: {
            title: 'Tradutor de Imagem IA Gratuito - Traduza Texto em Fotos, Mangá e Quadrinhos',
            description: 'Traduza texto em imagens instantaneamente enquanto preserva o estilo visual original. O Tradutor de Imagem IA da 微鲤AI apaga automaticamente o texto original e redesenha as traduções. Perfeito para quadrinhos, mangá e pôsteres de marketing.',
            keywords: 'tradutor imagem ai, traduzir texto em imagem, tradutor de imagens, tradutor mangá, traduzir quadrinhos, tradutor ocr, substituição texto imagem',
            og_title: 'Tradutor de Imagem IA Gratuito - Traduza Texto em Fotos, Mangá e Quadrinhos',
            og_description: 'Traduza texto em imagens instantaneamente enquanto preserva o estilo visual original. O Tradutor de Imagem IA da 微鲤AI apaga automaticamente o texto original e redesenha as traduções. Perfeito para quadrinhos, mangá e pôsteres de marketing.',
            twitter_title: 'Tradutor de Imagem IA Gratuito - Traduza Texto em Fotos, Mangá e Quadrinhos',
            twitter_description: 'Traduza texto em imagens instantaneamente enquanto preserva o estilo visual original. O Tradutor de Imagem IA da 微鲤AI apaga automaticamente o texto original e redesenha as traduções. Perfeito para quadrinhos, mangá e pôsteres de marketing.',
            page: {
                title1: 'Tradutor de Imagem IA Gratuito e Substituidor de Texto',
                title2: 'Traduza pôsteres, menus, quadrinhos e capturas de tela em segundos. Diferente dos tradutores padrão que apenas sobrepõem texto, a 微鲤AI usa IA Generativa para apagar o texto original e redesenhar o fundo, fazendo o texto traduzido parecer parte do design original.',
                faq: [
                    {
                        question: 'Como traduzir texto dentro de uma imagem?',
                        answer: 'Envie sua imagem (JPG, PNG) para a 微鲤AI. Selecione o idioma de origem (ou use Detecção Automática) e o idioma alvo. Clique em "Criar" para deixar a IA substituir o texto.',
                    },
                    {
                        question: 'O texto traduzido parecerá natural?',
                        answer: 'Sim. A 微鲤AI tenta corresponder ao tamanho e estilo da fonte do texto original. É crucial que ela redesenhe o fundo atrás do texto para que a tradução se integre perfeitamente.',
                    },
                    {
                        question: 'Posso usar isso para traduzir Mangá ou Manhwa?',
                        answer: 'Absolutamente. Este é um dos melhores casos de uso. A IA detecta balões de fala e texto vertical (comum em japonês), substituindo-os por texto traduzido horizontal.',
                    },
                    {
                        question: 'Quais idiomas são suportados?',
                        answer: 'Suportamos tradução entre os principais idiomas globais incluindo inglês, espanhol, chinês, japonês, coreano, francês, alemão e mais.',
                    },
                    {
                        question: 'Funciona com texto escrito à mão?',
                        answer: 'Funciona melhor com texto impresso, mas nosso motor OCR avançado pode reconhecer texto escrito à mão claro em quadros brancos ou notas.',
                    },
                    {
                        question: 'É gratuito?',
                        answer: 'Você pode traduzir imagens gratuitamente usando seus créditos diários.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como traduzir texto dentro de uma imagem?',
                    answer: `Envie sua imagem para a 微鲤AI. Selecione o idioma alvo e clique em 'Criar'. A IA substituirá o texto original pela tradução.`,
                },
                {
                    question: 'O texto traduzido parecerá natural?',
                    answer: 'Sim. A 微鲤AI redesenha o fundo atrás do texto e tenta corresponder ao estilo da fonte, garantindo que a tradução se integre perfeitamente.',
                },
                {
                    question: 'Posso usar isso para traduzir Mangá ou Manhwa?',
                    answer: 'Absolutamente. Este é um dos melhores casos de uso. A IA detecta balões de fala e texto vertical (comum em japonês), substituindo-os por texto traduzido horizontal.',
                },
            ],
            feature_title1: 'Inpainting e Redesenho Inteligentes',
            feature_desc1: 'Substituição de Texto Perfeita: Nossa IA analisa a textura do fundo atrás do texto. Ela apaga as palavras originais e preenche o espaço inteligentemente antes de adicionar a tradução, garantindo que nenhuma caixa de texto feia cubra sua imagem.',
            feature_title2: 'Tradução de Mangá e Quadrinhos',
            feature_desc2: 'Leia Mangá Bruto Instantaneamente: Perfeito para fãs de anime. Envie páginas de mangá bruto (japonês/coreano) e obtenha traduções instantâneas em inglês que se encaixam perfeitamente dentro dos balões de fala.',
            feature_title3: 'Localização de Marketing Global',
            feature_desc3: 'Localização com Um Clique: Lançando produtos globalmente? Traduza seus pôsteres de marketing, banners e capturas de tela de UI para mais de 30 idiomas sem precisar dos arquivos PSD originais.',
        },
        aiBackgroundChanger: {
            title: 'Alterador de Fundo IA Grátis - Gere Fundos a partir de Texto',
            description: 'Altere o fundo de fotos instantaneamente com IA. Descreva a cena que você quer e a 微鲤AI gerará fundos realistas para fotografia de produtos, headshots para LinkedIn e retratos criativos. Grátis e online.',
            keywords: 'mudar fundo de foto, gerador de fundo IA, fotografia de produto IA, fazer fundo branco, substituir fundo online, preenchimento generativo de fundo',
            og_title: 'Alterador de Fundo IA Grátis - Gere Fundos a partir de Texto',
            og_description: 'Altere o fundo de fotos instantaneamente com IA. Descreva a cena que você quer e a 微鲤AI gerará fundos realistas para fotografia de produtos, headshots para LinkedIn e retratos criativos. Grátis e online.',
            twitter_title: 'Alterador de Fundo IA Grátis - Gere Fundos a partir de Texto',
            twitter_description: 'Altere o fundo de fotos instantaneamente com IA. Descreva a cena que você quer e a 微鲤AI gerará fundos realistas para fotografia de produtos, headshots para LinkedIn e retratos criativos. Grátis e online.',
            page: {
                title1: 'Alterador de Fundo IA Grátis e Gerador',
                title2: 'Não apenas remova o fundo — substitua por algo melhor. Envie sua foto e descreva qualquer cena (ex.: "estúdio de mármore luxuoso", "skyline de escritório"). Nossa IA generativa entende iluminação e perspectiva para misturar seu assunto perfeitamente no novo ambiente.',
                faq: [
                    {
                        question: 'Como mudar o fundo usando texto?',
                        answer: 'Envie sua imagem e, na caixa "Prompt de Fundo", descreva a cena que você quer (ex.: "um café aconchegante"). Clique em Criar e a IA gerará esse fundo para você.',
                    },
                    {
                        question: 'Posso mudar o fundo para branco puro?',
                        answer: 'Sim. Basta digitar "pure white background" ou "studio white" no prompt. Isso é perfeito para anúncios de produtos na Amazon/eBay e fotos de documento.',
                    },
                    {
                        question: 'Isso é bom para fotografia de produtos?',
                        answer: 'Com certeza. A 微鲤AI analisa o ângulo do seu produto e gera fundos com sombras e iluminação corretas, fazendo parecer um ensaio profissional em estúdio.',
                    },
                    {
                        question: 'A iluminação vai parecer natural?',
                        answer: 'Nossa IA generativa (semelhante ao Adobe Firefly ou SDXL) tenta combinar a iluminação do fundo gerado com o seu assunto para uma composição natural.',
                    },
                    {
                        question: 'É grátis?',
                        answer: 'Sim, você pode gerar novos fundos gratuitamente usando seus créditos diários.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como mudar o fundo usando texto?',
                    answer: 'Envie sua imagem e, na caixa "Prompt de Fundo", descreva a cena que você quer (ex.: "um café aconchegante"). Clique em Criar e a IA gerará esse fundo para você.',
                },
                {
                    question: 'Posso mudar o fundo para branco puro?',
                    answer: 'Sim. Basta digitar "pure white background" ou "studio white" no prompt. Isso é perfeito para anúncios de produtos na Amazon/eBay e fotos de documento.',
                },
                {
                    question: 'Isso é bom para fotografia de produtos?',
                    answer: 'Com certeza. A 微鲤AI analisa o ângulo do seu produto e gera fundos com sombras e iluminação corretas, fazendo parecer um ensaio profissional em estúdio.',
                },
                {
                    question: 'A iluminação vai parecer natural?',
                    answer: 'Nossa IA generativa (semelhante ao Adobe Firefly ou SDXL) tenta combinar a iluminação do fundo gerado com o seu assunto para uma composição natural.',
                },
                {
                    question: 'É grátis?',
                    answer: 'Sim, você pode gerar novos fundos gratuitamente usando seus créditos diários.',
                },
            ],
            feature_title1: 'Fotos Profissionais de Identidade',
            feature_desc1: 'Headshots DIY para LinkedIn: Transforme uma selfie casual em uma foto de perfil profissional. Troque um fundo bagunçado de quarto por um escritório limpo ou um fundo cinza de estúdio instantaneamente.',
            feature_title2: 'Fotografia de Produto Instantânea',
            feature_desc2: 'Aumente vendas no e-commerce: Economize milhares em ensaios fotográficos. Coloque seu produto em uma mesa de madeira, uma praia de areia ou um pedestal com prompts simples. A IA adiciona sombras e reflexos realistas.',
            feature_title3: 'Teletransporte Criativo',
            feature_desc3: 'Viaje para qualquer lugar: Quer estar em Paris ou em um futuro cyberpunk? Basta digitar. Nossa IA substitui o fundo mantendo a iluminação consistente com sua foto original.',
        },
        imageUpscaler: {
            title: 'Upscaler de Imagem IA Grátis - Aumente para 4K e Restaure Fotos Antigas',
            description: 'Aumente instantaneamente imagens de baixa resolução para 2x, 4x e até 4K com o Melhorador de Imagem IA Grátis da 微鲤AI. Corrija fotos borradas, remova ruído e restaure fotos antigas de família online. Qualidade sem perdas.',
            keywords: 'upscaler de imagem IA, melhorador de fotos, aumentar imagem para 4k, remover desfoque, restauração de fotos antigas, corrigir foto pixelada, aumentar resolução da imagem',
            og_title: 'Upscaler de Imagem IA Grátis - Aumente para 4K e Restaure Fotos Antigas',
            og_description: 'Aumente instantaneamente imagens de baixa resolução para 2x, 4x e até 4K com o Melhorador de Imagem IA Grátis da 微鲤AI. Corrija fotos borradas, remova ruído e restaure fotos antigas de família online. Qualidade sem perdas.',
            twitter_title: 'Upscaler de Imagem IA Grátis - Aumente para 4K e Restaure Fotos Antigas',
            twitter_description: 'Aumente instantaneamente imagens de baixa resolução para 2x, 4x e até 4K com o Melhorador de Imagem IA Grátis da 微鲤AI. Corrija fotos borradas, remova ruído e restaure fotos antigas de família online. Qualidade sem perdas.',
            page: {
                title1: 'Upscaler e Melhorador de Imagem IA Grátis',
                title2: 'Transforme fotos pixeladas, borradas ou antigas em obras-primas em alta definição. A 微鲤AI usa IA avançada para aumentar a resolução em até 400% (4K), recuperando detalhes perdidos, corrigindo ruído e restaurando rostos em retratos familiares antigos.',
                faq: [
                    {
                        question: 'Posso aumentar imagens de baixa resolução para impressão?',
                        answer: 'Sim! A 微鲤AI aumenta a resolução (quantidade de pixels) da sua imagem até 4K, tornando-a adequada para impressão de alta qualidade em pôsteres, telas ou materiais de marketing.',
                    },
                    {
                        question: 'Como funciona a restauração de fotos antigas com IA?',
                        answer: 'A IA analisa as partes danificadas ou borradas da foto antiga e usa deep learning para prever e reconstruir detalhes faciais, texturas e fundos, “curando” a imagem.',
                    },
                    {
                        question: 'Quais formatos são suportados?',
                        answer: 'Suportamos formatos comuns como JPG, PNG e WEBP. A saída será um PNG ou JPG de alta qualidade.',
                    },
                    {
                        question: 'Funciona em anime/cartoons?',
                        answer: 'Sim. Nossa IA se destaca ao aumentar animes e ilustrações (estilo waifu2x), mantendo linhas nítidas e cores vibrantes sem artefatos.',
                    },
                    {
                        question: 'É grátis?',
                        answer: 'Sim, você pode melhorar imagens gratuitamente usando seus créditos diários.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso aumentar imagens de baixa resolução para impressão?',
                    answer: 'Sim! A 微鲤AI aumenta a resolução até 4K, tornando as imagens adequadas para impressão de alta qualidade.',
                },
                {
                    question: 'Como funciona a restauração de fotos antigas com IA?',
                    answer: 'A IA analisa áreas danificadas e reconstrói detalhes faciais e texturas com deep learning para “curar” a imagem.',
                },
                {
                    question: 'Funciona em anime?',
                    answer: 'Sim. Nossa IA se destaca ao aumentar animes e ilustrações, mantendo linhas nítidas sem artefatos.',
                },
            ],
            feature_title1: 'Upscaling Sem Perdas até 4K',
            feature_desc1: 'Qualidade Pronta para Impressão: Precisa imprimir uma imagem pequena? Aumente para 4K ou 8K sem perder qualidade. Perfeito para pôsteres, fotos de produto para e-commerce e papéis de parede.',
            feature_title2: 'Redução de Ruído e Desfoque Inteligente',
            feature_desc2: 'Corrija Fotos Noturnas: Remova ruído digital e granulação de fotos com pouca luz. Deixe bordas borradas mais nítidas instantaneamente para que suas fotos pareçam claras e profissionais.',
            feature_title3: 'Restauração de Fotos Antigas',
            feature_desc3: 'Reviva Memórias: Tem fotos antigas, danificadas ou em preto e branco? Nossa IA cria novos pixels para reparar riscos, deixar rostos mais nítidos e devolver clareza às suas lembranças.',
        },
        photoFaceSwap: {
            title: 'Face Swap IA Grátis Online - Troca de Rosto Realista | 微鲤AI',
            description: 'Troque rostos em fotos instantaneamente com o Face Swapper IA grátis da 微鲤AI. Crie memes engraçados, retratos artísticos (Mona Lisa) ou headshots profissionais com alto realismo. 100% privado e seguro.',
            keywords: 'face swap IA, troca de rosto online, mudador de rosto, reface grátis, substituir rosto na imagem, deepfake foto, criador de memes IA',
            og_title: 'Face Swap IA Grátis Online - Troca de Rosto Realista | 微鲤AI',
            og_description: 'Troque rostos em fotos instantaneamente com o Face Swapper IA grátis da 微鲤AI. Crie memes engraçados, retratos artísticos (Mona Lisa) ou headshots profissionais com alto realismo. 100% privado e seguro.',
            twitter_title: 'Face Swap IA Grátis Online - Troca de Rosto Realista | 微鲤AI',
            twitter_description: 'Troque rostos em fotos instantaneamente com o Face Swapper IA grátis da 微鲤AI. Crie memes engraçados, retratos artísticos (Mona Lisa) ou headshots profissionais com alto realismo. 100% privado e seguro.',
            page: {
                title1: 'Face Swap em Foto com IA Grátis',
                title2: 'Quer se ver como astronauta, estrela de cinema ou dentro de uma pintura clássica? Envie uma foto base e um rosto alvo, e nossa IA vai mesclar traços faciais, iluminação e tons de pele para um face swap hiper-realista em segundos.',
                faq: [
                    {
                        question: 'O Face Swap da 微鲤AI é gratuito?',
                        answer: 'Sim, oferecemos créditos diários gratuitos para você trocar rostos em fotos online. Não precisa instalar nada nem usar cartão.',
                    },
                    {
                        question: 'Meus dados estão seguros?',
                        answer: 'Com certeza. Priorizamos sua privacidade. As fotos enviadas são usadas apenas no processo de troca e são deletadas automaticamente dos nossos servidores após um curto período.',
                    },
                    {
                        question: 'Como obter os melhores resultados?',
                        answer: 'Para um resultado mais realista, garanta que a “Imagem Base” e a “Imagem do Rosto” estejam nítidas, de frente e com boa iluminação. Evite fotos com o rosto coberto por cabelo ou mãos.',
                    },
                    {
                        question: 'Posso trocar rostos em fotos de grupo?',
                        answer: 'No momento, nosso foco é a precisão em um único rosto. Para fotos de grupo, recorte a imagem ou aguarde nosso recurso de múltiplos rostos.',
                    },
                    {
                        question: 'Posso usar para memes?',
                        answer: 'Sim! É perfeito para criar memes engraçados. Troque o rosto de um amigo em um pôster de filme ou em um template viral instantaneamente.',
                    },
                ],
            },
            faq: [
                {
                    question: 'O Face Swap da 微鲤AI é gratuito?',
                    answer: 'Sim, oferecemos créditos diários gratuitos para face swap online. Sem instalação e sem cartão.',
                },
                {
                    question: 'Meus dados estão seguros?',
                    answer: 'Sim. As fotos são usadas apenas para a troca e são deletadas automaticamente após um curto período.',
                },
                {
                    question: 'Como obter os melhores resultados?',
                    answer: 'Garanta que ambas as fotos estejam nítidas, de frente e bem iluminadas. Evite rostos cobertos por cabelo ou óculos.',
                },
            ],
            feature_title1: 'Obras-primas Artísticas',
            feature_desc1: 'Viagem no tempo: Troque seu rosto em pinturas clássicas como a Mona Lisa ou A Moça com Brinco de Pérola. Crie avatares vintage únicos instantaneamente.',
            feature_title2: 'Avatares Profissionais e Estilosos',
            feature_desc2: 'Empregos dos sonhos: Veja-se com macacão de corrida, traje de astronauta ou roupa social sem comprar fantasia. Perfeito para fotos de perfil que se destacam.',
            feature_title3: 'Mistura Hiper-realista',
            feature_desc3: 'Sem efeito “colado”: Diferente de ferramentas simples de recortar e colar, a 微鲤AI analisa ângulo, luz e textura da pele para garantir que o rosto trocado pareça 100% natural, não falso.',
        },
        removeTextFromImage: {
            title: `Removedor de Texto IA Grátis - Apague Marcas d'Água e Datas | 微鲤AI`,
            description: 'Remova instantaneamente texto, datas, logos e legendas com a Borracha de Texto IA grátis da 微鲤AI. Restaure fundos perfeitamente com IA Inpainting. Ideal para limpar fotos e mockups de e-commerce.',
            keywords: `remover texto de imagem, removedor de texto IA, remover data da foto, remover marca d'água online, limpar fotos, IA inpainting, remover logo de foto`,
            og_title: `Removedor de Texto IA Grátis - Apague Marcas d'Água e Datas | 微鲤AI`,
            og_description: 'Remova instantaneamente texto, datas, logos e legendas com a Borracha de Texto IA grátis da 微鲤AI. Restaure fundos perfeitamente com IA Inpainting. Ideal para limpar fotos e mockups de e-commerce.',
            twitter_title: `Removedor de Texto IA Grátis - Apague Marcas d'Água e Datas | 微鲤AI`,
            twitter_description: 'Remova instantaneamente texto, datas, logos e legendas com a Borracha de Texto IA grátis da 微鲤AI. Restaure fundos perfeitamente com IA Inpainting. Ideal para limpar fotos e mockups de e-commerce.',
            page: {
                title1: 'Removedor de Texto IA Grátis',
                title2: 'Texto indesejado atrapalhando? Basta enviar sua imagem e nossa IA detecta e apaga texto, logos, datas ou legendas instantaneamente. Ela analisa os pixels ao redor para reconstruir o fundo, sem deixar rastros.',
                faq: [
                    {
                        question: 'Como remover texto de uma imagem sem borrar?',
                        answer: 'Use o Removedor de Texto IA da 微鲤AI. Em vez de borrão, usamos IA Inpainting para analisar o entorno e gerar novos pixels que preenchem a área de forma perfeita.',
                    },
                    {
                        question: 'Posso remover datas de fotos?',
                        answer: 'Sim! Caso de uso perfeito. A IA reconhece a fonte digital de data/hora e remove enquanto restaura a paisagem por trás.',
                    },
                    {
                        question: 'Funciona em fundos complexos?',
                        answer: 'Sim. Ele remove texto até em fundos complexos como montanhas ou roupas com padrões, entendendo o fluxo da textura.',
                    },
                    {
                        question: 'Posso remover pessoas ou objetos?',
                        answer: 'Apesar de otimizado para texto, a tecnologia base (Inpainting) também funciona para remover pequenos objetos, imperfeições de pele ou bagunça.',
                    },
                    {
                        question: 'É grátis?',
                        answer: 'Sim, você pode usar gratuitamente com créditos diários.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como remover texto de uma imagem sem borrar?',
                    answer: 'Use o Removedor de Texto IA da 微鲤AI. A IA Inpainting gera novos pixels para preencher a área de forma natural.',
                },
                {
                    question: 'Posso remover datas de fotos?',
                    answer: 'Sim! A IA reconhece datas/horas e remove, restaurando o fundo.',
                },
                {
                    question: 'Funciona em fundos complexos?',
                    answer: 'Sim. Entende o fluxo da textura e remove texto mesmo em fundos complexos.',
                },
            ],
            feature_title1: 'Limpeza de Roupas & Design',
            feature_desc1: 'Perfeito para Mockups: Vai revender roupas online? Remova logos, frases ou gráficos de fotos de camisetas para criar uma base limpa para seus designs.',
            feature_title2: 'Restauração de Memórias',
            feature_desc2: 'Apague Datas: Remova datas digitais laranjas de fotos antigas de família ou de viagem sem danificar a paisagem.',
            feature_title3: 'Inpainting Inteligente',
            feature_desc3: 'Preenchimento de Fundo Sem Marcas: Diferente de borrachas básicas que deixam borrão, a 微鲤AI usa IA generativa para “pintar” texturas realistas (grama, céu, montanhas) na área apagada.',
        },
        imgExtender: {
            title: 'Expanda Imagens Grátis Agora - Extensor de Imagens com IA | 微鲤AI',
            description: 'Use o Extensor de Imagens com IA grátis da 微鲤AI para ultrapassar instantaneamente as bordas originais da sua foto. Nosso outpainting gera novos pixels que se misturam perfeitamente ao upload — transforme retratos em fotos grande‑angulares mantendo o visual e a qualidade.',
            keywords: 'extensor de imagens IA, expandir imagem grátis, foto grande angular, expandir bordas da foto, outpainting sem marcas, manter qualidade original',
            og_title: 'Expanda Imagens Grátis Agora - Extensor de Imagens com IA | 微鲤AI',
            og_description: 'Expanda suas fotos para novos tamanhos e gere conteúdo que combina com a imagem. Experimente o Extensor de Imagens com IA grátis.',
            twitter_title: 'Expanda Imagens Grátis Agora - Extensor de Imagens com IA | 微鲤AI',
            twitter_description: 'Expanda suas fotos para novos tamanhos e gere conteúdo que combina com a imagem. Experimente o Extensor de Imagens com IA grátis.',
            featureList: [
                'extensor de imagens IA, expandir imagem grátis, grande angular, manter qualidade',
            ],
            page: {
                title1: 'Um poderoso Extensor de Imagens com IA, resultados incríveis',
                title2: 'Com poucos cliques, expanda além das bordas originais da foto. A IA gera novos pixels que se integram ao upload, transformando retratos em imagens mais amplas sem perder qualidade.',
                feature_title: 'O que torna o Extensor de Imagens da 微鲤AI especial',
                faq: [
                    {
                        question: 'O que é um extensor de imagens com IA?',
                        answer: 'É uma ferramenta que usa IA avançada para expandir as bordas de uma imagem, preenchendo de forma inteligente o conteúdo faltante. Útil para marketing, e‑commerce e redes sociais.',
                    },
                    {
                        question: 'Por que usar o Extensor de Imagens da 微鲤AI?',
                        answer: 'A 微鲤AI analisa os recursos da imagem e faz outpainting natural em alta definição, com integração sem marcas.',
                    },
                    {
                        question: 'É grátis?',
                        answer: 'Sim. Você pode usar gratuitamente com créditos de teste — uma opção econômica para qualquer fluxo de edição.',
                    },
                    {
                        question: 'Quão rápido é?',
                        answer: 'Normalmente leva apenas alguns segundos, ideal para edições rápidas e processamento em lote.',
                    },
                    {
                        question: 'A expansão afeta a qualidade?',
                        answer: 'Não. Mantém resolução, nitidez e detalhes durante o processo.',
                    },
                    {
                        question: 'Minhas imagens ficam privadas?',
                        answer: 'Sim. Protegemos seus dados com segurança padrão da indústria e políticas rígidas de privacidade.',
                    },
                    {
                        question: 'Quais formatos são suportados?',
                        answer: 'JPG, PNG, WebP e formatos comuns. Tamanho máximo: 10MB. Sem necessidade de conversão.',
                    },
                ],
            },
            faq: [
                {
                    question: 'O que é um extensor de imagens com IA?',
                    answer: 'É uma ferramenta que usa IA avançada para expandir as bordas de uma imagem, preenchendo de forma inteligente o conteúdo faltante. Útil para marketing, e‑commerce e redes sociais.',
                },
                {
                    question: 'Por que usar o Extensor de Imagens da 微鲤AI?',
                    answer: 'A 微鲤AI analisa os recursos da imagem e faz outpainting natural em alta definição, com integração sem marcas.',
                },
                {
                    question: 'É grátis?',
                    answer: 'Sim. Uso gratuito com créditos de teste.',
                },
                {
                    question: 'Quão rápido é?',
                    answer: 'Geralmente em alguns segundos.',
                },
                {
                    question: 'A expansão afeta a qualidade?',
                    answer: 'Não. A qualidade e os detalhes são preservados.',
                },
                {
                    question: 'Minhas imagens ficam privadas?',
                    answer: 'Sim. Seus dados são protegidos e não compartilhados.',
                },
                {
                    question: 'Quais formatos são suportados?',
                    answer: 'JPG, PNG, WebP (até 10MB).',
                },
            ],
            feature_title1: 'Repare detalhes e fundos faltantes',
            feature_desc1: 'Se a imagem foi recortada, preencha áreas faltantes para deixar a cena mais completa. O outpainting também ajuda a recuperar elementos perdidos em fotos antigas.',
            feature_title2: 'Melhore fotos de produto para vender mais',
            feature_desc2: 'Expanda a área ao redor do produto para adicionar fundos complementares. Também dá para criar composições mais largas e mostrar mais detalhes.',
            feature_title3: 'Crie obras visuais únicas',
            feature_desc3: 'Fotógrafos, criadores e artistas podem ultrapassar os limites e transformar ideias em visuais impressionantes.',
            feature_title4: 'Otimize proporções para redes sociais',
            feature_desc4: 'Expanda imagens para qualquer proporção no Instagram, X (antigo Twitter), Facebook e mais. A IA mantém nitidez e detalhes para um resultado chamativo.',
            textRemoverHowToUseTitle: 'Como usar nosso Extensor de Imagens com IA',
            textRemoverHowToUseDesc: '3 passos simples para expandir sua foto além das bordas',
            textRemoverHowToUseStep1Title: 'Envie uma imagem',
            textRemoverHowToUseStep1Desc: 'Clique ou arraste e solte a imagem que você quer expandir.',
            textRemoverHowToUseStep2Title: 'A IA processa automaticamente',
            textRemoverHowToUseStep2Desc: 'Após o envio, a IA detecta e expande automaticamente as bordas da imagem.',
            textRemoverHowToUseStep3Title: 'Baixe a imagem expandida',
            textRemoverHowToUseStep3Desc: 'Quando terminar, visualize e baixe sua imagem expandida!',
        },
        photoRestoration: {
            title: 'Restauração de Foto com IA Grátis - Colorize P&B e Repare Riscos | 微鲤AI',
            description: 'Reviva memórias de família com a Restauração de Foto com IA Grátis da 微鲤AI. Colorize automaticamente fotos em preto e branco, remova riscos, rasgos e desfoque para restaurar rostos em segundos.',
            keywords: 'restauração de foto antiga, colorizar foto, reparar foto riscada, reparo de foto IA, restaurar fotos antigas, preto e branco para cor, restauração de imagem IA',
            og_title: 'Restauração de Foto com IA Grátis - Colorize P&B e Repare Riscos | 微鲤AI',
            og_description: 'Reviva memórias de família com a Restauração de Foto com IA Grátis da 微鲤AI. Colorize automaticamente fotos em preto e branco, remova riscos, rasgos e desfoque para restaurar rostos em segundos.',
            twitter_title: 'Restauração de Foto com IA Grátis - Colorize P&B e Repare Riscos | 微鲤AI',
            twitter_description: 'Reviva memórias de família com a Restauração de Foto com IA Grátis da 微鲤AI. Colorize automaticamente fotos em preto e branco, remova riscos, rasgos e desfoque para restaurar rostos em segundos.',
            page: {
                title1: 'Restaurador e Colorizador de Fotos Antigas com IA (Grátis)',
                title2: 'Traga sua história de volta à vida. Seja uma foto de casamento P&B desbotada ou um retrato de infância riscado, nossa IA analisa e restaura áreas danificadas, melhora rostos e adiciona cores realistas em segundos.',
                faq: [
                    {
                        question: 'Como colorir uma foto em preto e branco?',
                        answer: 'Basta enviar sua imagem P&B para a 微鲤AI. A ferramenta detecta o modo em escala de cinza e aplica o recurso “Colorizar” para adicionar cores realistas instantaneamente.',
                    },
                    {
                        question: 'Consegue consertar fotos rasgadas ou riscadas?',
                        answer: 'Sim. Nossa IA reconhece riscos, rasgos e dobras e preenche as áreas danificadas com pixels que combinam com a textura ao redor.',
                    },
                    {
                        question: 'A foto restaurada vai parecer falsa?',
                        answer: 'Nosso foco é realismo. A melhoria facial adiciona detalhes mantendo a identidade reconhecível. Na colorização, a IA escolhe tons naturais adequados à época.',
                    },
                    {
                        question: 'E se a foto for muito pequena?',
                        answer: 'Sem problema. O processo inclui Upscaling, aumentando a resolução de fotos pequenas para visualização digital ou impressão.',
                    },
                    {
                        question: 'Minha privacidade está protegida?',
                        answer: 'Sim. Sabemos que fotos antigas são pessoais. Suas imagens são processadas com segurança e não são armazenadas permanentemente em nossos servidores.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como colorir uma foto em preto e branco?',
                    answer: 'Envie a imagem P&B e o recurso “Colorizar” adiciona cores realistas instantaneamente.',
                },
                {
                    question: 'Consegue consertar fotos rasgadas ou riscadas?',
                    answer: 'Sim. A IA detecta danos e reconstrói de acordo com a textura ao redor.',
                },
                {
                    question: 'A foto restaurada vai parecer falsa?',
                    answer: 'Priorizamos realismo e identidade reconhecível, com cores naturais.',
                },
            ],
            feature_title1: 'Remoção de Riscos & Rasgos',
            feature_desc1: 'Apague as marcas do tempo: detecte e preencha dobras, riscos, rasgos e manchas de poeira automaticamente. A IA reconstrói detalhes faciais perdidos para a foto parecer nova.',
            feature_title2: 'Colorização Inteligente',
            feature_desc2: 'P&B para Cor: não é só um filtro sépia. O modelo entende contexto (céu, pele, tecido) para adicionar cores vibrantes e realistas a fotos antigas.',
            feature_title3: 'Aprimoramento de Rosto',
            feature_desc3: 'Desborrar rostos: fotos antigas sofrem com desfoque e falta de foco. A 微鲤AI realça traços (olhos, nariz, boca) para revelar a semelhança real.',
        },
        photoEffects: {
            title: 'Efeitos de Imagem - Gerador de Efeitos de Imagem IA | 微鲤AI',
            description: 'Transforme suas fotos com efeitos alimentados por IA. Crie filtros de imagem, estilos e transformações impressionantes online gratuitamente.',
            keywords: 'efeitos de imagem IA, efeitos de imagem, filtro de foto, transformação de imagem IA, transferência de estilo de imagem',
        },
    },
    it: {
        textToImage: {
            title: 'Testo in Immagine - Generatore di Immagini IA Gratuito | 微鲤AI',
            description: `Genera immagini straordinarie a partire da descrizioni testuali con l'IA. Crea foto realistiche, illustrazioni e opere artistiche con modelli avanzati, ideale per contenuti creativi e progetti di design.`,
            keywords: 'testo in immagine, generatore immagini IA, generazione immagini, creazione immagini IA, testo in foto, strumento IA per immagini',
            og_title: 'Generatore di Immagini IA Gratuito da Testo - Crea Arte 4K e Foto Realistiche | 微鲤AI',
            og_description: 'Trasforma descrizioni testuali in visuali straordinarie con il Generatore di Immagini da Testo di 微鲤AI. Include il modello Nano Banana Pro per risultati ad alta fedeltà. Supporta risoluzione 1K/2K/4K e proporzioni 9:16/16:9. Gratuito e online.',
            twitter_title: 'Generatore di Immagini IA Gratuito da Testo - Crea Arte 4K e Foto Realistiche | 微鲤AI',
            twitter_description: 'Trasforma descrizioni testuali in visuali straordinarie con il Generatore di Immagini da Testo di 微鲤AI. Include il modello Nano Banana Pro per risultati ad alta fedeltà. Supporta risoluzione 1K/2K/4K e proporzioni 9:16/16:9. Gratuito e online.',
            faq: [
                {
                    question: 'Come genero immagini IA in 4K?',
                    answer: 'Inserisci semplicemente la tua descrizione e seleziona "4K" nelle impostazioni Dimensione Immagine nel pannello sinistro prima di fare clic su Crea.',
                },
                {
                    question: 'Quali proporzioni sono supportate?',
                    answer: 'Supportiamo tutte le proporzioni principali, inclusi 1:1, 9:16 (Mobile), 16:9 (Desktop), 4:3 e 3:2 per adattarsi a qualsiasi piattaforma.',
                },
                {
                    question: 'Posso usare le immagini commercialmente?',
                    answer: 'Sì. Le immagini generate sui piani 微鲤AI generalmente includono una licenza commerciale adatta per pubblicità e prodotti.',
                },
            ],
            page: {
                title1: 'Generatore Gratuito di Immagini IA da Testo',
                title2: 'Crea arte mozzafiato, immagini fotorealistiche e sfondi unici in pochi secondi. Basta descrivere ciò che vuoi vedere, e il nostro modello avanzato Nano Banana Pro genererà immagini 4K ad alta fedeltà che corrispondono perfettamente alla tua descrizione.',
                resolution: 'Smetti di accontentarti di immagini IA sfocate. 微鲤AI ti consente di generare direttamente immagini nitide da 1K, 2K e 4K, perfette per la stampa o display ad alta risoluzione.',
                aspectRatio: `Che tu abbia bisogno di un'immagine 9:16 per sfondi TikTok, 16:9 per miniature YouTube o 1:1 per Instagram, abbiamo preset per ogni piattaforma sociale.`,
                online_search: `Hai bisogno di contesto aggiornato? Abilita "Ricerca Online" per consentire all'IA di navigare sul web per una migliore comprensione di eventi attuali o riferimenti specifici nella tua descrizione.`,
                faq: [
                    {
                        question: 'Come genero immagini di alta qualità da testo?',
                        answer: `Inserisci una descrizione dettagliata che descriva il soggetto, l'illuminazione e lo stile. Seleziona "4K" nelle impostazioni Dimensione Immagine per i dettagli più nitidi.`,
                    },
                    {
                        question: `Cos'è il modello Nano Banana Pro?`,
                        answer: `Nano Banana Pro è il nostro modello con la massima fedeltà, ottimizzato per l'aderenza al prompt e il fotorealismo. Rivaleggia in qualità con modelli top come Midjourney v6 e Flux.`,
                    },
                    {
                        question: 'Posso usare le immagini per scopi commerciali?',
                        answer: 'Sì. Le immagini generate su 微鲤AI (piani a pagamento) vengono fornite con una licenza commerciale, permettendoti di usarle per pubblicità, siti web e prodotti.',
                    },
                    {
                        question: 'Quante immagini posso generare alla volta?',
                        answer: `Puoi generare fino a 4 immagini contemporaneamente (come mostrato nell'impostazione "Numero di Immagini di Output"), permettendoti di iterare rapidamente sulle idee.`,
                    },
                    {
                        question: 'È gratuito?',
                        answer: 'Sì, puoi generare immagini utilizzando i nostri crediti giornalieri gratuiti. Risoluzioni più elevate (4K) potrebbero richiedere più crediti.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Generatore Gratuito IA Immagine in Immagine - Trasforma Foto in Arte e 4K | 微鲤AI',
            description: `Carica una foto di riferimento e trasformala con l'IA Immagine in Immagine di 微鲤AI. Trasforma schizzi in arte realistica, cambia stili o genera variazioni mantenendo la composizione originale. Supporta risoluzione 4K.`,
            keywords: 'immagine in immagine ai, img2img, trasformare foto in disegno, variazione immagine ai, schizzo in immagine, remix foto ai, generatore arte ai gratuito',
            og_title: 'Generatore Gratuito IA Immagine in Immagine - Trasforma Foto in Arte e 4K | 微鲤AI',
            og_description: `Carica una foto di riferimento e trasformala con l'IA Immagine in Immagine di 微鲤AI. Trasforma schizzi in arte realistica, cambia stili o genera variazioni mantenendo la composizione originale. Supporta risoluzione 4K.`,
            twitter_title: 'Generatore Gratuito IA Immagine in Immagine - Trasforma Foto in Arte e 4K | 微鲤AI',
            twitter_description: `Carica una foto di riferimento e trasformala con l'IA Immagine in Immagine di 微鲤AI. Trasforma schizzi in arte realistica, cambia stili o genera variazioni mantenendo la composizione originale. Supporta risoluzione 4K.`,
            faq: [
                {
                    question: `Cos'è l'IA Immagine in Immagine?`,
                    answer: `Immagine in Immagine (Img2Img) utilizza un'immagine caricata come riferimento insieme a un prompt di testo per generare una nuova immagine, combinando input visivo con descrizione creativa.`,
                },
                {
                    question: 'Come trasformo uno schizzo in una foto realistica?',
                    answer: `Carica il tuo schizzo, inserisci un prompt che descrive la scena (ad esempio, 'edificio fotorealistico') e clicca su Crea.`,
                },
                {
                    question: 'Mantiene il volto originale?',
                    answer: `Preserva struttura e posa. Per una ritenzione precisa dell'identità del volto, si prega di utilizzare il nostro strumento Scambio Volto Foto.`,
                },
            ],
            page: {
                title1: 'Generatore Gratuito IA Immagine in Immagine',
                title2: 'Usa le tue immagini esistenti come modello. Carica una foto, uno schizzo o un layout, e lascia che la nostra IA lo rigeneri in uno stile completamente nuovo basato sul tuo prompt di testo. Perfetto per preservare la composizione mentre esplori infinite variazioni artistiche.',
                title3: 'Trasforma le Tue Foto con Trasferimento Stile IA',
                title4: 'Perché Usare Immagine in Immagine (Img2Img)?',
                upload_image: `Hai difficoltà a descrivere una posa o un layout a parole? Basta caricare un'immagine di riferimento. Il nostro motore Img2Img mantiene la struttura della tua foto originale ma ridipinge i dettagli.`,
                resolution: `Trasforma uno schizzo approssimativo o un wireframe in un rendering fotorealistico o un'illustrazione di alta qualità in secondi. Ideale per designer e architetti.`,
                output: 'Genera risorse pronte per la produzione. A differenza di altri strumenti che generano immagini piccole, 微鲤AI supporta risoluzioni 1K, 2K e 4K per dettagli nitidi.',
                faq: [
                    {
                        question: `Cos'è l'IA Immagine in Immagine?`,
                        answer: `Immagine in Immagine (Img2Img) è una tecnologia che utilizza un'immagine caricata come "riferimento" insieme a un prompt di testo per generare una nuova immagine. Combina il tuo input visivo con la tua descrizione creativa.`,
                    },
                    {
                        question: 'Come trasformo uno schizzo in una foto realistica?',
                        answer: `Carica il tuo schizzo nell'area "Immagine". Nella casella "Prompt", descrivi cosa rappresenta lo schizzo (ad esempio, "Una villa moderna, tramonto, fotorealistico, 8k"). Clicca su Crea per vedere la magia.`,
                    },
                    {
                        question: 'Mantiene il volto/persona originale?',
                        answer: 'Cerca di preservare la struttura generale e la posa. Tuttavia, per una ritenzione precisa del volto, raccomandiamo di utilizzare invece il nostro strumento specifico "Scambio Volto Foto".',
                    },
                    {
                        question: 'Quali proporzioni sono supportate?',
                        answer: `Supportiamo un'ampia gamma di proporzioni inclusi 9:16 (Storia), 16:9 (Cinematografico), 3:4 e 1:1, assicurando che la tua arte generata si adatti perfettamente a qualsiasi piattaforma.`,
                    },
                    {
                        question: 'È gratuito?',
                        answer: 'Sì, puoi generare variazioni gratuitamente utilizzando i tuoi crediti giornalieri.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Estensore e Ridimensionatore Immagine IA Gratuito - Scroppare ed Estendere Foto',
            description: `Ridimensiona immagini per Instagram, TikTok e YouTube senza ritagliare. L'Estensore Immagine IA di 微鲤AI usa riempimento generativo (estensione) per espandere intelligentemente i fondi delle immagini. Cambia proporzioni senza problemi.`,
            keywords: 'estensore immagine ai, scroppare immagine, estensione ai, ridimensionatore immagine ai, espandere fondo immagine, riempimento generativo online, fare foto verticale',
            og_title: 'Estensore e Ridimensionatore Immagine IA Gratuito - Scroppare ed Estendere Foto',
            og_description: `Ridimensiona immagini per Instagram, TikTok e YouTube senza ritagliare. L'Estensore Immagine IA di 微鲤AI usa riempimento generativo (estensione) per espandere intelligentemente i fondi delle immagini. Cambia proporzioni senza problemi.`,
            twitter_title: 'Estensore e Ridimensionatore Immagine IA Gratuito - Scroppare ed Estendere Foto',
            twitter_description: `Ridimensiona immagini per Instagram, TikTok e YouTube senza ritagliare. L'Estensore Immagine IA di 微鲤AI usa riempimento generativo (estensione) per espandere intelligentemente i fondi delle immagini. Cambia proporzioni senza problemi.`,
            page: {
                title1: 'Estensore e Ridimensionatore Immagine IA Gratuito',
                title2: `Smetti di ritagliare le tue foto preferite per adattarle ai social media. Che tu debba trasformare una foto orizzontale in una Storia verticale o espandere un'immagine quadrata a 16:9, il nostro Estensore Immagine IA genera magicamente nuovi dettagli di sfondo (Estensione) per adattarsi perfettamente a qualsiasi proporzione.`,
                faq: [
                    {
                        question: `Come ridimensionare un'immagine senza ritagliare?`,
                        answer: `Usa l'Estensore Immagine IA di 微鲤AI. Carica la tua foto, seleziona la proporzione target (ad esempio, 9:16), e l'IA genererà automaticamente (estenderà) le aree di sfondo mancanti invece di ritagliare la tua immagine.`,
                    },
                    {
                        question: `Cos'è l'Estensione IA?`,
                        answer: `L'estensione è una tecnologia di IA generativa che espande i bordi di un'immagine prevedendo e disegnando nuovo contenuto che corrisponde allo stile originale, "scroppando" efficacemente la foto.`,
                    },
                    {
                        question: 'Posso trasformare una foto orizzontale in verticale?',
                        answer: `Sì! Basta caricare la tua foto orizzontale (paesaggio) e selezionare la proporzione 9:16. L'IA estenderà la parte superiore e inferiore dell'immagine per riempire la cornice verticale.`,
                    },
                    {
                        question: 'Lo sfondo esteso sembrerà falso?',
                        answer: `微鲤AI usa modelli generativi avanzati addestrati su set di dati massicci per assicurare che lo sfondo esteso si fonda naturalmente con l'illuminazione e la texture originali.`,
                    },
                    {
                        question: 'È gratuito da usare?',
                        answer: 'Sì, gli utenti ricevono crediti gratuiti per provare le funzionalità di Ridimensionamento Intelligente IA e Estensione.',
                    },
                ],
            },
            faq: [
                {
                    question: `Come ridimensionare un'immagine senza ritagliare?`,
                    answer: `Usa l'Estensore Immagine IA di 微鲤AI. Carica la tua foto, seleziona la proporzione target (ad esempio, 9:16), e l'IA genererà automaticamente (estenderà) le aree di sfondo mancanti invece di ritagliare la tua immagine.`,
                },
                {
                    question: `Cos'è l'Estensione IA?`,
                    answer: `L'estensione è una tecnologia di IA generativa che espande i bordi di un'immagine prevedendo e disegnando nuovo contenuto che corrisponde allo stile originale, "scroppando" efficacemente la foto.`,
                },
                {
                    question: 'Posso trasformare una foto orizzontale in verticale?',
                    answer: `Sì! Basta caricare la tua foto orizzontale (paesaggio) e selezionare la proporzione 9:16. L'IA estenderà la parte superiore e inferiore dell'immagine per riempire la cornice verticale.`,
                },
                {
                    question: 'Lo sfondo esteso sembrerà falso?',
                    answer: `微鲤AI usa modelli generativi avanzati addestrati su set di dati massicci per assicurare che lo sfondo esteso si fonda naturalmente con l'illuminazione e la texture originali.`,
                },
                {
                    question: 'È gratuito da usare?',
                    answer: 'Sì, gli utenti ricevono crediti gratuiti per provare le funzionalità di Ridimensionamento Intelligente IA e Estensione.',
                },
            ],
            feature_title1: 'Estensione Intelligente dello Sfondo',
            feature_desc1: `Estensione Magica: L'IA comprende il contesto della tua immagine e dipinge nuovi pixel oltre i bordi originali. Espandi paesaggi, stanze o texture senza problemi per riempire la cornice.`,
            feature_title2: 'Protezione del Centro',
            feature_desc2: `Mai Ritagliare il Soggetto: La nostra IA identifica automaticamente la persona o l'oggetto principale e li blocca al centro, assicurando che non vengano mai tagliati durante il processo di ridimensionamento.`,
            feature_title3: 'Pronto per i Social Media',
            feature_desc3: 'Preimpostazioni con un clic per Instagram Stories (9:16), Miniature YouTube (16:9) e Post (4:5). Riusa il tuo contenuto su tutte le piattaforme istantaneamente.',
        },
        imageTextTranslate: {
            title: 'Traduttore Immagine IA Gratuito - Traduci Testo in Foto, Manga e Fumetti',
            description: 'Traduci testo nelle immagini istantaneamente preservando lo stile visivo originale. Il Traduttore Immagine IA di 微鲤AI cancella automaticamente il testo originale e ridisegna le traduzioni. Perfetto per fumetti, manga e poster di marketing.',
            keywords: 'traduttore immagine ai, tradurre testo immagine, traduttore immagini, traduttore manga, tradurre fumetti, traduttore ocr, sostituzione testo immagine',
            og_title: 'Traduttore Immagine IA Gratuito - Traduci Testo in Foto, Manga e Fumetti',
            og_description: 'Traduci testo nelle immagini istantaneamente preservando lo stile visivo originale. Il Traduttore Immagine IA di 微鲤AI cancella automaticamente il testo originale e ridisegna le traduzioni. Perfetto per fumetti, manga e poster di marketing.',
            twitter_title: 'Traduttore Immagine IA Gratuito - Traduci Testo in Foto, Manga e Fumetti',
            twitter_description: 'Traduci testo nelle immagini istantaneamente preservando lo stile visivo originale. Il Traduttore Immagine IA di 微鲤AI cancella automaticamente il testo originale e ridisegna le traduzioni. Perfetto per fumetti, manga e poster di marketing.',
            page: {
                title1: 'Traduttore Immagine IA Gratuito e Sostitutore di Testo',
                title2: 'Traduci poster, menu, fumetti e screenshot in secondi. A differenza dei traduttori standard che sovrappongono semplicemente il testo, 微鲤AI usa IA Generativa per cancellare il testo originale e ridisegnare lo sfondo, facendo sembrare il testo tradotto parte del design originale.',
                faq: [
                    {
                        question: `Come traduco il testo all'interno di un'immagine?`,
                        answer: `Carica la tua immagine (JPG, PNG) su 微鲤AI. Seleziona la lingua di origine (o usa Rilevamento Automatico) e la lingua di destinazione. Clicca su "Crea" per far sostituire il testo dall'IA.`,
                    },
                    {
                        question: 'Il testo tradotto sembrerà naturale?',
                        answer: 'Sì. 微鲤AI cerca di corrispondere alla dimensione e allo stile del carattere del testo originale. È cruciale che ridisegni lo sfondo dietro il testo in modo che la traduzione si integri perfettamente.',
                    },
                    {
                        question: 'Posso usare questo per tradurre Manga o Manhwa?',
                        answer: `Assolutamente. Questo è uno dei migliori casi d'uso. L'IA rileva fumetti di dialogo e testo verticale (comune in giapponese), sostituendoli con testo tradotto orizzontale.`,
                    },
                    {
                        question: 'Quali lingue sono supportate?',
                        answer: 'Supportiamo la traduzione tra le principali lingue globali incluse inglese, spagnolo, cinese, giapponese, coreano, francese, tedesco e altro.',
                    },
                    {
                        question: 'Funziona con testo scritto a mano?',
                        answer: 'Funziona meglio con testo stampato, ma il nostro motore OCR avanzato può riconoscere testo scritto a mano chiaro su lavagne o note.',
                    },
                    {
                        question: 'È gratuito?',
                        answer: 'Puoi tradurre immagini gratuitamente usando i tuoi crediti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: `Come traduco il testo all'interno di un'immagine?`,
                    answer: `Carica la tua immagine su 微鲤AI. Seleziona la lingua di destinazione e clicca su 'Crea'. L'IA sostituirà il testo originale con la traduzione.`,
                },
                {
                    question: 'Il testo tradotto sembrerà naturale?',
                    answer: 'Sì. 微鲤AI ridisegna lo sfondo dietro il testo e cerca di corrispondere allo stile del carattere, assicurando che la traduzione si integri perfettamente.',
                },
                {
                    question: 'Posso usare questo per tradurre Manga o Manhwa?',
                    answer: `Assolutamente. Questo è uno dei migliori casi d'uso. L'IA rileva fumetti di dialogo e testo verticale (comune in giapponese), sostituendoli con testo tradotto orizzontale.`,
                },
            ],
            feature_title1: 'Inpainting e Ridisegno Intelligenti',
            feature_desc1: 'Sostituzione Testo Perfetta: La nostra IA analizza la texture dello sfondo dietro il testo. Cancella le parole originali e riempie lo spazio intelligentemente prima di aggiungere la traduzione, assicurando che nessuna brutta casella di testo copra la tua immagine.',
            feature_title2: 'Traduzione Manga e Fumetti',
            feature_desc2: `Leggi Manga Grezzo Istantaneamente: Perfetto per i fan degli anime. Carica pagine di manga grezzo (giapponese/coreano) e ottieni traduzioni istantanee in inglese che si adattano perfettamente all'interno dei fumetti di dialogo.`,
            feature_title3: 'Localizzazione Marketing Globale',
            feature_desc3: 'Localizzazione con Un Clic: Stai lanciando prodotti globalmente? Traduci i tuoi poster di marketing, banner e screenshot UI in oltre 30 lingue senza bisogno dei file PSD originali.',
        },
        aiBackgroundChanger: {
            title: 'Cambia Sfondo IA Gratis - Genera Sfondi dal Testo',
            description: `Cambia lo sfondo delle foto all'istante con l'IA. Descrivi la scena che vuoi e 微鲤AI genererà sfondi realistici per foto prodotto, headshot per LinkedIn e ritratti creativi. Gratis e online.`,
            keywords: 'cambiare sfondo foto, generatore sfondi IA, fotografia prodotto IA, sfondo bianco, sostituire sfondo online, riempimento generativo sfondo',
            og_title: 'Cambia Sfondo IA Gratis - Genera Sfondi dal Testo',
            og_description: `Cambia lo sfondo delle foto all'istante con l'IA. Descrivi la scena che vuoi e 微鲤AI genererà sfondi realistici per foto prodotto, headshot per LinkedIn e ritratti creativi. Gratis e online.`,
            twitter_title: 'Cambia Sfondo IA Gratis - Genera Sfondi dal Testo',
            twitter_description: `Cambia lo sfondo delle foto all'istante con l'IA. Descrivi la scena che vuoi e 微鲤AI genererà sfondi realistici per foto prodotto, headshot per LinkedIn e ritratti creativi. Gratis e online.`,
            page: {
                title1: 'Cambia Sfondo IA Gratis & Generatore',
                title2: 'Non limitarti a rimuovere lo sfondo: sostituiscilo con qualcosa di meglio. Carica la tua foto e descrivi qualsiasi scena (es.: "studio in marmo di lusso", "skyline di uffici"). La nostra IA generativa capisce luce e prospettiva per fondere il soggetto perfettamente nel nuovo ambiente.',
                faq: [
                    {
                        question: 'Come cambio lo sfondo usando il testo?',
                        answer: `Carica la tua immagine e, nella casella "Prompt Sfondo", descrivi la scena che vuoi (es.: "un bar accogliente"). Clicca su Crea e l'IA genererà quello sfondo per te.`,
                    },
                    {
                        question: 'Posso cambiare lo sfondo in bianco puro?',
                        answer: 'Sì. Basta digitare "pure white background" o "studio white" nel prompt. È perfetto per le schede prodotto Amazon/eBay e per le foto documento.',
                    },
                    {
                        question: 'È adatto alla fotografia di prodotto?',
                        answer: `Assolutamente. 微鲤AI analizza l'angolazione del prodotto e genera sfondi con ombre e illuminazione corrette, facendolo sembrare uno shooting professionale.`,
                    },
                    {
                        question: `L'illuminazione sembrerà naturale?`,
                        answer: `La nostra IA generativa (simile ad Adobe Firefly o SDXL) prova ad abbinare l'illuminazione dello sfondo generato al soggetto, fondendoli in modo naturale.`,
                    },
                    {
                        question: 'È gratis?',
                        answer: 'Sì, puoi generare nuovi sfondi gratuitamente usando i tuoi crediti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come cambio lo sfondo usando il testo?',
                    answer: `Carica la tua immagine e, nella casella "Prompt Sfondo", descrivi la scena che vuoi (es.: "un bar accogliente"). Clicca su Crea e l'IA genererà quello sfondo per te.`,
                },
                {
                    question: 'Posso cambiare lo sfondo in bianco puro?',
                    answer: 'Sì. Basta digitare "pure white background" o "studio white" nel prompt. È perfetto per le schede prodotto Amazon/eBay e per le foto documento.',
                },
                {
                    question: 'È adatto alla fotografia di prodotto?',
                    answer: `Assolutamente. 微鲤AI analizza l'angolazione del prodotto e genera sfondi con ombre e illuminazione corrette, facendolo sembrare uno shooting professionale.`,
                },
                {
                    question: `L'illuminazione sembrerà naturale?`,
                    answer: `La nostra IA generativa (simile ad Adobe Firefly o SDXL) prova ad abbinare l'illuminazione dello sfondo generato al soggetto, fondendoli in modo naturale.`,
                },
                {
                    question: 'È gratis?',
                    answer: 'Sì, puoi generare nuovi sfondi gratuitamente usando i tuoi crediti giornalieri.',
                },
            ],
            feature_title1: 'Foto Professionali per ID',
            feature_desc1: 'Headshot LinkedIn fai-da-te: Trasforma una selfie casual in una foto profilo professionale. Cambia al volo uno sfondo disordinato della camera in un ufficio pulito o in un grigio da studio.',
            feature_title2: 'Fotografia di Prodotto Istantanea',
            feature_desc2: `Aumenta le vendite e-commerce: Risparmia migliaia in shooting. Metti il prodotto su un tavolo in legno, una spiaggia sabbiosa o un piedistallo con semplici prompt. L'IA aggiunge ombre e riflessi realistici.`,
            feature_title3: 'Teletrasporto Creativo',
            feature_desc3: 'Viaggia ovunque: Vuoi essere a Parigi o in un futuro cyberpunk? Scrivilo e basta. La nostra IA sostituisce lo sfondo mantenendo la coerenza della luce della foto originale.',
        },
        imageUpscaler: {
            title: 'Upscaler Immagini IA Gratis - Ingrandisci a 4K e Restaura Vecchie Foto',
            description: 'Ingrandisci istantaneamente immagini a bassa risoluzione a 2x, 4x e fino a 4K con il Miglioratore Immagini IA Gratis di 微鲤AI. Sistema foto sfocate, rimuovi il rumore e restaura online vecchie foto di famiglia. Qualità senza perdita.',
            keywords: 'upscaler immagini IA, miglioratore foto, ingrandire immagine a 4k, rimuovere sfocatura, restauro vecchie foto, correggere foto pixelata, aumentare risoluzione immagine',
            og_title: 'Upscaler Immagini IA Gratis - Ingrandisci a 4K e Restaura Vecchie Foto',
            og_description: 'Ingrandisci istantaneamente immagini a bassa risoluzione a 2x, 4x e fino a 4K con il Miglioratore Immagini IA Gratis di 微鲤AI. Sistema foto sfocate, rimuovi il rumore e restaura online vecchie foto di famiglia. Qualità senza perdita.',
            twitter_title: 'Upscaler Immagini IA Gratis - Ingrandisci a 4K e Restaura Vecchie Foto',
            twitter_description: 'Ingrandisci istantaneamente immagini a bassa risoluzione a 2x, 4x e fino a 4K con il Miglioratore Immagini IA Gratis di 微鲤AI. Sistema foto sfocate, rimuovi il rumore e restaura online vecchie foto di famiglia. Qualità senza perdita.',
            page: {
                title1: 'Upscaler e Miglioratore Immagini IA Gratis',
                title2: 'Trasforma foto pixelate, sfocate o vecchie in capolavori ad alta definizione. 微鲤AI usa IA avanzata per aumentare la risoluzione fino al 400% (4K), recuperando dettagli persi, correggendo il rumore e restaurando i volti nei vecchi ritratti di famiglia.',
                faq: [
                    {
                        question: 'Posso ingrandire immagini a bassa risoluzione per la stampa?',
                        answer: 'Sì! 微鲤AI aumenta la risoluzione (numero di pixel) fino a 4K, rendendola adatta a stampe di alta qualità su poster, tela o materiali di marketing.',
                    },
                    {
                        question: 'Come funziona il restauro di vecchie foto con IA?',
                        answer: `L'IA analizza le parti danneggiate o sfocate della foto e usa il deep learning per prevedere e ricostruire dettagli del viso, texture e sfondi, “guarendo” l'immagine.`,
                    },
                    {
                        question: 'Quali formati sono supportati?',
                        answer: `Supportiamo formati comuni come JPG, PNG e WEBP. L'output sarà un PNG o JPG di alta qualità.`,
                    },
                    {
                        question: 'Funziona con anime/cartoni?',
                        answer: `Sì. La nostra IA eccelle nell'upscaling di anime e illustrazioni (stile waifu2x), mantenendo linee nitide e colori vivaci senza artefatti.`,
                    },
                    {
                        question: 'È gratis?',
                        answer: 'Sì, puoi migliorare immagini gratuitamente usando i tuoi crediti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso ingrandire immagini a bassa risoluzione per la stampa?',
                    answer: 'Sì! 微鲤AI aumenta la risoluzione fino a 4K, rendendo le immagini adatte alla stampa di alta qualità.',
                },
                {
                    question: 'Come funziona il restauro di vecchie foto con IA?',
                    answer: `L'IA analizza le aree danneggiate e ricostruisce dettagli del viso e texture con il deep learning per “guarire” l'immagine.`,
                },
                {
                    question: 'Funziona con anime?',
                    answer: `Sì. La nostra IA eccelle nell'upscaling di anime e illustrazioni, mantenendo linee nitide senza artefatti.`,
                },
            ],
            feature_title1: 'Upscaling Senza Perdita fino a 4K',
            feature_desc1: `Qualità Pronta per la Stampa: Devi stampare un'immagine piccola? Ingrandiscila a 4K o 8K senza perdere qualità. Perfetto per poster, foto prodotto e-commerce e wallpaper.`,
            feature_title2: 'Riduzione Rumore & Deblur Intelligenti',
            feature_desc2: `Sistema le Foto Notturne: Rimuovi rumore digitale e grana dalle foto in scarsa luce. Rendi nitidi i bordi sfocati all'istante per foto più chiare e professionali.`,
            feature_title3: 'Restauro di Vecchie Foto',
            feature_desc3: 'Ravviva i Ricordi: Hai foto vecchie, danneggiate o in bianco e nero? La nostra IA crea nuovi pixel per riparare graffi, rendere i volti più nitidi e riportare chiarezza ai tuoi ricordi.',
        },
        photoFaceSwap: {
            title: 'Face Swap IA Gratis Online - Scambio Volto Realistico | 微鲤AI',
            description: `Scambia volti nelle foto all'istante con il Face Swapper IA gratuito di 微鲤AI. Crea meme divertenti, ritratti artistici (Mona Lisa) o headshot professionali con alto realismo. 100% privato e sicuro.`,
            keywords: 'face swap IA, scambio volto online, cambia volto foto, reface gratis, sostituire volto in immagine, deepfake foto, meme maker IA',
            og_title: 'Face Swap IA Gratis Online - Scambio Volto Realistico | 微鲤AI',
            og_description: `Scambia volti nelle foto all'istante con il Face Swapper IA gratuito di 微鲤AI. Crea meme divertenti, ritratti artistici (Mona Lisa) o headshot professionali con alto realismo. 100% privato e sicuro.`,
            twitter_title: 'Face Swap IA Gratis Online - Scambio Volto Realistico | 微鲤AI',
            twitter_description: `Scambia volti nelle foto all'istante con il Face Swapper IA gratuito di 微鲤AI. Crea meme divertenti, ritratti artistici (Mona Lisa) o headshot professionali con alto realismo. 100% privato e sicuro.`,
            page: {
                title1: 'Face Swap Foto IA Gratis',
                title2: 'Vuoi vederti come astronauta, star del cinema o dentro un dipinto classico? Carica una foto base e un volto target: la nostra IA fonde tratti del viso, illuminazione e tonalità della pelle per un face swap iper-realistico in pochi secondi.',
                faq: [
                    {
                        question: '微鲤AI Face Swap è gratuito?',
                        answer: 'Sì, offriamo crediti giornalieri gratuiti per scambiare volti nelle foto online. Nessuna installazione e nessuna carta richiesta.',
                    },
                    {
                        question: 'I miei dati sono al sicuro?',
                        answer: 'Assolutamente. La privacy è una priorità. Le foto caricate sono usate solo per lo scambio e vengono eliminate automaticamente dai nostri server dopo poco tempo.',
                    },
                    {
                        question: 'Come ottenere i migliori risultati?',
                        answer: `Per un risultato più realistico, assicurati che sia l'“Immagine Base” che l'“Immagine Volto” siano nitide, frontali e ben illuminate. Evita foto con il volto coperto da capelli o mani.`,
                    },
                    {
                        question: 'Posso scambiare volti in foto di gruppo?',
                        answer: `Al momento ci concentriamo sulla precisione con un solo volto. Per foto di gruppo, ritaglia l'immagine o usa la prossima funzione multi-volto.`,
                    },
                    {
                        question: 'Posso usarlo per i meme?',
                        answer: 'Sì! È perfetto per meme divertenti. Scambia il volto di un amico su un poster di un film o su un template virale in un attimo.',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI Face Swap è gratuito?',
                    answer: 'Sì, offriamo crediti giornalieri gratuiti per face swap online. Nessuna installazione e nessuna carta richiesta.',
                },
                {
                    question: 'I miei dati sono al sicuro?',
                    answer: 'Sì. Le foto sono usate solo per lo scambio e vengono eliminate automaticamente dopo poco tempo.',
                },
                {
                    question: 'Come ottenere i migliori risultati?',
                    answer: 'Assicurati che entrambe le foto siano nitide, frontali e ben illuminate. Evita volti coperti da capelli o occhiali.',
                },
            ],
            feature_title1: 'Capolavori Artistici',
            feature_desc1: `Viaggio nel tempo: Scambia il tuo volto in dipinti classici come la Mona Lisa o La ragazza con l'orecchino di perla. Crea avatar vintage unici in pochi secondi.`,
            feature_title2: 'Avatar Professionali e Cool',
            feature_desc2: 'Lavori da sogno: Vediti in tuta da corsa, equipaggiamento da astronauta o abbigliamento business senza comprare costumi. Perfetto per foto profilo che spiccano.',
            feature_title3: 'Fusione Iper-realistica',
            feature_desc3: 'Niente effetto “incollato”: A differenza del semplice ritaglia-e-incolla, 微鲤AI analizza angolo, luce e texture della pelle per un risultato 100% naturale, non finto.',
        },
        removeTextFromImage: {
            title: 'Rimuovi Testo con IA Gratis - Elimina Filigrane e Date | 微鲤AI',
            description: 'Rimuovi istantaneamente testo, date, loghi e didascalie con la Gomma Testo IA gratuita di 微鲤AI. Ripristina lo sfondo perfettamente con AI Inpainting. Ideale per ripulire foto e mockup e-commerce.',
            keywords: 'rimuovi testo da immagine, rimuovi testo IA, rimuovere timbro data, rimuovere filigrana online, pulire foto, AI inpainting, rimuovere logo da foto',
            og_title: 'Rimuovi Testo con IA Gratis - Elimina Filigrane e Date | 微鲤AI',
            og_description: 'Rimuovi istantaneamente testo, date, loghi e didascalie con la Gomma Testo IA gratuita di 微鲤AI. Ripristina lo sfondo perfettamente con AI Inpainting. Ideale per ripulire foto e mockup e-commerce.',
            twitter_title: 'Rimuovi Testo con IA Gratis - Elimina Filigrane e Date | 微鲤AI',
            twitter_description: 'Rimuovi istantaneamente testo, date, loghi e didascalie con la Gomma Testo IA gratuita di 微鲤AI. Ripristina lo sfondo perfettamente con AI Inpainting. Ideale per ripulire foto e mockup e-commerce.',
            page: {
                title1: 'Rimuovi Testo da Immagine con IA Gratis',
                title2: `Distratto da testo indesiderato? Carica l'immagine e la nostra IA rileverà e cancellerà testo, loghi, timbri data o didascalie all'istante. Analizza i pixel intorno per ricostruire lo sfondo senza lasciare tracce.`,
                faq: [
                    {
                        question: `Come rimuovere testo senza sfocare l'immagine?`,
                        answer: `Usa il Rimuovi Testo IA di 微鲤AI. Invece di sfocare, utilizza AI Inpainting per analizzare l'area e generare nuovi pixel che riempiono il vuoto in modo naturale.`,
                    },
                    {
                        question: 'Posso rimuovere i timbri data dalle foto?',
                        answer: `Sì! È un caso d'uso perfetto. L'IA riconosce il font digitale di data/ora e lo rimuove ripristinando il paesaggio dietro.`,
                    },
                    {
                        question: 'Funziona su sfondi complessi?',
                        answer: 'Sì. Può rimuovere testo anche su sfondi complessi come montagne o vestiti con pattern, capendo il flusso delle texture.',
                    },
                    {
                        question: 'Posso rimuovere persone o oggetti?',
                        answer: 'Anche se ottimizzato per il testo, la tecnologia base (Inpainting) funziona bene anche per rimuovere piccoli oggetti, imperfezioni della pelle o disordine.',
                    },
                    {
                        question: 'È gratis?',
                        answer: 'Sì, puoi usarlo gratis con i crediti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: `Come rimuovere testo senza sfocare l'immagine?`,
                    answer: `Usa il Rimuovi Testo IA di 微鲤AI. AI Inpainting genera nuovi pixel per riempire l'area in modo naturale.`,
                },
                {
                    question: 'Posso rimuovere i timbri data dalle foto?',
                    answer: `Sì! L'IA riconosce data/ora e li rimuove ripristinando lo sfondo.`,
                },
                {
                    question: 'Funziona su sfondi complessi?',
                    answer: 'Sì. Capisce il flusso delle texture e rimuove testo anche su sfondi complessi.',
                },
            ],
            feature_title1: 'Pulizia Abbigliamento & Design',
            feature_desc1: 'Perfetto per mockup: Rivendi vestiti online? Rimuovi loghi, slogan o grafiche dalle foto di magliette per creare una base pulita per i tuoi design.',
            feature_title2: 'Restauro dei Ricordi',
            feature_desc2: 'Elimina timbri data: Rimuovi i fastidiosi timbri arancioni di data dalle vecchie foto di famiglia o di viaggio senza rovinare lo scenario.',
            feature_title3: 'Inpainting Intelligente',
            feature_desc3: `Riempimento Sfondo Senza Giunture: A differenza delle gomme base che lasciano sfocature, 微鲤AI usa IA generativa per “dipingerе” texture realistiche (erba, cielo, montagne) nell'area cancellata.`,
        },
        imgExtender: {
            title: 'Espandi Immagini Gratis Subito - Estensore Immagini con IA | 微鲤AI',
            description: 'Con l’Estensore Immagini con IA gratuito di 微鲤AI, supera subito i bordi originali della tua foto. Il nostro outpainting genera nuovi pixel che si fondono perfettamente con l’immagine caricata, trasformando ritratti in scatti grandangolari mantenendo aspetto e qualità.',
            keywords: 'estensore immagini IA, espandere immagine gratis, foto grandangolare, estendere bordi foto, outpainting senza giunture, mantenere qualità',
            og_title: 'Espandi Immagini Gratis Subito - Estensore Immagini con IA | 微鲤AI',
            og_description: 'Espandi le tue foto a nuove dimensioni e genera contenuti coerenti. Prova l’Estensore Immagini con IA gratis.',
            twitter_title: 'Espandi Immagini Gratis Subito - Estensore Immagini con IA | 微鲤AI',
            twitter_description: 'Espandi le tue foto a nuove dimensioni e genera contenuti coerenti. Prova l’Estensore Immagini con IA gratis.',
            featureList: [
                'estensore immagini IA, espandere immagine gratis, grandangolo, mantenere qualità',
            ],
            page: {
                title1: 'Un potente Estensore Immagini con IA, risultati sorprendenti',
                title2: 'Con pochi clic, espandi oltre i bordi originali. L’IA genera nuovi pixel che si fondono con l’upload per un risultato naturale e in alta qualità.',
                feature_title: 'Cosa rende speciale l’Estensore Immagini 微鲤AI',
                faq: [
                    {
                        question: 'Cos’è un Estensore Immagini con IA?',
                        answer: 'È uno strumento che usa IA avanzata per estendere i bordi di un’immagine riempiendo in modo intelligente il contenuto mancante. Utile per marketing, e‑commerce e social media.',
                    },
                    {
                        question: 'Perché usare il nostro Estensore Immagini con IA?',
                        answer: '微鲤AI analizza le caratteristiche dell’immagine e fa outpainting naturale in alta definizione, senza giunture visibili.',
                    },
                    {
                        question: 'È gratis?',
                        answer: 'Sì. Puoi usarlo gratuitamente con crediti di prova: una soluzione economica per qualsiasi workflow.',
                    },
                    {
                        question: 'Quanto è veloce?',
                        answer: 'Di solito bastano pochi secondi, ideale per modifiche rapide e batch.',
                    },
                    {
                        question: 'Influisce su risoluzione o qualità?',
                        answer: 'No. Mantiene risoluzione, nitidezza e dettagli durante l’espansione.',
                    },
                    {
                        question: 'Le mie immagini restano private?',
                        answer: 'Sì. Proteggiamo i dati con sicurezza standard di settore e policy rigorose, senza condivisione con terzi.',
                    },
                    {
                        question: 'Quali formati sono supportati?',
                        answer: 'JPG, PNG, WebP e formati comuni. Dimensione massima: 10MB. Nessuna conversione richiesta.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Cos’è un Estensore Immagini con IA?',
                    answer: 'È uno strumento che usa IA avanzata per estendere i bordi di un’immagine riempiendo in modo intelligente il contenuto mancante. Utile per marketing, e‑commerce e social media.',
                },
                {
                    question: 'Perché usare il nostro Estensore Immagini con IA?',
                    answer: '微鲤AI analizza le caratteristiche dell’immagine e fa outpainting naturale in alta definizione, senza giunture visibili.',
                },
                {
                    question: 'È gratis?',
                    answer: 'Sì. Gratis con crediti di prova.',
                },
                {
                    question: 'Quanto è veloce?',
                    answer: 'Di solito in pochi secondi.',
                },
                {
                    question: 'Influisce su risoluzione o qualità?',
                    answer: 'No. Qualità e dettagli restano intatti.',
                },
                {
                    question: 'Le mie immagini restano private?',
                    answer: 'Sì. I tuoi dati sono protetti e non condivisi.',
                },
                {
                    question: 'Quali formati sono supportati?',
                    answer: 'JPG, PNG, WebP (max 10MB).',
                },
            ],
            feature_title1: 'Ripara dettagli e sfondi mancanti',
            feature_desc1: 'Se l’immagine è stata ritagliata, riempi le aree mancanti per rendere la scena più completa. L’outpainting può anche recuperare elementi persi in vecchie foto.',
            feature_title2: 'Migliora foto prodotto per aumentare le vendite',
            feature_desc2: 'Espandi l’area intorno al prodotto per aggiungere elementi di sfondo coerenti. Crea anche composizioni più ampie per mostrare più dettagli.',
            feature_title3: 'Crea capolavori visivi unici',
            feature_desc3: 'Fotografi, creator e artisti possono superare i confini e trasformare le idee in visual sorprendenti.',
            feature_title4: 'Ottimizza i rapporti per i social',
            feature_desc4: 'Espandi immagini per qualsiasi proporzione su Instagram, X (ex Twitter), Facebook e altro. L’IA mantiene nitidezza e dettagli per un risultato che colpisce.',
            textRemoverHowToUseTitle: 'Come usare il nostro Estensore Immagini con IA',
            textRemoverHowToUseDesc: '3 semplici passi per espandere la tua foto oltre i bordi',
            textRemoverHowToUseStep1Title: 'Carica un’immagine',
            textRemoverHowToUseStep1Desc: 'Clicca o trascina e rilascia l’immagine che vuoi espandere.',
            textRemoverHowToUseStep2Title: 'Elaborazione automatica IA',
            textRemoverHowToUseStep2Desc: 'Dopo il caricamento, l’IA rileva ed estende automaticamente i bordi.',
            textRemoverHowToUseStep3Title: 'Scarica l’immagine espansa',
            textRemoverHowToUseStep3Desc: 'A processo completato, visualizza e scarica l’immagine espansa!',
        },
        photoRestoration: {
            title: 'Restauro Foto AI Gratis - Colora B/N e Ripara Graffi | 微鲤AI',
            description: 'Ravviva i ricordi di famiglia con il Restauro Foto AI gratuito di 微鲤AI. Colora automaticamente le foto in bianco e nero, rimuove graffi, strappi e sfocature per ripristinare i volti in pochi secondi.',
            keywords: 'restauro foto antiche, colorare foto, riparare foto graffiate, riparazione foto AI, restaurare vecchie foto, bianco e nero a colori, restauro immagini AI',
            og_title: 'Restauro Foto AI Gratis - Colora B/N e Ripara Graffi | 微鲤AI',
            og_description: 'Ravviva i ricordi di famiglia con il Restauro Foto AI gratuito di 微鲤AI. Colora automaticamente le foto in bianco e nero, rimuove graffi, strappi e sfocature per ripristinare i volti in pochi secondi.',
            twitter_title: 'Restauro Foto AI Gratis - Colora B/N e Ripara Graffi | 微鲤AI',
            twitter_description: 'Ravviva i ricordi di famiglia con il Restauro Foto AI gratuito di 微鲤AI. Colora automaticamente le foto in bianco e nero, rimuove graffi, strappi e sfocature per ripristinare i volti in pochi secondi.',
            page: {
                title1: 'Restauro e Colorazione di Vecchie Foto con AI (Gratis)',
                title2: `Riporta in vita la tua storia. Che sia una foto di matrimonio in bianco e nero sbiadita o un ritratto d'infanzia graffiato, la nostra AI analizza e ripristina le aree danneggiate, rende i volti più nitidi e aggiunge colori realistici in pochi secondi.`,
                faq: [
                    {
                        question: 'Come posso colorare una foto in bianco e nero?',
                        answer: 'Carica la tua immagine B/N su 微鲤AI. Lo strumento rileva automaticamente la scala di grigi e applica la funzione “Colorizza” per aggiungere colori realistici subito.',
                    },
                    {
                        question: 'Può riparare foto strappate o graffiate?',
                        answer: 'Sì. La nostra AI riconosce graffi, strappi e pieghe e riempie le aree danneggiate con pixel che corrispondono alla texture circostante.',
                    },
                    {
                        question: 'La foto restaurata sembrerà finta?',
                        answer: `Il nostro obiettivo è il realismo. Il miglioramento del volto aggiunge dettagli mantenendo l'identità riconoscibile. Nella colorazione, l'AI sceglie tonalità naturali adatte all'epoca.`,
                    },
                    {
                        question: 'E se la foto è molto piccola?',
                        answer: `Nessun problema. Il processo include anche l'Upscaling, che aumenta la risoluzione delle foto piccole per la visualizzazione digitale o la stampa.`,
                    },
                    {
                        question: 'La mia privacy è protetta?',
                        answer: 'Sì. Sappiamo che le vecchie foto sono personali. Le tue immagini vengono elaborate in modo sicuro e non vengono conservate in modo permanente sui nostri server.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come posso colorare una foto in bianco e nero?',
                    answer: `Carica la foto B/N: la funzione “Colorizza” aggiunge colori realistici all'istante.`,
                },
                {
                    question: 'Può riparare foto strappate o graffiate?',
                    answer: `Sì. L'AI rileva i danni e li ricostruisce rispettando la texture intorno.`,
                },
                {
                    question: 'La foto restaurata sembrerà finta?',
                    answer: `Puntiamo al realismo, mantenendo l'identità e applicando colori naturali.`,
                },
            ],
            feature_title1: 'Rimozione Graffi & Strappi',
            feature_desc1: `Cancella i segni del tempo: rileva e riempie automaticamente pieghe, graffi, strappi e macchie di polvere. L'AI ricostruisce dettagli facciali mancanti per far sembrare la foto come nuova.`,
            feature_title2: 'Colorazione Intelligente',
            feature_desc2: 'Da B/N a Colore: non è un filtro seppia. Il nostro modello capisce il contesto (cielo, pelle, tessuti) e aggiunge colori vividi e realistici alle foto in bianco e nero.',
            feature_title3: 'Miglioramento del Volto',
            feature_desc3: 'Rendi nitidi i volti: le vecchie foto spesso soffrono di mosso o scarsa messa a fuoco. 微鲤AI migliora i tratti (occhi, naso, bocca) per rivelare la vera somiglianza.',
        },
        photoEffects: {
            title: 'Effetti Immagine - Generatore di Effetti Immagine IA | 微鲤AI',
            description: 'Trasforma le tue foto con effetti alimentati da IA. Crea filtri di immagine, stili e trasformazioni straordinarie online gratuitamente.',
            keywords: 'effetti immagine IA, effetti immagine, filtro foto, trasformazione immagine IA, trasferimento stile immagine',
        },
    },
    ar: {
        textToImage: {
            title: 'مولد صور بالذكاء الاصطناعي مجاني من النص - أنشئ فن 4K وصور واقعية | 微鲤AI',
            description: 'حوّل أوصاف النص إلى مرئيات مذهلة باستخدام مولد الصور من النص من 微鲤AI. يتضمن نموذج Nano Banana Pro للحصول على نتائج عالية الجودة. يدعم دقة 1K/2K/4K ونسب 9:16/16:9. مجاني وعبر الإنترنت.',
            keywords: 'نص إلى صورة, مولد صور بالذكاء الاصطناعي, مولد فن بالذكاء الاصطناعي, صور 4K بالذكاء الاصطناعي, نموذج nano banana, flux ai مجاني, مولد خلفية, إنشاء صور من النص',
            og_title: 'مولد صور بالذكاء الاصطناعي مجاني من النص - أنشئ فن 4K وصور واقعية | 微鲤AI',
            og_description: 'حوّل أوصاف النص إلى مرئيات مذهلة باستخدام مولد الصور من النص من 微鲤AI. يتضمن نموذج Nano Banana Pro للحصول على نتائج عالية الجودة. يدعم دقة 1K/2K/4K ونسب 9:16/16:9. مجاني وعبر الإنترنت.',
            twitter_title: 'مولد صور بالذكاء الاصطناعي مجاني من النص - أنشئ فن 4K وصور واقعية | 微鲤AI',
            twitter_description: 'حوّل أوصاف النص إلى مرئيات مذهلة باستخدام مولد الصور من النص من 微鲤AI. يتضمن نموذج Nano Banana Pro للحصول على نتائج عالية الجودة. يدعم دقة 1K/2K/4K ونسب 9:16/16:9. مجاني وعبر الإنترنت.',
            faq: [
                {
                    question: 'كيف يمكنني إنشاء صور بالذكاء الاصطناعي بدقة 4K؟',
                    answer: 'ما عليك سوى إدخال وصفك وتحديد "4K" في إعدادات حجم الصورة في اللوحة اليسرى قبل النقر على إنشاء.',
                },
                {
                    question: 'ما هي نسب العرض إلى الارتفاع المدعومة؟',
                    answer: 'ندعم جميع النسب الرئيسية بما في ذلك 1:1 و 9:16 (الهاتف المحمول) و 16:9 (سطح المكتب) و 4:3 و 3:2 لتناسب أي منصة.',
                },
                {
                    question: 'هل يمكنني استخدام الصور تجاريًا؟',
                    answer: 'نعم. عادةً ما تأتي الصور المُنشأة على خطط 微鲤AI مع ترخيص تجاري مناسب للإعلانات والسلع.',
                },
            ],
            page: {
                title1: 'مولد صور بالذكاء الاصطناعي مجاني من النص',
                title2: 'أنشئ أعمالًا فنية مذهلة وصورًا فوتوغرافية واقعية وخلفيات فريدة في ثوانٍ. ما عليك سوى وصف ما تريد رؤيته، وسيقوم نموذجنا المتقدم Nano Banana Pro بإنشاء صور 4K عالية الجودة تتطابق تمامًا مع وصفك.',
                resolution: 'توقف عن الرضا بصور الذكاء الاصطناعي الضبابية. يتيح لك 微鲤AI إنشاء صور واضحة بدقة 1K و 2K و 4K مباشرة، مثالية للطباعة أو الشاشات عالية الدقة.',
                aspectRatio: 'سواء كنت بحاجة إلى صورة 9:16 لخلفيات TikTok أو 16:9 لمصغرات YouTube أو 1:1 لـ Instagram، لدينا إعدادات مسبقة لكل منصة اجتماعية.',
                online_search: 'هل تحتاج إلى سياق محدث؟ فعّل "البحث عبر الإنترنت" للسماح للذكاء الاصطناعي بالتصفح على الويب لفهم أفضل للأحداث الحالية أو المراجع المحددة في وصفك.',
                faq: [
                    {
                        question: 'كيف أنشئ صورًا عالية الجودة من النص؟',
                        answer: 'أدخل وصفًا مفصلاً يصف الموضوع والإضاءة والأسلوب. حدد "4K" في إعدادات حجم الصورة للحصول على أدق التفاصيل.',
                    },
                    {
                        question: 'ما هو نموذج Nano Banana Pro؟',
                        answer: 'Nano Banana Pro هو نموذجنا الأعلى جودة، محسّن للالتزام بالوصف والواقعية الفوتوغرافية. ينافس في الجودة مع أفضل النماذج مثل Midjourney v6 و Flux.',
                    },
                    {
                        question: 'هل يمكنني استخدام الصور لأغراض تجارية؟',
                        answer: 'نعم. تأتي الصور المُنشأة على 微鲤AI (الخطط المدفوعة) مع ترخيص تجاري، مما يسمح لك باستخدامها للإعلانات والمواقع الإلكترونية والسلع.',
                    },
                    {
                        question: 'كم عدد الصور التي يمكنني إنشاؤها في وقت واحد؟',
                        answer: 'يمكنك إنشاء ما يصل إلى 4 صور في وقت واحد (كما هو موضح في إعداد "عدد صور الإخراج")، مما يسمح لك بالتكرار بسرعة على الأفكار.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يمكنك إنشاء الصور باستخدام رصيدنا اليومي المجاني. قد تتطلب الدقات الأعلى (4K) المزيد من الرصيد.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'مولد صور إلى صور بالذكاء الاصطناعي مجاني - حوّل الصور إلى فن و 4K | 微鲤AI',
            description: 'قم بتحميل صورة مرجعية وقم بتحويلها باستخدام ذكاء 微鲤AI الاصطناعي للصور إلى صور. حوّل الرسوم التخطيطية إلى فن واقعي، أو غيّر الأنماط، أو أنشئ متغيرات مع الحفاظ على التكوين الأصلي. يدعم دقة 4K.',
            keywords: 'صور إلى صور ai, img2img, تحويل صورة إلى رسم, متغير صورة ai, رسم تخطيطي إلى صورة, إعادة مزج صورة ai, مولد فن ai مجاني',
            og_title: 'مولد صور إلى صور بالذكاء الاصطناعي مجاني - حوّل الصور إلى فن و 4K | 微鲤AI',
            og_description: 'قم بتحميل صورة مرجعية وقم بتحويلها باستخدام ذكاء 微鲤AI الاصطناعي للصور إلى صور. حوّل الرسوم التخطيطية إلى فن واقعي، أو غيّر الأنماط، أو أنشئ متغيرات مع الحفاظ على التكوين الأصلي. يدعم دقة 4K.',
            twitter_title: 'مولد صور إلى صور بالذكاء الاصطناعي مجاني - حوّل الصور إلى فن و 4K | 微鲤AI',
            twitter_description: 'قم بتحميل صورة مرجعية وقم بتحويلها باستخدام ذكاء 微鲤AI الاصطناعي للصور إلى صور. حوّل الرسوم التخطيطية إلى فن واقعي، أو غيّر الأنماط، أو أنشئ متغيرات مع الحفاظ على التكوين الأصلي. يدعم دقة 4K.',
            faq: [
                {
                    question: 'ما هو ذكاء الصور إلى الصور الاصطناعي؟',
                    answer: 'الصور إلى الصور (Img2Img) يستخدم صورة محملة كمرجع مع مطالبة نصية لإنشاء صورة جديدة، ويمزج الإدخال المرئي مع الوصف الإبداعي.',
                },
                {
                    question: 'كيف أحول رسمًا تخطيطيًا إلى صورة واقعية؟',
                    answer: `قم بتحميل الرسم التخطيطي الخاص بك، وأدخل مطالبة تصف المشهد (على سبيل المثال، 'مبنى واقعي') وانقر على إنشاء.`,
                },
                {
                    question: 'هل يحتفظ بالوجه الأصلي؟',
                    answer: 'يحافظ على البنية والوضع. للحصول على الاحتفاظ الدقيق بهوية الوجه، يرجى استخدام أداة استبدال الوجه في الصورة الخاصة بنا.',
                },
            ],
            page: {
                title1: 'مولد صور إلى صور بالذكاء الاصطناعي مجاني',
                title2: 'استخدم صورك الموجودة كقالب. قم بتحميل صورة أو رسم تخطيطي أو تخطيط، ودع ذكاءنا الاصطناعي يعيد إنشائه بأسلوب جديد تمامًا بناءً على مطالبتك النصية. مثالي للحفاظ على التكوين أثناء استكشاف متغيرات فنية لا حصر لها.',
                title3: 'حوّل صورك مع نقل النمط بالذكاء الاصطناعي',
                title4: 'لماذا استخدام الصور إلى الصور (Img2Img)؟',
                upload_image: 'تواجه صعوبة في وصف وضع أو تخطيط بالكلمات؟ ما عليك سوى تحميل صورة مرجعية. يحافظ محرك Img2Img الخاص بنا على بنية صورتك الأصلية ولكن يعيد رسم التفاصيل.',
                resolution: 'حوّل رسمًا خشنًا أو إطارًا سلكيًا إلى عرض واقعي أو رسم توضيحي عالي الجودة في ثوانٍ. مثالي للمصممين والمهندسين المعماريين.',
                output: 'أنشئ أصولًا جاهزة للإنتاج. على عكس الأدوات الأخرى التي تنتج صورًا صغيرة، يدعم 微鲤AI دقات 1K و 2K و 4K للحصول على تفاصيل واضحة.',
                faq: [
                    {
                        question: 'ما هو ذكاء الصور إلى الصور الاصطناعي؟',
                        answer: 'الصور إلى الصور (Img2Img) هي تقنية تستخدم صورة محملة كـ "مرجع" مع مطالبة نصية لإنشاء صورة جديدة. تدمج إدخالك المرئي مع وصفك الإبداعي.',
                    },
                    {
                        question: 'كيف أحول رسمًا تخطيطيًا إلى صورة واقعية؟',
                        answer: 'قم بتحميل الرسم التخطيطي الخاص بك إلى منطقة "الصورة". في مربع "المطالبة"، صف ما يمثله الرسم التخطيطي (على سبيل المثال، "فيلا حديثة، غروب الشمس، واقعي، 8k"). انقر على إنشاء لرؤية السحر.',
                    },
                    {
                        question: 'هل يحتفظ بالوجه/الشخص الأصلي؟',
                        answer: 'يحاول الحفاظ على البنية العامة والوضع. ومع ذلك، للحصول على الاحتفاظ الدقيق بالوجه، نوصي باستخدام أداة "استبدال الوجه في الصورة" المحددة بدلاً من ذلك.',
                    },
                    {
                        question: 'ما هي نسب العرض إلى الارتفاع المدعومة؟',
                        answer: 'ندعم مجموعة واسعة من النسب بما في ذلك 9:16 (القصة) و 16:9 (السينمائي) و 3:4 و 1:1، مما يضمن أن فنك المُنشأ يناسب أي منصة بشكل مثالي.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يمكنك إنشاء متغيرات مجانًا باستخدام رصيدك اليومي.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'موسع ومغير حجم الصور بالذكاء الاصطناعي مجاني - إلغاء القص وتوسيع الصور | 微鲤AI',
            description: 'غيّر حجم الصور لـ Instagram و TikTok و YouTube دون قص. يستخدم موسع الصور بالذكاء الاصطناعي من 微鲤AI التعبئة التوليدية (التوسيع) لتوسيع خلفيات الصور بذكاء. غيّر نسب العرض إلى الارتفاع بسلاسة.',
            keywords: 'موسع صورة ai, إلغاء قص الصورة, توسيع ai, مغير حجم صورة ai, توسيع خلفية الصورة, تعبئة توليدية عبر الإنترنت, جعل الصورة عمودية',
            og_title: 'موسع ومغير حجم الصور بالذكاء الاصطناعي مجاني - إلغاء القص وتوسيع الصور | 微鲤AI',
            og_description: 'غيّر حجم الصور لـ Instagram و TikTok و YouTube دون قص. يستخدم موسع الصور بالذكاء الاصطناعي من 微鲤AI التعبئة التوليدية (التوسيع) لتوسيع خلفيات الصور بذكاء. غيّر نسب العرض إلى الارتفاع بسلاسة.',
            twitter_title: 'موسع ومغير حجم الصور بالذكاء الاصطناعي مجاني - إلغاء القص وتوسيع الصور | 微鲤AI',
            twitter_description: 'غيّر حجم الصور لـ Instagram و TikTok و YouTube دون قص. يستخدم موسع الصور بالذكاء الاصطناعي من 微鲤AI التعبئة التوليدية (التوسيع) لتوسيع خلفيات الصور بذكاء. غيّر نسب العرض إلى الارتفاع بسلاسة.',
            page: {
                title1: 'موسع ومغير حجم الصور بالذكاء الاصطناعي مجاني',
                title2: 'توقف عن قص صورك المفضلة لتناسب وسائل التواصل الاجتماعي. سواء كنت بحاجة إلى تحويل صورة أفقية إلى قصة عمودية أو توسيع صورة مربعة إلى 16:9، فإن موسع الصور بالذكاء الاصطناعي الخاص بنا يولد بذكاء تفاصيل خلفية جديدة (التوسيع) لتناسب أي نسبة عرض إلى ارتفاع بشكل مثالي.',
                faq: [
                    {
                        question: 'كيف أغير حجم صورة دون قص؟',
                        answer: 'استخدم موسع الصور بالذكاء الاصطناعي من 微鲤AI. قم بتحميل صورتك، واختر نسبة العرض إلى الارتفاع المستهدفة (على سبيل المثال، 9:16)، وسيقوم الذكاء الاصطناعي تلقائيًا بتوليد (توسيع) المناطق الخلفية المفقودة بدلاً من قص صورتك.',
                    },
                    {
                        question: 'ما هو التوسيع بالذكاء الاصطناعي؟',
                        answer: 'التوسيع هو تقنية ذكاء اصطناعي توليدية تمدد حدود الصورة من خلال التنبؤ ورسم محتوى جديد يطابق النمط الأصلي، مما يؤدي بشكل فعال إلى "إلغاء قص" الصورة.',
                    },
                    {
                        question: 'هل يمكنني تحويل صورة أفقية إلى عمودية؟',
                        answer: 'نعم! ما عليك سوى تحميل صورتك الأفقية (منظر طبيعي) واختيار النسبة 9:16. سيقوم الذكاء الاصطناعي بتوسيع الجزء العلوي والسفلي من الصورة لملء الإطار العمودي.',
                    },
                    {
                        question: 'هل ستبدو الخلفية الموسعة مزيفة؟',
                        answer: 'يستخدم 微鲤AI نماذج توليدية متقدمة مدربة على مجموعات بيانات ضخمة لضمان أن الخلفية الموسعة تندمج بشكل طبيعي مع الإضاءة والملمس الأصليين.',
                    },
                    {
                        question: 'هل هو مجاني للاستخدام؟',
                        answer: 'نعم، يحصل المستخدمون على رصيد مجاني لتجربة ميزات تغيير الحجم الذكي بالذكاء الاصطناعي والتوسيع.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أغير حجم صورة دون قص؟',
                    answer: 'استخدم موسع الصور بالذكاء الاصطناعي من 微鲤AI. قم بتحميل صورتك، واختر نسبة العرض إلى الارتفاع المستهدفة (على سبيل المثال، 9:16)، وسيقوم الذكاء الاصطناعي تلقائيًا بتوليد (توسيع) المناطق الخلفية المفقودة بدلاً من قص صورتك.',
                },
                {
                    question: 'ما هو التوسيع بالذكاء الاصطناعي؟',
                    answer: 'التوسيع هو تقنية ذكاء اصطناعي توليدية تمدد حدود الصورة من خلال التنبؤ ورسم محتوى جديد يطابق النمط الأصلي، مما يؤدي بشكل فعال إلى "إلغاء قص" الصورة.',
                },
                {
                    question: 'هل يمكنني تحويل صورة أفقية إلى عمودية؟',
                    answer: 'نعم! ما عليك سوى تحميل صورتك الأفقية (منظر طبيعي) واختيار النسبة 9:16. سيقوم الذكاء الاصطناعي بتوسيع الجزء العلوي والسفلي من الصورة لملء الإطار العمودي.',
                },
                {
                    question: 'هل ستبدو الخلفية الموسعة مزيفة؟',
                    answer: 'يستخدم 微鲤AI نماذج توليدية متقدمة مدربة على مجموعات بيانات ضخمة لضمان أن الخلفية الموسعة تندمج بشكل طبيعي مع الإضاءة والملمس الأصليين.',
                },
                {
                    question: 'هل هو مجاني للاستخدام؟',
                    answer: 'نعم، يحصل المستخدمون على رصيد مجاني لتجربة ميزات تغيير الحجم الذكي بالذكاء الاصطناعي والتوسيع.',
                },
            ],
            feature_title1: 'توسيع الخلفية الذكي',
            feature_desc1: 'التوسيع السحري: يفهم الذكاء الاصطناعي سياق صورتك ويرسم بكسل جديدة خارج الحدود الأصلية. قم بتوسيع المناظر الطبيعية أو الغرف أو القوام بسلاسة لملء الإطار.',
            feature_title2: 'حماية المركز',
            feature_desc2: 'لا تقطع الموضوع أبدًا: يحدد ذكاءنا الاصطناعي تلقائيًا الشخص أو الكائن الرئيسي ويقفله في المركز، مما يضمن عدم قطعه أبدًا أثناء عملية تغيير الحجم.',
            feature_title3: 'جاهز لوسائل التواصل الاجتماعي',
            feature_desc3: 'إعدادات مسبقة بنقرة واحدة لـ Instagram Stories (9:16) ومصغرات YouTube (16:9) والمنشورات (4:5). أعد استخدام محتواك عبر جميع المنصات على الفور.',
        },
        imageTextTranslate: {
            title: 'مترجم صور بالذكاء الاصطناعي مجاني - ترجم النص في الصور والمانجا والكوميكس',
            description: 'ترجم النص في الصور فورًا مع الحفاظ على النمط البصري الأصلي. يمحو مترجم الصور بالذكاء الاصطناعي من 微鲤AI النص الأصلي تلقائيًا ويعيد رسم الترجمات. مثالي للكوميكس والمانجا والملصقات التسويقية.',
            keywords: 'مترجم صور ai, ترجم النص في الصورة, مترجم صور, مترجم مانجا, ترجم كوميكس, مترجم ocr, استبدال نص الصورة',
            og_title: 'مترجم صور بالذكاء الاصطناعي مجاني - ترجم النص في الصور والمانجا والكوميكس',
            og_description: 'ترجم النص في الصور فورًا مع الحفاظ على النمط البصري الأصلي. يمحو مترجم الصور بالذكاء الاصطناعي من 微鲤AI النص الأصلي تلقائيًا ويعيد رسم الترجمات. مثالي للكوميكس والمانجا والملصقات التسويقية.',
            twitter_title: 'مترجم صور بالذكاء الاصطناعي مجاني - ترجم النص في الصور والمانجا والكوميكس',
            twitter_description: 'ترجم النص في الصور فورًا مع الحفاظ على النمط البصري الأصلي. يمحو مترجم الصور بالذكاء الاصطناعي من 微鲤AI النص الأصلي تلقائيًا ويعيد رسم الترجمات. مثالي للكوميكس والمانجا والملصقات التسويقية.',
            page: {
                title1: 'مترجم صور بالذكاء الاصطناعي مجاني ومستبدل النص',
                title2: 'ترجم الملصقات والقوائم والكوميكس ولقطات الشاشة في ثوانٍ. على عكس المترجمين القياسيين الذين يضعون النص فقط، يستخدم 微鲤AI الذكاء الاصطناعي التوليدي لمحو النص الأصلي وإعادة رسم الخلفية، مما يجعل النص المترجم يبدو وكأنه جزء من التصميم الأصلي.',
                faq: [
                    {
                        question: 'كيف أترجم النص داخل صورة؟',
                        answer: 'قم بتحميل صورتك (JPG, PNG) إلى 微鲤AI. اختر لغة المصدر (أو استخدم الكشف التلقائي) ولغة الهدف. انقر على "إنشاء" للسماح للذكاء الاصطناعي باستبدال النص.',
                    },
                    {
                        question: 'هل سيبدو النص المترجم طبيعيًا؟',
                        answer: 'نعم. يحاول 微鲤AI مطابقة حجم الخط ونمط النص الأصلي. من المهم أنه يعيد رسم الخلفية خلف النص حتى تندمج الترجمة بسلاسة.',
                    },
                    {
                        question: 'هل يمكنني استخدام هذا لترجمة المانجا أو المانهوا؟',
                        answer: 'بالتأكيد. هذا أحد أفضل حالات الاستخدام. يكتشف الذكاء الاصطناعي فقاعات الكلام والنص العمودي (شائع في اليابانية)، ويستبدلها بنص مترجم أفقي.',
                    },
                    {
                        question: 'ما هي اللغات المدعومة؟',
                        answer: 'ندعم الترجمة بين اللغات العالمية الرئيسية بما في ذلك الإنجليزية والإسبانية والصينية واليابانية والكورية والفرنسية والألمانية والمزيد.',
                    },
                    {
                        question: 'هل يعمل على النص المكتوب بخط اليد؟',
                        answer: 'يعمل بشكل أفضل على النص المطبوع، ولكن يمكن لمحرك OCR المتقدم لدينا التعرف على النص المكتوب بخط اليد الواضح على اللوحات البيضاء أو الملاحظات.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'يمكنك ترجمة الصور مجانًا باستخدام رصيدك اليومي.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أترجم النص داخل صورة؟',
                    answer: 'قم بتحميل صورتك إلى 微鲤AI. اختر لغة الهدف وانقر على "إنشاء". سيستبدل الذكاء الاصطناعي النص الأصلي بالترجمة.',
                },
                {
                    question: 'هل سيبدو النص المترجم طبيعيًا؟',
                    answer: 'نعم. يعيد 微鲤AI رسم الخلفية خلف النص ويحاول مطابقة نمط الخط، مما يضمن اندماج الترجمة بسلاسة.',
                },
                {
                    question: 'هل يمكنني استخدام هذا لترجمة المانجا أو المانهوا؟',
                    answer: 'بالتأكيد. هذا أحد أفضل حالات الاستخدام. يكتشف الذكاء الاصطناعي فقاعات الكلام والنص العمودي (شائع في اليابانية)، ويستبدلها بنص مترجم أفقي.',
                },
            ],
            feature_title1: 'الرسم الذكي والإعادة',
            feature_desc1: 'استبدال النص السلس: يحلل ذكاءنا الاصطناعي نسيج الخلفية خلف النص. يمحو الكلمات الأصلية ويملأ المساحة بذكاء قبل إضافة الترجمة، مما يضمن عدم تغطية صناديق النص القبيحة لصورتك.',
            feature_title2: 'ترجمة المانجا والكوميكس',
            feature_desc2: 'اقرأ المانجا الخام فورًا: مثالي لعشاق الأنمي. قم بتحميل صفحات المانجا الخام (اليابانية/الكورية) واحصل على ترجمات إنجليزية فورية تناسب فقاعات الكلام بشكل مثالي.',
            feature_title3: 'توطين التسويق العالمي',
            feature_desc3: 'التوطين بنقرة واحدة: هل تطلق منتجات عالميًا؟ ترجم ملصقاتك التسويقية واللافتات ولقطات شاشة واجهة المستخدم إلى أكثر من 30 لغة دون الحاجة إلى ملفات PSD الأصلية.',
        },
        aiBackgroundChanger: {
            title: 'مغيّر الخلفية بالذكاء الاصطناعي مجانًا - أنشئ خلفيات من النص',
            description: 'غيّر خلفية الصور فورًا باستخدام الذكاء الاصطناعي. صف المشهد الذي تريده وسيقوم 微鲤AI بإنشاء خلفيات واقعية لتصوير المنتجات وصور LinkedIn الاحترافية واللقطات الإبداعية. مجاني وعبر الإنترنت.',
            keywords: 'تغيير خلفية الصورة, مولد خلفيات بالذكاء الاصطناعي, تصوير منتجات بالذكاء الاصطناعي, صنع خلفية بيضاء, استبدال الخلفية عبر الإنترنت, تعبئة توليدية للخلفية',
            og_title: 'مغيّر الخلفية بالذكاء الاصطناعي مجانًا - أنشئ خلفيات من النص',
            og_description: 'غيّر خلفية الصور فورًا باستخدام الذكاء الاصطناعي. صف المشهد الذي تريده وسيقوم 微鲤AI بإنشاء خلفيات واقعية لتصوير المنتجات وصور LinkedIn الاحترافية واللقطات الإبداعية. مجاني وعبر الإنترنت.',
            twitter_title: 'مغيّر الخلفية بالذكاء الاصطناعي مجانًا - أنشئ خلفيات من النص',
            twitter_description: 'غيّر خلفية الصور فورًا باستخدام الذكاء الاصطناعي. صف المشهد الذي تريده وسيقوم 微鲤AI بإنشاء خلفيات واقعية لتصوير المنتجات وصور LinkedIn الاحترافية واللقطات الإبداعية. مجاني وعبر الإنترنت.',
            page: {
                title1: 'مغيّر الخلفية ومولّدها بالذكاء الاصطناعي مجانًا',
                title2: 'لا تكتفِ بإزالة الخلفية—استبدلها بما هو أفضل. ارفع صورتك وصف أي مشهد (مثل "استوديو رخام فاخر" أو "أفق مكاتب"). يفهم ذكاؤنا الاصطناعي التوليدي الإضاءة والمنظور لدمج موضوعك بشكل مثالي في البيئة الجديدة.',
                faq: [
                    {
                        question: 'كيف أغيّر الخلفية باستخدام النص؟',
                        answer: 'ارفع صورتك، وفي مربع "موجه الخلفية" صف المشهد الذي تريده (مثل "مقهى دافئ"). انقر على "إنشاء" وسيقوم الذكاء الاصطناعي بإنشاء الخلفية لك.',
                    },
                    {
                        question: 'هل يمكنني تغيير الخلفية إلى أبيض صافٍ؟',
                        answer: 'نعم. اكتب فقط "pure white background" أو "studio white" في الموجه. هذا مثالي لصور منتجات Amazon/eBay وصور الهوية الرسمية.',
                    },
                    {
                        question: 'هل هذا مناسب لتصوير المنتجات؟',
                        answer: 'بالتأكيد. يحلل 微鲤AI زاوية منتجك ويولّد خلفيات بظلال وإضاءة صحيحة لتبدو كجلسة تصوير احترافية في الاستوديو.',
                    },
                    {
                        question: 'هل ستبدو الإضاءة طبيعية؟',
                        answer: 'يحاول ذكاؤنا الاصطناعي التوليدي (المشابه لـ Adobe Firefly أو SDXL) مطابقة إضاءة الخلفية المولّدة مع موضوعك لدمجهما بسلاسة.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يمكنك إنشاء خلفيات جديدة مجانًا باستخدام رصيدك اليومي.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أغيّر الخلفية باستخدام النص؟',
                    answer: 'ارفع صورتك، وفي مربع "موجه الخلفية" صف المشهد الذي تريده (مثل "مقهى دافئ"). انقر على "إنشاء" وسيقوم الذكاء الاصطناعي بإنشاء الخلفية لك.',
                },
                {
                    question: 'هل يمكنني تغيير الخلفية إلى أبيض صافٍ؟',
                    answer: 'نعم. اكتب فقط "pure white background" أو "studio white" في الموجه. هذا مثالي لصور منتجات Amazon/eBay وصور الهوية الرسمية.',
                },
                {
                    question: 'هل هذا مناسب لتصوير المنتجات؟',
                    answer: 'بالتأكيد. يحلل 微鲤AI زاوية منتجك ويولّد خلفيات بظلال وإضاءة صحيحة لتبدو كجلسة تصوير احترافية في الاستوديو.',
                },
                {
                    question: 'هل ستبدو الإضاءة طبيعية؟',
                    answer: 'يحاول ذكاؤنا الاصطناعي التوليدي (المشابه لـ Adobe Firefly أو SDXL) مطابقة إضاءة الخلفية المولّدة مع موضوعك لدمجهما بسلاسة.',
                },
                {
                    question: 'هل هو مجاني؟',
                    answer: 'نعم، يمكنك إنشاء خلفيات جديدة مجانًا باستخدام رصيدك اليومي.',
                },
            ],
            feature_title1: 'صور هوية احترافية',
            feature_desc1: 'صور LinkedIn احترافية بنفسك: حوّل سيلفي عادي إلى صورة ملف شخصي احترافية. غيّر خلفية غرفة فوضوية إلى مكتب نظيف أو خلفية رمادية للاستوديو فورًا.',
            feature_title2: 'تصوير منتجات فوري',
            feature_desc2: 'زد مبيعات التجارة الإلكترونية: وفّر آلافًا على جلسات التصوير. ضع منتجك على طاولة خشبية أو شاطئ رملي أو منصة باستخدام موجهات نصية بسيطة. يضيف الذكاء الاصطناعي ظلالًا وانعكاسات واقعية.',
            feature_title3: 'انتقال إبداعي',
            feature_desc3: 'سافر إلى أي مكان: تريد أن تكون في باريس أو في مستقبل سايبربانك؟ فقط اكتب ذلك. يستبدل ذكاؤنا الاصطناعي الخلفية مع الحفاظ على اتساق الإضاءة مع صورتك الأصلية.',
        },
        imageUpscaler: {
            title: 'مكبّر الصور بالذكاء الاصطناعي مجانًا - كبّر إلى 4K واستعد الصور القديمة',
            description: 'كبّر الصور منخفضة الدقة فورًا إلى 2x و4x وحتى 4K باستخدام محسّن الصور المجاني من 微鲤AI. أصلح الصور الضبابية، أزل الضوضاء، واستعد صور العائلة القديمة عبر الإنترنت بجودة بدون فقدان.',
            keywords: 'مكبر الصور بالذكاء الاصطناعي, محسّن الصور, تكبير الصورة إلى 4k, إزالة الضبابية, استعادة الصور القديمة, إصلاح الصور المكسّرة, زيادة دقة الصورة',
            og_title: 'مكبّر الصور بالذكاء الاصطناعي مجانًا - كبّر إلى 4K واستعد الصور القديمة',
            og_description: 'كبّر الصور منخفضة الدقة فورًا إلى 2x و4x وحتى 4K باستخدام محسّن الصور المجاني من 微鲤AI. أصلح الصور الضبابية، أزل الضوضاء، واستعد صور العائلة القديمة عبر الإنترنت بجودة بدون فقدان.',
            twitter_title: 'مكبّر الصور بالذكاء الاصطناعي مجانًا - كبّر إلى 4K واستعد الصور القديمة',
            twitter_description: 'كبّر الصور منخفضة الدقة فورًا إلى 2x و4x وحتى 4K باستخدام محسّن الصور المجاني من 微鲤AI. أصلح الصور الضبابية، أزل الضوضاء، واستعد صور العائلة القديمة عبر الإنترنت بجودة بدون فقدان.',
            page: {
                title1: 'مكبّر ومحسّن الصور بالذكاء الاصطناعي مجانًا',
                title2: 'حوّل الصور المكسّرة أو الضبابية أو القديمة إلى روائع عالية الدقة. يستخدم 微鲤AI ذكاءً اصطناعيًا متقدمًا لزيادة الدقة حتى 400% (4K) مع استعادة التفاصيل المفقودة، وإصلاح الضوضاء، واستعادة الوجوه في صور العائلة القديمة.',
                faq: [
                    {
                        question: 'هل يمكنني تكبير الصور منخفضة الدقة للطباعة؟',
                        answer: 'نعم! يزيد 微鲤AI دقة الصورة (عدد البكسلات) حتى 4K، مما يجعلها مناسبة للطباعة عالية الجودة على الملصقات أو اللوحات القماشية أو مواد التسويق.',
                    },
                    {
                        question: 'كيف تعمل استعادة الصور القديمة بالذكاء الاصطناعي؟',
                        answer: 'يحلل الذكاء الاصطناعي الأجزاء التالفة أو الضبابية من الصورة القديمة ويستخدم التعلم العميق للتنبؤ وإعادة بناء تفاصيل الوجه والملمس والخلفيات، مما “يعالج” الصورة بشكل فعال.',
                    },
                    {
                        question: 'ما الصيغ المدعومة؟',
                        answer: 'ندعم الصيغ الشائعة مثل JPG وPNG وWEBP. سيكون الإخراج بصيغة PNG أو JPG عالية الجودة.',
                    },
                    {
                        question: 'هل يعمل مع الأنمي/الرسوم؟',
                        answer: 'نعم. يتفوّق ذكاؤنا الاصطناعي في تكبير الأنمي والرسومات (نمط waifu2x)، مع الحفاظ على خطوط حادة وألوان نابضة دون تشوهات.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يمكنك تحسين الصور مجانًا باستخدام رصيدك اليومي.',
                    },
                ],
            },
            faq: [
                {
                    question: 'هل يمكنني تكبير الصور منخفضة الدقة للطباعة؟',
                    answer: 'نعم! يزيد 微鲤AI الدقة حتى 4K، مما يجعل الصور مناسبة للطباعة عالية الجودة.',
                },
                {
                    question: 'كيف تعمل استعادة الصور القديمة بالذكاء الاصطناعي؟',
                    answer: 'يحلل الذكاء الاصطناعي المناطق التالفة ويعيد بناء تفاصيل الوجه والملمس باستخدام التعلم العميق “لعلاج” الصورة.',
                },
                {
                    question: 'هل يعمل مع الأنمي؟',
                    answer: 'نعم. يتفوّق ذكاؤنا الاصطناعي في تكبير الأنمي والرسومات مع الحفاظ على خطوط حادة دون تشوهات.',
                },
            ],
            feature_title1: 'تكبير بدون فقدان حتى 4K',
            feature_desc1: 'جودة جاهزة للطباعة: هل تحتاج لطباعة صورة صغيرة؟ كبّرها إلى 4K أو 8K بدون فقدان الجودة. مثالي للملصقات وصور منتجات التجارة الإلكترونية وخلفيات الشاشة.',
            feature_title2: 'إزالة الضوضاء وإزالة الضبابية بذكاء',
            feature_desc2: 'أصلح صور الليل: أزل الضوضاء الرقمية والحبيبات من الصور منخفضة الإضاءة. حَدّد الحواف الضبابية فورًا لتبدو صورك واضحة واحترافية.',
            feature_title3: 'استعادة الصور القديمة',
            feature_desc3: 'أعد إحياء الذكريات: هل لديك صور قديمة أو تالفة أو بالأبيض والأسود؟ ينشئ ذكاؤنا الاصطناعي بكسلات جديدة لإصلاح الخدوش وتوضيح الوجوه وإعادة الوضوح لذكرياتك الثمينة.',
        },
        photoFaceSwap: {
            title: 'تبديل الوجه بالذكاء الاصطناعي مجانًا عبر الإنترنت - نتائج واقعية | 微鲤AI',
            description: 'بدّل الوجوه في الصور فورًا باستخدام أداة Face Swap المجانية من 微鲤AI. أنشئ ميمات مضحكة، صورًا فنية (موناليزا)، أو صورًا احترافية واقعية للغاية. خصوصية وأمان 100%.',
            keywords: 'face swap بالذكاء الاصطناعي, تبديل الوجه عبر الإنترنت, تغيير الوجه في الصورة, reface مجاني, استبدال الوجه في الصورة, deepfake صورة, صانع ميمات بالذكاء الاصطناعي',
            og_title: 'تبديل الوجه بالذكاء الاصطناعي مجانًا عبر الإنترنت - نتائج واقعية | 微鲤AI',
            og_description: 'بدّل الوجوه في الصور فورًا باستخدام أداة Face Swap المجانية من 微鲤AI. أنشئ ميمات مضحكة، صورًا فنية (موناليزا)، أو صورًا احترافية واقعية للغاية. خصوصية وأمان 100%.',
            twitter_title: 'تبديل الوجه بالذكاء الاصطناعي مجانًا عبر الإنترنت - نتائج واقعية | 微鲤AI',
            twitter_description: 'بدّل الوجوه في الصور فورًا باستخدام أداة Face Swap المجانية من 微鲤AI. أنشئ ميمات مضحكة، صورًا فنية (موناليزا)، أو صورًا احترافية واقعية للغاية. خصوصية وأمان 100%.',
            page: {
                title1: 'تبديل الوجه في الصور بالذكاء الاصطناعي مجانًا',
                title2: 'هل تريد أن ترى نفسك كرائد فضاء أو نجم سينما أو داخل لوحة كلاسيكية؟ ارفع صورة أساسية ووجهًا مستهدفًا، ودع ذكاءنا الاصطناعي يدمج ملامح الوجه والإضاءة ودرجة لون البشرة بسلاسة لنتيجة تبديل وجه فائقة الواقعية خلال ثوانٍ.',
                faq: [
                    {
                        question: 'هل تبديل الوجه من 微鲤AI مجاني؟',
                        answer: 'نعم، نوفر رصيدًا يوميًا مجانيًا لتبديل الوجوه في الصور عبر الإنترنت. لا حاجة للتثبيت أو لبطاقة ائتمان.',
                    },
                    {
                        question: 'هل بياناتي آمنة؟',
                        answer: 'بالتأكيد. نحن نضع الخصوصية أولاً. تُستخدم الصور التي ترفعها فقط لعملية التبديل ويتم حذفها تلقائيًا من خوادمنا بعد فترة قصيرة.',
                    },
                    {
                        question: 'كيف أحصل على أفضل النتائج؟',
                        answer: 'لأفضل نتيجة واقعية، تأكد أن “الصورة الأساسية” و“صورة الوجه” واضحتان ومن الأمام وبإضاءة جيدة. تجنّب الصور التي يكون فيها الوجه مغطى بالشعر أو اليدين.',
                    },
                    {
                        question: 'هل يمكنني تبديل الوجوه في صور جماعية؟',
                        answer: 'حاليًا نركز على دقة تبديل وجه واحد. للصور الجماعية، قص الصورة أو استخدم ميزة تعدد الوجوه القادمة قريبًا.',
                    },
                    {
                        question: 'هل يمكنني استخدامه للميمات؟',
                        answer: 'نعم! إنه مثالي لصنع ميمات مضحكة. بدّل وجه صديقك على ملصق فيلم أو قالب ميم منتشر فورًا.',
                    },
                ],
            },
            faq: [
                {
                    question: 'هل تبديل الوجه من 微鲤AI مجاني؟',
                    answer: 'نعم، نوفر رصيدًا يوميًا مجانيًا لتبديل الوجوه عبر الإنترنت بدون تثبيت أو بطاقة ائتمان.',
                },
                {
                    question: 'هل بياناتي آمنة؟',
                    answer: 'نعم. تُستخدم الصور فقط للتبديل ويتم حذفها تلقائيًا بعد فترة قصيرة.',
                },
                {
                    question: 'كيف أحصل على أفضل النتائج؟',
                    answer: 'تأكد أن الصورتين واضحتان ومن الأمام وبإضاءة جيدة. تجنّب الوجوه المغطاة بالشعر أو النظارات.',
                },
            ],
            feature_title1: 'روائع فنية',
            feature_desc1: 'سفر عبر الزمن: بدّل وجهك داخل لوحات كلاسيكية مثل موناليزا أو الفتاة ذات القرط اللؤلؤي. أنشئ صورًا رمزية قديمة وفريدة فورًا.',
            feature_title2: 'صور رمزية احترافية وجذابة',
            feature_desc2: 'وظائف الأحلام: شاهد نفسك ببدلة سباق أو معدات رائد فضاء أو ملابس رسمية دون شراء الزي. مثالي لصور ملف شخصي لافتة.',
            feature_title3: 'دمج فائق الواقعية',
            feature_desc3: 'بدون تأثير “القص واللصق”: على عكس الأدوات البسيطة، يحلل 微鲤AI الزاوية والإضاءة وملمس البشرة ليبدو الوجه المستبدل طبيعيًا 100% وليس مزيفًا.',
        },
        removeTextFromImage: {
            title: 'مزيل النص بالذكاء الاصطناعي مجانًا - امسح العلامات المائية والتواريخ | 微鲤AI',
            description: 'أزل فورًا النصوص وأختام التاريخ والشعارات والتسميات من الصور باستخدام ممحاة النص المجانية من 微鲤AI. استعد الخلفيات بشكل مثالي عبر AI Inpainting. مثالي لتنظيف الصور وموكابات التجارة الإلكترونية.',
            keywords: 'إزالة النص من الصورة, مزيل نص بالذكاء الاصطناعي, إزالة ختم التاريخ, إزالة العلامة المائية عبر الإنترنت, تنظيف الصور, AI inpainting, إزالة الشعار من الصورة',
            og_title: 'مزيل النص بالذكاء الاصطناعي مجانًا - امسح العلامات المائية والتواريخ | 微鲤AI',
            og_description: 'أزل فورًا النصوص وأختام التاريخ والشعارات والتسميات من الصور باستخدام ممحاة النص المجانية من 微鲤AI. استعد الخلفيات بشكل مثالي عبر AI Inpainting. مثالي لتنظيف الصور وموكابات التجارة الإلكترونية.',
            twitter_title: 'مزيل النص بالذكاء الاصطناعي مجانًا - امسح العلامات المائية والتواريخ | 微鲤AI',
            twitter_description: 'أزل فورًا النصوص وأختام التاريخ والشعارات والتسميات من الصور باستخدام ممحاة النص المجانية من 微鲤AI. استعد الخلفيات بشكل مثالي عبر AI Inpainting. مثالي لتنظيف الصور وموكابات التجارة الإلكترونية.',
            page: {
                title1: 'مزيل النص من الصور بالذكاء الاصطناعي مجانًا',
                title2: 'هل يشتتك نص غير مرغوب فيه؟ ارفع صورتك ببساطة وسيقوم الذكاء الاصطناعي باكتشاف ومسح النصوص والشعارات وأختام التاريخ أو التسميات فورًا. يحلل البكسلات المحيطة لإعادة بناء الخلفية دون ترك أي أثر.',
                faq: [
                    {
                        question: 'كيف أزيل النص من صورة بدون تشويش/ضبابية؟',
                        answer: 'استخدم مزيل النص بالذكاء الاصطناعي من 微鲤AI. بدلًا من الضبابية، نستخدم AI Inpainting لتحليل المحيط وتوليد بكسلات جديدة لملء الفراغ بسلاسة.',
                    },
                    {
                        question: 'هل يمكنني إزالة أختام التاريخ من الصور؟',
                        answer: 'نعم! هذا استخدام مثالي. يتعرف الذكاء الاصطناعي على خط التاريخ/الوقت الرقمي ويمسحه مع استعادة المشهد خلفه.',
                    },
                    {
                        question: 'هل يعمل مع خلفيات معقدة؟',
                        answer: 'نعم. يمكنه إزالة النص حتى من خلفيات معقدة مثل الجبال أو الملابس ذات النقوش عبر فهم تدفق الملمس.',
                    },
                    {
                        question: 'هل يمكنني إزالة أشخاص أو أشياء؟',
                        answer: 'رغم أنه مُحسّن للنصوص، فإن التقنية الأساسية (Inpainting) تعمل أيضًا لإزالة الأشياء الصغيرة أو عيوب البشرة أو الفوضى.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يمكنك استخدامه مجانًا عبر رصيدك اليومي.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أزيل النص من صورة بدون تشويش/ضبابية؟',
                    answer: 'استخدم مزيل النص بالذكاء الاصطناعي من 微鲤AI. AI Inpainting يولد بكسلات جديدة لملء المنطقة بشكل طبيعي.',
                },
                {
                    question: 'هل يمكنني إزالة أختام التاريخ من الصور؟',
                    answer: 'نعم! يتعرف الذكاء الاصطناعي على التاريخ/الوقت ويمسحه مع استعادة الخلفية.',
                },
                {
                    question: 'هل يعمل مع خلفيات معقدة؟',
                    answer: 'نعم. يفهم تدفق الملمس ويزيل النص حتى على الخلفيات المعقدة.',
                },
            ],
            feature_title1: 'تنظيف الملابس والتصميم',
            feature_desc1: 'مثالي للموكابات: تبيع ملابس عبر الإنترنت؟ أزل الشعارات أو العبارات أو الرسومات من صور التيشيرت لإنشاء مساحة نظيفة لتصاميمك.',
            feature_title2: 'استعادة الذكريات',
            feature_desc2: 'مسح أختام التاريخ: أزل أختام التاريخ البرتقالية المزعجة من صور العائلة القديمة أو صور السفر دون إتلاف المنظر.',
            feature_title3: 'Inpainting ذكي',
            feature_desc3: 'ملء الخلفية بسلاسة: على عكس الممحاة الأساسية التي تترك ضبابية، يستخدم 微鲤AI الذكاء الاصطناعي التوليدي لـ“رسم” قوام واقعي (عشب، سماء، جبال) داخل المنطقة الممسوحة.',
        },
        imgExtender: {
            title: 'وسّع الصور مجانًا فورًا - موسّع الصور بالذكاء الاصطناعي | 微鲤AI',
            description: 'استخدم موسّع الصور بالذكاء الاصطناعي المجاني من 微鲤AI لتجاوز حدود الصورة الأصلية فورًا. تقوم الأداة بتوليد بكسلات جديدة تندمج بسلاسة مع الصورة المرفوعة، لتحويل الصور الشخصية إلى لقطات واسعة مع الحفاظ على الشكل والجودة.',
            keywords: 'موسّع صور بالذكاء الاصطناعي, توسيع صورة مجانًا, صورة واسعة, توسيع حدود الصورة, outpainting بسلاسة, الحفاظ على الجودة',
            og_title: 'وسّع الصور مجانًا فورًا - موسّع الصور بالذكاء الاصطناعي | 微鲤AI',
            og_description: 'وسّع صورك إلى أحجام جديدة وولّد محتوى متناسقًا معها. جرّب موسّع الصور بالذكاء الاصطناعي مجانًا اليوم.',
            twitter_title: 'وسّع الصور مجانًا فورًا - موسّع الصور بالذكاء الاصطناعي | 微鲤AI',
            twitter_description: 'وسّع صورك إلى أحجام جديدة وولّد محتوى متناسقًا معها. جرّب موسّع الصور بالذكاء الاصطناعي مجانًا اليوم.',
            featureList: [
                'موسّع صور بالذكاء الاصطناعي, توسيع صورة مجانًا, لقطة واسعة, الحفاظ على الجودة',
            ],
            page: {
                title1: 'موسّع صور قوي بالذكاء الاصطناعي لنتائج مذهلة',
                title2: 'بنقرات بسيطة، وسّع صورتك خارج حدودها الأصلية. يولّد الذكاء الاصطناعي بكسلات جديدة تمتزج بسلاسة مع الصورة، مع الحفاظ على المظهر والجودة.',
                feature_title: 'ما الذي يميز موسّع الصور من 微鲤AI؟',
                faq: [
                    {
                        question: 'ما هو موسّع الصور بالذكاء الاصطناعي؟',
                        answer: 'أداة تستخدم ذكاءً اصطناعيًا متقدمًا لتوسيع حدود الصورة عبر ملء المحتوى الناقص خارج الإطار بشكل ذكي. مناسبة للتسويق والتجارة الإلكترونية ومنشورات السوشيال.',
                    },
                    {
                        question: 'لماذا أستخدم موسّع الصور من 微鲤AI؟',
                        answer: 'يحلل 微鲤AI خصائص الصورة ويقوم بعملية outpainting طبيعية وبجودة عالية دون فواصل واضحة.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم. يمكنك استخدامه مجانًا عبر أرصدة التجربة، ما يجعله خيارًا اقتصاديًا لأي سير عمل.',
                    },
                    {
                        question: 'ما مدى سرعة المعالجة؟',
                        answer: 'غالبًا ما يكتمل خلال ثوانٍ، وهو مناسب للتعديلات السريعة والعمل الدُفعي.',
                    },
                    {
                        question: 'هل سيؤثر على الدقة أو الجودة؟',
                        answer: 'لا. يحافظ على الدقة والوضوح والتفاصيل أثناء التوسيع.',
                    },
                    {
                        question: 'هل تبقى صوري خاصة؟',
                        answer: 'نعم. نحمي بياناتك بمعايير أمان صناعية وسياسات خصوصية صارمة دون مشاركة مع أطراف ثالثة.',
                    },
                    {
                        question: 'ما صيغ الصور المدعومة؟',
                        answer: 'JPG وPNG وWebP وصيغ شائعة أخرى. الحد الأقصى 10MB للملف الواحد ولا حاجة للتحويل.',
                    },
                ],
            },
            faq: [
                {
                    question: 'ما هو موسّع الصور بالذكاء الاصطناعي؟',
                    answer: 'أداة تستخدم ذكاءً اصطناعيًا متقدمًا لتوسيع حدود الصورة عبر ملء المحتوى الناقص خارج الإطار بشكل ذكي. مناسبة للتسويق والتجارة الإلكترونية ومنشورات السوشيال.',
                },
                {
                    question: 'لماذا أستخدم موسّع الصور من 微鲤AI؟',
                    answer: 'يحلل 微鲤AI خصائص الصورة ويقوم بعملية outpainting طبيعية وبجودة عالية دون فواصل واضحة.',
                },
                {
                    question: 'هل هو مجاني؟',
                    answer: 'نعم. مجانًا عبر أرصدة التجربة.',
                },
                {
                    question: 'ما مدى سرعة المعالجة؟',
                    answer: 'عادة خلال ثوانٍ.',
                },
                {
                    question: 'هل سيؤثر على الدقة أو الجودة؟',
                    answer: 'لا. تبقى الجودة والتفاصيل محفوظة.',
                },
                {
                    question: 'هل تبقى صوري خاصة؟',
                    answer: 'نعم. بياناتك محمية ولا تتم مشاركتها.',
                },
                {
                    question: 'ما صيغ الصور المدعومة؟',
                    answer: 'JPG وPNG وWebP (حتى 10MB).',
                },
            ],
            feature_title1: 'إصلاح التفاصيل والخلفيات المفقودة',
            feature_desc1: 'إذا كانت الصورة مقصوصة، يمكن للذكاء الاصطناعي ملء المناطق الناقصة لجعل المشهد أكثر اكتمالًا. كما يساعد outpainting في استعادة عناصر مفقودة في الصور القديمة.',
            feature_title2: 'تحسين صور المنتجات لزيادة المبيعات',
            feature_desc2: 'وسّع المساحة حول صورة المنتج لإضافة خلفية متناسقة. ويمكنك أيضًا إنشاء تكوين أعرض لإظهار تفاصيل أكثر وتعزيز التحويل.',
            feature_title3: 'ابتكر أعمالًا بصرية فريدة',
            feature_desc3: 'سواء كنت مصورًا أو صانع محتوى أو فنانًا، يمكنك تجاوز الحدود الإبداعية وتحويل أفكارك إلى صور مذهلة.',
            feature_title4: 'تحسين نسب الأبعاد للسوشيال',
            feature_desc4: 'وسّع الصور لأي نسبة تناسب Instagram وX (تويتر سابقًا) وFacebook وغيرها. يحافظ الذكاء الاصطناعي على التفاصيل لتبقى النتيجة لافتة.',
            textRemoverHowToUseTitle: 'كيفية استخدام موسّع الصور بالذكاء الاصطناعي',
            textRemoverHowToUseDesc: '3 خطوات بسيطة لتوسيع صورتك خارج الحدود',
            textRemoverHowToUseStep1Title: 'ارفع صورة',
            textRemoverHowToUseStep1Desc: 'انقر أو اسحب وأفلت الصورة التي تريد توسيعها.',
            textRemoverHowToUseStep2Title: 'معالجة تلقائية بالذكاء الاصطناعي',
            textRemoverHowToUseStep2Desc: 'بعد الرفع، يكتشف الذكاء الاصطناعي الحدود ويقوم بتوسيعها تلقائيًا.',
            textRemoverHowToUseStep3Title: 'نزّل الصورة الموسّعة',
            textRemoverHowToUseStep3Desc: 'بعد الانتهاء، يمكنك معاينة الصورة وتنزيل النسخة الموسّعة.',
        },
        photoRestoration: {
            title: 'استعادة الصور بالذكاء الاصطناعي مجانًا - تلوين الأبيض والأسود وإصلاح الخدوش | 微鲤AI',
            description: 'أعد إحياء ذكريات العائلة مع استعادة الصور المجانية من 微鲤AI. لوّن صور الأبيض والأسود تلقائيًا وأزل الخدوش والتمزقات والضبابية لاستعادة الوجوه فورًا.',
            keywords: 'استعادة الصور القديمة, تلوين صور أبيض وأسود, إصلاح صور مخدوشة, إصلاح الصور بالذكاء الاصطناعي, استرجاع الصور القديمة, من الأبيض والأسود إلى الألوان, ترميم الصور بالذكاء الاصطناعي',
            og_title: 'استعادة الصور بالذكاء الاصطناعي مجانًا - تلوين الأبيض والأسود وإصلاح الخدوش | 微鲤AI',
            og_description: 'أعد إحياء ذكريات العائلة مع استعادة الصور المجانية من 微鲤AI. لوّن صور الأبيض والأسود تلقائيًا وأزل الخدوش والتمزقات والضبابية لاستعادة الوجوه فورًا.',
            twitter_title: 'استعادة الصور بالذكاء الاصطناعي مجانًا - تلوين الأبيض والأسود وإصلاح الخدوش | 微鲤AI',
            twitter_description: 'أعد إحياء ذكريات العائلة مع استعادة الصور المجانية من 微鲤AI. لوّن صور الأبيض والأسود تلقائيًا وأزل الخدوش والتمزقات والضبابية لاستعادة الوجوه فورًا.',
            page: {
                title1: 'استعادة وتلوين الصور القديمة بالذكاء الاصطناعي (مجانًا)',
                title2: 'أعد تاريخك إلى الحياة. سواء كانت صورة زفاف باهتة بالأبيض والأسود أو بورتريه طفولة مليئًا بالخدوش، يقوم الذكاء الاصطناعي بتحليل المناطق التالفة واستعادتها، وتحسين وضوح الوجوه، وإضافة ألوان واقعية خلال ثوانٍ.',
                faq: [
                    {
                        question: 'كيف ألوّن صورة بالأبيض والأسود؟',
                        answer: 'ارفع صورتك بالأبيض والأسود إلى 微鲤AI. سيكتشف النظام تلقائيًا أنها رمادية ويطبّق ميزة “التلوين” لإضافة ألوان واقعية فورًا.',
                    },
                    {
                        question: 'هل يمكنه إصلاح الصور الممزقة أو المخدوشة؟',
                        answer: 'نعم. تم تدريب الذكاء الاصطناعي على التعرف على الخدوش والتمزقات والثنيات، ثم يملأ المناطق التالفة ببكسلات تطابق الملمس المحيط.',
                    },
                    {
                        question: 'هل ستبدو الصورة المستعادة مزيفة؟',
                        answer: 'هدفنا هو الواقعية. تحسين الوجه يضيف تفاصيل مع الحفاظ على هوية الشخص واضحة. وفي التلوين، يختار الذكاء الاصطناعي درجات طبيعية مناسبة للعصر.',
                    },
                    {
                        question: 'ماذا لو كانت الصورة صغيرة جدًا؟',
                        answer: 'لا مشكلة. تتضمن العملية أيضًا Upscaling لرفع دقة الصور الصغيرة للعرض الرقمي أو الطباعة.',
                    },
                    {
                        question: 'هل خصوصيتي محمية؟',
                        answer: 'نعم. نعلم أن الصور القديمة شخصية. تتم معالجة صورك بأمان ولا يتم تخزينها بشكل دائم على خوادمنا.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف ألوّن صورة بالأبيض والأسود؟',
                    answer: 'ارفع صورتك وسيقوم خيار “التلوين” بإضافة ألوان واقعية فورًا.',
                },
                {
                    question: 'هل يمكنه إصلاح الصور الممزقة أو المخدوشة؟',
                    answer: 'نعم. يكتشف الذكاء الاصطناعي التلف ويعيد بناءه وفقًا للملمس المحيط.',
                },
                {
                    question: 'هل ستبدو الصورة المستعادة مزيفة؟',
                    answer: 'نركز على الواقعية والحفاظ على الهوية مع ألوان طبيعية.',
                },
            ],
            feature_title1: 'إزالة الخدوش والتمزقات',
            feature_desc1: 'امسح آثار الزمن: اكتشف تلقائيًا الثنيات والخدوش والتمزقات وبقع الغبار واملأها. يعيد الذكاء الاصطناعي بناء تفاصيل الوجه المفقودة لتبدو الصورة كالجديدة.',
            feature_title2: 'تلوين ذكي',
            feature_desc2: 'من الأبيض والأسود إلى الألوان: ليس مجرد فلتر سيبيا. يفهم نموذج التعلم العميق السياق (السماء، البشرة، القماش) لإضافة ألوان نابضة وواقعية للصور القديمة.',
            feature_title3: 'تحسين الوجه',
            feature_desc3: 'إزالة ضبابية الوجوه: غالبًا ما تعاني الصور القديمة من اهتزاز أو ضعف تركيز. يقوم 微鲤AI بتحسين ملامح الوجه (العينين، الأنف، الفم) لإظهار الشبه الحقيقي.',
        },
        photoEffects: {
            title: 'تأثيرات الصور - مولد تأثيرات الصور بالذكاء الاصطناعي | 微鲤AI',
            description: 'حوّل صورك بتأثيرات مدعومة بالذكاء الاصطناعي. أنشئ فلاتر صور وأنماط وتحويلات مذهلة عبر الإنترنت مجانًا.',
            keywords: 'تأثيرات صور بالذكاء الاصطناعي, تأثيرات الصور, فلتر الصور, تحويل الصور بالذكاء الاصطناعي, نقل نمط الصورة',
        },
    },
    tw: {
        textToImage: {
            title: '免費 AI 文生圖生成器 - 創作 4K 藝術與寫實照片 | 微鲤AI',
            description: '使用 微鲤AI 的文生圖生成器把文字提示轉為驚豔視覺。採用 Nano Banana Pro 模型，生成高保真結果。支援 1K/2K/4K 解析度與 9:16/16:9 長寬比。免費線上使用。',
            keywords: '文生圖, AI 圖像生成, AI 藝術生成器, 4K AI 圖片, Nano Banana 模型, Flux AI 免費, 桌布生成器, 文字生成圖片',
            og_title: '免費 AI 文生圖生成器 - 創作 4K 藝術與寫實照片 | 微鲤AI',
            og_description: '使用 微鲤AI 的文生圖生成器把文字提示轉為驚豔視覺。採用 Nano Banana Pro 模型，生成高保真結果。支援 1K/2K/4K 解析度與 9:16/16:9 長寬比。免費線上使用。',
            twitter_title: '免費 AI 文生圖生成器 - 創作 4K 藝術與寫實照片 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的文生圖生成器把文字提示轉為驚豔視覺。採用 Nano Banana Pro 模型，生成高保真結果。支援 1K/2K/4K 解析度與 9:16/16:9 長寬比。免費線上使用。',
            faq: [
                {
                    question: '如何生成 4K AI 圖片？',
                    answer: '只需輸入提示詞，並在左側面板的圖片尺寸設定中選擇「4K」，再點擊建立即可。',
                },
                {
                    question: '支援哪些長寬比？',
                    answer: '我們支援所有主流比例，包括 1:1、9:16（手機）、16:9（桌面）、4:3 和 3:2，適用各種平台。',
                },
                {
                    question: '我可以將圖片用於商業用途嗎？',
                    answer: '可以。微鲤AI 方案生成的圖片通常附帶商業授權，適用於廣告與商品。',
                },
            ],
            page: {
                title1: '免費 AI 文生圖生成器',
                title2: '在幾秒內創作驚豔藝術、寫實圖片與獨特桌布。只要描述你想看到的內容，我們先進的 Nano Banana Pro 模型會生成與提示完美匹配的高保真 4K 圖片。',
                resolution: '別再將就模糊的 AI 圖片。微鲤AI 讓你直接生成清晰的 1K、2K 與 4K 圖片，適合列印或高解析度螢幕。',
                aspectRatio: '無論你需要 9:16 的 TikTok 背景、16:9 的 YouTube 縮圖，或 1:1 的 Instagram 圖片，我們都有適合各平台的預設。',
                online_search: '需要最新資訊？啟用「線上搜尋」讓 AI 瀏覽網路，更好理解提示中的時事或特定參考。',
                faq: [
                    {
                        question: '如何從文字生成高品質圖片？',
                        answer: '輸入詳細提示，描述主體、光線與風格。在圖片尺寸設定中選擇「4K」可獲得最清晰細節。',
                    },
                    {
                        question: 'Nano Banana Pro 模型是什麼？',
                        answer: 'Nano Banana Pro 是我們最高保真模型，針對提示詞遵循度與寫實感優化，品質可媲美 Midjourney v6 與 Flux 等頂級模型。',
                    },
                    {
                        question: '我可以將圖片用於商業用途嗎？',
                        answer: '可以。微鲤AI（付費方案）生成的圖片附帶商業授權，可用於廣告、網站與商品。',
                    },
                    {
                        question: '我可以一次生成多少張圖片？',
                        answer: '最多可同時生成 4 張（如「輸出圖片數量」設定所示），方便快速迭代想法。',
                    },
                    {
                        question: '它是免費的嗎？',
                        answer: '是的，你可以使用每日免費點數生成圖片。更高解析度（4K）可能需要更多點數。',
                    },
                ],
            },
        },
        imageToImage: {
            title: '免費 AI 圖生圖生成器 - 把照片變成藝術 & 4K | 微鲤AI',
            description: '上傳參考照片，使用 微鲤AI 的圖生圖 AI 進行轉換。可把素描變成寫實藝術、改變風格，或在保留原構圖的同時生成變體。支援 4K 解析度。',
            keywords: '圖生圖 AI, Img2Img, 照片變繪畫, AI 圖片變體, 素描轉圖片, 照片混音 AI, 免費 AI 藝術生成器',
            og_title: '免費 AI 圖生圖生成器 - 把照片變成藝術 & 4K | 微鲤AI',
            og_description: '上傳參考照片，使用 微鲤AI 的圖生圖 AI 進行轉換。可把素描變成寫實藝術、改變風格，或在保留原構圖的同時生成變體。支援 4K 解析度。',
            twitter_title: '免費 AI 圖生圖生成器 - 把照片變成藝術 & 4K | 微鲤AI',
            twitter_description: '上傳參考照片，使用 微鲤AI 的圖生圖 AI 進行轉換。可把素描變成寫實藝術、改變風格，或在保留原構圖的同時生成變體。支援 4K 解析度。',
            faq: [
                {
                    question: '什麼是圖生圖 AI？',
                    answer: '圖生圖（Img2Img）會用上傳圖片作為參考，搭配文字提示生成新圖片，融合視覺輸入與創意描述。',
                },
                {
                    question: '如何將素描轉成寫實照片？',
                    answer: '上傳素描，輸入描述場景的提示（例如「寫實建築」），然後點擊建立。',
                },
                {
                    question: '它會保留原本的臉嗎？',
                    answer: '會保留結構與姿勢。如需精準保留臉部身份，請使用我們的照片換臉工具。',
                },
            ],
            page: {
                title1: '免費 AI 圖生圖生成器',
                title2: '使用你現有的圖片作為藍圖。上傳照片、素描或版面，讓 AI 依照文字提示以全新風格重新生成。適合在保留構圖的同時探索無限藝術變化。',
                title3: '用 AI 風格轉換你的照片',
                title4: '為什麼使用圖生圖（Img2Img）？',
                upload_image: '難以用文字描述姿勢或構圖？只要上傳參考圖片。我們的 Img2Img 引擎會保留原始結構，但重新繪製細節。',
                resolution: '把粗略塗鴉或線框快速變成寫實渲染或高品質插畫，特別適合設計師與建築師。',
                output: '生成可直接使用的素材。不同於只輸出小圖的工具，微鲤AI 支援 1K、2K、4K 解析度，細節更清晰。',
                faq: [
                    {
                        question: '什麼是圖生圖 AI？',
                        answer: '圖生圖（Img2Img）是一種技術，使用上傳圖片作為「參考」，並搭配文字提示生成新圖片，融合視覺輸入與創意描述。',
                    },
                    {
                        question: '如何將素描轉成寫實照片？',
                        answer: '把素描上傳到「圖片」區域。在「提示詞」輸入框描述內容（例如「現代別墅、夕陽、寫實、8k」）。點擊建立即可。',
                    },
                    {
                        question: '它會保留原本的臉／人物嗎？',
                        answer: '會盡量保留整體結構與姿勢。如需精準保留臉部身份，建議使用我們的「照片換臉」工具。',
                    },
                    {
                        question: '支援哪些長寬比？',
                        answer: '支援 9:16（Story）、16:9（Cinematic）、3:4、1:1 等多種比例，確保作品適配各平台。',
                    },
                    {
                        question: '免費嗎？',
                        answer: '是的，你可以使用每日免費點數生成變體。',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: '免費 AI 圖像擴展與尺寸調整 - 智慧補全背景 | 微鲤AI',
            description: '無需裁剪即可調整圖像尺寸。使用 AI Outpainting 技術智慧擴展背景，完美適配社群媒體。',
            keywords: '圖像擴展, AI 補全, 尺寸調整, 背景擴展, 微鲤AI',
        },
        imageTextTranslate: {
            title: '免費 AI 圖片文字翻譯 - 支援漫畫與海報翻譯 | 微鲤AI',
            description: '即時翻譯圖片中的文字並保持原始風格。自動擦除原文字並重新繪製背景。',
            keywords: '圖片翻譯, 漫畫翻譯, OCR 翻譯, 文字替換, 微鲤AI',
            og_title: '免費 AI 圖片文字翻譯 - 支援漫畫與海報翻譯 | 微鲤AI',
            og_description: '即時翻譯圖片中的文字並保持原始風格。自動擦除原文字並重新繪製背景。',
            twitter_title: '免費 AI 圖片文字翻譯 - 支援漫畫與海報翻譯 | 微鲤AI',
            twitter_description: '即時翻譯圖片中的文字並保持原始風格。自動擦除原文字並重新繪製背景。',
            page: {
                title1: '免費 AI 圖片翻譯器 & 文字替換',
                title2: '秒級翻譯海報、菜單、漫畫和螢幕截圖。不同於僅疊加文字的普通翻譯器，微鲤AI 使用產生式 AI 擦除原始文字並重繪背景，讓翻譯後的文字宛如原生設計。',
                faq: [
                    {
                        question: '如何翻譯圖片中的文字？',
                        answer: '將您的圖片（JPG、PNG）上傳到 微鲤AI。選擇來源語言（或使用自動檢測）和目標語言。點擊「產生」讓 AI 替換文字。',
                    },
                    {
                        question: '翻譯後的文字看起來自然嗎？',
                        answer: '是的。微鲤AI 會嘗試匹配原始文字的字體大小和風格。最重要的是，它會重繪文字背後的背景，使翻譯內容完美融合。',
                    },
                    {
                        question: '我可以使用它來翻譯漫畫嗎？',
                        answer: '當然可以。這是最佳使用場景之一。AI 會檢測對話氣泡和垂直文字（常見於日語），並將其替換為橫向翻譯文字。',
                    },
                    {
                        question: '支援哪些語言？',
                        answer: '我們支援全球主要語言之間的互譯，包括英語、西班牙語、中文、日語、韓語、法語、德語等。',
                    },
                    {
                        question: '它對手寫文字有效嗎？',
                        answer: '它對列印文本效果最好，但我們先進的 OCR 引擎也可以識別白板或筆記上清晰的手寫文字。',
                    },
                    {
                        question: '它是免費的嗎？',
                        answer: '您可以使用每日免費點數免費翻譯圖片。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何翻譯圖片中的文字？',
                    answer: '將您的圖片上傳到 微鲤AI。選擇目標語言並點擊「產生」。AI 將用翻譯替換原始文字。',
                },
                {
                    question: '翻譯後的文字看起來自然嗎？',
                    answer: '是的。微鲤AI 會重繪文字背後的背景，並嘗試匹配字體風格，確保翻譯內容無縫融合。',
                },
                {
                    question: '我可以使用它來翻譯漫畫嗎？',
                    answer: '當然可以。這是最佳使用場景之一。AI 會檢測對話氣泡和垂直文字（常見於日語），並將其替換為橫向翻譯文字。',
                },
            ],
            feature_title1: '智慧擦除與重繪',
            feature_desc1: '無痕文字替換：我們的 AI 會分析文字背後的背景紋理。它會智慧擦除原始文字並填補空隙，然後再添加翻譯，確保沒有醜陋的文本框遮擋您的圖片。',
            feature_title2: '漫畫與動漫翻譯',
            feature_desc2: '即時閱讀生肉漫畫：動漫迷的完美選擇。上傳日文/韓文生肉漫畫頁面，獲取完美貼合對話氣泡的即時英文或中文翻譯。',
            feature_title3: '全球行銷本地化',
            feature_desc3: '一鍵本地化：產品要推向全球？將您的行銷海報、橫幅和 UI 截圖翻譯成 30 多種語言，無需原始 PSD 文件。',
        },
        aiBackgroundChanger: {
            title: '免費 AI 背景更換器 - 從文字產生背景 | 微鲤AI',
            description: '使用 AI 立即更換照片背景。描述您想要的場景，微鲤AI 將為產品攝影、LinkedIn 頭像和創意肖像產生真實背景。免費且在線。',
            keywords: '更換照片背景, AI 背景產生器, 產品攝影 AI, 白色背景製作, 在線替換背景, 產生式填充背景',
        },
        imageUpscaler: {
            title: '免費 AI 圖片放大器 - 升級至 4K 並修復舊照片 | 微鲤AI',
            description: '使用 微鲤AI 的免費 AI 圖片增強器，立即將低解析度圖片升級至 2x、4x 和 4K。在線修復模糊照片、消除噪點並修復舊家庭照片。無損畫質。',
            keywords: 'AI 圖片放大器, 照片增強器, 升級圖片至 4K, 消除圖片模糊, 舊照片修復, 修復像素化照片, 提高圖片解析度',
        },
        photoFaceSwap: {
            title: '免費 AI 照片換臉在線 - 超逼真照片換臉器 | 微鲤AI',
            description: '使用 微鲤AI 的免費 AI 換臉器立即更換照片中的臉部。建立有趣的迷因、藝術肖像（蒙娜麗莎）或具有高度真實感的專業頭像。100% 私密且安全。',
            keywords: 'AI 換臉, 在線換臉, 照片換臉器, 免費換臉, 替換圖片中的臉部, Deepfake 照片, 迷因製作 AI',
        },
        removeTextFromImage: {
            title: '免費 AI 圖片文字刪除器 - 擦除浮水印和日期標記 | 微鲤AI',
            description: '使用 微鲤AI 的免費 AI 文字擦除器，立即從圖像中刪除文字、日期標記、標誌和字幕。使用 AI Inpainting 完美修復背景。非常適合清理照片和電子商務模型。',
            keywords: '從圖像中刪除文字, AI 文字刪除器, 刪除日期標記, 在線刪除浮水印, 清理圖片, AI Inpainting, 從照片中刪除標誌',
            og_title: '免費 AI 圖片文字刪除器 - 擦除浮水印和日期標記 | 微鲤AI',
            og_description: '使用 微鲤AI 的免費 AI 文字擦除器，立即從圖像中刪除文字、日期標記、標誌和字幕。使用 AI Inpainting 完美修復背景。非常適合清理照片和電子商務模型。',
            twitter_title: '免費 AI 圖片文字刪除器 - 擦除浮水印和日期標記 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的免費 AI 文字擦除器，立即從圖像中刪除文字、日期標記、標誌 and 字幕。使用 AI Inpainting 完美修復背景。非常適合清理照片和電子商務模型。',
            page: {
                title1: '免費 AI 圖片文字刪除器',
                title2: '被不想要的文字干擾？只需上傳您的圖片，我們的 AI 就會立即檢測並擦除文字、標誌、日期標記或字幕。它會智慧分析周圍的像素以重建背景，不留痕跡。',
                faq: [
                    {
                        question: '如何在不模糊的情況下刪除圖片中的文字？',
                        answer: '使用 微鲤AI 的 AI 文字刪除器。我們的工具不使用模糊，而是使用 AI Inpainting 技術分析周圍環境並產生新的像素，以無縫填充間隙。',
                    },
                    {
                        question: '我可以從照片中刪除日期標記嗎？',
                        answer: '是的！這是一個完美的案例。AI 可以輕鬆識別日期/時間標記的數位字體並將其刪除，同時修復背後的風景。',
                    },
                    {
                        question: '它在複雜背景下有效嗎？',
                        answer: '是的。如我們的範例所示，它可以透過理解紋理流動，甚至從山脈或有圖案的衣服等複雜背景中刪除文字。',
                    },
                    {
                        question: '我可以用它來刪除人物或物體嗎？',
                        answer: '雖然針對文字進行了優化，但底層技術（Inpainting）在刪除不想要的小物體、皮膚瑕疵或雜物方面也表現良好。',
                    },
                    {
                        question: '它是免費的嗎？',
                        answer: '是的，您可以使用每日點數免費使用 AI 文字刪除器。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何在不模糊的情況下刪除圖片中的文字？',
                    answer: '使用 微鲤AI 的 AI 文字刪除器。我們的工具使用 AI Inpainting 技術分析周圍環境並產生新的像素，以無縫填充間隙。',
                },
                {
                    question: '我可以從照片中刪除日期標記嗎？',
                    answer: '是的！AI 可以輕鬆識別日期/時間標記的數位字體並將其刪除，同時修復背後的風景。',
                },
                {
                    question: '它在複雜背景下有效嗎？',
                    answer: '是的。如我們的範例所示，它可以透過理解紋理流動，甚至從山脈或有圖案的衣服等複雜背景中刪除文字。',
                },
            ],
            feature_title1: '服裝與設計清理',
            feature_desc1: '非常適合模型：在線轉售衣服？從 T 恤模特照片中刪除現有的標誌、標語 or 圖形，為您自己的設計建立一個乾淨的版面。',
            feature_title2: '記憶修復',
            feature_desc2: '擦除日期標記：從您的舊家庭照片或旅行照中刪除干擾的橙色數位日期標記，而不會損壞底層風景。',
            feature_title3: '智慧 Inpainting',
            feature_desc3: '無縫背景填充：與留下模糊的基礎擦除工具不同，微鲤AI 使用產生式 AI 在擦除區域中“繪製”真實紋理（如草地、天空或山脈）。',
        },
        imgExtender: {
            title: '立即免費擴展圖片 - AI 圖片擴展器 | 微鲤AI',
            description: '使用 微鲤AI 的免費 AI 圖片擴展器立即突破照片的原始邊界。我們的 AI Outpainting 工具產生與您上傳內容完美融合的新像素—將肖像轉換為廣角鏡頭，同時保持原始外觀和品質。',
            keywords: 'AI 圖片擴展器, 免費圖片擴展, 廣角照片產生器, 擴展照片邊界, 無縫 Outpainting, 保留原始品質',
        },
        photoRestoration: {
            title: '免費 AI 照片修復 - 為黑白照片上色並修復劃痕 | 微鲤AI',
            description: '使用 微鲤AI 的免費 AI 照片修復功能重現舊的家庭記憶。自動為黑白照片上色，刪除劃痕、撕裂和模糊，立即修復面部。',
            keywords: '舊照片修復, 照片上色, 修復劃痕照片, AI 照片修理, 修復舊圖片, 黑白轉彩色, 圖像修復 AI',
        },
        photoEffects: {
            title: '圖片特效 - AI 圖像特效產生器 | 微鲤AI',
            description: '使用 AI 驅動的特效轉換您的照片。在線免費建立驚豔的圖片濾鏡、風格與轉換。',
            keywords: '圖片特效, AI 圖像, 濾鏡, 圖片轉換, 微鲤AI',
        },
    },
    pl: {
        textToImage: {
            title: 'Darmowy generator obrazów AI z tekstu - Twórz sztukę 4K i realistyczne zdjęcia | 微鲤AI',
            description: 'Zamień opisy tekstowe w zachwycające grafiki dzięki generatorowi tekst→obraz 微鲤AI. Model Nano Banana Pro zapewnia wysoką wierność. Obsługa rozdzielczości 1K/2K/4K i proporcji 9:16/16:9. Za darmo i online.',
            keywords: 'tekst na obraz, generator obrazów AI, generator sztuki AI, obrazy AI 4K, model Nano Banana, Flux AI za darmo, generator tapet, tworzenie obrazów z tekstu',
            og_title: 'Darmowy generator obrazów AI z tekstu - Twórz sztukę 4K i realistyczne zdjęcia | 微鲤AI',
            og_description: 'Zamień opisy tekstowe w zachwycające grafiki dzięki generatorowi tekst→obraz 微鲤AI. Model Nano Banana Pro zapewnia wysoką wierność. Obsługa rozdzielczości 1K/2K/4K i proporcji 9:16/16:9. Za darmo i online.',
            twitter_title: 'Darmowy generator obrazów AI z tekstu - Twórz sztukę 4K i realistyczne zdjęcia | 微鲤AI',
            twitter_description: 'Zamień opisy tekstowe w zachwycające grafiki dzięki generatorowi tekst→obraz 微鲤AI. Model Nano Banana Pro zapewnia wysoką wierność. Obsługa rozdzielczości 1K/2K/4K i proporcji 9:16/16:9. Za darmo i online.',
            faq: [
                {
                    question: 'Jak wygenerować obrazy AI w 4K?',
                    answer: 'Wpisz prompt i wybierz „4K” w ustawieniach rozmiaru obrazu po lewej stronie, a następnie kliknij Utwórz.',
                },
                {
                    question: 'Jakie proporcje obrazu są obsługiwane?',
                    answer: 'Obsługujemy wszystkie główne proporcje, w tym 1:1, 9:16 (Mobile), 16:9 (Desktop), 4:3 i 3:2.',
                },
                {
                    question: 'Czy mogę używać obrazów komercyjnie?',
                    answer: 'Tak. Obrazy generowane w planach 微鲤AI zwykle mają licencję komercyjną odpowiednią do reklam i produktów.',
                },
            ],
            page: {
                title1: 'Darmowy generator obrazów AI z tekstu',
                title2: 'Twórz zachwycającą sztukę, fotorealistyczne obrazy i unikalne tapety w kilka sekund. Opisz, co chcesz zobaczyć, a nasz zaawansowany model Nano Banana Pro wygeneruje obrazy 4K idealnie dopasowane do Twojego promptu.',
                resolution: 'Nie zadowalaj się rozmytymi obrazami AI. 微鲤AI pozwala generować wyraźne obrazy 1K, 2K i 4K — idealne do druku lub wyświetlaczy wysokiej rozdzielczości.',
                aspectRatio: 'Potrzebujesz 9:16 na tło TikToka, 16:9 na miniatury YouTube lub 1:1 na Instagrama? Mamy presety dla każdej platformy społecznościowej.',
                online_search: 'Potrzebujesz aktualnego kontekstu? Włącz "Online Search", aby AI mogła przeglądać sieć i lepiej rozumieć bieżące wydarzenia lub konkretne odniesienia w promptach.',
                faq: [
                    {
                        question: 'Jak generować wysokiej jakości obrazy z tekstu?',
                        answer: 'Wpisz szczegółowy prompt opisujący temat, oświetlenie i styl. Wybierz „4K” w ustawieniach rozmiaru obrazu, aby uzyskać najostrzejsze detale.',
                    },
                    {
                        question: 'Czym jest model Nano Banana Pro?',
                        answer: 'Nano Banana Pro to nasz model o najwyższej wierności, zoptymalizowany pod zgodność z promptem i fotorealizm. Jakością dorównuje Midjourney v6 i Flux.',
                    },
                    {
                        question: 'Czy mogę używać obrazów komercyjnie?',
                        answer: 'Tak. Obrazy generowane w 微鲤AI (plany płatne) mają licencję komercyjną i mogą być używane w reklamach, na stronach i produktach.',
                    },
                    {
                        question: 'Ile obrazów mogę wygenerować naraz?',
                        answer: 'Do 4 obrazów jednocześnie (jak w ustawieniu „Output Image Number”), co pozwala szybko iterować pomysły.',
                    },
                    {
                        question: 'Czy to jest darmowe?',
                        answer: 'Tak, możesz generować obrazy z darmowych dziennych kredytów. Wyższe rozdzielczości (4K) mogą wymagać większej liczby kredytów.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Darmowy generator AI obraz→obraz - Zamień zdjęcia w sztukę i 4K | 微鲤AI',
            description: 'Prześlij zdjęcie referencyjne i przekształć je dzięki Image to Image AI 微鲤AI. Zamieniaj szkice w realistyczną sztukę, zmieniaj style lub twórz wariacje, zachowując oryginalną kompozycję. Obsługa 4K.',
            keywords: 'obraz na obraz AI, img2img, zamień zdjęcie w rysunek, wariacje obrazu AI, szkic na obraz, remix zdjęć AI, darmowy generator sztuki AI',
            og_title: 'Darmowy generator AI obraz→obraz - Zamień zdjęcia w sztukę i 4K | 微鲤AI',
            og_description: 'Prześlij zdjęcie referencyjne i przekształć je dzięki Image to Image AI 微鲤AI. Zamieniaj szkice w realistyczną sztukę, zmieniaj style lub twórz wariacje, zachowując oryginalną kompozycję. Obsługa 4K.',
            twitter_title: 'Darmowy generator AI obraz→obraz - Zamień zdjęcia w sztukę i 4K | 微鲤AI',
            twitter_description: 'Prześlij zdjęcie referencyjne i przekształć je dzięki Image to Image AI 微鲤AI. Zamieniaj szkice w realistyczną sztukę, zmieniaj style lub twórz wariacje, zachowując oryginalną kompozycję. Obsługa 4K.',
            faq: [
                {
                    question: 'Czym jest Image to Image AI?',
                    answer: 'Image to Image (Img2Img) używa przesłanego obrazu jako referencji wraz z promptem tekstowym, aby wygenerować nowy obraz, łącząc wejście wizualne z opisem kreatywnym.',
                },
                {
                    question: 'Jak zamienić szkic w realistyczne zdjęcie?',
                    answer: 'Prześlij szkic, wpisz prompt opisujący scenę (np. „fotorealistyczny budynek”), a następnie kliknij Utwórz.',
                },
                {
                    question: 'Czy zachowuje oryginalną twarz?',
                    answer: 'Zachowuje strukturę i pozę. Aby precyzyjnie zachować tożsamość twarzy, użyj naszego narzędzia Photo Face Swap.',
                },
            ],
            page: {
                title1: 'Darmowy generator AI obraz→obraz',
                title2: 'Użyj istniejących obrazów jako planu. Prześlij zdjęcie, szkic lub układ, a AI odtworzy go w nowym stylu na podstawie promptu. Idealne do zachowania kompozycji i odkrywania nieskończonych wariacji.',
                title3: 'Zmień styl swoich zdjęć dzięki AI',
                title4: 'Dlaczego warto używać Image to Image (Img2Img)?',
                upload_image: 'Masz problem z opisaniem pozy lub układu? Po prostu prześlij obraz referencyjny. Nasz silnik Img2Img zachowuje strukturę oryginału, ale przerysowuje detale.',
                resolution: 'Zamień szkic lub makietę w fotorealistyczny render albo wysokiej jakości ilustrację w kilka sekund. Idealne dla projektantów i architektów.',
                output: 'Generuj zasoby gotowe do użycia. W przeciwieństwie do innych narzędzi, 微鲤AI obsługuje 1K, 2K i 4K, aby uzyskać ostre detale.',
                faq: [
                    {
                        question: 'Czym jest Image to Image AI?',
                        answer: 'Image to Image (Img2Img) to technologia, która używa przesłanego obrazu jako „referencji” wraz z promptem tekstowym, aby wygenerować nowy obraz. Łączy wejście wizualne z opisem kreatywnym.',
                    },
                    {
                        question: 'Jak zamienić szkic w realistyczne zdjęcie?',
                        answer: 'Prześlij szkic do obszaru „Image”. W polu „Prompt” opisz, co przedstawia szkic (np. „Nowoczesna willa, zachód słońca, fotorealistycznie, 8k”). Kliknij Utwórz.',
                    },
                    {
                        question: 'Czy zachowuje oryginalną twarz/osobę?',
                        answer: 'Stara się zachować ogólną strukturę i pozę. Dla precyzyjnego zachowania tożsamości twarzy polecamy narzędzie „Photo Face Swap”.',
                    },
                    {
                        question: 'Jakie proporcje są obsługiwane?',
                        answer: 'Obsługujemy szeroki zakres proporcji, w tym 9:16 (Story), 16:9 (Cinematic), 3:4 i 1:1, aby Twoja grafika pasowała do każdej platformy.',
                    },
                    {
                        question: 'Czy to jest darmowe?',
                        answer: 'Tak, możesz generować wariacje za darmo, korzystając z dziennych kredytów.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Zmień rozmiar obrazu AI - Inteligentne kadrowanie i skalowanie | 微鲤AI',
            description: 'Zmieniaj rozmiar i proporcje obrazów bez utraty jakości. Idealne dla mediów społecznościowych.',
            keywords: 'zmiana rozmiaru obrazu, kadrowanie AI, skalowanie, 微鲤AI',
        },
        imageTextTranslate: {
            title: 'Darmowy tłumacz obrazów AI - Tłumaczenie tekstów na zdjęciach, mangi i komiksów',
            description: 'Błyskawicznie tłumacz tekst na obrazach, zachowując oryginalny styl wizualny. Tłumacz obrazów AI 微鲤AI automatycznie wymazuje oryginalny tekst i przerysowuje tłumaczenia. Idealny do komiksów, mangi i plakatów marketingowych.',
            keywords: 'tłumacz obrazów ai, tłumacz tekst na obrazie, tłumacz zdjęć, tłumacz mangi, tłumacz komiksów, tłumacz ocr, wymiana tekstu w obrazie',
            og_title: 'Darmowy tłumacz obrazów AI - Tłumaczenie tekstów na zdjęciach, mangi i komiksów',
            og_description: 'Błyskawicznie tłumacz tekst na obrazach, zachowując oryginalny styl wizualny. Tłumacz obrazów AI 微鲤AI automatycznie wymazuje oryginalny tekst i przerysowuje tłumaczenia. Idealny do komiksów, mangi i plakatów marketingowych.',
            twitter_title: 'Darmowy tłumacz obrazów AI - Tłumaczenie tekstów na zdjęciach, mangi i komiksów',
            twitter_description: 'Błyskawicznie tłumacz tekst na obrazach, zachowując oryginalny styl wizualny. Tłumacz obrazów AI 微鲤AI automatycznie wymazuje oryginalny tekst i przerysowuje tłumaczenia. Idealny do komiksów, mangi i plakatów marketingowych.',
            page: {
                title1: 'Darmowy tłumacz obrazów AI i narzędzie do zastępowania tekstu',
                title2: 'Tłumacz plakaty, menu, komiksy i zrzuty ekranu w kilka sekund. W przeciwieństwie do standardowych tłumaczy, które tylko nakładają tekst, 微鲤AI używa generatywnej sztucznej inteligencji do wymazywania oryginalnego tekstu i przerysowywania tła, dzięki czemu przetłumaczony tekst wygląda, jakby był częścią oryginalnego projektu.',
                faq: [
                    {
                        question: 'Jak przetłumaczyć tekst wewnątrz obrazu?',
                        answer: 'Prześlij swój obraz (JPG, PNG) do 微鲤AI. Wybierz język źródłowy (lub użyj automatycznego wykrywania) i język docelowy. Kliknij „Utwórz”, aby pozwolić AI zastąpić tekst.',
                    },
                    {
                        question: 'Czy przetłumaczony tekst będzie wyglądał naturalnie?',
                        answer: 'Tak. 微鲤AI próbuje dopasować rozmiar i styl czcionki oryginalnego tekstu. Co najważniejsze, przerysowuje tło za tekstem, dzięki czemu tłumaczenie wtapia się bezproblemowo.',
                    },
                    {
                        question: 'Czy mogę użyć tego do tłumaczenia mangi lub manhwy?',
                        answer: 'Absolutnie. To jeden z najlepszych przypadków użycia. AI wykrywa dymki i tekst pionowy (powszechny w języku japońskim), zastępując go poziomym tekstem przetłumaczonym.',
                    },
                    {
                        question: 'Jakie języki są obsługiwane?',
                        answer: 'Obsługujemy tłumaczenia między głównymi językami globalnymi, w tym angielskim, hiszpańskim, chińskim, japońskim, koreańskim, francuskim, niemieckim i innymi.',
                    },
                    {
                        question: 'Czy to działa na tekście odręcznym?',
                        answer: 'Najlepiej działa na tekście drukowanym, ale nasz zaawansowany silnik OCR potrafi rozpoznać wyraźny tekst odręczny na tablicach lub notatkach.',
                    },
                    {
                        question: 'Czy to jest darmowe?',
                        answer: 'Możesz tłumaczyć obrazy za darmo, korzystając z dziennych kredytów.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Jak przetłumaczyć tekst wewnątrz obrazu?',
                    answer: 'Prześlij swój obraz do 微鲤AI. Wybierz język docelowy i kliknij „Utwórz”. AI zastąpi oryginalny tekst tłumaczeniem.',
                },
                {
                    question: 'Czy przetłumaczony tekst będzie wyglądał naturalnie?',
                    answer: 'Tak. 微鲤AI przerysowuje tło za tekstem i próbuje dopasować styl czcionki, zapewniając płynne wtopienie się tłumaczenia.',
                },
                {
                    question: 'Czy mogę użyć tego do tłumaczenia mangi lub manhwy?',
                    answer: 'Absolutnie. To jeden z najlepszych przypadków użycia. AI wykrywa dymki i tekst pionowy, zastępując je poziomym tekstem przetłumaczonym.',
                },
            ],
            feature_title1: 'Inteligentne uzupełnianie i przerysowywanie',
            feature_desc1: 'Bezproblemowa wymiana tekstu: Nasza AI analizuje teksturę tła za tekstem. Inteligentnie wymazuje oryginalne słowa i wypełnia lukę przed dodaniem tłumaczenia, zapewniając, że żadne brzydkie pola tekstowe nie zakrywają obrazu.',
            feature_title2: 'Tłumaczenie mangi i komiksów',
            feature_desc2: 'Czytaj surową mangę natychmiast: Idealne dla fanów anime. Prześlij surowe strony mangi (japońskiej/koreańskiej) i uzyskaj natychmiastowe tłumaczenia, które idealnie pasują do dymków.',
            feature_title3: 'Globalna lokalizacja marketingu',
            feature_desc3: 'Lokalizacja jednym kliknięciem: Wprowadzasz produkty na rynek globalny? Tłumacz plakaty marketingowe, banery i zrzuty ekranu interfejsu użytkownika na ponad 30 języków bez potrzeby posiadania oryginalnych plików PSD.',
        },
        aiBackgroundChanger: {
            title: 'Darmowe narzędzie AI do zmiany tła - Zmieniaj tło za pomocą tekstu | 微鲤AI',
            description: 'Błyskawicznie zmieniaj tła zdjęć za pomocą AI. Opisz scenę, którą chcesz uzyskać.',
            keywords: 'zmiana tła AI, zmień tło, 微鲤AI',
        },
        imageUpscaler: {
            title: 'Darmowy AI Image Upscaler - Zwiększ jakość do 4K | 微鲤AI',
            description: 'Zwiększaj rozdzielczość obrazów do 4K za pomocą AI Enhancer.',
            keywords: 'upscaler obrazu, ai enhancer, 4k, 微鲤AI',
        },
        photoFaceSwap: {
            title: 'Darmowa podmiana twarzy na zdjęciach online | 微鲤AI',
            description: 'Zmieniaj twarze na zdjęciach błyskawicznie z wysokim realizmem.',
            keywords: 'face swap, podmiana twarzy, WeryAI',
            page: {
                title1: 'Darmowa podmiana twarzy AI',
                title2: 'Chcesz zobaczyć siebie jako astronautę, gwiazdę filmową lub na klasycznym obrazie? Prześlij zdjęcie bazowe i twarz docelową, a nasza AI płynnie połączy cechy twarzy, oświetlenie i odcienie skóry, tworząc hiperrealistyczną podmianę w kilka sekund.',
            },
            feature_title1: 'Arcydzieła artystyczne',
            feature_desc1: 'Podróż w czasie: Podmień swoją twarz na klasyczne obrazy jak Mona Lisa lub Dziewczyna z perłą. Twórz unikalne awatary w stylu vintage natychmiast.',
            feature_title2: 'Profesjonalne i stylowe awatary',
            feature_desc2: 'Praca marzeń: Zobacz siebie w kombinezonie wyścigowym, stroju astronauty lub garniturze biznesowym bez kupowania kostiumu. Idealne do tworzenia wyróżniających się zdjęć profilowych.',
            feature_title3: 'Hiperrealistyczne mieszanie',
            feature_desc3: 'Bez efektu „wklejania": W przeciwieństwie do prostych narzędzi wycinania, WeryAI analizuje kąt, oświetlenie i teksturę skóry, aby zamieniona twarz wyglądała w 100% naturalnie.',
        },
        removeTextFromImage: {
            title: 'Darmowe narzędzie AI do usuwania tekstu z obrazów - Wymazywanie znaków wodnych i datowników',
            description: 'Błyskawicznie usuwaj tekst, datowniki, logo i napisy z obrazów za pomocą darmowej gumki AI od 微鲤AI. Idealnie przywracaj tło dzięki technologii AI Inpainting. Idealne do czyszczenia zdjęć i makiet e-commerce.',
            keywords: 'usuwanie tekstu z obrazu, narzędzie AI do usuwania tekstu, usuń datownik, usuń znak wodny online, czyszczenie zdjęć, AI inpainting, usuń logo ze zdjęcia',
            og_title: 'Darmowe narzędzie AI do usuwania tekstu z obrazów - Wymazywanie znaków wodnych i datowników',
            og_description: 'Błyskawicznie usuwaj tekst, datowniki, logo i napisy z obrazów za pomocą darmowej gumki AI od 微鲤AI. Idealnie przywracaj tło dzięki technologii AI Inpainting. Idealne do czyszczenia zdjęć i makiet e-commerce.',
            twitter_title: 'Darmowe narzędzie AI do usuwania tekstu z obrazów - Wymazywanie znaków wodnych i datowników',
            twitter_description: 'Błyskawicznie usuwaj tekst, datowniki, logo i napisy z obrazów za pomocą darmowej gumki AI od 微鲤AI. Idealnie przywracaj tło dzięki technologii AI Inpainting. Idealne do czyszczenia zdjęć i makiet e-commerce.',
            page: {
                title1: 'Darmowe narzędzie AI do usuwania tekstu z obrazów',
                title2: 'Przeszkadza Ci niechciany tekst? Po prostu prześlij obraz, a nasza AI natychmiast wykryje i usunie tekst, logo, datowniki lub napisy. Inteligentnie analizuje otaczające piksele, aby zrekonstruować tło, nie pozostawiając żadnych śladów.',
                faq: [
                    {
                        question: 'Jak usunąć tekst ze zdjęcia bez jego rozmycia?',
                        answer: 'Użyj narzędzia AI Text Remover od 微鲤AI. Zamiast rozmycia, nasze narzędzie wykorzystuje technologię AI Inpainting do analizy otoczenia i generowania nowych pikseli, które płynnie wypełniają lukę.',
                    },
                    {
                        question: 'Czy mogę usunąć datowniki ze zdjęć?',
                        answer: 'Tak! To idealne zastosowanie. AI z łatwością rozpoznaje cyfrowe czcionki datowników/znaczników czasu i usuwa je, przywracając krajobraz w tle.',
                    },
                    {
                        question: 'Czy to działa na złożonych tłach?',
                        answer: 'Tak. Jak pokazano w naszych przykładach, może usuwać tekst nawet ze złożonych teł, takich jak pasma górskie lub wzorzysta odzież, rozumiejąc strukturę tekstury.',
                    },
                    {
                        question: 'Czy mogę go użyć do usuwania ludzi lub przedmiotów?',
                        answer: 'Chociaż narzędzie jest zoptymalizowane pod kątem tekstu, technologia Inpainting dobrze radzi sobie również z usuwaniem małych niechcianych obiektów, niedoskonałości skóry lub bałaganu.',
                    },
                    {
                        question: 'Czy to jest darmowe?',
                        answer: 'Tak, możesz korzystać z AI Text Remover za darmo dzięki dziennym kredytom.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Jak usunąć tekst ze zdjęcia bez jego rozmycia?',
                    answer: 'Użyj narzędzia AI Text Remover od 微鲤AI. Zamiast rozmycia, nasze narzędzie wykorzystuje technologię AI Inpainting do analizy otoczenia i generowania nowych pikseli, które płynnie wypełniają lukę.',
                },
                {
                    question: 'Czy mogę usunąć datowniki ze zdjęć?',
                    answer: 'Tak! AI z łatwością rozpoznaje cyfrowe czcionki datowników/znaczników czasu i usuwa je, przywracając krajobraz w tle.',
                },
                {
                    question: 'Czy to działa na złożonych tłach?',
                    answer: 'Tak. Jak pokazano w naszych przykładach, może usuwać tekst nawet ze złożonych teł, takich jak pasma górskie lub wzorzysta odzież, rozumiejąc strukturę tekstury.',
                },
            ],
            feature_title1: 'Czyszczenie odzieży i projektów',
            feature_desc1: 'Idealne do makiet: Sprzedajesz ubrania online? Usuń istniejące logo, slogany lub grafiki ze zdjęć modeli w koszulkach, aby stworzyć czystą kartę dla własnych projektów.',
            feature_title2: 'Przywracanie wspomnień',
            feature_desc2: 'Usuwanie datowników: Usuwaj rozpraszające pomarańczowe cyfrowe datowniki ze starych zdjęć rodzinnych lub zdjęć z podróży bez uszkadzania tła.',
            feature_title3: 'Inteligentne Inpainting',
            feature_desc3: 'Płynne wypełnianie tła: W przeciwieństwie do podstawowych gumek, które pozostawiają rozmycie, 微鲤AI używa generatywnej AI do „malowania” realistycznych tekstur (takich jak trawa, niebo lub góry) w usuniętym obszarze.',
        },
        imgExtender: {
            title: 'Darmowy AI Image Extender - Rozszerzaj zdjęcia | 微鲤AI',
            description: 'Inteligentnie rozszerzaj krawędzie obrazu dzięki AI Outpainting.',
            keywords: 'rozszerzanie obrazu, outpainting, 微鲤AI',
        },
        photoRestoration: {
            title: 'Darmowa naprawa zdjęć AI - Napraw stare zdjęcia | 微鲤AI',
            description: 'Przywracaj stare zdjęcia rodzinne i naprawiaj zadrapania.',
            keywords: 'naprawa zdjęć, naprawianie starych zdjęć, 微鲤AI',
        },
        photoEffects: {
            title: 'Efekty zdjęć - Generator efektów obrazu AI | 微鲤AI',
            description: 'Przekształć swoje zdjęcia dzięki efektom opartym na AI. Twórz zachwycające filtry, style i transformacje obrazów online za darmo.',
            keywords: 'efekty zdjęć AI, filtry AI, edycja zdjęć AI, 微鲤AI',
        },
    },
    th: {
        textToImage: {
            title: 'เครื่องมือสร้างภาพจากข้อความ AI ฟรี - สร้างงานศิลป์ 4K และภาพสมจริง | 微鲤AI',
            description: 'เปลี่ยนข้อความเป็นภาพสวยด้วยเครื่องมือ Text to Image ของ 微鲤AI มาพร้อมโมเดล Nano Banana Pro เพื่อผลลัพธ์ความละเอียดสูง รองรับ 1K/2K/4K และอัตราส่วน 9:16/16:9 ฟรีและใช้งานออนไลน์ได้',
            keywords: 'ข้อความเป็นภาพ, เครื่องมือสร้างภาพ AI, เครื่องมือสร้างศิลปะ AI, ภาพ AI 4K, โมเดล Nano Banana, Flux AI ฟรี, เครื่องมือทำวอลเปเปอร์, สร้างภาพจากข้อความ',
            og_title: 'เครื่องมือสร้างภาพจากข้อความ AI ฟรี - สร้างงานศิลป์ 4K และภาพสมจริง | 微鲤AI',
            og_description: 'เปลี่ยนข้อความเป็นภาพสวยด้วยเครื่องมือ Text to Image ของ 微鲤AI มาพร้อมโมเดล Nano Banana Pro เพื่อผลลัพธ์ความละเอียดสูง รองรับ 1K/2K/4K และอัตราส่วน 9:16/16:9 ฟรีและใช้งานออนไลน์ได้',
            twitter_title: 'เครื่องมือสร้างภาพจากข้อความ AI ฟรี - สร้างงานศิลป์ 4K และภาพสมจริง | 微鲤AI',
            twitter_description: 'เปลี่ยนข้อความเป็นภาพสวยด้วยเครื่องมือ Text to Image ของ 微鲤AI มาพร้อมโมเดล Nano Banana Pro เพื่อผลลัพธ์ความละเอียดสูง รองรับ 1K/2K/4K และอัตราส่วน 9:16/16:9 ฟรีและใช้งานออนไลน์ได้',
            faq: [
                {
                    question: 'ทำอย่างไรถึงจะสร้างภาพ AI 4K ได้?',
                    answer: 'เพียงพิมพ์พรอมต์ แล้วเลือก "4K" ในการตั้งค่าขนาดภาพทางแถบซ้ายก่อนกดสร้าง',
                },
                {
                    question: 'รองรับอัตราส่วนภาพใดบ้าง?',
                    answer: 'เรารองรับอัตราส่วนหลักทั้งหมด เช่น 1:1, 9:16 (มือถือ), 16:9 (เดสก์ท็อป), 4:3 และ 3:2',
                },
                {
                    question: 'สามารถใช้ภาพเชิงพาณิชย์ได้ไหม?',
                    answer: 'ได้ ภาพที่สร้างบนแผน 微鲤AI มักมาพร้อมใบอนุญาตเชิงพาณิชย์ เหมาะสำหรับโฆษณาและสินค้า',
                },
            ],
            page: {
                title1: 'เครื่องมือสร้างภาพจากข้อความ AI ฟรี',
                title2: 'สร้างงานศิลป์ ภาพสมจริง และวอลเปเปอร์สุดพิเศษในไม่กี่วินาที แค่บอกสิ่งที่อยากเห็น โมเดล Nano Banana Pro จะสร้างภาพ 4K ความละเอียดสูงที่ตรงกับพรอมต์ของคุณ',
                resolution: 'อย่าพอใจกับภาพ AI ที่เบลออีกต่อไป 微鲤AI ให้คุณสร้างภาพคมชัดระดับ 1K, 2K และ 4K ได้โดยตรง เหมาะสำหรับงานพิมพ์หรือจอความละเอียดสูง',
                aspectRatio: 'ไม่ว่าจะต้องการภาพ 9:16 สำหรับพื้นหลัง TikTok, 16:9 สำหรับภาพย่อ YouTube หรือ 1:1 สำหรับ Instagram เรามีพรีเซ็ตสำหรับทุกแพลตฟอร์ม',
                online_search: 'ต้องการบริบทล่าสุดไหม? เปิด "Online Search" ให้ AI ท่องเว็บเพื่อเข้าใจเหตุการณ์ปัจจุบันหรือการอ้างอิงเฉพาะในพรอมต์ของคุณ',
                faq: [
                    {
                        question: 'ทำอย่างไรให้สร้างภาพคุณภาพสูงจากข้อความ?',
                        answer: 'ใส่พรอมต์ที่ละเอียด อธิบายหัวข้อ แสง และสไตล์ เลือก "4K" ในการตั้งค่าขนาดภาพเพื่อรายละเอียดที่คมชัดที่สุด',
                    },
                    {
                        question: 'โมเดล Nano Banana Pro คืออะไร?',
                        answer: 'Nano Banana Pro คือโมเดลความละเอียดสูงสุดของเรา ปรับให้ยึดตามพรอมต์และความสมจริง เทียบได้กับ Midjourney v6 และ Flux',
                    },
                    {
                        question: 'ใช้ภาพเชิงพาณิชย์ได้ไหม?',
                        answer: 'ได้ ภาพที่สร้างบน 微鲤AI (แผนชำระเงิน) มาพร้อมใบอนุญาตเชิงพาณิชย์ ใช้ได้กับโฆษณา เว็บไซต์ และสินค้า',
                    },
                    {
                        question: 'สร้างภาพได้กี่ภาพในครั้งเดียว?',
                        answer: 'สร้างได้สูงสุด 4 ภาพพร้อมกัน (ตามการตั้งค่า "Output Image Number") ช่วยให้ทดลองไอเดียได้เร็ว',
                    },
                    {
                        question: 'ฟรีไหม?',
                        answer: 'ฟรี คุณสามารถใช้เครดิตฟรีรายวันเพื่อสร้างภาพได้ ความละเอียดสูง (4K) อาจใช้เครดิตมากขึ้น',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'เครื่องมือ AI ภาพสู่ภาพฟรี - เปลี่ยนรูปเป็นงานศิลป์ & 4K | 微鲤AI',
            description: 'อัปโหลดภาพอ้างอิงแล้วแปลงด้วย Image to Image AI ของ 微鲤AI เปลี่ยนสเก็ตช์เป็นงานศิลป์สมจริง เปลี่ยนสไตล์ หรือสร้างเวอร์ชันใหม่โดยยังคงองค์ประกอบเดิม รองรับความละเอียด 4K',
            keywords: 'ภาพสู่ภาพ AI, img2img, เปลี่ยนรูปเป็นภาพวาด, เวอร์ชันภาพ AI, สเก็ตช์เป็นภาพ, รีมิกซ์ภาพ AI, เครื่องมือสร้างศิลปะ AI ฟรี',
            og_title: 'เครื่องมือ AI ภาพสู่ภาพฟรี - เปลี่ยนรูปเป็นงานศิลป์ & 4K | 微鲤AI',
            og_description: 'อัปโหลดภาพอ้างอิงแล้วแปลงด้วย Image to Image AI ของ 微鲤AI เปลี่ยนสเก็ตช์เป็นงานศิลป์สมจริง เปลี่ยนสไตล์ หรือสร้างเวอร์ชันใหม่โดยยังคงองค์ประกอบเดิม รองรับความละเอียด 4K',
            twitter_title: 'เครื่องมือ AI ภาพสู่ภาพฟรี - เปลี่ยนรูปเป็นงานศิลป์ & 4K | 微鲤AI',
            twitter_description: 'อัปโหลดภาพอ้างอิงแล้วแปลงด้วย Image to Image AI ของ 微鲤AI เปลี่ยนสเก็ตช์เป็นงานศิลป์สมจริง เปลี่ยนสไตล์ หรือสร้างเวอร์ชันใหม่โดยยังคงองค์ประกอบเดิม รองรับความละเอียด 4K',
            faq: [
                {
                    question: 'Image to Image AI คืออะไร?',
                    answer: 'Image to Image (Img2Img) ใช้ภาพที่อัปโหลดเป็นภาพอ้างอิงร่วมกับพรอมต์ข้อความเพื่อสร้างภาพใหม่ ผสานข้อมูลภาพกับคำอธิบายเชิงสร้างสรรค์',
                },
                {
                    question: 'ทำอย่างไรให้เปลี่ยนสเก็ตช์เป็นภาพสมจริง?',
                    answer: 'อัปโหลดสเก็ตช์ ใส่พรอมต์อธิบายฉาก (เช่น "อาคารสมจริง") แล้วกดสร้าง',
                },
                {
                    question: 'จะคงใบหน้าเดิมไว้ไหม?',
                    answer: 'จะคงโครงสร้างและท่าทาง หากต้องการคงตัวตนใบหน้าอย่างแม่นยำ ให้ใช้เครื่องมือ Photo Face Swap',
                },
            ],
            page: {
                title1: 'เครื่องมือ AI ภาพสู่ภาพฟรี',
                title2: 'ใช้ภาพที่มีอยู่เป็นพิมพ์เขียว อัปโหลดรูป สเก็ตช์ หรือเลย์เอาต์ แล้วให้ AI สร้างใหม่ด้วยสไตล์ที่แตกต่างตามพรอมต์ เหมาะสำหรับคงองค์ประกอบเดิมและทดลองสไตล์ได้ไม่สิ้นสุด',
                title3: 'เปลี่ยนสไตล์รูปของคุณด้วย AI',
                title4: 'ทำไมต้องใช้ Image to Image (Img2Img)?',
                upload_image: 'อธิบายท่าหรือเลย์เอาต์ด้วยคำพูดยากไหม? แค่อัปโหลดภาพอ้างอิง เครื่องยนต์ Img2Img ของเราจะคงโครงสร้างเดิมไว้ แต่รีเพนต์รายละเอียดใหม่',
                resolution: 'เปลี่ยนสเก็ตช์หรือไวร์เฟรมให้เป็นเรนเดอร์สมจริงหรือภาพประกอบคุณภาพสูงในไม่กี่วินาที เหมาะสำหรับดีไซเนอร์และสถาปนิก',
                output: 'สร้างไฟล์พร้อมใช้งาน แตกต่างจากเครื่องมืออื่นที่ให้ภาพขนาดเล็ก 微鲤AI รองรับ 1K, 2K และ 4K เพื่อรายละเอียดที่คมชัด',
                faq: [
                    {
                        question: 'Image to Image AI คืออะไร?',
                        answer: 'Image to Image (Img2Img) คือเทคโนโลยีที่ใช้ภาพที่อัปโหลดเป็น "ภาพอ้างอิง" ร่วมกับพรอมต์ข้อความเพื่อสร้างภาพใหม่ ผสานข้อมูลภาพกับคำอธิบายเชิงสร้างสรรค์',
                    },
                    {
                        question: 'ทำอย่างไรให้เปลี่ยนสเก็ตช์เป็นภาพสมจริง?',
                        answer: 'อัปโหลดสเก็ตช์ไปที่ส่วน "Image" แล้วใส่พรอมต์อธิบายฉาก (เช่น "บ้านสมัยใหม่, พระอาทิตย์ตก, สมจริง, 8k") จากนั้นกดสร้าง',
                    },
                    {
                        question: 'จะคงใบหน้า/บุคคลเดิมไว้ไหม?',
                        answer: 'พยายามคงโครงสร้างและท่าทาง หากต้องการคงตัวตนใบหน้าอย่างแม่นยำ แนะนำใช้เครื่องมือ "Photo Face Swap"',
                    },
                    {
                        question: 'รองรับอัตราส่วนใดบ้าง?',
                        answer: 'รองรับอัตราส่วนหลากหลาย เช่น 9:16 (Story), 16:9 (Cinematic), 3:4 และ 1:1 เพื่อให้เหมาะกับทุกแพลตฟอร์ม',
                    },
                    {
                        question: 'ฟรีไหม?',
                        answer: 'ฟรี คุณสามารถสร้างเวอร์ชันใหม่ได้ด้วยเครดิตฟรีรายวัน',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'เครื่องมือปรับขนาดภาพ AI - การตัดขอบและขยายภาพอัจฉริยะ | 微鲤AI',
            description: 'เครื่องมือปรับขนาดภาพ AI - การตัดขอบและขยายภาพอัจฉริยะ on 微鲤AI platform. High-quality results.',
            keywords: 'aiImageResizer, AI, 微鲤AI',
        },
        imageTextTranslate: {
            title: 'เครื่องมือแปลข้อความในรูปภาพ AI ฟรี - แปลข้อความในรูปภาพ, มังงะ และคอมิกส์',
            description: 'แปลข้อความในรูปภาพได้ทันทีโดยยังคงสไตล์ภาพเดิมไว้ เครื่องมือแปลรูปภาพ AI ของ 微鲤AI จะลบข้อความเดิมและวาดข้อความแปลใหม่โดยอัตโนมัติ เหมาะสำหรับคอมิกส์, มังงะ และโปสเตอร์การตลาด',
            keywords: 'เครื่องมือแปลรูปภาพ ai, แปลข้อความในรูปภาพ, ตัวแปลรูปภาพ, เครื่องมือแปลมังงะ, แปลคอมิกส์, ตัวแปล ocr, การแทนที่ข้อความในภาพ',
            og_title: 'เครื่องมือแปลข้อความในรูปภาพ AI ฟรี - แปลข้อความในรูปภาพ, มังงะ และคอมิกส์',
            og_description: 'แปลข้อความในรูปภาพได้ทันทีโดยยังคงสไตล์ภาพเดิมไว้ เครื่องมือแปลรูปภาพ AI ของ 微鲤AI จะลบข้อความเดิมและวาดข้อความแปลใหม่โดยอัตโนมัติ เหมาะสำหรับคอมิกส์, มังงะ และโปสเตอร์การตลาด',
            twitter_title: 'เครื่องมือแปลข้อความในรูปภาพ AI ฟรี - แปลข้อความในรูปภาพ, มังงะ และคอมิกส์',
            twitter_description: 'แปลข้อความในรูปภาพได้ทันทีโดยยังคงสไตล์ภาพเดิมไว้ เครื่องมือแปลรูปภาพ AI ของ 微鲤AI จะลบข้อความเดิมและวาดข้อความแปลใหม่โดยอัตโนมัติ เหมาะสำหรับคอมิกส์, มังงะ และโปสเตอร์การตลาด',
            page: {
                title1: 'เครื่องมือแปลรูปภาพ AI และการแทนที่ข้อความฟรี',
                title2: 'แปลโปสเตอร์, เมนู, มังงะ และสกรีนช็อตในไม่กี่วินาที ไม่เหมือนตัวแปลทั่วไปที่แค่แปะข้อความทับ 微鲤AI ใช้ Generative AI เพื่อลบข้อความเดิมและวาดพื้นหลังใหม่ ทำให้ข้อความที่แปลแล้วดูเหมือนเป็นส่วนหนึ่งของดีไซน์ดั้งเดิม',
                faq: [
                    {
                        question: 'ฉันจะแปลข้อความในรูปภาพได้อย่างไร?',
                        answer: 'อัปโหลดรูปภาพของคุณ (JPG, PNG) ไปยัง 微鲤AI เลือกภาษาต้นทาง (หรือใช้การตรวจจับอัตโนมัติ) และภาษาเป้าหมาย คลิก "สร้าง" เพื่อให้ AI แทนที่ข้อความ',
                    },
                    {
                        question: 'ข้อความที่แปลแล้วจะดูเป็นธรรมชาติหรือไม่?',
                        answer: 'ใช่ 微鲤AI พยายามจับคู่ขนาดและสไตล์ฟอนต์ของข้อความเดิม ที่สำคัญคือมันจะวาดพื้นหลังด้านหลังข้อความใหม่เพื่อให้ข้อความแปลกลมกลืนอย่างไร้รอยต่อ',
                    },
                    {
                        question: 'ฉันสามารถใช้สิ่งนี้แปลมังงะหรือมันฮวาได้หรือไม่?',
                        answer: 'แน่นอน นี่คือหนึ่งในกรณีการใช้งานที่ดีที่สุด AI จะตรวจจับฟองคำพูดและข้อความแนวตั้ง (ที่พบบ่อยในภาษาญี่ปุ่น) และแทนที่ด้วยข้อความแปลแนวนอน',
                    },
                    {
                        question: 'รองรับภาษาใดบ้าง?',
                        answer: 'เราเครองรับการแปลระหว่างภาษาหลักๆ ทั่วโลก รวมถึงอังกฤษ, สเปน, จีน, ญี่ปุ่น, เกาหลี, ฝรั่งเศส, เยอรมัน และอื่นๆ',
                    },
                    {
                        question: 'มันใช้ได้กับข้อความที่เขียนด้วยมือหรือไม่?',
                        answer: 'มันทำงานได้ดีที่สุดกับข้อความพิมพ์ แต่เอนจิน OCR ขั้นสูงของเราสามารถจดจำข้อความเขียนด้วยมือที่ชัดเจนบนไวท์บอร์ดหรือบันทึกได้',
                    },
                    {
                        question: 'ฟรีหรือไม่?',
                        answer: 'คุณสามารถแปลรูปภาพได้ฟรีโดยใช้เครดิตรายวันของคุณ',
                    },
                ],
            },
            faq: [
                {
                    question: 'ฉันจะแปลข้อความในรูปภาพได้อย่างไร?',
                    answer: 'อัปโหลดรูปภาพของคุณไปยัง 微鲤AI เลือกภาษาเป้าหมายแล้วคลิก "สร้าง" AI จะแทนที่ข้อความเดิมด้วยข้อความแปล',
                },
                {
                    question: 'ข้อความที่แปลแล้วจะดูเป็นธรรมชาติหรือไม่?',
                    answer: 'ใช่ 微鲤AI จะวาดพื้นหลังด้านหลังข้อความใหม่และพยายามจับคู่สไตล์ฟอนต์ เพื่อให้แน่ใจว่าข้อความแปลกลมกลืนอย่างไร้รอยต่อ',
                },
                {
                    question: 'ฉันสามารถใช้สิ่งนี้แปลมังงะหรือมันฮวาได้หรือไม่?',
                    answer: 'แน่นอน นี่คือหนึ่งในกรณีการใช้งานที่ดีที่สุด AI จะตรวจจับฟองคำพูดและข้อความแนวตั้ง และแทนที่ด้วยข้อความแปลแนวนอน',
                },
            ],
            feature_title1: 'การเติมภาพและวาดใหม่ที่ชาญฉลาด',
            feature_desc1: 'การแทนที่ข้อความไร้รอยต่อ: AI ของเราจะวิเคราะห์พื้นผิวพื้นหลังด้านหลังข้อความ มันจะลบคำเดิมและเติมช่องว่างอย่างชาญฉลาดก่อนที่จะเพิ่มข้อความแปล เพื่อให้แน่ใจว่าไม่มีกล่องข้อความที่น่าเกลียดมาบดบังรูปภาพของคุณ',
            feature_title2: 'การแปลมังงะและคอมิกส์',
            feature_desc2: 'อ่านมังงะดิบได้ทันที: เหมาะสำหรับแฟนๆ อนิเมะ อัปโหลดหน้ามังงะดิบ (ญี่ปุ่น/เกาหลี) และรับข้อความแปลเป็นภาษาอังกฤษหรือไทยทันทีที่พอดีกับฟองคำพูดอย่างสมบูรณ์แบบ',
            feature_title3: 'การปรับแต่งการตลาดระดับโลก',
            feature_desc3: 'การปรับแต่งในคลิกเดียว: จะเปิดตัวผลิตภัณฑ์ทั่วโลกใช่ไหม? แปลโปสเตอร์การตลาด, แบนเนอร์ และสกรีนช็อต UI ของคุณเป็นภาษาต่างๆ กว่า 30 ภาษาโดยไม่จำเป็นต้องใช้ไฟล์ PSD ต้นฉบับ',
        },
        aiBackgroundChanger: {
            title: 'เครื่องมือเปลี่ยนพื้นหลัง AI ฟรี - เปลี่ยนพื้นหลังด้วยข้อความ | 微鲤AI',
            description: 'เปลี่ยนพื้นหลังภาพถ่ายทันทีด้วย AI อธิบายฉากที่คุณต้องการ',
            keywords: 'เครื่องมือเปลี่ยนพื้นหลัง ai, เปลี่ยนพื้นหลัง, 微鲤AI',
        },
        imageUpscaler: {
            title: 'เครื่องมือขยายคุณภาพภาพ AI ฟรี - เพิ่มความคมชัดระดับ 4K | 微鲤AI',
            description: 'ขยายภาพความละเอียดต่ำเป็น 4K ด้วย AI Enhancer',
            keywords: 'ขยายคุณภาพภาพ, ai enhancer, 4k, 微鲤AI',
        },
        photoFaceSwap: {
            title: 'เครื่องมือสลับใบหน้าภาพถ่าย AI ออนไลน์ฟรี | 微鲤AI',
            description: 'สลับใบหน้าในภาพถ่ายทันทีด้วยความสมจริงสูง',
            keywords: 'สลับใบหน้า, ตัวเปลี่ยนใบหน้าในรูปภาพ, WeryAI',
            page: {
                title1: 'สลับใบหน้าภาพถ่าย AI ฟรี',
                title2: 'อยากเห็นตัวเองเป็นนักบินอวกาศ ดาราหนัง หรือในภาพวาดคลาสสิก? อัปโหลดภาพพื้นฐานและใบหน้าเป้าหมาย แล้ว AI ของเราจะผสานลักษณะใบหน้า แสง และโทนสีผิวอย่างลื่นไหล เพื่อสลับใบหน้าแบบสมจริงมากในไม่กี่วินาที',
            },
            feature_title1: 'ผลงานศิลปะชั้นครู',
            feature_desc1: 'ย้อนเวลา: สลับใบหน้าของคุณเข้าไปในภาพวาดสีน้ำมันคลาสสิกอย่าง Mona Lisa หรือ Girl with a Pearl Earring สร้างอวาตาร์วินเทจที่ไม่เหมือนใครทันที',
            feature_title2: 'อวาตาร์มืออาชีพและเท่',
            feature_desc2: 'งานในฝัน: ดูตัวเองในชุดแข่งรถ ชุดนักบินอวกาศ หรือชุดสูทธุรกิจโดยไม่ต้องซื้อเครื่องแต่งกาย เหมาะสำหรับสร้างรูปโปรไฟล์ที่โดดเด่น',
            feature_title3: 'การผสานที่สมจริงมาก',
            feature_desc3: 'ไม่มีเอฟเฟกต์ "วาง": ไม่เหมือนเครื่องมือตัดแปะธรรมดา WeryAI วิเคราะห์มุม แสง และพื้นผิวผิวเพื่อให้ใบหน้าที่สลับดูเป็นธรรมชาติ 100% ไม่ปลอม',
        },
        removeTextFromImage: {
            title: 'เครื่องมือลบข้อความในภาพ AI ฟรี | 微鲤AI',
            description: 'ลบลายน้ำ โลโก้ และข้อความออกจากรูปภาพ',
            keywords: 'ลบข้อความ, ลบตัวอักษร, 微鲤AI',
        },
        imgExtender: {
            title: 'เครื่องมือขยายภาพ AI ฟรี - เติมภาพให้กว้างขึ้น | 微鲤AI',
            description: 'ขยายขอบภาพอย่างชาญฉลาดด้วย AI Outpainting',
            keywords: 'ขยายภาพ, outpainting, 微鲤AI',
        },
        photoRestoration: {
            title: 'เครื่องมือซ่อมแซมภาพถ่าย AI ฟรี - ซ่อมภาพเก่า | 微鲤AI',
            description: 'ฟื้นฟูภาพถ่ายครอบครัวเก่าและซ่อมแซมรอยขีดข่วน',
            keywords: 'ซ่อมแซมภาพถ่าย, ซ่อมภาพเก่า, 微鲤AI',
        },
        photoEffects: {
            title: 'เอฟเฟกต์ภาพถ่าย - เครื่องมือสร้างเอฟเฟกต์ภาพ AI | 微鲤AI',
            description: 'เปลี่ยนภาพถ่ายของคุณด้วยเอฟเฟกต์ที่ขับเคลื่อนด้วย AI สร้างฟิลเตอร์ สไตล์ และการแปลงภาพที่น่าทึ่งออนไลน์ได้ฟรี',
            keywords: 'เอฟเฟกต์ภาพ AI, ฟิลเตอร์ AI, 微鲤AI',
        },
    },
    da: {
        textToImage: {
            title: 'Gratis AI tekst-til-billede generator - Skab 4K kunst og realistiske fotos | 微鲤AI',
            description: `Omdan tekstprompter til imponerende visuals med 微鲤AI's tekst-til-billede generator. Indeholder Nano Banana Pro-modellen for resultater i høj kvalitet. Understøtter 1K/2K/4K opløsning og 9:16/16:9 formater. Gratis og online.`,
            keywords: 'tekst til billede, ai billedgenerator, ai kunst generator, 4k ai billeder, nano banana model, flux ai gratis, tapet generator, lav billeder fra tekst',
            og_title: 'Gratis AI tekst-til-billede generator - Skab 4K kunst og realistiske fotos | 微鲤AI',
            og_description: `Omdan tekstprompter til imponerende visuals med 微鲤AI's tekst-til-billede generator. Indeholder Nano Banana Pro-modellen for resultater i høj kvalitet. Understøtter 1K/2K/4K opløsning og 9:16/16:9 formater. Gratis og online.`,
            twitter_title: 'Gratis AI tekst-til-billede generator - Skab 4K kunst og realistiske fotos | 微鲤AI',
            twitter_description: `Omdan tekstprompter til imponerende visuals med 微鲤AI's tekst-til-billede generator. Indeholder Nano Banana Pro-modellen for resultater i høj kvalitet. Understøtter 1K/2K/4K opløsning og 9:16/16:9 formater. Gratis og online.`,
            faq: [
                {
                    question: 'Hvordan genererer jeg 4K AI-billeder?',
                    answer: 'Indtast din prompt og vælg "4K" i billedstørrelse i venstre panel, før du klikker Opret.',
                },
                {
                    question: 'Hvilke billedformater understøttes?',
                    answer: 'Vi understøtter alle vigtige formater, herunder 1:1, 9:16 (mobil), 16:9 (desktop), 4:3 og 3:2.',
                },
                {
                    question: 'Kan jeg bruge billederne kommercielt?',
                    answer: 'Ja. Billeder genereret på 微鲤AI-planer kommer typisk med en kommerciel licens, der er egnet til annoncer og produkter.',
                },
            ],
            page: {
                title1: 'Gratis AI tekst-til-billede generator',
                title2: 'Skab betagende kunst, fotorealistiske billeder og unikke baggrunde på få sekunder. Beskriv blot, hvad du vil se, og vores avancerede Nano Banana Pro-model genererer 4K-billeder med høj kvalitet, der matcher din prompt perfekt.',
                resolution: 'Stop med at nøjes med slørede AI-billeder. 微鲤AI lader dig generere knivskarpe 1K-, 2K- og 4K-billeder direkte — perfekt til print eller højopløselige skærme.',
                aspectRatio: 'Uanset om du har brug for 9:16 til TikTok-baggrunde, 16:9 til YouTube-miniaturer eller 1:1 til Instagram, har vi presets til alle sociale platforme.',
                online_search: 'Har du brug for opdateret kontekst? Aktivér "Online Search", så AI kan browse nettet og forstå aktuelle begivenheder eller specifikke referencer i din prompt.',
                faq: [
                    {
                        question: 'Hvordan genererer jeg billeder i høj kvalitet fra tekst?',
                        answer: 'Indtast en detaljeret prompt, der beskriver motiv, lys og stil. Vælg "4K" i billedstørrelse for de skarpeste detaljer.',
                    },
                    {
                        question: 'Hvad er Nano Banana Pro-modellen?',
                        answer: 'Nano Banana Pro er vores model med højeste kvalitet, optimeret til prompt-overholdelse og fotorealisme. Den matcher topmodeller som Midjourney v6 og Flux.',
                    },
                    {
                        question: 'Kan jeg bruge billederne kommercielt?',
                        answer: 'Ja. Billeder genereret på 微鲤AI (betalingsplaner) leveres med kommerciel licens og kan bruges til annoncer, websites og produkter.',
                    },
                    {
                        question: 'Hvor mange billeder kan jeg generere på én gang?',
                        answer: 'Op til 4 billeder samtidigt (som vist i "Output Image Number"), så du hurtigt kan iterere på ideer.',
                    },
                    {
                        question: 'Er det gratis?',
                        answer: 'Ja, du kan generere billeder med gratis daglige credits. Højere opløsninger (4K) kan kræve flere credits.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Gratis AI billede-til-billede generator - Gør fotos til kunst & 4K | 微鲤AI',
            description: `Upload et referencefoto og transformer det med 微鲤AI's Image to Image AI. Forvandl skitser til realistisk kunst, skift stil eller generér variationer, mens den originale komposition bevares. Understøtter 4K opløsning.`,
            keywords: 'billede til billede ai, img2img, gør foto til tegning, ai billedvariation, skitse til billede, foto remix ai, gratis ai kunst generator',
            og_title: 'Gratis AI billede-til-billede generator - Gør fotos til kunst & 4K | 微鲤AI',
            og_description: `Upload et referencefoto og transformer det med 微鲤AI's Image to Image AI. Forvandl skitser til realistisk kunst, skift stil eller generér variationer, mens den originale komposition bevares. Understøtter 4K opløsning.`,
            twitter_title: 'Gratis AI billede-til-billede generator - Gør fotos til kunst & 4K | 微鲤AI',
            twitter_description: `Upload et referencefoto og transformer det med 微鲤AI's Image to Image AI. Forvandl skitser til realistisk kunst, skift stil eller generér variationer, mens den originale komposition bevares. Understøtter 4K opløsning.`,
            faq: [
                {
                    question: 'Hvad er Image to Image AI?',
                    answer: 'Image to Image (Img2Img) bruger et uploadet billede som reference sammen med en tekstprompt for at generere et nyt billede og blande visuelt input med kreativ beskrivelse.',
                },
                {
                    question: 'Hvordan laver jeg en skitse om til et realistisk foto?',
                    answer: 'Upload din skitse, indtast en prompt, der beskriver scenen (f.eks. "fotorealistisk bygning"), og klik Opret.',
                },
                {
                    question: 'Beholder den det originale ansigt?',
                    answer: 'Den bevarer struktur og positur. For præcis ansigtsidentitet anbefaler vi Photo Face Swap.',
                },
            ],
            page: {
                title1: 'Gratis AI billede-til-billede generator',
                title2: 'Brug dine eksisterende billeder som blueprint. Upload et foto, en skitse eller et layout, og lad AI genskabe det i en helt ny stil baseret på din prompt. Perfekt til at bevare kompositionen og udforske uendelige variationer.',
                title3: 'Forvandl dine fotos med AI-stiloverførsel',
                title4: 'Hvorfor bruge Image to Image (Img2Img)?',
                upload_image: 'Har du svært ved at beskrive en pose eller et layout med ord? Upload bare et referencebillede. Vores Img2Img-motor bevarer strukturen, men genskaber detaljerne.',
                resolution: 'Forvandl en grov skitse eller wireframe til et fotorealistisk render eller en illustration i høj kvalitet på få sekunder. Ideelt for designere og arkitekter.',
                output: 'Generér produktionsklare assets. I modsætning til andre værktøjer, der kun giver små billeder, understøtter 微鲤AI 1K, 2K og 4K for skarpe detaljer.',
                faq: [
                    {
                        question: 'Hvad er Image to Image AI?',
                        answer: 'Image to Image (Img2Img) er en teknologi, der bruger et uploadet billede som "reference" sammen med en tekstprompt for at generere et nyt billede. Den kombinerer visuelt input med kreativ beskrivelse.',
                    },
                    {
                        question: 'Hvordan laver jeg en skitse om til et realistisk foto?',
                        answer: 'Upload din skitse til "Image"-området. Beskriv motivet i "Prompt"-feltet (f.eks. "Moderne villa, solnedgang, fotorealistisk, 8k"). Klik Opret.',
                    },
                    {
                        question: 'Beholder den det originale ansigt/person?',
                        answer: 'Den forsøger at bevare den overordnede struktur og positur. For præcis ansigtsbevarelse anbefaler vi værktøjet "Photo Face Swap".',
                    },
                    {
                        question: 'Hvilke billedformater understøttes?',
                        answer: 'Vi understøtter et bredt udvalg af formater, herunder 9:16 (Story), 16:9 (Cinematic), 3:4 og 1:1, så dit kunstværk passer til enhver platform.',
                    },
                    {
                        question: 'Er det gratis?',
                        answer: 'Ja, du kan generere variationer gratis med dine daglige credits.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'AI billede resizer - Smart beskæring og skalering | 微鲤AI',
            description: 'AI billede resizer - Smart beskæring og skalering on 微鲤AI platform. High-quality results.',
            keywords: 'aiImageResizer, AI, 微鲤AI',
        },
        imageTextTranslate: {
            title: 'Gratis AI billedoversætter - Oversæt tekst i fotos, manga og tegneserier',
            description: 'Oversæt tekst i billeder med det samme, mens den originale visuelle stil bevares. WeryAIs AI billedoversætter sletter automatisk den originale tekst og tegner oversættelserne igen. Perfekt til tegneserier, manga og marketingplakater.',
            keywords: 'ai billedoversætter, oversæt tekst i billede, billedoversætter, manga oversætter, oversæt tegneserier, ocr oversætter, billedtekst udskiftning',
            og_title: 'Gratis AI billedoversætter - Oversæt tekst i fotos, manga og tegneserier',
            og_description: 'Oversæt tekst i billeder med det samme, mens den originale visuelle stil bevares. WeryAIs AI billedoversætter sletter automatisk den originale tekst og tegner oversættelserne igen. Perfekt til tegneserier, manga og marketingplakater.',
            twitter_title: 'Gratis AI billedoversætter - Oversæt tekst i fotos, manga og tegneserier',
            twitter_description: 'Oversæt tekst i billeder med det samme, mens den originale visuelle stil bevares. WeryAIs AI billedoversætter sletter automatisk den originale tekst og tegner oversættelserne igen. Perfekt til tegneserier, manga og marketingplakater.',
            page: {
                title1: 'Gratis AI billedoversætter og tekst-udskifter',
                title2: 'Oversæt plakater, menuer, tegneserier og screenshots på få sekunder. I modsætning til standardoversættere, der bare lægger tekst ovenpå, bruger 微鲤AI generativ AI til at slette den originale tekst og tegne baggrunden igen, så den oversatte tekst ser ud som en del af det originale design.',
                faq: [
                    {
                        question: 'Hvordan oversætter jeg tekst i et billede?',
                        answer: 'Upload dit billede (JPG, PNG) til 微鲤AI. Vælg kildesproget (eller brug Auto-detektering) og målsproget. Klik på "Opret" for at lade AI udskifte teksten.',
                    },
                    {
                        question: 'Vil den oversatte tekst se naturlig ud?',
                        answer: 'Ja. 微鲤AI forsøger at matche skrifttypestørrelse og stil på den originale tekst. Vigtigst af alt tegner den baggrunden bag teksten igen, så oversættelsen blender problemfrit ind.',
                    },
                    {
                        question: 'Kan jeg bruge dette til at oversætte manga eller manhwa?',
                        answer: `Absolut. Dette er et af de bedste brugsscenarier. AI'en detekterer talebobler og lodret tekst (almindeligt i japansk) og erstatter dem med vandret oversat tekst.`,
                    },
                    {
                        question: 'Hvilke sprog understøttes?',
                        answer: 'Vi understøtter oversættelse mellem større globale sprog, herunder engelsk, spansk, kinesisk, japansk, koreansk, fransk, tysk og mere.',
                    },
                    {
                        question: 'Virker det på håndskrevet tekst?',
                        answer: 'Det virker bedst på trykt tekst, men vores avancerede OCR-motor kan genkende tydelig håndskreven tekst på whiteboards eller noter.',
                    },
                    {
                        question: 'Er det gratis?',
                        answer: 'Du kan oversætte billeder gratis ved hjælp af dine daglige credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan oversætter jeg tekst i et billede?',
                    answer: `Upload dit billede til 微鲤AI. Vælg målsproget og klik på 'Opret'. AI'en vil erstatte den originale tekst med oversættelsen.`,
                },
                {
                    question: 'Vil den oversatte tekst se naturlig ud?',
                    answer: 'Ja. 微鲤AI tegner baggrunden bag teksten igen og forsøger at matche skrifttypestilen, hvilket sikrer, at oversættelsen blender problemfrit ind.',
                },
                {
                    question: 'Kan jeg bruge dette til at oversætte manga eller manhwa?',
                    answer: `Absolut. Dette er et af de bedste brugsscenarier. AI'en detekterer talebobler og lodret tekst og erstatter dem med vandret oversat tekst.`,
                },
            ],
            feature_title1: 'Smart Inpainting & Redrawing',
            feature_desc1: 'Sømløs tekst-udskiftning: Vores AI analyserer baggrundsteksturen bag teksten. Den sletter de originale ord og udfylder hullet intelligent, før oversættelsen tilføjes, hvilket sikrer, at ingen grimme tekstbokse dækker dit billede.',
            feature_title2: 'Manga & tegneserie oversættelse',
            feature_desc2: 'Læs rå manga med det samme: Perfekt til anime-fans. Upload rå mangasider (japansk/koreansk) og få øjeblikkelige oversættelser, der passer perfekt ind i taleboblerne.',
            feature_title3: 'Global marketing-lokalisering',
            feature_desc3: 'Lokalisering med ét klik: Lancerer du produkter globalt? Oversæt dine marketingplakater, bannere og UI-screenshots til over 30 sprog uden behov for de originale PSD-filer.',
        },
        aiBackgroundChanger: {
            title: 'Gratis AI-baggrundsskifter - Skift baggrunde med tekst | 微鲤AI',
            description: 'Skift øjeblikkeligt fotobaggrunde ved hjælp af AI. Beskriv den scene, du ønsker.',
            keywords: 'ai baggrundsskifter, skift baggrund, 微鲤AI',
        },
        imageUpscaler: {
            title: 'Gratis AI Image Upscaler - Forbedr til 4K | 微鲤AI',
            description: 'Opskalér lavopløsningsbilleder til 4K med AI Enhancer.',
            keywords: 'billed-upscaler, ai enhancer, 4k, 微鲤AI',
        },
        photoFaceSwap: {
            title: 'Gratis AI Foto Ansigtsbytte Online | 微鲤AI',
            description: 'Byt ansigter på fotos øjeblikkeligt med høj realisme.',
            keywords: 'ansigtsbytte, foto ansigtsskifter, WeryAI',
            page: {
                title1: 'Gratis AI Foto Ansigtsbytte',
                title2: 'Vil du se dig selv som astronaut, filmstjerne eller i et klassisk maleri? Upload et basisbillede og et målansigt, og lad vores AI blande ansigtstræk, lys og hudtoner sømløst for et hyperrealistisk ansigtsbytte på få sekunder.',
            },
            feature_title1: 'Kunstneriske mesterværker',
            feature_desc1: 'Tidsrejse: Byt dit ansigt ind i klassiske oliemalerier som Mona Lisa eller Pige med perleørering. Skab unikke vintage-avatarer øjeblikkeligt.',
            feature_title2: 'Professionelle og fede avatarer',
            feature_desc2: 'Drømmejob: Se dig selv i racerdragt, astronautudstyr eller forretningsattire uden at købe kostumerne. Perfekt til at skabe iøjnefaldende profilbilleder.',
            feature_title3: 'Hyperrealistisk blending',
            feature_desc3: 'Ingen "indsæt"-effekt: I modsætning til simple klip-og-indsæt-værktøjer analyserer WeryAI vinkel, lys og hudtekstur for at sikre, at det byttede ansigt ser 100% naturligt ud, ikke falsk.',
        },
        removeTextFromImage: {
            title: 'Gratis AI Tekstfjerner fra billede | 微鲤AI',
            description: 'Slet vandmærker, logoer og tekst fra fotos.',
            keywords: 'tekstfjerner, slet tekst, 微鲤AI',
        },
        imgExtender: {
            title: 'Free AI Image Extender - Outpaint Photos | 微鲤AI',
            description: 'Extend image borders intelligently with AI Outpainting.',
            keywords: 'image extender, outpainting, 微鲤AI',
        },
        photoRestoration: {
            title: 'Gratis AI Fotorestaurering - Reparer gamle fotos | 微鲤AI',
            description: 'Genskab gamle familiebilleder og reparer ridser.',
            keywords: 'fotorestaurering, reparer gamle fotos, 微鲤AI',
        },
        photoEffects: {
            title: 'Billedeffekter - AI-billed­effekt generator | 微鲤AI',
            description: 'Forvandl dine fotos med AI-drevne effekter. Skab fantastiske billedfiltre, stilarter og transformationer online gratis.',
            keywords: 'AI billedeffekter, AI filtre, 微鲤AI',
        },
    },
    no: {
        textToImage: {
            title: 'Gratis AI tekst-til-bilde-generator - Lag 4K kunst og realistiske bilder | 微鲤AI',
            description: 'Gjør tekstprompter om til imponerende bilder med WeryAIs tekst-til-bilde-generator. Nano Banana Pro-modellen gir høy kvalitet. Støtter 1K/2K/4K oppløsning og 9:16/16:9-formater. Gratis og på nett.',
            keywords: 'tekst til bilde, ai bildegenerator, ai kunstgenerator, 4k ai-bilder, nano banana modell, flux ai gratis, bakgrunnsbildegenerator, lag bilder fra tekst',
            og_title: 'Gratis AI tekst-til-bilde-generator - Lag 4K kunst og realistiske bilder | 微鲤AI',
            og_description: 'Gjør tekstprompter om til imponerende bilder med WeryAIs tekst-til-bilde-generator. Nano Banana Pro-modellen gir høy kvalitet. Støtter 1K/2K/4K oppløsning og 9:16/16:9-formater. Gratis og på nett.',
            twitter_title: 'Gratis AI tekst-til-bilde-generator - Lag 4K kunst og realistiske bilder | 微鲤AI',
            twitter_description: 'Gjør tekstprompter om til imponerende bilder med WeryAIs tekst-til-bilde-generator. Nano Banana Pro-modellen gir høy kvalitet. Støtter 1K/2K/4K oppløsning og 9:16/16:9-formater. Gratis og på nett.',
            faq: [
                {
                    question: 'Hvordan lager jeg 4K AI-bilder?',
                    answer: 'Skriv inn prompten og velg "4K" i bildestørrelse i venstre panel før du klikker Opprett.',
                },
                {
                    question: 'Hvilke sideforhold støttes?',
                    answer: 'Vi støtter alle hovedformater, inkludert 1:1, 9:16 (mobil), 16:9 (desktop), 4:3 og 3:2.',
                },
                {
                    question: 'Kan jeg bruke bildene kommersielt?',
                    answer: 'Ja. Bilder generert på 微鲤AI-planer kommer vanligvis med en kommersiell lisens som passer for annonser og produkter.',
                },
            ],
            page: {
                title1: 'Gratis AI tekst-til-bilde-generator',
                title2: 'Lag fantastisk kunst, fotorealistiske bilder og unike bakgrunnsbilder på få sekunder. Beskriv hva du vil se, og vår avanserte Nano Banana Pro-modell genererer 4K-bilder som matcher prompten perfekt.',
                resolution: 'Slutt å nøye deg med uklare AI-bilder. 微鲤AI lar deg generere skarpe 1K-, 2K- og 4K-bilder direkte, perfekt for utskrift eller høyoppløselige skjermer.',
                aspectRatio: 'Enten du trenger 9:16 for TikTok-bakgrunner, 16:9 for YouTube-miniatyrer eller 1:1 for Instagram, har vi forhåndsinnstillinger for alle sosiale plattformer.',
                online_search: 'Trenger du oppdatert kontekst? Aktiver "Online Search" slik at AI kan surfe på nettet og forstå aktuelle hendelser eller spesifikke referanser i prompten din.',
                faq: [
                    {
                        question: 'Hvordan lager jeg bilder av høy kvalitet fra tekst?',
                        answer: 'Skriv en detaljert prompt som beskriver motiv, lys og stil. Velg "4K" i bildestørrelse for de skarpeste detaljene.',
                    },
                    {
                        question: 'Hva er Nano Banana Pro-modellen?',
                        answer: 'Nano Banana Pro er vår modell med høyest kvalitet, optimalisert for prompt-etterlevelse og fotorealisme. Den matcher toppmodeller som Midjourney v6 og Flux.',
                    },
                    {
                        question: 'Kan jeg bruke bildene kommersielt?',
                        answer: 'Ja. Bilder generert på 微鲤AI (betalte planer) leveres med kommersiell lisens og kan brukes til annonser, nettsteder og produkter.',
                    },
                    {
                        question: 'Hvor mange bilder kan jeg generere om gangen?',
                        answer: 'Opptil 4 bilder samtidig (som vist i innstillingen "Output Image Number"), slik at du raskt kan iterere på ideer.',
                    },
                    {
                        question: 'Er det gratis?',
                        answer: 'Ja, du kan generere bilder med gratis daglige kreditter. Høyere oppløsninger (4K) kan kreve flere kreditter.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Gratis AI bilde-til-bilde-generator - Gjør foto til kunst og 4K | 微鲤AI',
            description: 'Last opp et referansefoto og transformer det med WeryAIs Image to Image AI. Gjør skisser om til realistisk kunst, endre stil eller lag variasjoner samtidig som komposisjonen beholdes. Støtter 4K oppløsning.',
            keywords: 'bilde til bilde ai, img2img, gjør foto til tegning, ai bildevariasjon, skisse til bilde, foto remix ai, gratis ai kunstgenerator',
            og_title: 'Gratis AI bilde-til-bilde-generator - Gjør foto til kunst og 4K | 微鲤AI',
            og_description: 'Last opp et referansefoto og transformer det med WeryAIs Image to Image AI. Gjør skisser om til realistisk kunst, endre stil eller lag variasjoner samtidig som komposisjonen beholdes. Støtter 4K oppløsning.',
            twitter_title: 'Gratis AI bilde-til-bilde-generator - Gjør foto til kunst og 4K | 微鲤AI',
            twitter_description: 'Last opp et referansefoto og transformer det med WeryAIs Image to Image AI. Gjør skisser om til realistisk kunst, endre stil eller lag variasjoner samtidig som komposisjonen beholdes. Støtter 4K oppløsning.',
            faq: [
                {
                    question: 'Hva er Image to Image AI?',
                    answer: 'Image to Image (Img2Img) bruker et opplastet bilde som referanse sammen med en tekstprompt for å generere et nytt bilde, og blander visuelt input med kreativ beskrivelse.',
                },
                {
                    question: 'Hvordan gjør jeg en skisse om til et realistisk foto?',
                    answer: 'Last opp skissen din, skriv inn en prompt som beskriver scenen (f.eks. "fotorealistisk bygning"), og klikk Opprett.',
                },
                {
                    question: 'Beholder den det originale ansiktet?',
                    answer: 'Den bevarer struktur og positur. For presis ansiktsidentitet anbefaler vi verktøyet Photo Face Swap.',
                },
            ],
            page: {
                title1: 'Gratis AI bilde-til-bilde-generator',
                title2: 'Bruk eksisterende bilder som blåkopi. Last opp et foto, en skisse eller et layout, og la AI gjenskape det i en helt ny stil basert på prompten din. Perfekt for å bevare komposisjon og utforske uendelige variasjoner.',
                title3: 'Forvandle bildene dine med AI-stiloverføring',
                title4: 'Hvorfor bruke Image to Image (Img2Img)?',
                upload_image: 'Synes du det er vanskelig å beskrive en positur eller layout med ord? Last opp et referansebilde. Vår Img2Img-motor bevarer strukturen, men maler om detaljene.',
                resolution: 'Gjør en grov skisse eller wireframe om til en fotorealistisk rendering eller en illustrasjon av høy kvalitet på sekunder. Ideelt for designere og arkitekter.',
                output: 'Generer produksjonsklare ressurser. I motsetning til andre verktøy som gir små bilder, støtter 微鲤AI 1K, 2K og 4K for skarpe detaljer.',
                faq: [
                    {
                        question: 'Hva er Image to Image AI?',
                        answer: 'Image to Image (Img2Img) er en teknologi som bruker et opplastet bilde som "referanse" sammen med en tekstprompt for å generere et nytt bilde. Den kombinerer visuelt input med kreativ beskrivelse.',
                    },
                    {
                        question: 'Hvordan gjør jeg en skisse om til et realistisk foto?',
                        answer: 'Last opp skissen din til "Image"-området. I "Prompt"-feltet beskriver du hva skissen viser (f.eks. "Moderne villa, solnedgang, fotorealistisk, 8k"). Klikk Opprett.',
                    },
                    {
                        question: 'Beholder den det originale ansiktet/personen?',
                        answer: 'Den prøver å bevare den generelle strukturen og posituren. For presis ansiktsbevaring anbefaler vi verktøyet "Photo Face Swap".',
                    },
                    {
                        question: 'Hvilke sideforhold støttes?',
                        answer: 'Vi støtter et bredt utvalg av formater, inkludert 9:16 (Story), 16:9 (Cinematic), 3:4 og 1:1, slik at kunstverket passer til alle plattformer.',
                    },
                    {
                        question: 'Er det gratis?',
                        answer: 'Ja, du kan generere variasjoner gratis med daglige kreditter.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'AI bilde resizer - Smart beskjæring og skalering | 微鲤AI',
            description: 'AI bilde resizer - Smart beskjæring og skalering on 微鲤AI platform. High-quality results.',
            keywords: 'aiImageResizer, AI, 微鲤AI',
        },
        imageTextTranslate: {
            title: 'Gratis AI bildeoversetter - Oversett tekst i bilder, manga og tegneserier',
            description: 'Oversett tekst i bilder umiddelbart mens du beholder den originale visuelle stilen. WeryAIs AI bildeoversetter sletter automatisk originalteksten og tegner oversettelsene på nytt. Perfekt for tegneserier, manga og markedsføringsplakater.',
            keywords: 'ai bildeoversetter, oversett tekst i bilde, bildeoversetter, manga oversetter, oversett tegneserier, ocr oversetter, bilde tekst utskifting',
            og_title: 'Gratis AI bildeoversetter - Oversett tekst i bilder, manga og tegneserier',
            og_description: 'Oversett tekst i bilder umiddelbart mens du beholder den originale visuelle stilen. WeryAIs AI bildeoversetter sletter automatisk originalteksten og tegner oversettelsene på nytt. Perfekt for tegneserier, manga og markedsføringsplakater.',
            twitter_title: 'Gratis AI bildeoversetter - Oversett tekst i bilder, manga og tegneserier',
            twitter_description: 'Oversett tekst i bilder umiddelbart mens du beholder den originale visuelle stilen. WeryAIs AI bildeoversetter sletter automatisk originalteksten og tegner oversettelsene på nytt. Perfekt for tegneserier, manga og markedsføringsplakater.',
            page: {
                title1: 'Gratis AI bildeoversetter og tekstutskifting',
                title2: 'Oversett plakater, menyer, tegneserier og skjermbilder på sekunder. I motsetning til standard oversettere som bare legger tekst oppå, bruker 微鲤AI generativ AI for å slette originalteksten og tegne bakgrunnen på nytt, slik at den oversatte teksten ser ut som en del av det originale designet.',
                faq: [
                    {
                        question: 'Hvordan oversetter jeg tekst inne i et bilde?',
                        answer: 'Last opp bildet ditt (JPG, PNG) til 微鲤AI. Velg kildespråket (eller bruk Auto-detect) og målspråket. Klikk på "Opprett" for å la AI erstatte teksten.',
                    },
                    {
                        question: 'Vil den oversatte teksten se naturlig ut?',
                        answer: 'Ja. 微鲤AI prøver å matche skriftstørrelse og stil på originalteksten. Viktigst av alt tegner den bakgrunnen bak teksten på nytt slik at oversettelsen blender sømløst inn.',
                    },
                    {
                        question: 'Kan jeg bruke dette til å oversette manga eller manhwa?',
                        answer: 'Absolutt. Dette er et av de beste bruksområdene. AI-en oppdager snakkebobler og vertikal tekst (vanlig i japansk), og erstatter dem med horisontal oversatt tekst.',
                    },
                    {
                        question: 'Hvilke språk støttes?',
                        answer: 'Vi støtter oversettelse mellom alle store globale språk, inkludert engelsk, spansk, kinesisk, japansk, koreansk, fransk, tysk og mer.',
                    },
                    {
                        question: 'Fungerer det på håndskrevet tekst?',
                        answer: 'Det fungerer best på trykt tekst, men vår avanserte OCR-motor kan gjenkjenne tydelig håndskrevet tekst på tavler eller notater.',
                    },
                    {
                        question: 'Er det gratis?',
                        answer: 'Du kan oversette bilder gratis ved å bruke dine daglige kreditter.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan oversetter jeg tekst inne i et bilde?',
                    answer: `Last opp bildet ditt til 微鲤AI. Velg målspråket og klikk på 'Opprett'. AI-en vil erstatte den originale teksten med oversettelsen.`,
                },
                {
                    question: 'Vil den oversatte teksten se naturlig ut?',
                    answer: 'Ja. 微鲤AI tegner bakgrunnen bak teksten på nytt og prøver å matche skriftstilen, noe som sikrer at oversettelsen blender sømløst inn.',
                },
                {
                    question: 'Kan jeg bruke dette til å oversette manga eller manhwa?',
                    answer: 'Absolutt. Dette er et av de beste bruksområdene. AI-en oppdager snakkebobler og vertikal tekst, og erstatter dem med horisontal oversatt tekst.',
                },
            ],
            feature_title1: 'Smart Inpainting & Redrawing',
            feature_desc1: 'Sømløs tekstutskifting: Vår AI analyserer bakgrunnsteksturen bak teksten. Den sletter de originale ordene og fyller gapet intelligent før oversettelsen legges til, noe som sikrer at ingen stygge tekstbokser dekker bildet ditt.',
            feature_title2: 'Manga- og tegneserieoversettelse',
            feature_desc2: 'Les rå manga umiddelbart: Perfekt for anime-fans. Last opp rå mangasider (japansk/koreansk) og få umiddelbare oversettelser som passer perfekt inne i snakkeboblene.',
            feature_title3: 'Global markedsføringslokalisering',
            feature_desc3: 'Lokalisering med ett klikk: Lanserer du produkter globalt? Oversett markedsføringsplakater, bannere og UI-skjermbilder til over 30 språk uten behov for de originale PSD-filene.',
        },
        aiBackgroundChanger: {
            title: 'Gratis AI-bakgrunnsveksler - Endre bakgrunner med tekst | 微鲤AI',
            description: 'Endre bildebakgrunner umiddelbart ved hjelp av AI. Beskriv scenen du ønsker.',
            keywords: 'ai bakgrunnsveksler, endre bakgrunn, 微鲤AI',
        },
        imageUpscaler: {
            title: 'Gratis AI Image Upscaler - Forbedre til 4K | 微鲤AI',
            description: 'Oppskaler lavoppløselige bilder til 4K med AI Enhancer.',
            keywords: 'bilde-upscaler, ai enhancer, 4k, 微鲤AI',
        },
        photoFaceSwap: {
            title: 'Gratis AI Foto Ansiktsbytte Online | 微鲤AI',
            description: 'Bytt ansikter i bilder umiddelbart med høy realisme.',
            keywords: 'ansiktsbytte, foto ansiktsveksler, WeryAI',
            page: {
                title1: 'Gratis AI Foto Ansiktsbytte',
                title2: 'Vil du se deg selv som astronaut, filmstjerne eller i et klassisk maleri? Last opp et basisbilde og et målansikt, og la vår AI blande ansiktstrekk, lys og hudtoner sømløst for et hyperrealistisk ansiktsbytte på få sekunder.',
            },
            feature_title1: 'Kunstneriske mesterverk',
            feature_desc1: 'Tidsreise: Bytt ansiktet ditt inn i klassiske oljemalerier som Mona Lisa eller Piken med perleøredobben. Lag unike vintage-avatarer umiddelbart.',
            feature_title2: 'Profesjonelle og kule avatarer',
            feature_desc2: 'Drømmejobb: Se deg selv i racerdrakt, astronautdrakt eller forretningsantrekk uten å kjøpe kostymene. Perfekt for å lage iøynefallende profilbilder.',
            feature_title3: 'Hyperrealistisk blending',
            feature_desc3: 'Ingen "lim inn"-effekt: I motsetning til enkle klipp-og-lim-verktøy analyserer WeryAI vinkel, lys og hudtekstur for å sikre at det byttede ansiktet ser 100% naturlig ut, ikke falskt.',
        },
        removeTextFromImage: {
            title: 'Gratis AI Tekstfjerner fra bilde | 微鲤AI',
            description: 'Slett vannmerker, logoer og tekst fra bilder.',
            keywords: 'tekstfjerner, slett tekst, 微鲤AI',
        },
        imgExtender: {
            title: 'Gratis AI Image Extender - Utvid bilder | 微鲤AI',
            description: 'Utvid bildekanter intelligent med AI Outpainting.',
            keywords: 'bildeutvidelse, outpainting, 微鲤AI',
        },
        photoRestoration: {
            title: 'Gratis AI Fotorestaurering - Reparer gamle bilder | 微鲤AI',
            description: 'Gjenopprett gamle familiebilder og reparer riper.',
            keywords: 'fotorestaurering, reparer gamle bilder, 微鲤AI',
        },
        photoEffects: {
            title: 'Bildeeffekter - AI-bildeeffekt generator | 微鲤AI',
            description: 'Forvandle bildene dine med AI-drevne effekter. Lag fantastiske bildefiltre, stiler og transformasjoner online gratis.',
            keywords: 'AI bildeeffekter, AI filtre, 微鲤AI',
        },
    },
    nl: {
        textToImage: {
            title: 'Gratis AI tekst-naar-beeld generator - Maak 4K kunst en realistische foto’s | 微鲤AI',
            description: 'Zet tekstprompts om in verbluffende visuals met de Text to Image-generator van 微鲤AI. Met het Nano Banana Pro-model voor hoge kwaliteit. Ondersteunt 1K/2K/4K-resolutie en 9:16/16:9-verhoudingen. Gratis en online.',
            keywords: 'tekst naar beeld, ai afbeeldingsgenerator, ai kunst generator, 4k ai afbeeldingen, nano banana model, flux ai gratis, wallpaper generator, maak afbeeldingen van tekst',
            og_title: 'Gratis AI tekst-naar-beeld generator - Maak 4K kunst en realistische foto’s | 微鲤AI',
            og_description: 'Zet tekstprompts om in verbluffende visuals met de Text to Image-generator van 微鲤AI. Met het Nano Banana Pro-model voor hoge kwaliteit. Ondersteunt 1K/2K/4K-resolutie en 9:16/16:9-verhoudingen. Gratis en online.',
            twitter_title: 'Gratis AI tekst-naar-beeld generator - Maak 4K kunst en realistische foto’s | 微鲤AI',
            twitter_description: 'Zet tekstprompts om in verbluffende visuals met de Text to Image-generator van 微鲤AI. Met het Nano Banana Pro-model voor hoge kwaliteit. Ondersteunt 1K/2K/4K-resolutie en 9:16/16:9-verhoudingen. Gratis en online.',
            faq: [
                {
                    question: 'Hoe genereer ik 4K AI-afbeeldingen?',
                    answer: 'Voer je prompt in en kies "4K" bij de instelling Beeldgrootte in het linkerpaneel voordat je op Maken klikt.',
                },
                {
                    question: 'Welke beeldverhoudingen worden ondersteund?',
                    answer: 'We ondersteunen alle belangrijke verhoudingen, waaronder 1:1, 9:16 (mobiel), 16:9 (desktop), 4:3 en 3:2.',
                },
                {
                    question: 'Kan ik de afbeeldingen commercieel gebruiken?',
                    answer: 'Ja. Afbeeldingen die met 微鲤AI-plannen worden gegenereerd, hebben meestal een commerciële licentie die geschikt is voor advertenties en producten.',
                },
            ],
            page: {
                title1: 'Gratis AI tekst-naar-beeld generator',
                title2: 'Maak adembenemende kunst, fotorealistische beelden en unieke wallpapers in enkele seconden. Beschrijf wat je wilt zien en ons geavanceerde Nano Banana Pro-model genereert hoogwaardige 4K-beelden die perfect bij je prompt passen.',
                resolution: 'Neem geen genoegen met wazige AI-beelden. 微鲤AI laat je direct scherpe 1K-, 2K- en 4K-beelden genereren, perfect voor print of schermen met hoge resolutie.',
                aspectRatio: 'Of je nu 9:16 nodig hebt voor TikTok-achtergronden, 16:9 voor YouTube-thumbnails of 1:1 voor Instagram: we hebben presets voor elk sociaal platform.',
                online_search: 'Actuele context nodig? Schakel "Online Search" in zodat de AI het web kan doorzoeken en actuele gebeurtenissen of specifieke referenties in je prompt beter begrijpt.',
                faq: [
                    {
                        question: 'Hoe genereer ik hoogwaardige beelden uit tekst?',
                        answer: 'Voer een gedetailleerde prompt in met onderwerp, belichting en stijl. Kies "4K" in de instelling Beeldgrootte voor de scherpste details.',
                    },
                    {
                        question: 'Wat is het Nano Banana Pro-model?',
                        answer: 'Nano Banana Pro is ons model met de hoogste kwaliteit, geoptimaliseerd voor promptnauwkeurigheid en fotorealisme. Het kan zich meten met topmodellen zoals Midjourney v6 en Flux.',
                    },
                    {
                        question: 'Kan ik de afbeeldingen commercieel gebruiken?',
                        answer: 'Ja. Afbeeldingen die met 微鲤AI (betaalde plannen) zijn gemaakt, bevatten een commerciële licentie en mogen worden gebruikt voor advertenties, websites en producten.',
                    },
                    {
                        question: 'Hoeveel afbeeldingen kan ik tegelijk genereren?',
                        answer: 'Je kunt maximaal 4 afbeeldingen tegelijk genereren (zoals aangegeven bij "Output Image Number"), zodat je snel ideeën kunt itereren.',
                    },
                    {
                        question: 'Is het gratis?',
                        answer: 'Ja, je kunt afbeeldingen genereren met gratis dagelijkse credits. Hogere resoluties (4K) kunnen meer credits vereisen.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Gratis AI beeld-naar-beeld generator - Verander foto’s in kunst & 4K | 微鲤AI',
            description: `Upload een referentiefoto en transformeer deze met 微鲤AI's Image to Image AI. Zet schetsen om in realistische kunst, verander stijlen of genereer variaties terwijl de originele compositie behouden blijft. Ondersteunt 4K-resolutie.`,
            keywords: 'beeld naar beeld ai, img2img, foto naar tekening, ai beeldvariatie, schets naar beeld, foto remix ai, gratis ai kunst generator',
            og_title: 'Gratis AI beeld-naar-beeld generator - Verander foto’s in kunst & 4K | 微鲤AI',
            og_description: `Upload een referentiefoto en transformeer deze met 微鲤AI's Image to Image AI. Zet schetsen om in realistische kunst, verander stijlen of genereer variaties terwijl de originele compositie behouden blijft. Ondersteunt 4K-resolutie.`,
            twitter_title: 'Gratis AI beeld-naar-beeld generator - Verander foto’s in kunst & 4K | 微鲤AI',
            twitter_description: `Upload een referentiefoto en transformeer deze met 微鲤AI's Image to Image AI. Zet schetsen om in realistische kunst, verander stijlen of genereer variaties terwijl de originele compositie behouden blijft. Ondersteunt 4K-resolutie.`,
            faq: [
                {
                    question: 'Wat is Image to Image AI?',
                    answer: 'Image to Image (Img2Img) gebruikt een geüploade afbeelding als referentie samen met een tekstprompt om een nieuw beeld te genereren, waarbij visuele input wordt gecombineerd met creatieve beschrijving.',
                },
                {
                    question: 'Hoe verander ik een schets in een realistische foto?',
                    answer: 'Upload je schets, voer een prompt in die de scène beschrijft (bijv. "fotorealistisch gebouw") en klik op Maken.',
                },
                {
                    question: 'Behoudt het het originele gezicht?',
                    answer: 'Het behoudt structuur en pose. Voor nauwkeurige gezichtsidentiteit raden we de Photo Face Swap-tool aan.',
                },
            ],
            page: {
                title1: 'Gratis AI beeld-naar-beeld generator',
                title2: 'Gebruik je bestaande beelden als blauwdruk. Upload een foto, schets of lay-out en laat onze AI het in een volledig nieuwe stijl reconstrueren op basis van je prompt. Perfect om compositie te behouden en eindeloze variaties te verkennen.',
                title3: 'Transformeer je foto’s met AI-stijltransfer',
                title4: 'Waarom Image to Image (Img2Img) gebruiken?',
                upload_image: 'Heb je moeite om een pose of lay-out in woorden te beschrijven? Upload gewoon een referentiebeeld. Onze Img2Img-engine behoudt de structuur, maar schildert de details opnieuw.',
                resolution: 'Verander een ruwe schets of wireframe in een fotorealistische render of een illustratie van hoge kwaliteit in enkele seconden. Ideaal voor ontwerpers en architecten.',
                output: 'Genereer productieklare assets. In tegenstelling tot andere tools die kleine afbeeldingen leveren, ondersteunt 微鲤AI 1K, 2K en 4K voor scherpe details.',
                faq: [
                    {
                        question: 'Wat is Image to Image AI?',
                        answer: 'Image to Image (Img2Img) is een technologie die een geüploade afbeelding als "referentie" gebruikt samen met een tekstprompt om een nieuw beeld te genereren. Het combineert visuele input met creatieve beschrijving.',
                    },
                    {
                        question: 'Hoe verander ik een schets in een realistische foto?',
                        answer: 'Upload je schets naar het "Image"-gebied. Beschrijf in het "Prompt"-veld wat de schets voorstelt (bijv. "Moderne villa, zonsondergang, fotorealistisch, 8k"). Klik op Maken.',
                    },
                    {
                        question: 'Behoudt het het originele gezicht/persoon?',
                        answer: 'Het probeert de algemene structuur en pose te behouden. Voor nauwkeurige gezichtsbehoud raden we de "Photo Face Swap"-tool aan.',
                    },
                    {
                        question: 'Welke beeldverhoudingen worden ondersteund?',
                        answer: 'We ondersteunen een breed scala aan verhoudingen, waaronder 9:16 (Story), 16:9 (Cinematic), 3:4 en 1:1, zodat je kunst bij elk platform past.',
                    },
                    {
                        question: 'Is het gratis?',
                        answer: 'Ja, je kunt variaties gratis genereren met je dagelijkse credits.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'AI beeld resizer - Slim bijsnijden en schalen | 微鲤AI',
            description: 'AI beeld resizer - Slim bijsnijden en schalen on 微鲤AI platform. High-quality results.',
            keywords: 'aiImageResizer, AI, 微鲤AI',
        },
        imageTextTranslate: {
            title: `Gratis AI-beeldvertaler - Vertaal tekst in foto's, manga en strips`,
            description: 'Vertaal tekst in afbeeldingen onmiddellijk met behoud van de originele visuele stijl. De AI-beeldvertaler van 微鲤AI wist automatisch de originele tekst en tekent de vertalingen opnieuw. Perfect voor strips, manga en marketingposters.',
            keywords: 'ai beeldvertaler, vertaal tekst in afbeelding, foto vertaler, manga vertaler, vertaal strips, ocr vertaler, beeldtekst vervanging',
            og_title: `Gratis AI-beeldvertaler - Vertaal tekst in foto's, manga en strips`,
            og_description: 'Vertaal tekst in afbeeldingen onmiddellijk met behoud van de originele visuele stijl. De AI-beeldvertaler van 微鲤AI wist automatisch de originele tekst en tekent de vertalingen opnieuw. Perfect voor strips, manga en marketingposters.',
            twitter_title: `Gratis AI-beeldvertaler - Vertaal tekst in foto's, manga en strips`,
            twitter_description: 'Vertaal tekst in afbeeldingen onmiddellijk met behoud van de originele visuele stijl. De AI-beeldvertaler van 微鲤AI wist automatisch de originele tekst en tekent de vertalingen opnieuw. Perfect voor strips, manga en marketingposters.',
            page: {
                title1: 'Gratis AI-beeldvertaler en tekstvervanger',
                title2: `Vertaal posters, menu's, strips en screenshots in enkele seconden. In tegenstelling tot standaardvertalers die alleen tekst overlappen, gebruikt 微鲤AI generatieve AI om de originele tekst te wissen en de achtergrond opnieuw te tekenen, waardoor de vertaalde tekst eruitziet alsof deze deel uitmaakt van het originele ontwerp.`,
                faq: [
                    {
                        question: 'Hoe vertaal ik tekst in een afbeelding?',
                        answer: 'Upload je afbeelding (JPG, PNG) naar 微鲤AI. Selecteer de brontaal (of gebruik automatische detectie) en de doeltaal. Klik op "Maken" om de AI de tekst te laten vervangen.',
                    },
                    {
                        question: 'Zal de vertaalde tekst er natuurlijk uitzien?',
                        answer: 'Ja. 微鲤AI probeert de lettergrootte en stijl van de originele tekst te evenaren. Cruciaal is dat de achtergrond achter de tekst opnieuw wordt getekend, zodat de vertaling naadloos overvloeit.',
                    },
                    {
                        question: 'Kan ik dit gebruiken om manga of manhwa te vertalen?',
                        answer: `Absoluut. Dit is een van de beste gebruiksscenario's. De AI detecteert tekstballonnen en verticale tekst (gebruikelijk in het Japans) en vervangt deze door horizontale vertaalde tekst.`,
                    },
                    {
                        question: 'Welke talen worden ondersteund?',
                        answer: 'We ondersteunen vertaling tussen de belangrijkste wereldtalen, waaronder Engels, Spaans, Chinees, Japans, Koreaans, Frans, Duits en meer.',
                    },
                    {
                        question: 'Werkt het op handgeschreven tekst?',
                        answer: 'Het werkt het beste op gedrukte tekst, maar onze geavanceerde OCR-engine kan duidelijke handgeschreven tekst op whiteboards of notities herkennen.',
                    },
                    {
                        question: 'Is het gratis?',
                        answer: 'Je kunt afbeeldingen gratis vertalen met je dagelijkse credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hoe vertaal ik tekst in een afbeelding?',
                    answer: `Upload je afbeelding naar 微鲤AI. Selecteer de doeltaal en klik op 'Maken'. De AI zal de originele tekst vervangen door de vertaling.`,
                },
                {
                    question: 'Zal de vertaalde tekst er natuurlijk uitzien?',
                    answer: 'Ja. 微鲤AI tekent de achtergrond achter de tekst opnieuw en probeert de letterstijl te evenaren, zodat de vertaling naadloos overvloeit.',
                },
                {
                    question: 'Kan ik dit gebruiken om manga of manhwa te vertalen?',
                    answer: `Absoluut. Dit is een van de beste gebruiksscenario's. De AI detecteert tekstballonnen en verticale tekst en vervangt deze door horizontale vertaalde tekst.`,
                },
            ],
            feature_title1: 'Slimme Inpainting & Redrawing',
            feature_desc1: 'Naadloze tekstvervanging: Onze AI analyseert de achtergrondtextuur achter de tekst. Het wist de originele woorden en vult het gat intelligent op voordat de vertaling wordt toegevoegd, zodat er geen lelijke tekstvakken over je afbeelding komen.',
            feature_title2: 'Manga & Strip Vertaling',
            feature_desc2: `Lees rauwe manga direct: Perfect voor anime-fans. Upload rauwe mangapagina's (Japans/Koreaans) en ontvang directe vertalingen die perfect in de tekstballonnen passen.`,
            feature_title3: 'Wereldwijde marketinglokalisatie',
            feature_desc3: 'Lokalisatie met één klik: Producten wereldwijd lanceren? Vertaal je marketingposters, banners en UI-screenshots in meer dan 30 talen zonder de originele PSD-bestanden nodig te hebben.',
        },
        aiBackgroundChanger: {
            title: 'Gratis AI Achtergrondwisselaar - Verander achtergronden met tekst | 微鲤AI',
            description: 'Verander foto-achtergronden direct met AI. Beschrijf de scène die je wilt.',
            keywords: 'ai achtergrondwisselaar, achtergrond veranderen, 微鲤AI',
        },
        imageUpscaler: {
            title: 'Gratis AI Image Upscaler - Verbeter naar 4K | 微鲤AI',
            description: 'Upscale afbeeldingen met lage resolutie naar 4K met AI Enhancer.',
            keywords: 'afbeelding upscaler, ai enhancer, 4k, 微鲤AI',
        },
        photoFaceSwap: {
            title: 'Gratis AI Foto Gezichtswissel Online | 微鲤AI',
            description: `Verwissel gezichten in foto's direct met hoog realisme.`,
            keywords: 'gezichtswissel, foto gezichtswisselaar, WeryAI',
            page: {
                title1: 'Gratis AI Foto Gezichtswissel',
                title2: `Wil je jezelf zien als astronaut, filmster of in een klassiek schilderij? Upload een basisfoto en een doelgezicht, en laat onze AI gezichtskenmerken, licht en huidtinten naadloos mengen voor een hyperrealistische gezichtswissel in seconden.`,
            },
            feature_title1: 'Artistieke meesterwerken',
            feature_desc1: 'Tijdreizen: Wissel je gezicht in klassieke olieverfschilderijen zoals de Mona Lisa of Meisje met de parel. Maak direct unieke vintage-avatars.',
            feature_title2: `Professionele en coole avatars`,
            feature_desc2: 'Droombanen: Zie jezelf in een racepak, astronautenuitrusting of zakelijke kleding zonder de kostuums te kopen. Perfect voor opvallende profielfotos.',
            feature_title3: 'Hyperrealistische blending',
            feature_desc3: `Geen "plak"-effect: In tegenstelling tot simpele knip-en-plak-tools analyseert WeryAI de hoek, belichting en huidtextuur om ervoor te zorgen dat het gewisselde gezicht 100% natuurlijk oogt, niet nep.`,
        },
        removeTextFromImage: {
            title: 'Gratis AI Tekstverwijderaar van afbeelding | 微鲤AI',
            description: `Wis watermerken, logo's en tekst van foto's.`,
            keywords: 'tekstverwijderaar, tekst wissen, 微鲤AI',
        },
        imgExtender: {
            title: `Gratis AI Image Extender - Foto's uitbreiden | 微鲤AI`,
            description: 'Breid afbeeldingsranden intelligent uit met AI Outpainting.',
            keywords: 'afbeelding uitbreiden, outpainting, 微鲤AI',
        },
        photoRestoration: {
            title: `Gratis AI Fotorestauratie - Herstel oude foto's | 微鲤AI`,
            description: `Herstel oude familiefoto's en repareer krassen.`,
            keywords: `fotorestauratie, oude foto's herstellen, 微鲤AI`,
        },
        photoEffects: {
            title: 'Foto-effecten - AI-beeld­effectgenerator | 微鲤AI',
            description: `Transformeer je foto's met AI-gestuurde effecten. Maak gratis online verbluffende beeldfilters, stijlen en transformaties.`,
            keywords: 'AI foto-effecten, AI filters, 微鲤AI',
        },
    },
    id: {
        textToImage: {
            title: 'Generator Gambar AI dari Teks Gratis - Buat Seni 4K & Foto Realistis | 微鲤AI',
            description: 'Ubah prompt teks menjadi visual menakjubkan dengan Text to Image Generator 微鲤AI. Menggunakan model Nano Banana Pro untuk hasil fidelitas tinggi. Mendukung resolusi 1K/2K/4K dan rasio 9:16/16:9. Gratis & online.',
            keywords: 'teks ke gambar, generator gambar AI, generator seni AI, gambar AI 4K, model Nano Banana, flux AI gratis, generator wallpaper, membuat gambar dari teks',
            og_title: 'Generator Gambar AI dari Teks Gratis - Buat Seni 4K & Foto Realistis | 微鲤AI',
            og_description: 'Ubah prompt teks menjadi visual menakjubkan dengan Text to Image Generator 微鲤AI. Menggunakan model Nano Banana Pro untuk hasil fidelitas tinggi. Mendukung resolusi 1K/2K/4K dan rasio 9:16/16:9. Gratis & online.',
            twitter_title: 'Generator Gambar AI dari Teks Gratis - Buat Seni 4K & Foto Realistis | 微鲤AI',
            twitter_description: 'Ubah prompt teks menjadi visual menakjubkan dengan Text to Image Generator 微鲤AI. Menggunakan model Nano Banana Pro untuk hasil fidelitas tinggi. Mendukung resolusi 1K/2K/4K dan rasio 9:16/16:9. Gratis & online.',
            faq: [
                {
                    question: 'Bagaimana cara membuat gambar AI 4K?',
                    answer: 'Masukkan prompt, lalu pilih "4K" di pengaturan Ukuran Gambar pada panel kiri sebelum klik Buat.',
                },
                {
                    question: 'Rasio aspek apa saja yang didukung?',
                    answer: 'Kami mendukung semua rasio utama, termasuk 1:1, 9:16 (Mobile), 16:9 (Desktop), 4:3, dan 3:2.',
                },
                {
                    question: 'Apakah gambar bisa digunakan untuk komersial?',
                    answer: 'Ya. Gambar yang dibuat pada paket 微鲤AI biasanya disertai lisensi komersial yang cocok untuk iklan dan produk.',
                },
            ],
            page: {
                title1: 'Generator Gambar AI dari Teks Gratis',
                title2: 'Buat karya seni menakjubkan, gambar fotorealistik, dan wallpaper unik dalam hitungan detik. Cukup jelaskan apa yang ingin Anda lihat, dan model Nano Banana Pro kami akan menghasilkan gambar 4K berkualitas tinggi yang sesuai dengan prompt Anda.',
                resolution: 'Jangan puas dengan gambar AI yang buram. 微鲤AI memungkinkan Anda menghasilkan gambar 1K, 2K, dan 4K yang tajam secara langsung, cocok untuk cetak atau layar resolusi tinggi.',
                aspectRatio: 'Butuh gambar 9:16 untuk latar TikTok, 16:9 untuk thumbnail YouTube, atau 1:1 untuk Instagram? Kami menyediakan preset untuk setiap platform sosial.',
                online_search: 'Butuh konteks terbaru? Aktifkan "Online Search" agar AI dapat menjelajah web dan memahami peristiwa terkini atau referensi spesifik di prompt Anda.',
                faq: [
                    {
                        question: 'Bagaimana membuat gambar berkualitas tinggi dari teks?',
                        answer: 'Masukkan prompt yang detail tentang subjek, pencahayaan, dan gaya. Pilih "4K" pada pengaturan Ukuran Gambar untuk detail paling tajam.',
                    },
                    {
                        question: 'Apa itu model Nano Banana Pro?',
                        answer: 'Nano Banana Pro adalah model dengan fidelitas tertinggi kami, dioptimalkan untuk kepatuhan prompt dan fotorealisme. Kualitasnya menyaingi model top seperti Midjourney v6 dan Flux.',
                    },
                    {
                        question: 'Apakah gambar bisa digunakan untuk komersial?',
                        answer: 'Ya. Gambar yang dihasilkan di 微鲤AI (paket berbayar) disertai lisensi komersial, sehingga dapat digunakan untuk iklan, situs web, dan produk.',
                    },
                    {
                        question: 'Berapa banyak gambar yang bisa dibuat sekaligus?',
                        answer: 'Anda dapat menghasilkan hingga 4 gambar sekaligus (seperti pada pengaturan "Output Image Number"), sehingga mudah untuk mengulang ide dengan cepat.',
                    },
                    {
                        question: 'Apakah gratis?',
                        answer: 'Ya, Anda bisa membuat gambar dengan kredit harian gratis. Resolusi lebih tinggi (4K) mungkin membutuhkan lebih banyak kredit.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Generator AI Gambar ke Gambar Gratis - Ubah Foto jadi Seni & 4K | 微鲤AI',
            description: 'Unggah foto referensi dan transformasikan dengan Image to Image AI 微鲤AI. Ubah sketsa menjadi seni realistis, ganti gaya, atau buat variasi sambil mempertahankan komposisi asli. Mendukung resolusi 4K.',
            keywords: 'gambar ke gambar ai, img2img, ubah foto jadi gambar, variasi gambar ai, sketsa ke gambar, remix foto ai, generator seni ai gratis',
            og_title: 'Generator AI Gambar ke Gambar Gratis - Ubah Foto jadi Seni & 4K | 微鲤AI',
            og_description: 'Unggah foto referensi dan transformasikan dengan Image to Image AI 微鲤AI. Ubah sketsa menjadi seni realistis, ganti gaya, atau buat variasi sambil mempertahankan komposisi asli. Mendukung resolusi 4K.',
            twitter_title: 'Generator AI Gambar ke Gambar Gratis - Ubah Foto jadi Seni & 4K | 微鲤AI',
            twitter_description: 'Unggah foto referensi dan transformasikan dengan Image to Image AI 微鲤AI. Ubah sketsa menjadi seni realistis, ganti gaya, atau buat variasi sambil mempertahankan komposisi asli. Mendukung resolusi 4K.',
            faq: [
                {
                    question: 'Apa itu Image to Image AI?',
                    answer: 'Image to Image (Img2Img) menggunakan gambar yang diunggah sebagai referensi bersama prompt teks untuk menghasilkan gambar baru, menggabungkan input visual dan deskripsi kreatif.',
                },
                {
                    question: 'Bagaimana mengubah sketsa menjadi foto realistis?',
                    answer: 'Unggah sketsa Anda, masukkan prompt yang menggambarkan adegan (mis. "bangunan fotorealistik"), lalu klik Buat.',
                },
                {
                    question: 'Apakah wajah asli tetap dipertahankan?',
                    answer: 'Struktur dan pose dipertahankan. Untuk mempertahankan identitas wajah secara presisi, gunakan alat Photo Face Swap.',
                },
            ],
            page: {
                title1: 'Generator AI Gambar ke Gambar Gratis',
                title2: 'Gunakan gambar yang sudah ada sebagai blueprint. Unggah foto, sketsa, atau layout, lalu biarkan AI membuat ulang dengan gaya baru berdasarkan prompt Anda. Cocok untuk mempertahankan komposisi sambil mengeksplorasi variasi artistik tanpa batas.',
                title3: 'Ubah foto Anda dengan transfer gaya AI',
                title4: 'Mengapa menggunakan Image to Image (Img2Img)?',
                upload_image: 'Sulit menjelaskan pose atau layout dengan kata-kata? Cukup unggah gambar referensi. Mesin Img2Img kami mempertahankan struktur asli namun menggambar ulang detailnya.',
                resolution: 'Ubah coretan kasar atau wireframe menjadi render fotorealistik atau ilustrasi berkualitas tinggi dalam hitungan detik. Ideal untuk desainer dan arsitek.',
                output: 'Hasilkan aset siap pakai. Tidak seperti alat lain yang menghasilkan gambar kecil, 微鲤AI mendukung resolusi 1K, 2K, dan 4K untuk detail yang tajam.',
                faq: [
                    {
                        question: 'Apa itu Image to Image AI?',
                        answer: 'Image to Image (Img2Img) adalah teknologi yang menggunakan gambar yang diunggah sebagai "referensi" bersama prompt teks untuk menghasilkan gambar baru. Ini menggabungkan input visual dengan deskripsi kreatif.',
                    },
                    {
                        question: 'Bagaimana mengubah sketsa menjadi foto realistis?',
                        answer: 'Unggah sketsa ke area "Image". Di kolom "Prompt", jelaskan apa yang digambar (mis. "Vila modern, senja, fotorealistik, 8k"). Klik Buat.',
                    },
                    {
                        question: 'Apakah wajah/orang asli tetap dipertahankan?',
                        answer: 'Akan berusaha mempertahankan struktur dan pose. Untuk retensi identitas wajah yang presisi, kami merekomendasikan alat "Photo Face Swap".',
                    },
                    {
                        question: 'Rasio aspek apa saja yang didukung?',
                        answer: 'Kami mendukung berbagai rasio termasuk 9:16 (Story), 16:9 (Cinematic), 3:4, dan 1:1 agar karya Anda cocok di semua platform.',
                    },
                    {
                        question: 'Apakah gratis?',
                        answer: 'Ya, Anda bisa membuat variasi secara gratis dengan kredit harian.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'AI Image Resizer - Pemangkasan & Penskalaan Cerdas | 微鲤AI',
            description: 'AI Image Resizer - Pemangkasan & Penskalaan Cerdas on 微鲤AI platform. High-quality results.',
            keywords: 'aiImageResizer, AI, 微鲤AI',
        },
        imageTextTranslate: {
            title: 'Penerjemah Teks Gambar AI Gratis - Terjemahkan Teks di Foto, Manga & Komik',
            description: 'Terjemahkan teks dalam gambar secara instan sambil mempertahankan gaya visual asli. Penerjemah Gambar AI 微鲤AI secara otomatis menghapus teks asli dan menggambar ulang terjemahan. Sempurna untuk komik, manga, dan poster pemasaran.',
            keywords: 'penerjemah gambar ai, terjemahkan teks dalam gambar, penerjemah foto, penerjemah manga, terjemahkan komik, penerjemah ocr, penggantian teks gambar',
            og_title: 'Penerjemah Teks Gambar AI Gratis - Terjemahkan Teks di Foto, Manga & Komik',
            og_description: 'Terjemahkan teks dalam gambar secara instan sambil mempertahankan gaya visual asli. Penerjemah Gambar AI 微鲤AI secara otomatis menghapus teks asli dan menggambar ulang terjemahan. Sempurna untuk komik, manga, dan poster pemasaran.',
            twitter_title: 'Penerjemah Teks Gambar AI Gratis - Terjemahkan Teks di Foto, Manga & Komik',
            twitter_description: 'Terjemahkan teks dalam gambar secara instan sambil mempertahankan gaya visual asli. Penerjemah Gambar AI 微鲤AI secara otomatis menghapus teks asli dan menggambar ulang terjemahan. Sempurna untuk komik, manga, dan poster pemasaran.',
            page: {
                title1: 'Penerjemah Gambar AI & Pengganti Teks Gratis',
                title2: 'Terjemahkan poster, menu, komik, dan tangkapan layar dalam hitungan detik. Tidak seperti penerjemah standar yang hanya menumpuk teks, 微鲤AI menggunakan AI Generatif untuk menghapus teks asli dan menggambar ulang latar belakang, membuat teks terjemahan terlihat seolah-olah merupakan bagian dari desain asli.',
                faq: [
                    {
                        question: 'Bagaimana cara menerjemahkan teks di dalam gambar?',
                        answer: 'Unggah gambar Anda (JPG, PNG) ke 微鲤AI. Pilih bahasa sumber (atau gunakan Deteksi Otomatis) dan bahasa target. Klik "Buat" untuk membiarkan AI mengganti teks.',
                    },
                    {
                        question: 'Apakah teks terjemahan akan terlihat alami?',
                        answer: 'Ya. 微鲤AI mencoba mencocokkan ukuran dan gaya font teks asli. Yang terpenting, ia menggambar ulang latar belakang di belakang teks sehingga terjemahannya menyatu dengan mulus.',
                    },
                    {
                        question: 'Dapatkah saya menggunakan ini untuk menerjemahkan Manga atau Manhwa?',
                        answer: 'Tentu saja. Ini adalah salah satu kasus penggunaan terbaik. AI mendeteksi gelembung ucapan dan teks vertikal (umum dalam bahasa Jepang), menggantinya dengan teks terjemahan horizontal.',
                    },
                    {
                        question: 'Bahasa apa saja yang didukung?',
                        answer: 'Kami mendukung terjemahan antara bahasa-bahasa global utama termasuk Inggris, Spanyol, Mandarin, Jepang, Korea, Prancis, Jerman, dan banyak lagi.',
                    },
                    {
                        question: 'Apakah ini berfungsi pada teks tulisan tangan?',
                        answer: 'Ini berfungsi paling baik pada teks cetak, tetapi mesin OCR canggih kami dapat mengenali teks tulisan tangan yang jelas pada papan tulis atau catatan.',
                    },
                    {
                        question: 'Apakah ini gratis?',
                        answer: 'Anda dapat menerjemahkan gambar secara gratis menggunakan kredit harian Anda.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Bagaimana cara menerjemahkan teks di dalam gambar?',
                    answer: `Unggah gambar Anda ke 微鲤AI. Pilih bahasa target dan klik 'Buat'. AI akan mengganti teks asli dengan terjemahan.`,
                },
                {
                    question: 'Apakah teks terjemahan akan terlihat alami?',
                    answer: 'Ya. 微鲤AI menggambar ulang latar belakang di belakang teks dan mencoba mencocokkan gaya font, memastikan terjemahan menyatu dengan mulus.',
                },
                {
                    question: 'Dapatkah saya menggunakan ini untuk menerjemahkan Manga atau Manhwa?',
                    answer: ' Tentu saja. Ini adalah salah satu kasus penggunaan terbaik. AI mendeteksi gelembung ucapan dan teks vertikal, menggantinya dengan teks terjemahan horizontal.',
                },
            ],
            feature_title1: 'Smart Inpainting & Redrawing',
            feature_desc1: 'Penggantian Teks Mulus: AI kami menganalisis tekstur latar belakang di belakang teks. Ia menghapus kata-kata asli dan mengisi celah secara cerdas sebelum menambahkan terjemahan, memastikan tidak ada kotak teks jelek yang menutupi gambar Anda.',
            feature_title2: 'Terjemahan Manga & Komik',
            feature_desc2: 'Baca Manga Raw Secara Instan: Sempurna untuk penggemar anime. Unggah halaman manga raw (Jepang/Korea) dan dapatkan terjemahan bahasa Inggris atau Indonesia instan yang pas di dalam gelembung ucapan.',
            feature_title3: 'Lokalisasi Pemasaran Global',
            feature_desc3: 'Lokalisasi Satu Klik: Meluncurkan produk secara global? Terjemahkan poster pemasaran, spanduk, dan tangkapan layar UI Anda ke dalam 30+ bahasa tanpa memerlukan file PSD asli.',
        },
        aiBackgroundChanger: {
            title: 'Pengubah Latar Belakang AI Gratis - Ubah Latar Belakang dengan Teks | 微鲤AI',
            description: 'Ubah latar belakang foto secara instan menggunakan AI. Deskripsikan pemandangan yang Anda inginkan.',
            keywords: 'ai background changer, ubah latar belakang, 微鲤AI',
        },
        imageUpscaler: {
            title: 'AI Image Upscaler Gratis - Tingkatkan ke 4K | 微鲤AI',
            description: 'Tingkatkan resolusi gambar rendah ke 4K dengan AI Enhancer.',
            keywords: 'image upscaler, ai enhancer, 4k, 微鲤AI',
        },
        photoFaceSwap: {
            title: 'Tukar Wajah Foto AI Online Gratis | 微鲤AI',
            description: 'Tukar wajah di foto secara instan dengan realisme tinggi.',
            keywords: 'tukar wajah, pengubah wajah foto, WeryAI',
            page: {
                title1: 'Tukar Wajah Foto AI Gratis',
                title2: 'Ingin melihat diri Anda sebagai astronot, bintang film, atau dalam lukisan klasik? Unggah foto dasar dan wajah target, dan biarkan AI kami memadukan fitur wajah, pencahayaan, dan warna kulit dengan mulus untuk pertukaran wajah yang sangat realistis dalam hitungan detik.',
            },
            feature_title1: 'Mahakarya artistik',
            feature_desc1: 'Perjalanan waktu: Tukar wajah Anda ke dalam lukisan minyak klasik seperti Mona Lisa atau Girl with a Pearl Earring. Buat avatar vintage unik secara instan.',
            feature_title2: 'Avatar profesional dan keren',
            feature_desc2: 'Pekerjaan impian: Lihat diri Anda dalam setelan balap, perlengkapan astronot, atau pakaian bisnis tanpa membeli kostumnya. Sempurna untuk membuat foto profil yang menonjol.',
            feature_title3: 'Pencampuran sangat realistis',
            feature_desc3: 'Tanpa efek "tempel": Tidak seperti alat potong-tempel sederhana, WeryAI menganalisis sudut, pencahayaan, dan tekstur kulit untuk memastikan wajah yang ditukar terlihat 100% alami, bukan palsu.',
        },
        removeTextFromImage: {
            title: 'Penghapus Teks AI dari Gambar Gratis | 微鲤AI',
            description: 'Hapus tanda air, logo, dan teks dari foto.',
            keywords: 'penghapus teks, hapus teks, 微鲤AI',
        },
        imgExtender: {
            title: 'AI Image Extender Gratis - Perluas Foto | 微鲤AI',
            description: 'Perluas batas gambar secara cerdas dengan AI Outpainting.',
            keywords: 'image extender, outpainting, 微鲤AI',
        },
        photoRestoration: {
            title: 'Restorasi Foto AI Gratis - Perbaiki Foto Lama | 微鲤AI',
            description: 'Pulihkan foto keluarga lama dan perbaiki goresan.',
            keywords: 'restorasi foto, perbaiki foto lama, 微鲤AI',
        },
        photoEffects: {
            title: 'Efek Foto - Generator Efek Gambar AI | 微鲤AI',
            description: 'Ubah foto Anda dengan efek bertenaga AI. Buat filter gambar, gaya, dan transformasi yang menakjubkan secara online gratis.',
            keywords: 'efek foto AI, filter AI, 微鲤AI',
        },
    },
    tr: {
        textToImage: {
            title: 'Ücretsiz AI Metinden Görsele Üretici - 4K Sanat ve Gerçekçi Fotoğraflar | 微鲤AI',
            description: `微鲤AI'nin Metinden Görsele Üreticisiyle metin açıklamalarını etkileyici görsellere dönüştürün. Nano Banana Pro modeli yüksek doğruluk sağlar. 1K/2K/4K çözünürlük ve 9:16/16:9 oranlarını destekler. Ücretsiz ve çevrimiçi.`,
            keywords: 'metinden görsele, ai görsel üretici, ai sanat üretici, 4k ai görseller, nano banana modeli, flux ai ücretsiz, duvar kağıdı üretici, metinden görsel oluşturma',
            og_title: 'Ücretsiz AI Metinden Görsele Üretici - 4K Sanat ve Gerçekçi Fotoğraflar | 微鲤AI',
            og_description: `微鲤AI'nin Metinden Görsele Üreticisiyle metin açıklamalarını etkileyici görsellere dönüştürün. Nano Banana Pro modeli yüksek doğruluk sağlar. 1K/2K/4K çözünürlük ve 9:16/16:9 oranlarını destekler. Ücretsiz ve çevrimiçi.`,
            twitter_title: 'Ücretsiz AI Metinden Görsele Üretici - 4K Sanat ve Gerçekçi Fotoğraflar | 微鲤AI',
            twitter_description: `微鲤AI'nin Metinden Görsele Üreticisiyle metin açıklamalarını etkileyici görsellere dönüştürün. Nano Banana Pro modeli yüksek doğruluk sağlar. 1K/2K/4K çözünürlük ve 9:16/16:9 oranlarını destekler. Ücretsiz ve çevrimiçi.`,
            faq: [
                {
                    question: '4K AI görsellerini nasıl oluştururum?',
                    answer: `Promptunuzu girin ve soldaki Görsel Boyutu ayarından "4K" seçeneğini seçip Oluştur'a tıklayın.`,
                },
                {
                    question: 'Hangi en-boy oranları destekleniyor?',
                    answer: '1:1, 9:16 (Mobil), 16:9 (Masaüstü), 4:3 ve 3:2 dahil tüm ana oranları destekliyoruz.',
                },
                {
                    question: 'Görselleri ticari olarak kullanabilir miyim?',
                    answer: 'Evet. 微鲤AI planlarında oluşturulan görseller genellikle reklamlar ve ürünler için uygun ticari lisansla gelir.',
                },
            ],
            page: {
                title1: 'Ücretsiz AI Metinden Görsele Üretici',
                title2: 'Birkaç saniyede nefes kesici sanat, fotogerçekçi görüntüler ve benzersiz duvar kağıtları oluşturun. Ne görmek istediğinizi tarif edin; gelişmiş Nano Banana Pro modelimiz, promptunuza kusursuz şekilde uyan yüksek kaliteli 4K görseller üretir.',
                resolution: 'Bulanık AI görsellerle yetinmeyin. 微鲤AI, baskı veya yüksek çözünürlüklü ekranlar için ideal olan net 1K, 2K ve 4K görselleri doğrudan üretmenizi sağlar.',
                aspectRatio: 'TikTok arka planı için 9:16, YouTube küçük resmi için 16:9 veya Instagram için 1:1 mi gerekiyor? Her sosyal platform için hazır oranlarımız var.',
                online_search: `Güncel bağlam mı lazım? "Online Search" özelliğini etkinleştirerek AI'nin webde gezinmesini ve promptunuzdaki güncel olayları veya özel referansları daha iyi anlamasını sağlayın.`,
                faq: [
                    {
                        question: 'Metinden yüksek kaliteli görselleri nasıl üretirim?',
                        answer: 'Konu, ışık ve stili anlatan detaylı bir prompt girin. En keskin detaylar için Görsel Boyutu ayarında "4K" seçin.',
                    },
                    {
                        question: 'Nano Banana Pro modeli nedir?',
                        answer: 'Nano Banana Pro, prompt uyumu ve fotogerçekçilik için optimize edilmiş en yüksek doğruluklu modelimizdir. Midjourney v6 ve Flux gibi üst modellerle kalite açısından yarışır.',
                    },
                    {
                        question: 'Görselleri ticari amaçla kullanabilir miyim?',
                        answer: 'Evet. 微鲤AI (ücretli planlar) ile üretilen görseller ticari lisansla gelir; reklam, web sitesi ve ürünlerde kullanılabilir.',
                    },
                    {
                        question: 'Aynı anda kaç görsel üretebilirim?',
                        answer: 'Aynı anda en fazla 4 görsel üretebilirsiniz ("Output Image Number" ayarında gösterildiği gibi). Bu sayede fikirleri hızlıca iterasyonlayabilirsiniz.',
                    },
                    {
                        question: 'Ücretsiz mi?',
                        answer: 'Evet, günlük ücretsiz kredilerle görsel üretebilirsiniz. Daha yüksek çözünürlükler (4K) daha fazla kredi gerektirebilir.',
                    },
                ],
            },
        },
        imageToImage: {
            title: 'Ücretsiz AI Görselden Görsele Üretici - Fotoğrafları Sanata & 4K’ya Dönüştür | 微鲤AI',
            description: 'Referans fotoğraf yükleyin ve 微鲤AI Görselden Görsele AI ile dönüştürün. Eskizleri gerçekçi sanata çevirin, stil değiştirin veya orijinal kompozisyonu koruyarak varyasyonlar üretin. 4K çözünürlük desteklenir.',
            keywords: 'görselden görsele ai, img2img, fotoğrafı çizime çevir, ai görsel varyasyonu, eskizden görsel, fotoğraf remix ai, ücretsiz ai sanat üretici',
            og_title: 'Ücretsiz AI Görselden Görsele Üretici - Fotoğrafları Sanata & 4K’ya Dönüştür | 微鲤AI',
            og_description: 'Referans fotoğraf yükleyin ve 微鲤AI Görselden Görsele AI ile dönüştürün. Eskizleri gerçekçi sanata çevirin, stil değiştirin veya orijinal kompozisyonu koruyarak varyasyonlar üretin. 4K çözünürlük desteklenir.',
            twitter_title: 'Ücretsiz AI Görselden Görsele Üretici - Fotoğrafları Sanata & 4K’ya Dönüştür | 微鲤AI',
            twitter_description: 'Referans fotoğraf yükleyin ve 微鲤AI Görselden Görsele AI ile dönüştürün. Eskizleri gerçekçi sanata çevirin, stil değiştirin veya orijinal kompozisyonu koruyarak varyasyonlar üretin. 4K çözünürlük desteklenir.',
            faq: [
                {
                    question: 'Image to Image AI nedir?',
                    answer: 'Image to Image (Img2Img), yüklenen bir görseli referans olarak alıp metin promptuyla birlikte yeni bir görsel oluşturur; görsel girdiyi yaratıcı açıklamayla birleştirir.',
                },
                {
                    question: 'Eskizi gerçekçi fotoğrafa nasıl dönüştürürüm?',
                    answer: `Eskizinizi yükleyin, sahneyi anlatan bir prompt girin (ör. "fotogerçekçi bina") ve Oluştur'a tıklayın.`,
                },
                {
                    question: 'Orijinal yüzü korur mu?',
                    answer: 'Yapı ve pozu korur. Yüz kimliğini hassas şekilde korumak için Photo Face Swap aracını kullanın.',
                },
            ],
            page: {
                title1: 'Ücretsiz AI Görselden Görsele Üretici',
                title2: 'Mevcut görsellerinizi birer plan olarak kullanın. Fotoğraf, eskiz veya düzen yükleyin; AI, metin promptunuza göre tamamen yeni bir stilde yeniden üretir. Kompozisyonu korurken sonsuz sanatsal varyasyonlar keşfetmek için idealdir.',
                title3: 'Fotoğraflarınızı AI stil aktarımıyla dönüştürün',
                title4: 'Neden Image to Image (Img2Img) kullanmalı?',
                upload_image: 'Pozu veya düzeni kelimelerle anlatmakta zorlanıyor musunuz? Referans görsel yükleyin. Img2Img motorumuz yapıyı korur ama detayları yeniden çizer.',
                resolution: 'Kaba bir eskizi veya wireframe’i saniyeler içinde fotogerçekçi bir render ya da yüksek kaliteli bir illüstrasyona dönüştürün. Tasarımcılar ve mimarlar için idealdir.',
                output: 'Üretime hazır varlıklar oluşturun. Diğer araçların küçük çıktılarının aksine 微鲤AI, keskin detaylar için 1K, 2K ve 4K çözünürlükleri destekler.',
                faq: [
                    {
                        question: 'Image to Image AI nedir?',
                        answer: 'Image to Image (Img2Img), yüklenen bir görseli "referans" olarak alıp metin promptuyla birlikte yeni bir görsel üretir. Görsel girdiyi yaratıcı açıklamayla birleştirir.',
                    },
                    {
                        question: 'Eskizi gerçekçi fotoğrafa nasıl dönüştürürüm?',
                        answer: `Eskizinizi "Image" alanına yükleyin. "Prompt" kutusunda neyi anlattığını yazın (ör. "Modern villa, gün batımı, fotogerçekçi, 8k"). Ardından Oluştur'a tıklayın.`,
                    },
                    {
                        question: 'Orijinal yüz/kişi korunur mu?',
                        answer: 'Genel yapı ve pozu korumaya çalışır. Yüz kimliğinin hassas korunması için "Photo Face Swap" aracını öneririz.',
                    },
                    {
                        question: 'Hangi en-boy oranları destekleniyor?',
                        answer: '9:16 (Story), 16:9 (Cinematic), 3:4 ve 1:1 dahil geniş bir oran yelpazesini destekliyoruz; böylece görselleriniz her platforma uyum sağlar.',
                    },
                    {
                        question: 'Ücretsiz mi?',
                        answer: 'Evet, günlük kredilerinizle ücretsiz varyasyonlar oluşturabilirsiniz.',
                    },
                ],
            },
        },
        aiImageResizer: {
            title: 'Yapay Zeka Görsel Yeniden Boyutlandırıcı - Akıllı Kırpma ve Ölçeklendirme | 微鲤AI',
            description: 'Yapay Zeka Görsel Yeniden Boyutlandırıcı - Akıllı Kırpma ve Ölçeklendirme on 微鲤AI platform. High-quality results.',
            keywords: 'aiImageResizer, AI, 微鲤AI',
        },
        imageTextTranslate: {
            title: 'Ücretsiz Yapay Zeka Görsel Çevirmen - Fotoğraf, Manga ve Çizgi Roman Metinlerini Çevir',
            description: `Orijinal görsel stili koruyarak görsellerdeki metinleri anında çevirin. 微鲤AI'nın Yapay Zeka Görsel Çevirmeni orijinal metni otomatik olarak siler ve çevirileri yeniden çizer. Çizgi romanlar, mangalar ve pazarlama afişleri için mükemmeldir.`,
            keywords: 'yapay zeka görsel çevirmen, görselde metin çevir, resim çevirmen, manga çevirmen, çizgi roman çevir, ocr çevirmen, görsel metin değiştirme',
            og_title: 'Ücretsiz Yapay Zeka Görsel Çevirmen - Fotoğraf, Manga ve Çizgi Roman Metinlerini Çevir',
            og_description: `Orijinal görsel stili koruyarak görsellerdeki metinleri anında çevirin. 微鲤AI'nın Yapay Zeka Görsel Çevirmeni orijinal metni otomatik olarak siler ve çevirileri yeniden çizer. Çizgi romanlar, mangalar ve pazarlama afişleri için mükemmeldir.`,
            twitter_title: 'Ücretsiz Yapay Zeka Görsel Çevirmen - Fotoğraf, Manga ve Çizgi Roman Metinlerini Çevir',
            twitter_description: `Orijinal görsel stili koruyarak görsellerdeki metinleri anında çevirin. 微鲤AI'nın Yapay Zeka Görsel Çevirmeni orijinal metni otomatik olarak siler ve çevirileri yeniden çizer. Çizgi romanlar, mangalar ve pazarlama afişleri için mükemmeldir.`,
            page: {
                title1: 'Ücretsiz Yapay Zeka Görsel Çevirmen ve Metin Değiştirici',
                title2: 'Afişleri, menüleri, çizgi romanları ve ekran görüntülerini saniyeler içinde çevirin. Yalnızca metni üst üste bindiren standart çevirmenlerin aksine 微鲤AI, orijinal metni silmek ve arka planı yeniden çizmek için Üretken Yapay Zeka kullanır, böylece çevrilen metin orijinal tasarımın bir parçasıymış gibi görünür.',
                faq: [
                    {
                        question: 'Bir görselin içindeki metni nasıl çeviririm?',
                        answer: `Görselinizi (JPG, PNG) 微鲤AI'ya yükleyin. Kaynak dili seçin (veya Otomatik Algıla'yı kullanın) ve hedef dili seçin. Yapay zekanın metni değiştirmesine izin vermek için "Oluştur"a tıklayın.`,
                    },
                    {
                        question: 'Çevrilen metin doğal görünecek mi?',
                        answer: 'Evet. 微鲤AI, orijinal metnin yazı tipi boyutunu ve stilini eşleştirmeye çalışır. En önemlisi, çevirinin sorunsuz bir şekilde karışması için metnin arkasındaki arka planı yeniden çizer.',
                    },
                    {
                        question: 'Bunu Manga veya Manhwa çevirmek için kullanabilir miyim?',
                        answer: 'Kesinlikle. Bu en iyi kullanım durumlarından biridir. Yapay zeka, konuşma balonlarını ve dikey metinleri (Japoncada yaygın) algılar ve bunları yatay çevrilmiş metinle değiştirir.',
                    },
                    {
                        question: 'Hangi diller destekleniyor?',
                        answer: 'İngilizce, İspanyolca, Çince, Japonca, Korece, Fransızca, Almanca ve daha fazlası dahil olmak üzere başlıca küresel diller arasında çeviri yapılmasını destekliyoruz.',
                    },
                    {
                        question: 'El yazısı metinlerde çalışıyor mu?',
                        answer: 'En iyi basılı metinlerde çalışır, ancak gelişmiş OCR motorumuz beyaz tahtalardaki veya notlardaki net el yazılarını tanıyabilir.',
                    },
                    {
                        question: 'Ücretsiz mi?',
                        answer: 'Günlük kredilerinizi kullanarak görselleri ücretsiz olarak çevirebilirsiniz.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Bir görselin içindeki metni nasıl çeviririm?',
                    answer: `Görselinizi 微鲤AI'ya yükleyin. Hedef dili seçin ve 'Oluştur'a tıklayın. Yapay zeka orijinal metni çeviriyle değiştirecektir.`,
                },
                {
                    question: 'Çevrilen metin doğal görünecek mi?',
                    answer: 'Evet. 微鲤AI metnin arkasındaki arka planı yeniden çizer ve yazı tipi stiliyle eşleşmeye çalışarak çevirinin sorunsuz bir şekilde karışmasını sağlar.',
                },
                {
                    question: 'Bunu Manga veya Manhwa çevirmek için kullanabilir miyim?',
                    answer: 'Kesinlikle. Bu en iyi kullanım durumlarından biridir. Yapay zeka konuşma balonlarını ve dikey metni algılar ve bunları yatay çevrilmiş metinle değiştirir.',
                },
            ],
            feature_title1: 'Akıllı Boyama ve Yeniden Çizim',
            feature_desc1: 'Sorunsuz Metin Değiştirme: Yapay zekamız metnin arkasındaki arka plan dokusunu analiz eder. Çeviriyi eklemeden önce orijinal kelimeleri akıllıca siler ve boşluğu doldurur, böylece görselinizi kapatan çirkin metin kutuları oluşmaz.',
            feature_title2: 'Manga ve Çizgi Roman Çevirisi',
            feature_desc2: 'Ham Mangaları Anında Okuyun: Anime hayranları için mükemmel. Ham manga sayfalarını (Japonca/Korece) yükleyin ve konuşma balonlarına tam oturan anında İngilizce veya Türkçe çeviriler alın.',
            feature_title3: 'Küresel Pazarlama Yerelleştirmesi',
            feature_desc3: `Tek Tıkla Yerelleştirme: Ürünlerinizi küresel çapta mı piyasaya sürüyorsunuz? Pazarlama afişlerinizi, bannerlarınızı ve UI ekran görüntülerinizi orijinal PSD dosyalarına ihtiyaç duymadan 30'dan fazla dile çevirin.`,
        },
        aiBackgroundChanger: {
            title: 'Ücretsiz Yapay Zeka Arka Plan Değiştirici - Metinle Arka Plan Değiştir | 微鲤AI',
            description: 'Yapay zeka kullanarak fotoğraf arka planlarını anında değiştirin. İstediğiniz sahneyi tanımlayın.',
            keywords: 'yapay zeka arka plan değiştirici, arka planı değiştir, 微鲤AI',
        },
        imageUpscaler: {
            title: 'Ücretsiz Yapay Zeka Görüntü Yükseltici - 4K Kalitesine Artır | 微鲤AI',
            description: `Yapay Zeka Geliştirici ile düşük çözünürlüklü görüntüleri 4K'ya yükseltin.`,
            keywords: 'görüntü yükseltici, yapay zeka geliştirici, 4k, 微鲤AI',
        },
        photoFaceSwap: {
            title: 'Ücretsiz Yapay Zeka Fotoğraf Yüz Değiştirme Online | 微鲤AI',
            description: 'Fotoğraflardaki yüzleri yüksek gerçekçilikle anında değiştirin.',
            keywords: 'yüz değiştirme, fotoğraf yüz değiştirici, WeryAI',
            page: {
                title1: 'Ücretsiz Yapay Zeka Fotoğraf Yüz Değiştirme',
                title2: 'Kendinizi astronot, film yıldızı veya klasik bir tabloda görmek ister misiniz? Bir temel fotoğraf ve hedef yüz yükleyin, yapay zekamız yüz özelliklerini, ışığı ve cilt tonlarını sorunsuz bir şekilde harmanlayarak saniyeler içinde hiper-gerçekçi bir yüz değişimi oluştursun.',
            },
            feature_title1: 'Sanatsal başyapıtlar',
            feature_desc1: 'Zaman yolculuğu: Yüzünüzü Mona Lisa veya İnci Küpeli Kız gibi klasik yağlı boya tablolara yerleştirin. Anında benzersiz vintage avatarlar oluşturun.',
            feature_title2: 'Profesyonel ve havalı avatarlar',
            feature_desc2: 'Hayalinizdeki iş: Kostüm satın almadan kendinizi yarış kıyafetinde, astronot giysisinde veya iş kıyafetinde görün. Göz alıcı profil fotoğrafları oluşturmak için mükemmel.',
            feature_title3: 'Hiper-gerçekçi harmanlama',
            feature_desc3: `"Yapıştırma" efekti yok: Basit kes-yapıştır araçlarının aksine, WeryAI açıyı, aydınlatmayı ve cilt dokusunu analiz ederek değiştirilen yüzün %100 doğal görünmesini sağlar, sahte değil.`,
        },
        removeTextFromImage: {
            title: 'Ücretsiz Yapay Zeka Görüntüden Metin Kaldırıcı | 微鲤AI',
            description: 'Fotoğraflardan filigranları, logoları ve metinleri silin.',
            keywords: 'metin kaldırıcı, metni sil, 微鲤AI',
        },
        imgExtender: {
            title: 'Ücretsiz Yapay Zeka Görüntü Genişletici - Fotoğrafları Tamamla | 微鲤AI',
            description: 'Yapay Zeka Outpainting ile görüntü sınırlarını akıllıca genişletin.',
            keywords: 'görüntü genişletici, outpainting, 微鲤AI',
        },
        photoRestoration: {
            title: 'Ücretsiz Yapay Zeka Fotoğraf Restorasyonu - Eski Fotoğrafları Onar | 微鲤AI',
            description: 'Eski aile fotoğraflarını geri yükleyin ve çizikleri onarın.',
            keywords: 'fotoğraf restorasyonu, eski fotoğrafları onar, 微鲤AI',
        },
        photoEffects: {
            title: 'Fotoğraf Efektleri - AI Görsel Efekt Oluşturucu | 微鲤AI',
            description: 'Fotoğraflarınızı AI destekli efektlerle dönüştürün. Harika görsel filtreleri, stiller ve dönüşümleri online olarak ücretsiz oluşturun.',
            keywords: 'AI fotoğraf efektleri, AI filtreleri, 微鲤AI',
        },
    },
}
